/*!
=========================================================
* 新受注管理
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardBody, CardTitle, 
  Table, Col,
  FormGroup, Input, Row,
  Label,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import { Link } from 'react-router-dom';
import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import WithRole from '../FormParts/ButtonWithRole';
import Definition from '../../common/Definition';
import FormatCode from "../../common/FormatCode";
import InputText from '../FormParts/InputText'
import InputSelect from '../FormParts/InputSelect'
import InputCheckBox from '../FormParts/InputCheckBox'
import InputDatetime from '../FormParts/InputDatetime'
import InputFile from '../FormParts/InputFile';
import InputNumber from '../FormParts/InputNumber';
import InputNumberChange from '../FormParts/InputNumberChange';
import InputRadio from '../FormParts/InputRadio';
import Format from "../../common/Format";
import OptionConvert from '../../common/OptionConvert';
import DialogBase from "../Base/DialogBase";
import _ from 'underscore';
import 'moment/locale/ja'
import moment from 'moment/moment'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFileLines as faFileLinesSolid, faLock, faLockOpen } from '@fortawesome/free-solid-svg-icons'
import { faFileLines } from '@fortawesome/free-regular-svg-icons'

//import ListBaseTree from '../Base/ListBaseTreeUnlimit';
import ListBaseDetails from '../Base/ListBaseDetails'
import { GetMessage, GetMessageWithParam, getErrorCodes } from "../../variables/message";
import PdfViewer from "../ViewParts/PdfViewer";
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import format_url from '../../variables/format_url';
import GoogleDrive from "../../common/GoogleDrive";
import custom_report from "../../variables/custom_report"
import AddMemoPopup from "../ViewParts/AddMemoPopup";
import MemoPopup from "../ViewParts/MemoPopup";

import ImageControl from '../FormParts/ImageControl'
import StaticMap from '../../common/StaticMap'
import CustomReport from "../../variables/custom_report"
import InputInvoice from "../ViewParts/InputInvoice";
import AlertAndpadModal from '../ViewParts/AlertAndpadModal';
import AlertModal from "../ViewParts/AlertModal";

import {
	cst_non_taxable_flag,
	cst_tax_in_flag,
	cst_term_month_flag,
	cst_invoice_change_flag,
	cst_application_form_auto_send_flag,
	cst_application_form_send_target_status,
	cst_latest_pdf_plotting_request_status,
	cst_estimate_management_memo_type,
	cst_contact_memo_for_customer_user,
	cst_cannot_extention_flag,
  } from '../../variables/codes_map';
import Validate from "../../common/Validate";

import { andpad_json_data, andpad_json_data_estimate } from '../../variables/andpad';

moment.locale('ja')

moment.updateLocale('ja', {
  months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
});

var domain = "";  

// import {GetMessage} from "../../variables/message"


//class List extends ListBaseTree {
class List extends ListBaseDetails {
	default_column = [
		{ Header: '見積ID',id:"expander",accessor: 'ESTIMATE_estimate_natural_id',headerClassName:'text-center',className:'text-left text-top va-top',width:150,minWidth:150,isSortDisabled:true},
		{ Header: '顧客情報',accessor: '___JOIN_client_master',headerClassName:'text-center',className:'text-left text-top va-top',width:200,minWidth:200,isSortDisabled:true},
		{ Header: '現場名/工事番号/現場住所/現場担当者',accessor: '___JOIN_project_detail',headerClassName:'text-center',className:'text-left text-top va-top',width:220,minWidth:200,isSortDisabled:true},
		{ Header: '見積期間/契約期間',accessor: '___JOIN_request_date',headerClassName:'text-center',className:'text-left text-top va-top',width:300,minWidth:300,isSortDisabled:true},
		{ Header: '駐車場名/台数',accessor: '___JOIN_parking_detail',headerClassName:'text-center',className:'text-left text-top va-top',width:150,minWidth:150,isSortDisabled:true},
		{ Header: '担当設定',accessor: '___ACTION_ACCOUNT',headerClassName:'text-center',className:'text-left text-top va-top',width:425,minWidth:425,isSortDisabled:true},
	]
	default_sort_column = [
		{ label: "見積/契約開始日", value: "survey_or_quote_start_date"},
		{ label: "見積/契約終了日", value: "survey_or_quote_end_date"},
		{ label: "見積ID", value: "estimate_natural_id"},
		{ label: "契約書到着予定日", value: "return_deadline"},
		{ label: "発注書アップロード日", value: "purchase_order_upload_date"},
	]
	constructor(props) {
		super(props);
		// 契約書以降　初期をユーザの支店にする
		const user_branch_natural_id = props.box_status >= 7 ? localStorage.getItem("user_branch_natural_id") : ""

		Object.assign(this.state, {
			title: '受注管理',
			column: this.default_column,
			sort_column: this.default_sort_column,
			add_url: '',
			search_url: '/api/order_box',
			searchData: {
				values:{
					box_status: props.box_status,
					user_branch_natural_id: user_branch_natural_id,
				},
				errors:{},
				requiredData:{}
			},
			// 2022/10/24 一括登録用データ
			bulkData: {
				values:{},
				errors:{},
				requiredData:{}
			},
			data_count: 0,
			pager : {
				offset: 0,
				limit : 50,
				sort : null,
				order: null,
			},
			customer_user:[],
			landmark_user:[],
			users: {
				customer: [],
				supplier: [],
				landmark: []
			},
			estimate_memo: [],
			estimate_id:0, // メモ追加用
			estimate_natural_id:"",
			modal: {
				estimate_memo: false,
				estimate_memo_history: false
			},
			dialogData:{
				values:{},
				errors:{},
				requiredData:{}
			  },
			unique_key: "ESTIMATE__estimate_natural_id",
			with_all_check: true,
			memoPopupData:{},
			addMemoPopupData:{},
            show_recode_header : false,
            show_sort_field : true,
		});

		this.search = this.search.bind(this);
		this.search_count = this.search_count.bind(this);
		this.onchange_account_check = this.onchange_account_check.bind(this);
		this.validateCallback = this.validateCallback.bind(this);
		this.validEstimateAccount = this.validEstimateAccount.bind(this);
		this.toggleChangeFlag = this.toggleChangeFlag.bind(this);
		this.registEstimateStatus = this.registEstimateStatus.bind(this);
		this.registEstimateStatusOnHold = this.registEstimateStatusOnHold.bind(this);
		this.updateOrderBoxStatus = this.updateOrderBoxStatus.bind(this);
		this.toggleEstimateMemo = this.toggleEstimateMemo.bind(this);
		this.toggleEstimateHistory = this.toggleEstimateHistory.bind(this);
		this.checkCallBack = this.checkCallBack.bind(this);
		this.button_defines = this.button_defines.bind(this);
		this.checkedEstimate = this.checkedEstimate.bind(this);
		this.viewShpeadSheetQuote = this.viewShpeadSheetQuote.bind(this);
		this.check_invoice_regist = this.check_invoice_regist.bind(this);

		this.dialogEstimateMemo = React.createRef();
		this.dialogUploadPurchaseOrder = React.createRef();
		this.dialogCreateApplication = React.createRef();
		this.dialogUploadFileInvoice = React.createRef();
		this.dialogUploadFileOther = React.createRef();
		this.dialogOrderConfirm = React.createRef();
		this.dialogSendQuote = React.createRef();
		this.dialogSendApproval = React.createRef();
		this.dialogUploadBlockMap = React.createRef();
		this.dialogSubmissionBlockMap = React.createRef();
		this.dialogSubmissionBlockMapReport = React.createRef();
		this.dialogUploadFileContract = React.createRef();
		this.dialogUploadFileCustomerContract = React.createRef();
		this.dialogUploadFileApplicationForm = React.createRef();
		this.dialogLostOrder = React.createRef();
		// this.dialogMessageToCustomerUser = React.createRef();
		this.memoPopup = React.createRef();
		// 見積依頼書ダウンロード
		this.dialogCustomerRequestFile = React.createRef();

		// 2022/10/24
		this.updateCheckData = this.updateCheckData.bind(this);
		this.validateBulkData = this.validateBulkData.bind(this);
		this.handleClickApplication = this.handleClickApplication.bind(this);
		this.addMemoPopup = React.createRef();

	}
	componentDidMount(){
		Request.get("/api/landmark/user_branch",{}, res => {
			const user_branch_list = res.Data.map((data)=>{
			  return {
				  value:data.user_branch_natural_id,
				  label:data.user_branch_name,
			  }
			})
			this.setState({landmark_user_branch:user_branch_list});
		})

		Request.get("/api/customer",{without_limit:true}, res => {
			const customerList = res.Data.map(element=>{
			  return {
				value:element.ulid,
				label:element.customer_name
			  }
			})
			this.setState({customerList});
		})	  


		Request.get("/api/landmark/lastupdate",{}, res => {
			const user_list = OptionConvert.options(res.Data)
			const landmark_user = OptionConvert.optionsById(res.Data)
	  
			this.setState({
				customer_user : user_list,
				landmark_user : landmark_user,
				users: {
					...this.state.users,
					landmark: res.Data.map(lu=>{
						return {
							key : lu.id,
							label : lu.name
						}
					})
				},

			},
				()=>this.search());
		})
	}
	sortData (options) {
		this.setState({
			paging: {
				...this.state.paging,
				index: 0,
			},
			pager: {
				...this.state.pager,
				limit: this.state.paging.limit,
				sort: options.col.length === 0 ? "survey_or_quote_start_date" : options.col,
				order: options.ask ? "ASC" : "DESC"
			}
		},
		()=> {
			this.search()
		})
	}
	mapStatus (status) {
		return status.map(data=>{
			return {
				errors:{},
				requiredData:{},
				values:{
					contract_user_lock_flag : data.contract_user_lock_flag,
					payment_user_lock_flag : data.payment_user_lock_flag,
					survey_account_user_lock_flag : data.survey_account_user_lock_flag,
					estimate_caution_flag : data.estimate_caution_flag==1? true: false,
					estimate_emergency_flag : data.estimate_emergency_flag==1? true: false,
					estimate_exclusive_flag : data.estimate_exclusive_flag==1? true: false,
					web_survey_account : data.web_survey_account,             // 調査担当者
					contract_user_id : data.contract_user_id,               // 発注担当者
					payment_user_id : data.payment_user_id // 仕入担当者
				}
			}
		})
	}
	search_params() {
		const {values} = this.state.searchData
		return values&&Object.keys(values).reduce((acc, key)=>{
		  let val = String(values[key]);
		  if (val != "" && values[key] != null){
			acc[key] = val;
		  }
		  return acc
		},{})
	}
	search (flgTaskCount=false, refreshData=false) {
		this.search_count()
		let search_param = { ...this.search_params(),
			...this.state.pager,
			pager_index: this.state.pager.offset,
			pager_limit: this.state.pager.limit
		}
		Request.get(this.state.search_url, search_param,res => {
			if(flgTaskCount==true){
				// window.location.reload();
				this.props.refreshTaskCount();
			}
			this.setState({
				estimate_status: this.mapStatus( res.Data ),
				checkedItems : refreshData==true? []: this.state.checkedItems,
				bulkData: refreshData==true? {
					values:{},
					errors:{},
					requiredData:{}
				} : this.state.bulkData,
			},()=>{
				// console.log(res.Data)
				this.setState({
					data: this.dataMap( res.Data ),
					resetExpanded: true
				},()=>{
					this.setState({
						resetExpanded: false
					})
				})
			})
		})
	}
	search_count () {
		var search_param = this.search_params();
		search_param["data_count"] = 1;
		Request.get(this.state.search_url, search_param, res => {
			this.setState({data_count: res.Data});
		})
			
	}
	onchange_account_check (index,param,checked) {

		let {
			order_box_status
		} = this.state.data[index].originalData

		if ( param == "estimate_exclusive_flag" && checked == true ) {
			let {
				web_survey_account,
				contract_user_id               // 契約担当者
			} = this.state.estimate_status[index]

		}


		let estimate_status = this.state.estimate_status.map((e,n)=>{
			if (n == index) {
				return {
					...e,
					values: {
						...e.values,
						[param] : checked
					},
					errors: checked&&e.values.contract_user_id==null&&e.values.web_survey_account==null?{
						contract_user_id: [GetMessage(2515)]
					}:{}
				}
			}
			return e
		})
		this.setState({
			estimate_status
		})
	}
	dataMap(data,resetCheck=false){
		return data.map((prop, key) => {
			let {
				order_box_status,               // BOXステータス
				supplier_name,
				supplier_tel,
				supplier_tel2,
				survey_cost_parking_rent,       // 調査見積仕入金額：賃料（月単価）
				survey_cost_total_amt,          // 調査見積仕入金額：仕入合計
				survey_commission_discount_amt, // 調査見積見積金額：実質手数料
				survey_cost_security_deposit,   // 調査見積仕入金額：敷金
				survey_key_money,               // 調査見積見積金額：礼金
				web_survey_account,             // WEB調査担当者
				onsite_survey_account,          // 現地調査担当者
				contract_user_id,               // 契約担当者
				estimate_natural_id,
				estimate_caution_flag,
				estimate_emergency_flag,
				estimate_exclusive_flag,
				survey_account_user_lock_flag,
				contract_user_lock_flag,
				payment_user_lock_flag,
				register_type,
				quote_estimate_senddate,
				purchase_order_upload_date,
				return_deadline
			} = prop
			// console.log(prop)
//			console.log(survey_account_user_lock_flag,contract_user_lock_flag,payment_user_lock_flag);
			// console.log(prop.supplier_memo);
			let manager = this.state.estimate_status[key]
			let order_memo = prop.order_memo == null ? "" : prop.order_memo
			let supplier_memo = prop.supplier_memo == null ? "" : prop.supplier_memo
			let current_date = new Date()
			const isAutoOrder = prop.auto_order_execution_flag == 1 && prop.auto_order_function_flag == 1
			// console.log(prop)
			const rowColor = isAutoOrder ? "bg-lyellow" : prop.register_type === 1 ? "bg-lblue" : "";

			return {
				id: key,
				prop,
				rowColor: rowColor,
				// isCustorder:register_type==1?true:false,
				checked:resetCheck ? undefined : ( this.checkedForItem(prop) )? true: undefined,
				pdf_check_list:order_box_status == 4?{
					values:{
						purchase_order_check: 0,
						application_check: 0,
						invoice_check: 0,
					},
					errors:{},
					requiredData:{}
				}:{},
				estimate_data: this.state.estimate_status[key],
				ESTIMATE_estimate_natural_id: (<>
					<div dangerouslySetInnerHTML={{__html:Definition.item('ESTIMATE_estimate_natural_id', prop)}} />
					{this.checkedEstimate(prop,key)}
					</>),
				___JOIN_client_master: (<><div className={"customer"} dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />
										<div className={"memo"}>
											顧客メモ<br />
											<Input
												type={"textarea"}
												value={order_memo}
												onChange={()=>{}}
												disabled={false}
												onClick={() => {
													this.setState({
														addMemoPopupData : {
															values : prop,
															isOrderMemo: true,
															label: "顧客メモ"
														}
													}, () => { 
														this.addMemoPopup.current.show()
													})
												}}
											/>
										</div>

{/*
										<InputText multiline={true}
											labelOn={false}
											label='顧客用メモ'
											name='ESTIMATE__contact_memo'
											validateCallback={this.validateCallback} 
											rootData={data}
											validateType='regist'
										/>
 */}
										</>),
				___JOIN_project_detail: (<><div className={"address"} dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_project_detail_with_site_customer', prop)}} />
										<div className={"memo"}>
											仕入先メモ<br />
											<Input
												type={"textarea"}
												value={supplier_memo}
												onChange={()=>{}}
												disabled={false}
												onClick={() => {
													this.setState({
														addMemoPopupData : {
														values : prop,
														isOrderMemo: false,
														label: "仕入先メモ"
														}
													}, () => { 
													this.addMemoPopup.current.show()
													})
												}}
											/>
										</div>											
{/*
										<InputText multiline={true}
											labelOn={false}
											label='仕入先メモ'
											name='ESTIMATE__contact_memo'
											validateCallback={this.validateCallback} 
											rootData={data}
											validateType='regist'
										/>
 */}
										</>),
				___JOIN_request_date: (<>
										<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_date', prop)}} />
										<div>確定見積送付日付：{Format.format_date_yyyymmdd(quote_estimate_senddate)}</div>
										<div>契約書到着予定日：<font color={return_deadline !== undefined && return_deadline !== null && current_date >= new Date(return_deadline) ? "red" : ""}>{Format.format_date_yyyymmdd(return_deadline)}</font></div>
										<div>発注書アップロード日：{Format.format_date_yyyymmdd(purchase_order_upload_date)}</div>
										<div className={"supplier"}>
											<div className={"title"}>仕入先</div>
											<div className={"title"}>仕入先電話番号</div>
											<div className={"title"}>仕入賃料（月単価）</div>
											<div className={"title"}>仕入合計</div>
										</div>
										</>),
				___JOIN_parking_detail: (<>
										<div className={"parking"} dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_parking_detail', prop)}} />
										<div className={"supplier"}>
											<div className={"data"}>{supplier_name}</div>
											<div className={"data"}>{supplier_tel}</div>
											<div className={"data"}>{Format.format_number_with_commas(survey_cost_parking_rent)}円</div>
											<div className={"data"}>{Format.format_number_with_commas(survey_cost_total_amt)}円</div>
										</div>
										</>),
				___ACTION_ACCOUNT: (<>
									<Row>
										<Col md="7">
										調査&nbsp;
										<FontAwesomeIcon 
											className="hover" 
											onClick={(e)=>{this.toggleChangeFlag(key, "survey_account_user_lock_flag")}} 
											icon={survey_account_user_lock_flag==0? faLockOpen: faLock}
										/>&nbsp;
										<InputSelect
											label="調査担当者"
											className="select-user-box"
											name="REQUEST__web_survey_account"
											labelOn={false}
											options={this.state.landmark_user}
											validateCallback={(newData)=>{(this.validEstimateAccount(key,newData))}}
											rootData={manager}
											isSearchable={true}
											menuPosition={"fixed"}
											validateType={'regist'}
											disabled={survey_account_user_lock_flag==0?false:true}
										/>
											
										</Col>
										<Col md="5">
											{this.box_status_button_defines(prop)}
										{/**
										<Button size="sm" onClick={()=>this.registEstimateStatusOnHold(key)}>
											保留BOX
										</Button>
										 */}
										</Col>

										<Col md="7">
											発注&nbsp;
											<FontAwesomeIcon 
												className="hover" 
												onClick={(e)=>{this.toggleChangeFlag(key, "contract_user_lock_flag")}} 
												icon={contract_user_lock_flag==0? faLockOpen: faLock}
											/>&nbsp;
											<InputSelect
												label="発注担当者"
												className="select-user-box"
												name="ESTIMATE__contract_user_id"
												labelOn={false}
												options={this.state.landmark_user}
												validateCallback={(newData)=>{(this.validEstimateAccount(key,newData))}}
												rootData={manager}
												menuPosition={"fixed"}
												isSearchable={true}
												validateType={'regist'}
												disabled={contract_user_lock_flag==0?false:true}
											/>
										</Col>
										<Col md="7">
											仕入&nbsp;
											<FontAwesomeIcon 
												className="hover"
												onClick={(e)=>{this.toggleChangeFlag(key, "payment_user_lock_flag")}} 
												icon={payment_user_lock_flag==0? faLockOpen: faLock}
											/>&nbsp;
											<InputSelect
												label="仕入担当者"
												className="select-user-box"
												name="ESTIMATE__payment_user_id"
												labelOn={false}
												options={this.state.landmark_user}
												validateCallback={(newData)=>{(this.validEstimateAccount(key,newData))}}
												rootData={manager}
												menuPosition={"fixed"}
												isSearchable={true}
												validateType={'regist'}
												disabled={payment_user_lock_flag==0?false:true}
											/>
										</Col>
{/** 
										<Col md="8">
										<Button size="sm" onClick={()=>this.registEstimateStatus(key)}>
											登録
										</Button>
										</Col>
*/}
								</Row>
						</>),
				originalData: {
					...prop,
					estimate_caution_flag: prop.estimate_caution_flag==null? false: prop.estimate_caution_flag,
					estimate_emergency_flag: prop.estimate_emergency_flag==null? false: prop.estimate_emergency_flag,
					estimate_exclusive_flag: prop.estimate_exclusive_flag==null? false: prop.estimate_exclusive_flag,
				},
			}
		})
	}
	checkedEstimate(data,key){
		// console.log(key)
		let {estimate_caution_flag,estimate_emergency_flag,estimate_exclusive_flag} = data;

		return(
			<>
			<Input type="checkbox" 
					id={`estimate_caution_flag-`+key} 
					className="inline__input" 
					label="注意" 
					onChange={(e)=>{this.toggleChangeFlag(key,"estimate_caution_flag")}} 
					defaultChecked={estimate_caution_flag==0?false:true}
					checked={estimate_caution_flag==0?false:true} />
			<label className="inline__label" for={`estimate_caution_flag-`+key}>注</label>
			<Input type="checkbox" 
					id={`estimate_emergency_flag-`+key}  
					className="inline__input" 
					label="緊急" 
					onChange={(e)=>{this.toggleChangeFlag(key,"estimate_emergency_flag")}} 
					defaultChecked={estimate_emergency_flag==0?false:true}
					checked={estimate_emergency_flag==0?false:true} />
			<label className="inline__label" for={`estimate_emergency_flag-`+key} >緊</label>
			<Input type="checkbox" 
					id={`estimate_exclusive_flag-`+key} 
					className="inline__input" 
					label="到着" 
					onChange={(e)=>{this.toggleChangeFlag(key,"estimate_exclusive_flag")}} 
					defaultChecked={estimate_exclusive_flag==0?false:true}
					checked={estimate_exclusive_flag==0?false:true} />
			<label className="inline__label" for={`estimate_exclusive_flag-`+key}>着</label>
			</>
		)
	}

	toggleChangeFlag (index, prm) {

		let tmpData = {
						[prm]:this.state.data[index].originalData[prm]== 0 ? 1: 0,
						update_timestamp:this.state.data[index].originalData.update_timestamp
					}
		Request.put("/api/order_box/change_flag/" + this.state.data[index].originalData.estimate_ulid,tmpData,res=>{
			document.body.style.overflow = "auto";
			this.search();
		})

	}
	clickRowCallback ( props ) {
		let { estimate_id } = props.originalData
		Request.get("/api/order_box/memo",{estimate_id},res=>{
//			console.log(res);
			this.setState({
				estimate_memo: res.Data
			})
		})
	}
	checkCallBack(valid, index){
		let pdf_type = Object.keys(valid)[0]
		let checked = Object.values(valid)[0]
		// console.log(valid,index)
		let data = this.state.data
		this.setState({
			data: this.state.data.map((d,i)=>{
				return i == index? {
					...d,
					pdf_check_list: {
						...d.pdf_check_list,
						values: {
							...d.pdf_check_list.values,
							[pdf_type]: checked
						}
					}
				}:d
			})
		},()=>{
			console.log(this.state.data);
		})
	}
	pdf_view(data,index){
		if(data.order_box_status == 4){
			// console.log(data)
			return (<>
			{data.latest_pdf_purchase_order_url != "" && (<PdfViewer index={index} pdf={"/api/gcs_download/" + data.latest_pdf_purchase_order_url} type="purchase_order" data={data} rootData={this.state.data[index].pdf_check_list} checkCallBack={(valid)=>this.checkCallBack(valid,index)} />)}
			{(data.application_form_upload_flag == 0 && data.latest_pdf_application_form_url != "")  && (<PdfViewer index={index} pdf={`/api/gcs_download/Drive/${data.latest_pdf_application_form_url}?drive=1`} type="application" data={data} checkCallBack={(valid)=>this.checkCallBack(valid,index)} />)}
			{(data.application_form_upload_flag == 1 && data.latest_pdf_application_form_url != "")  && (<PdfViewer index={index} pdf={`/api/gcs_download/${data.latest_pdf_application_form_url}`} type="application" data={data} checkCallBack={(valid)=>this.checkCallBack(valid,index)} />)}
			{data.latest_pdf_supplier_invoice_url != "" && (<PdfViewer index={index} pdf={"/api/gcs_download/" + data.latest_pdf_supplier_invoice_url} type="invoice" data={data} checkCallBack={(valid)=>this.checkCallBack(valid,index)} />)}
			</>
			)
		}
	}

	check_invoice_status (data) {
		// console.log(data);

		if(data.request_type == 3){
			return !(this.check_invoice_regist(data.survey_cost_total_amt,
								 data.survey_cost_parking_rent_payment_type,
								 data.survey_cost_parking_rent_invoice_business_type,
								 data.survey_cost_parking_rent_invoice_registration_number,
								 data))
		}else{
			const check_parking_rent = this.check_invoice_regist(data.survey_cost_parking_rent,
										data.survey_cost_parking_rent_payment_type,
										data.survey_cost_parking_rent_invoice_business_type,
										data.survey_cost_parking_rent_invoice_registration_number,
										data)
			const check_commission = this.check_invoice_regist(data.survey_cost_commission,
										data.survey_cost_commission_payment_type,
										data.survey_cost_commission_invoice_business_type,
										data.survey_cost_commission_invoice_registration_number,
										data)

			const check_key_money = this.check_invoice_regist(data.survey_cost_key_money,
										data.survey_cost_key_money_payment_type,
										data.survey_cost_key_money_invoice_business_type,
										data.survey_cost_key_money_invoice_registration_number,
										data)

			const check_other = this.check_invoice_regist(data.survey_cost_other,
										data.survey_cost_other_payment_type,
										data.survey_cost_other_invoice_business_type,
										data.survey_cost_other_invoice_registration_number,
										data)

			// console.log(check_parking_rent ,check_commission , check_key_money, check_other)
			return !(check_parking_rent && check_commission && check_key_money && check_other)

		}

	}
	// 適格事業者チェック
	check_invoice_regist(cost,payment_type,business_type,registration_number,data){
		let check = true;
		// console.log(cost,payment_type,business_type,registration_number,data)
		if(cost > 0){
			// 仕入先
			if(payment_type == 0){
				check = this.check_supplier_invoice_status(data);
			}else if(payment_type == 1){
				check = !(business_type==0 || business_type==null || business_type == 1 && !registration_number)
			}else{
				check = false
			}
		}
		return check;
	}

	check_supplier_invoice_status (data) {
		const business_type_check = !(data.supplier_invoice_business_type == null)
		const invoice_number_check = !(data.supplier_invoice_business_type == 0 || data.supplier_invoice_business_type == null || data.supplier_invoice_business_type == 1 && !data.supplier_invoice_registration_number)
		// console.log(business_type_check,invoice_number_check)
		return (business_type_check && invoice_number_check)
	}

	cell_details (row) {
		
		if(!this.state.data[row.index]){
			return ;
		}
		if(this.state.data[row.index].originalData == undefined){
			return ;
		}

		let {
			order_box_status,
			supplier_name,
			supplier_tel,
			supplier_tel2,
			survey_cost_parking_rent,
			survey_cost_total_amt,
			survey_commission_discount_amt,
			survey_cost_security_deposit,
			survey_key_money,
			estimate_natural_id,
			estimate_id,
			estimate_change_flag,
			order_start_date,
			order_end_date,
			order_capacity_qty,
			survey_available_start_date,
			survey_available_end_date,
			survey_capacity_qty,
			contact_memo,
			quote_available_start_date,
			quote_available_end_date,
			quote_capacity_qty,
			payment,
			quote_cost_total_amt
		} = this.state.data[row.index].originalData
		// let {
		// 	survey_account_user_lock_flag, // 調査担当者ロックフラグ
		// 	contract_user_lock_flag, // 契約担当者ロックフラグ
		// 	estimate_caution_flag,
		// 	estimate_emergency_flag,
		// 	estimate_exclusive_flag,
		// } = this.state.estimate_status[row.index].values
		let org_data = this.state.data[row.index].originalData;
		let pdf_check_list = this.state.data[row.index].pdf_check_list.values
		
		order_box_status = order_box_status?order_box_status:0;

		// console.log(order_box_status)
		let pdf_check_flag = false
		if ( order_box_status == 4 ) {
			pdf_check_flag = Object.values(pdf_check_list).find(check=>check==0)==undefined? true: false
		}

		let _CAL_payment_amt = 0
		
		let alert = "";
		if(payment && payment.length > 0 ){
			payment.forEach((p)=>{	
				// console.log(p);
				_CAL_payment_amt += p.payment_amt
			}) 
		}
		let data = this.state.data[row.index].originalData;

		let _CAL_const_amt = Definition.item('___SUM_all_amt', data)

		// console.log(_CAL_payment_amt,_CAL_const_amt)

		if(payment && payment.length > 0  && _CAL_payment_amt != _CAL_const_amt ||
			payment && payment.length == 0 || payment && payment.length == undefined ){
				if (data.order_box_status >= 4){
					alert = GetMessage(2539);
				}
		}		

		if (data.order_box_status == 5){
			// 実費専用項目
			if(data.survey_adjustment_amt != null && data.survey_adjustment_amt != ""){
				alert +=  "\n"+ GetMessage(2540)
			}

			// 上乗せ上限額確認
			const survey_parking_rent_profit = (data.request_type==3) 
			? 0 
			: ( 
				data.survey_parking_rent === null 
				? null
				: this.getNumberForCalculation(data.survey_parking_rent) - data.survey_cost_parking_rent 
			)
			if(data.upper_limit_additional_amt && (data.upper_limit_additional_amt < survey_parking_rent_profit)){
				alert +=  "\n"+  GetMessage(2541)
			}

			// 利益額確認
			const _CAL_profit_amt = data.quote_total_amt - data.quote_cost_total_amt
			if(_CAL_profit_amt < 0){
				alert +=  "\n"+  GetMessage(2542)
			}
		}

		/**
		 ・支払先が未設定（追加）
		・支払先が仕入先　かつ　仕入先マスターの適格事業者情報が未登録
		・支払先が仕入先　かつ　仕入先マスターが適格事業者　かつ　適格事業者番号が未登録の場合
		・支払先がその他　かつ　適格事業者　かつ　適格事業者番号が未登録の場合
		ただし
		仕入れ賃料、仕入れ手数料、仕入れ礼金すべて0の場合は対象外（追加）
		**/
		let invoice_not_set = this.check_invoice_status(data)
		// console.log("invoice_not_set",invoice_not_set);
		return (<>
		<Row>
			<Col md="6">
				{/* <div className="dt-col icons" style={{display:"block",position:"absolute"}}> */}
				<div className="dt-col icons">
					{this.button_defines(org_data,"見積依頼書")}
					{this.button_defines(org_data,"調査経路図")}
					{this.button_defines(org_data,"見積書")}
					{this.button_defines(org_data,"発注書")}
					{this.button_defines(org_data,"申込書")}
					{this.button_defines(org_data,"その他資料")}
					<br/>
					{this.button_defines(org_data,"受領請求書")}
					{this.button_defines(org_data,"確定見積書")}
					{this.button_defines(org_data,"受領区画図")}
					{this.button_defines(org_data,"提出区画図")}
					{this.button_defines(org_data,"顧客契約書")}
					{this.button_defines(org_data,"仕入契約書")}
				</div>
			</Col>
			<Col md="6">
				<Row>
					<Col md="6">
						{order_box_status == 3? (<Button onClick={()=>{this.handleClickRequestPayment(org_data)}}>支払依頼</Button>)
						: order_box_status == 4 || order_box_status == 5 ? (<Button onClick={()=>{this.handleClickRequestPayment(org_data)}}>支払金額修正</Button>)
						:(<Button disabled>支払依頼</Button>)}
					</Col>
					<Col md="6">
						{order_box_status <= 5 && (<>
						<Button onClick={()=>{this.handleClickLostOrder(org_data)}}>失注</Button>&nbsp;
						</>)}
						{this.button_apply_defines(org_data,pdf_check_flag,invoice_not_set)}
					</Col>
				</Row>
				<Row>
					<Col md="6"></Col>
					<Col md="6">{invoice_not_set && <font color="red">{GetMessage(2036)}</font>}</Col>
				</Row>
				<Row>
					<Col md="6" >
						{estimate_change_flag=="1"?(
							<>
								<span style={{color:"red"}}>注意、見積内容から変更あり<br />
								契約開始日 {Format.format_date_en(survey_available_start_date)} → {Format.format_date_en(order_start_date ? order_start_date : quote_available_start_date)}<br />
								契約終了日 {Format.format_date_en(survey_available_end_date)} → {Format.format_date_en(order_end_date ? order_end_date : quote_available_end_date)}<br />
								台数 {survey_capacity_qty}台 → {order_capacity_qty ? order_capacity_qty : quote_capacity_qty}台<br />
								</span>
							</>
						):""}
						{alert != "" ? (
							<>
								<span style={{color:"red",whiteSpace: "break-spaces"}}>{alert}<br /></span>
							</>
						):
						""}
						<Button 
							className={"juchu_confirm"}
							style={{marginTop: "100px"}}
							disabled={data.latest_pdf_quote_url!= null && data.latest_pdf_quote_url != ""}
							onClick={()=>{
								this.setState({
									dialogData:{
										values:data,
										from: 'juchu_confirm',
										errors:{},
										requiredData:{}
									}
								}, ()=>{
									this.dialogOrderConfirm.current.show()
								})
							}
						    
						}>受注確認</Button>
					</Col>
					<Col md="6" className={"contact_memo"}>
						顧客情報（下請先）<br />
						<div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', org_data)}} />
						{/* 顧客への連絡欄<br /> */}
						{/* <label>
							<Input type={"textarea"} value={contact_memo} disabled={true}></Input>
						</label>
						<br />
						<Button 
							className={"contact_memo"}
							onClick={()=>{
							this.setState({
								memoPopupData:{
									values:org_data,
									errors:{},
									requiredData:{}
								},
						},()=>{
							// this.dialogMessageToCustomerUser.current.show();
							this.memoPopup.current.show();
						})
						}}>顧客への連絡事項<br />（顧客システムの利用者へ通知します）</Button> */}
					</Col>
				</Row>
			</Col>
		</Row>
		{this.pdf_view(this.state.data[row.index].originalData, row.index)}
		</>
		)
	}

	button_apply_defines (data, pdf_check=false, invoice_not_set=false) {
		// console.log(data)
		switch (data.order_box_status) {
			case 0:
			case 1:
			case 2:
			case 3: {
				return (<Button disabled>申請</Button>)
			}
			case 4: {
				if (pdf_check == true && !invoice_not_set) {
					return (<Button onClick={()=>this.handleClickApply(data)}>申請</Button>)
				}
				else {
					return (<Button disabled>申請</Button>)
				}
			}
			case 5:{
				return (<Button onClick={()=>this.handleClickApproval(data)}>承認</Button>)
			}
			case 6:
			case 7:
			case 8:
			case 9: 
			case 10: {
				return (<Button disabled>承認</Button>)
			}
			default:
				return (<></>)
		}
	}

	button_defines (data,value) {
		const {order_box_status,
			   latest_pdf_purchase_order_url,
			   latest_pdf_application_form_url,
			   latest_pdf_supplier_invoice_url,
			   latest_pdf_survey_file_id,
			   latest_pdf_survey_url,
  	 		   latest_pdf_quote_url,
  			   latest_pdf_supplier_plotting_url,
			   quote_plotting_picture_url,
			   contract_pdf_url,
			   supplier_contract_pdf_url,
			   latest_pdf_route_file_id,
			   latest_pdf_route_url,
			   latest_pdf_plotting_url,
			   contract_receive_flag,
			   estimate_id,
			   special_agreement_flag,
			   special_agreement_datetime,
			   special_agreement_user_id,
			   application_form_upload_flag,
			   customer_request_file_flag,
			   invoice_process_status,
			   latest_pdf_plotting_request_status,
			   latest_plotting_picture_timestamp,
			   customer_system_use_flag,
			   latest_other_file_url
			  } = data;
		let file_icon = (<FontAwesomeIcon icon={faFileLines} />);
		let file_disabled_icon = (<FontAwesomeIcon icon={faFileLinesSolid} style={{color:"gray"}} />);
		let setIcon ;
		let setBtn;
		let setOptBtn;
		let setOpt2Btn;
		const ButtonWithRole = WithRole(Button, this.props.buttons, data)
		// console.log(data);
		// console.log(order_box_status,latest_pdf_purchase_order_url)
		switch(value){
			// 2023/07/25 見積依頼書ダウンロードボタンの追加
			case "見積依頼書":
				setIcon = customer_request_file_flag == 1 ?(<a style={{"cursor":"pointer"}} onClick={()=>this.clickCustomerRequestFile(data)}>{file_icon}</a>):file_disabled_icon;
			break;
			case "調査経路図":
				setIcon = latest_pdf_route_url != null && latest_pdf_route_url != "" ?this.pdf_url_define(latest_pdf_route_url,file_icon,value):file_disabled_icon;
			break;
			case "見積書":
				setIcon = latest_pdf_survey_url != null && latest_pdf_survey_url != "" ?this.pdf_url_define(latest_pdf_survey_url,file_icon,value):file_disabled_icon;
			break;
			case "発注書":
				setIcon = latest_pdf_purchase_order_url != null && latest_pdf_purchase_order_url != "" ?this.pdf_url_define(latest_pdf_purchase_order_url,file_icon,value):file_disabled_icon;
				switch(order_box_status){
					case 0:
					case 1:
					case 2:
						setBtn = (<Button size="sm" className={"btn-sm-new"} onClick={()=>{
						            // 工事番号が必須かチェック
									const isRequiredClient = data.construction_number_require_flag == 1 ? true : false;
									const requiredAlert = isRequiredClient&&!data.construction_number
									if(requiredAlert){
 			 						  document.body.style.overflow = "auto";
									  this.props.alertModal.current.confirmCheck({
										messageNo:2414,
									  },() => {
										this.props.alertModal.current.toggleErrorModal();
									  }, false);
									  return;
									}
									this.setState({
										dialogData:{
										values:data,
										errors:{},
										requiredData:{}
									  }
									}, ()=>{
									  this.dialogUploadPurchaseOrder.current.show()
									})
							}}>内容確認</Button>);
						break;
				}
			break;
			case "申込書":
				setIcon = latest_pdf_application_form_url!= null && latest_pdf_application_form_url != "" ?this.pdf_url_define(latest_pdf_application_form_url,file_icon,value,"",application_form_upload_flag):file_disabled_icon;;
				switch(order_box_status){
					case 0:
					case 1:
					case 2:
					case 3:
					case 4:
					case 5:
						setBtn = (<Button size="sm"
							className={"btn-sm-new"}
							disabled={application_form_upload_flag == 1 ? true: false} 
						    onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
							  this.dialogCreateApplication.current.show()
							})
						}}>作成</Button>);
						setOptBtn = (<Button size="sm" className={"btn-sm-new"} onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
							  this.dialogUploadFileApplicationForm.current.show()
							})
						}}>ｱｯﾌﾟﾛｰﾄﾞ</Button>);
						break;
				}
			break;
			case "その他資料":
				setIcon = latest_other_file_url!= null && latest_other_file_url != "" ?this.pdf_url_define(latest_other_file_url,file_icon,value,"",application_form_upload_flag):file_disabled_icon;
				setBtn = (<Button size="sm" className={"btn-sm-new"}
					disabled={customer_system_use_flag != 1}
					onClick={()=>{
					this.setState({
						dialogData:{
						values:data,
						errors:{},
						requiredData:{}
					  }
					}, ()=>{
					  this.dialogUploadFileOther.current.show()
					})
				}}>ｱｯﾌﾟﾛｰﾄﾞ</Button>);
			break;
			case "受領請求書":
				setIcon = latest_pdf_supplier_invoice_url!= null && latest_pdf_supplier_invoice_url != "" ?this.pdf_url_define(latest_pdf_supplier_invoice_url,file_icon,value):file_disabled_icon;;
				switch(order_box_status){
					case 0:
					case 1:
					case 2:
					case 3:
					case 4:
					case 5:
						setBtn = (<Button size="sm" className={"btn-sm-new"} onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
							  this.dialogUploadFileInvoice.current.show()
							})
						}}>ｱｯﾌﾟﾛｰﾄﾞ</Button>);
						break;
				}
			break;
			case "確定見積書":
				setIcon = latest_pdf_quote_url!= null && latest_pdf_quote_url != "" ?this.pdf_url_define(latest_pdf_quote_url,file_icon,value,contract_pdf_url):file_disabled_icon;;
				let disabled;
				let send_disabled;
				let sp_disabled;
				send_disabled = quote_plotting_picture_url == null || latest_pdf_supplier_invoice_url == null || latest_pdf_supplier_invoice_url == "" ? true : false ;
				sp_disabled = latest_pdf_quote_url == null || latest_pdf_plotting_url == null ? true : false ;

				switch(order_box_status){
					// case 0:
					// case 1:

					// break;
					case 2:
						disabled = latest_pdf_application_form_url == null || latest_pdf_application_form_url =="" ? order_box_status==2?true:false : false ;
						setBtn = (<Button size="sm"
							className={"btn-sm-new"}
							disabled={disabled}
							onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
								}
							}, ()=>{
								// console.log(this.state.dialogData);
								this.dialogOrderConfirm.current.show()
							})
						}}>作成</Button>);
					break;
					case 3:
					case 4:
						setOptBtn = special_agreement_flag == "1" ?(
							<Button size="sm" 
									className={"btn-sm-new"}
									disabled={sp_disabled}
									onClick={()=>{
									this.setState({
										dialogData:{
										values:data,
										errors:{},
										requiredData:{}
									  }
									}, ()=>{
										this.dialogSendApproval.current.show()
									})
								}}>送信</Button>
						):(
							<ButtonWithRole size="sm"
									className={"special_btn btn-sm-new"}
									button_id={"BTN_D2_01_02060"}
									disabled={sp_disabled}
									onClick={
										()=>{this.execSpecialAgreement(data)}
									}>特別承認</ButtonWithRole>
		
						);

					case 5:
						
						setBtn = (<Button size="sm"
							className="btn-sm-new"
						    onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
								// console.log(this.state.dialogData);
								this.dialogOrderConfirm.current.show()
							})
						}}>作成</Button>);

						break;
					case 6:
						setOptBtn = ""
						setBtn = (<Button size="sm" 
							className="btn-sm-new"
							disabled={send_disabled}
							onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
								this.dialogSendQuote.current.show()
							})
						}}>送信</Button>);
						break;
					case 7:
					case 8:
					case 9:
					case 10:
						// 請求ステータスが未処理または請求依頼済の場合活性
						// #1918
						// disabled = !(invoice_process_status == 0 || invoice_process_status == 1);
						// #1732
						setBtn = (<Button size="sm"
							className={"btn-sm-new"}
							// disabled={disabled}// #1918
							onClick={() => {
								this.setState({
									dialogData: {
										values: data,
										errors: {},
										requiredData: {}
									}
								}, () => {
									// console.log(this.state.dialogData);
									this.dialogOrderConfirm.current.show()
								})
							}}>区画番号変更</Button>);
						break;
				}
				break;
			case "受領区画図":
				setIcon = latest_pdf_supplier_plotting_url!= null && latest_pdf_supplier_plotting_url != "" ?this.pdf_url_define(latest_pdf_supplier_plotting_url,file_icon,value):file_disabled_icon;;
				setBtn = (<Button size="sm" className="btn-sm-new" onClick={()=>{
					this.setState({
						dialogData:{
						values:data,
						errors:{},
						requiredData:{}
					  }
					}, ()=>{
						this.dialogUploadBlockMap.current.show()
					})
					}}>ｱｯﾌﾟﾛｰﾄﾞ</Button>);
				break;
			case "提出区画図":
				setIcon = latest_pdf_plotting_url!= null && latest_pdf_plotting_url != "" ?this.pdf_url_define(latest_pdf_plotting_url,file_icon,value):file_disabled_icon;;
				switch(order_box_status){
					case 0:
					case 1:
					case 2:
					case 3:
					case 4:
					case 5:
					case 6:

						setOptBtn = quote_plotting_picture_url!= null && quote_plotting_picture_url != "" ? (
							<a className={"download_btn"} target='_blank' 
							href={GoogleDrive.getDownloadUrl(quote_plotting_picture_url, `区画図_${moment().format("YYYYMMDDHHmmss")}`)}>
								<Button size="sm" className="btn-sm-new">提出区画図<br />のﾀﾞｳﾝﾛｰﾄﾞ</Button>							
							</a>
							) : "";
						setOpt2Btn = latest_pdf_plotting_request_status == 3  && // 提出区画図依頼ステータスがアップロード済み
							latest_plotting_picture_timestamp != null ? ( // 提出区画図アップロード日時が存在する（表示用）
							<><Button size="sm" className="btn-sm-new" onClick={()=>{
								this.setState({
									dialogData:{
									values:data,
									errors:{},
									requiredData:{}
								  }
								}, ()=>{
									this.dialogSubmissionBlockMapReport.current.show()
								})
								}}>帳票区画図<br />作成</Button>
							<br />
							ｱｯﾌﾟﾛｰﾄﾞされました<br />{Format.format_datetime_mmdd_hhmm(latest_plotting_picture_timestamp)}</>
							) : "";
						setBtn = (<Button size="sm" className="btn-sm-new" onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
								this.dialogSubmissionBlockMap.current.show()
							})
							}}>作成した区画図<br />のｱｯﾌﾟﾛｰﾄﾞ</Button>);
						// console.log(latest_pdf_supplier_plotting_url);
						break;
				}
			break;
			case "顧客契約書":
				setIcon = contract_receive_flag == "1"?this.pdf_url_define(estimate_id,file_icon,value):file_disabled_icon;;
				switch(order_box_status){
					case 7:
					case 8:
					case 9:
						setBtn = (<Button size="sm" className="btn-sm-new" onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
								this.dialogUploadFileCustomerContract.current.show()
							})						
							}}>ｱｯﾌﾟﾛｰﾄﾞ</Button>);
						break;
				}
			break;
			case "仕入契約書":
				setIcon = supplier_contract_pdf_url!= null && supplier_contract_pdf_url != "" ?this.pdf_url_define(supplier_contract_pdf_url,file_icon,value):file_disabled_icon;;
				switch(order_box_status){
					case 7:
					case 8:
					case 9:
						setBtn = (<Button size="sm" className="btn-sm-new" onClick={()=>{
							this.setState({
								dialogData:{
								values:data,
								errors:{},
								requiredData:{}
							  }
							}, ()=>{
								this.dialogUploadFileContract.current.show()
							})						
							}}>ｱｯﾌﾟﾛｰﾄﾞ</Button>);
						break;						
				}
			break;
		}

		return (
			<>
				<div style={{width:"110px",display:"table-cell",textAlign:"center"}}>
					<div>{setIcon}</div>
					<div>{value}</div>
					{setBtn}<br />
					{setOptBtn}<br />
					{setOpt2Btn}
				</div>					
			</>					
		)				



	}

	// 特別承認実行
	execSpecialAgreement(data){
		// 承認を実行しますか？
		let messageNo = 2529
		document.body.style.overflow = "auto";
		this.props.alertModal.current.confirmCheck({messageNo},()=>{
			const url = "/api/order_box/special_agreement/"+data.estimate_ulid
			const params = {...data}
			Request.put(url, params,
			res => {
				if(res.Code === 200) {
				this.search()
				}
			}
			)
		})
	}

	viewShpeadSheetQuote(latest_pdf_quote_url,contract_pdf_url){
		// console.log(latest_pdf_quote_url);
		// console.log(contract_pdf_url);
		
		if(latest_pdf_quote_url!= null && latest_pdf_quote_url != "" ){
			window.open(`https://drive.google.com/open?id=`+latest_pdf_quote_url);			
		}
		if(contract_pdf_url!= null && contract_pdf_url != "" ){
			window.open(`https://drive.google.com/open?id=`+contract_pdf_url);			
		}
		return ;
	}
	viewConstract(estimate_id){
		// ファイル情報取得
		// 捺印済みをﾀﾞｳﾝﾛｰﾄﾞ
		Request.get('/api/cufile', { ref_id : estimate_id, file_type : 5, file_detail_type : 502 }, res => {
			if(res.Code == 200){
				res.Data.map((file, index) => {
					window.open(`/api/gcs_download/${file.file_path}?d=${file.file_name}`);
				})		
			}
		})
	}

	pdf_url_define (url,icon,value,sub_url="",application_form_upload_flag=""){
		switch(value){
			case "見積書":
			case "調査経路図":
			case "提出区画図":
				return (<a href={`https://drive.google.com/open?id=${url}`} target="_blank">{icon}</a>)
			break;
			case "その他資料":
				return (<a href={`${url}`} target="_blank">{icon}</a>)
			break;
			case "申込書":
				// console.log(application_form_upload_flag)
				if(application_form_upload_flag == 0){
					return (<a href={`https://drive.google.com/open?id=${url}`} target="_blank">{icon}</a>)
				}else{
					return (<a href={`/api/gcs_download/${url}?d=${value}_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">{icon}</a>)
				}
			break;

			case "確定見積書":
				return (<a style={{"cursor":"pointer"}} onClick={()=>this.viewShpeadSheetQuote(url,sub_url)}>{icon}</a>)
			break;
			case "顧客契約書":
				return (<a style={{"cursor":"pointer"}} onClick={()=>this.viewConstract(url)}>{icon}</a>)
			break;
			case "受領請求書":
			case "発注書":
			case "受領区画図":
			case "仕入契約書":
				return (<a href={`/api/gcs_download/${url}?d=${value}_${moment().format("YYYYMMDDHHmmss")}&extension=true`} target="_blank">{icon}</a>)
			break;
		}
	}
	clickCustomerRequestFile(prop){
		this.setState({
			dialogCustomerRequestFileData:{
				...this.state.dialogCustomerRequestFileData,
				values:prop,
			}
		}, () => { this.dialogCustomerRequestFile.current.show() })
	}
	
	dialog_defines () {
		return (<>
			<DialogEstimateMemo 
				ref={this.dialogEstimateMemo} 
				{...this.props}
				estimate_id={this.state.estimate_id}
				estimate_natural_id={this.state.estimate_natural_id}
				landmark_user={this.state.landmark_user}
				positive={true}
				refreshCallback={this.search}
			/>
			<DialogUploadPurchaseOrder 
				ref={this.dialogUploadPurchaseOrder} 
				{...this.props}
				data={this.state.dialogData}
				positive={true}
				positive_label={"内容確認"}
				refreshCallback={this.search}
			/>
			<DialogCreateApplication 
				ref={this.dialogCreateApplication} 
				{...this.props}
				positive={true}
				positive_label={"作成"}
				data={this.state.dialogData}
				refreshCallback={()=>this.search(true)}
			/>
			<DialogUploadFileOther
				ref={this.dialogUploadFileOther} 
				{...this.props}
				positive={true}
				positive_label={"アップロード"}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogUploadFileInvoice
				ref={this.dialogUploadFileInvoice} 
				{...this.props}
				positive={true}
				positive_label={"アップロード"}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogOrderConfirm
				ref={this.dialogOrderConfirm} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={()=>this.search(true)}
			/>
			<DialogSendQuote
				ref={this.dialogSendQuote} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogSendApproval
				ref={this.dialogSendApproval} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>			

			<DialogUploadBlockMap
				ref={this.dialogUploadBlockMap} 
				{...this.props}
				positive={true}
				positive_label={"保存"}
				data={this.state.dialogData}
				refreshCallback={()=>this.search(true)}
			/>
			<DialogSubmissionBlockMap
				ref={this.dialogSubmissionBlockMap} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogSubmissionBlockMapReport
				ref={this.dialogSubmissionBlockMapReport} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogUploadFileContract
				ref={this.dialogUploadFileContract} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogUploadFileCustomerContract
				ref={this.dialogUploadFileCustomerContract} 
				{...this.props}
				positive={true}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			<DialogLostOrder
				ref={this.dialogLostOrder} 
				{...this.props}
				data={this.state.dialogData}
				landmark_user={this.state.landmark_user}
				positive={true}
				refreshCallback={()=>this.search(true)}
			/>
			{/* <DialogMessageToCustomerUser
				ref={this.dialogMessageToCustomerUser} 
				{...this.props}
				data={this.state.dialogData}
				landmark_user={this.state.landmark_user}
				positive={true}
				refreshCallback={()=>this.search()}
			/> */}
			
			<MemoPopup 
				ref={this.memoPopup} 
				data={this.state.memoPopupData} 
				positive={true}
				updateMemo = {(data) => this.updateMemoForCustomer(data)}
				{...this.props}
			/>

			<AddMemoPopup 
				ref={this.addMemoPopup} 
				data={this.state.addMemoPopupData} 
				positive={true}
				updateMemo = {(data, isOrderMemo) => this.updateMemo(data, isOrderMemo)}
				{...this.props}
				name={this.state.addMemoPopupData.isOrderMemo ? "ESTIMATE__order_memo" : "ESTIMATE__supplier_memo"}
			/>
			<DialogUploadFileApplicationForm
				ref={this.dialogUploadFileApplicationForm} 
				{...this.props}
				positive={true}
				positive_label={"アップロード"}
				data={this.state.dialogData}
				refreshCallback={this.search}
			/>
			{/* 2023/07/25 見積依頼書ダウンロードモーダル */}
			<DialogCustomerRequestFileDownload
				ref={this.dialogCustomerRequestFile}
				data={this.state.dialogCustomerRequestFileData}
				positive={false}
				negative_label="閉じる"
				//refreshCallback={this.search}
			/>

		</>)
	}
	search_field_cols(){
		return (<>
			<Col md="3">
				<InputSelect label="ランドマーク支店"
				name="PROJECT__user_branch_natural_id"
				labelOn={true} 
				validateCallback={this.validateCallback} 
				options={this.state.landmark_user_branch}
				enterSearch={true}
				enterCallback={this.searchWithPageIndex}
				rootData={this.state.searchData} />
			</Col>
			<Col md="3">
				<InputText
				label='見積ID'
				name='ESTIMATE__estimate_natural_id'
				labelOn={true}
				validateCallback={this.validateCallback}
				enterCallback={this.searchWithPageIndex}
				enterSearchFlag={true}
				rootData={this.state.searchData}
				validateType={'search'}
				/>
			</Col>
			<Col md="3">
				<InputText
				label='顧客担当者TEL'
				name='CUSTOMER_BRANCH__customer_tel'
				labelOn={true}
				validateCallback={this.validateCallback}
				enterCallback={this.searchWithPageIndex}
				enterSearchFlag={true}
				rootData={this.state.searchData}
				validateType={'search'}
				/>
			</Col>
		</>)
	}
	detail_search_field_cols(){
		return (<>
          <Col md="3">
          <FormGroup>
            <InputSelect label="調査担当者"
              name="REQUEST__web_survey_account"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              options={this.state.landmark_user}
			  isSearchable={true}
              enterSearch={true}
              enterCallback={this.searchWithPageIndex}
              rootData={this.state.searchData} />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputCheckBox label="調査担当者が設定されていないデータ"
              name="REQUEST__web_survey_account_none"
			  labelOn={false} 
              validateCallback={this.validateCallback} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
			/>
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputSelect label="発注担当者"
              name="ESTIMATE__contract_user_id"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              options={this.state.landmark_user}
			  isSearchable={true}
              enterSearch={true}
              enterCallback={this.searchWithPageIndex}
              rootData={this.state.searchData} />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputCheckBox label="発注担当者が設定されていないデータ"
              name="ESTIMATE__contract_user_id_none" 
			  labelOn={false} 
              validateCallback={this.validateCallback} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
			/>
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputSelect label="仕入担当者"
              name="ESTIMATE__payment_user_id"
              labelOn={true} 
              validateCallback={this.validateCallback} 
              options={this.state.landmark_user}
			  isSearchable={true}
              enterSearch={true}
              enterCallback={this.searchWithPageIndex}
              rootData={this.state.searchData} />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputCheckBox label="仕入担当者が設定されていないデータ"
              name="ESTIMATE__payment_user_id_none" 
			  labelOn={false} 
              validateCallback={this.validateCallback} 
              checkedValue={1}
              uncheckedValue={0}
              rootData={this.state.searchData}
			/>
          </FormGroup>
          </Col>
          <Col md="3">
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='現場名'
              name='PROJECT__site_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
          <InputSelect
            label="顧客会社名"
            labelOn={true}
            name="CUSTOMER__customer_ulid"
            options={this.state.customerList}
            validateCallback={this.validateCallback} 
            validateType='search'
            rootData={this.state.searchData}
            isSearchable={true}
            isCreatable={true}
            searchStartLength={2}
          />
          </FormGroup>
          </Col>
          <Col md="3">
          <InputSelect
            label="顧客支店名"
            labelOn={true}
            key={`customer_branch_${this.state.searchData.values.customer_customer_ulid}`}
            name="CUSTOMER_BRANCH__customer_branch_ulid"
            options={this.state.customerBranchList}
            validateCallback={this.validateCallback} 
            validateType='search'
            rootData={this.state.searchData}
            isSearchable={true}
            isCreatable={true}
          />
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='現場所在地（市区町村）'
              name='PROJECT__site_city'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='現場所在地（町名以降）'
              name='PROJECT__site_address'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先名'
              name='ESTIMATE__supplier_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='仕入先TEL'
              name='ESTIMATE__supplier_tel'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場名'
              name='ESTIMATE__survey_parking_name'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='工事番号'
              name='PROJECT__construction_number'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場所在地（市区町村）'
              name='ESTIMATE__survey_parking_city'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputText
              label='駐車場所在地（町名以降）'
              name='ESTIMATE__survey_parking_address'
              labelOn={true}
              validateCallback={this.validateCallback}
              enterCallback={this.searchWithPageIndex}
              enterSearchFlag={true}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出期限（FROM）'
              name='REQUEST__estimate_deadline_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出期限（TO）'
              name='REQUEST__estimate_deadline_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（FROM）'
              name='REQUEST__request_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='依頼受付日（TO）'
              name='REQUEST__request_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出日（FROM）'
              name='REQUEST__first_estimate_send_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='見積提出日（TO）'
              name='REQUEST__first_estimate_send_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約開始日（FROM）'
              name='ESTIMATE__quote_available_start_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約開始日（TO）'
              name='ESTIMATE__quote_available_start_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約終了日（FROM）'
              name='ESTIMATE__quote_available_end_date_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='契約終了日（TO）'
              name='ESTIMATE__quote_available_end_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
		  
		  {/* #1732 */}
		   <Col md="3">
          <FormGroup>
            <InputDatetime
              label='確定見積送付日（FROM）'
              name='ESTIMATE__quote_estimate_senddate_from'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
          <Col md="3">
          <FormGroup>
            <InputDatetime
              label='確定見積送付日（TO）'
              name='ESTIMATE__quote_estimate_senddate_date_to'
              labelOn={true}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              validateType={'search'}
            />
          </FormGroup>
          </Col>
		</>)
	}
	// 2022-10-25
	search_field_optional_cols () {
		return(<>
			<Col md="3" style={{lineHeight:"3rem",textAlign:"center"}}>
				チェックした案件に設定する発注担当者：
			</Col>
			<Col md="3" style={{margin:"auto 0"}}>
				<InputSelect
					label="担当者"
					labelOn={false} 
					name="ESTIMATE__contract_user_id"
					validateCallback={this.validateBulkData} 
					options={this.state.landmark_user}
					rootData={this.state.bulkData}
					isSearchable={true}
				/>
			</Col>
			<Col md="4">
				<Button onClick={()=>this.updateCheckData("ESTIMATE__contract_user_id")}>一括変更</Button>
			</Col>
			<Col md="3" style={{lineHeight:"3rem",textAlign:"center"}}>
				チェックした案件に設定する仕入担当者：
			</Col>
			<Col md="3" style={{margin:"auto 0"}}>
				<InputSelect
					label="担当者"
					labelOn={false} 
					name="ESTIMATE__payment_user_id"
					validateCallback={this.validateBulkData} 
					options={this.state.landmark_user}
					rootData={this.state.bulkData}
					isSearchable={true}
				/>
			</Col>
			<Col md="4">
				<Button onClick={()=>this.updateCheckData("ESTIMATE__payment_user_id")}>一括変更</Button>
			</Col>
		</>);
	}
	updateCheckData (dataType) {

		let keys = dataType.split("__");
		let p = keys[0];
		let col = keys[1];
		let {values} = this.state.bulkData;

		const payment_flag = col == "payment_user_id"?true:false;
		let messageNo = 2999;
		let payment_user_lock_count = 0;
		let contract_user_lock_count = 0;


    //2531: "選択した案件に発注担当者ロックされている案件が含まれているため、変更することはできません。",
    //2532: '変更する発注担当者が選択されていません。担当者を選択して実行してください。',
    //2533: '案件の発注担当者を変更しますがよろしいですか?',
	
    //2534: "選択した案件に仕入担当者ロックされている案件が含まれているため、変更することはできません。",
    //2535: '変更する仕入担当者が選択されていません。担当者を選択して実行してください。',
    //2536: '案件の仕入担当者を変更しますがよろしいですか?',


		if (col in values){}else{
				messageNo = payment_flag?2535:2532
				this.props.alertModal.current.showErrorModal({messageNo});
				return 
		}

		if (col in values && this.state.checkedItems.length > 0) {
			let landmark_user_id = values[col];
			let estimates = this.state.checkedItems.map(item=>{
				// console.log(item);
				return item.originalData
			});
			
			estimates.map(item=>{
				if (item.payment_user_lock_flag == 1){
					payment_user_lock_count += 1;
				}
				if (item.contract_user_lock_flag == 1){
					contract_user_lock_count += 1;
				}
			})
			//2518: 選択した依頼に調査担当者ロックされている依頼が含まれているため、登録することはできません。
			if (col == "payment_user_id" && payment_user_lock_count > 0) {
				messageNo = 2534
				this.props.alertModal.current.showErrorModal({messageNo});
				return 
			} 

			if (col == "contract_user_id" && contract_user_lock_count > 0) {
				messageNo = 2531
				this.props.alertModal.current.showErrorModal({messageNo});
				return 
			} 
			messageNo =payment_flag?2536:2533
			this.props.alertModal.current.confirmCheck({messageNo},()=>{
				Request.put("/api/order_box/bulk_update/"+col,{landmark_user_id:landmark_user_id,estimates:estimates},(res)=>{
					this.search(false, true);
				});
			});
		} else {
			messageNo = 2524
			this.props.alertModal.current.showErrorModal({messageNo});
				return 
		}
	}
	updateMemo(data, isOrderMemo){
		const url = '/api/estimate/memo/'+data.estimate_ulid
		const params = {
		  ...data,
		  isOrderMemo,
		  login_user: localStorage.getItem("name")
		}
		Request.put(url, params, (res)=>{
		  this.search(); 
		})
	  }
	async validateCallback(newData, callback=()=>{}){
		if(newData.values.customer_name != undefined || newData.values.customer_ulid != undefined){
			const customerParam = (this.state.customerList.findIndex(customer=>customer.value==newData.values.customer_ulid)>-1)
			? {
			  customer_ulid: newData.values.customer_ulid,
			  customer_name: undefined
			} : {
			  customer_ulid:undefined,
			  customer_name: (newData.values.customer_ulid != undefined)?newData.values.customer_ulid:newData.values.customer_name
			}
		//    console.log(customerParam, newData);
			const customerBranchList = this.state.searchData.values.customer_ulid!=customerParam.customer_ulid
			? (customerParam.customer_ulid
			  ? await new Promise(resolve=>{
				Request.get("/api/customer/branch",{
				  customer_ulid:customerParam.customer_ulid,
				  customer_branch_delete_flag : 1
				}, res => {
				  resolve(res.Data.map(element=>{
					return {
					  value:element.ulid,
					  label:element.customer_branch_name
					}
				  })) 
				})
			  })
			  : [])
			: this.state.customerBranchList
			const customerBranchParam = this.state.searchData.values.customer_ulid==customerParam.customer_ulid
			? (customerBranchList.findIndex(customer=>customer.value==newData.values.customer_branch_ulid)>-1)
			  ? {
				customer_branch_ulid: newData.values.customer_branch_ulid,
				customer_branch_name: undefined
			  }
			  : {
				customer_branch_ulid: undefined,
				customer_branch_name: (newData.values.customer_branch_ulid != undefined)? newData.values.customer_branch_ulid:newData.values.customer_branch_name
			  }
			: {
			  customer_branch_ulid: undefined,
			  customer_branch_name: undefined
			}
			
			this.setState({
			  searchData:{
				...this.state.searchData,
				...newData,
				values:{
					...this.state.searchData.values,
					...newData.values,
					...customerParam,
					...customerBranchParam
				}
			  },
			  customerBranchList
			}, ()=>callback())
		}else{
			this.setState({
				searchData:{
				  ...this.state.searchData,
				  ...newData,
				  values:{
					  ...this.state.searchData.values,
					  ...newData.values,
				  }
				},
			  }, ()=>callback())
		}

	}
	validEstimateAccount (index, newData) {
		let {
			values: prevValues
		} = this.state.estimate_status[index]
		let {
			values
		} = newData
		let {
			originalData
		} = this.state.data[index]

		let updateKey = null
		Object.keys(values).forEach(key=>{
			if (values[key] != prevValues[key]) {
				updateKey = key
			}
		})

		if ( updateKey != null ) {
			Request.put(
				"/api/order_box/status/"+originalData.estimate_ulid,
				{
					[updateKey]: values[updateKey],
					request:"estimate_status",
					request_ulid:originalData.request_ulid,
					estimate_ulid:originalData.estimate_ulid
				},
				res=>{
	//				console.log(res);
					this.search();
			})
		}

/*
		console.log(newData);
		this.setState({
			estimate_status: this.state.estimate_status.map((ed,n)=>{
								if (index == n) {
									let {
										estimate_exclusive_flag,
										payment_user_id,
										contract_user_id,
										web_survey_account
									} = newData.values
									return {
										...newData,
										errors: estimate_exclusive_flag&&contract_user_id==null&&web_survey_account==null&&payment_user_id==null?{
											contract_user_id: [GetMessage(2515)],
											payment_user_id: [GetMessage(2515)],
										}:{}
									}
								}
								return ed
							})
		},()=>{
			console.log(this.state.estimate_status[index]);
		});
*/
	}
	validateBulkData (newData, callback=()=>{}) {
		this.setState({
			bulkData:{
			  ...this.state.bulkData,
			  ...newData,
			  values:{
				  ...this.state.bulkData.values,
				  ...newData.values,
			  }
			}
		  }, ()=>callback())
	}
	registEstimateStatus (index) {
		if (Object.keys(this.state.estimate_status[index].errors).length>0) {
			alert(Object.values(this.state.estimate_status[index].errors)[0]);
			return
		}
		// ここから登録処理
		let newData = {}
		let uploadData = this.state.estimate_status[index].values
		let {originalData} = this.state.data[index]
		var editData = false

		// 更新データの確認
		Object.keys(uploadData).forEach(k=>{
			if ( k in originalData && uploadData[k] != originalData[k] ) {
				editData = true
				newData[k] = uploadData[k]
			}
		})
		if (editData) {
			Request.put(
				"/api/order_box/status/"+originalData.estimate_ulid,
				{...newData,
					request:"estimate_status",
					request_ulid:originalData.request_ulid,
					estimate_ulid:originalData.estimate_ulid
				},
				res=>{
//				console.log(res);
					this.props.alertModal.current.confirmCheck({
						title: "更新が完了しました。",
						messageNo: 2527,
						closeBtn: false
					}, ()=>{
						this.search();
					}, false)
				})
		}
//		console.log(editData);
	}
	registEstimateStatusOnHold (index) {
		let {originalData} = this.state.data[index]
		// console.log(originalData.order_box_status)
		if (originalData.order_box_status != 1) {
			Request.put(
				"/api/order_box/status/"+originalData.estimate_ulid,
			{
				...originalData,
				request:"box_status",
				order_box_status:1,
			},
			res=>{
//				console.log(res);
				this.props.alertModal.current.confirmCheck({
					title: "更新が完了しました。",
					messageNo: 2527,
					closeBtn: false
				}, ()=>{
					this.search();
				}, false)
			})
		}
	}
	updateOrderBoxStatus (data, status) {
		let message = `ステータスを「${FormatCode.decode("cst_order_box_status",status)}BOX」に変更します。<br />よろしいですか？`

		this.props.alertModal.current.confirmCheck({
			message:message,
			title:"更新確認"
		},()=>{

			Request.put(
				"/api/order_box/status/"+data.estimate_ulid,
			{
				...data,
				request:"box_status",
				order_box_status:status,
			},
			res=>{
	//				console.log(res);
				// this.props.alertModal.current.confirmCheck({
				// 	title: "更新が完了しました。",
				// 	messageNo: 2527,
				// 	closeBtn: false
				// }, ()=>{
					this.search(true);
				// }, false)
			})	

		})

	}
	box_status_button_defines(data) {
		// console.log(data)
		switch (data.order_box_status) {
			case 0: {
				return(<>
					<Button size="sm" onClick={()=>this.updateOrderBoxStatus(data,1)}>
						保留BOXへ
					</Button>
				</>)
			}
			case 1: {
				return(<>
					<Button size="sm" onClick={()=>this.updateOrderBoxStatus(data,0)}>
						未着手BOXへ
					</Button>
				</>)
			}
			case 5: {
				return(<>
					<Button size="sm" onClick={()=>this.updateOrderBoxStatus(data,4)}>
						チェックBOXへ
					</Button>
				</>)
			}			
			case 8: {
				const now = new Date();
				const buf = moment(now);
				const basic_contract_signing_date = data.basic_contract_signing_date ? moment(data.basic_contract_signing_date) : undefined
				// console.log(moment(data.basic_contract_signing_date),buf,basic_contract_signing_date <= buf)

				return(<>
					<Button size="sm" onClick={()=>this.updateOrderBoxStatus(data,9)}>
						調整中BOXへ
					</Button>
					{
						(data.supplier_contract_pdf_url != null && parseInt(data.contract_receive_flag) == 1 || 
						(basic_contract_signing_date != undefined && basic_contract_signing_date <= buf && data.supplier_contract_pdf_url != null)) &&(
						<Button size="sm" onClick={()=>this.updateOrderBoxStatus(data,10)}>
							チェックOK
						</Button>
						)
					}
				</>)
			}
			case 9: {
				return(<>
					<Button size="sm" onClick={()=>this.updateOrderBoxStatus(data,8)}>
						チェック待ちBOXへ
					</Button>
				</>)
			}
			default:
				return(<></>)
		}
	}
	toggleEstimateMemo (data) {
		let {
			estimate_id,
			estimate_natural_id,
		} = data
		this.setState({
			estimate_id,
			estimate_natural_id,
		},()=>{
			// console.log(this.state.estimate_id,this.state.estimate_natural_id);
			this.dialogEstimateMemo.current.show()
		});
	}
	toggleEstimateHistory (estimate_id) {
		this.setState({
			estimate_id
		},()=>{
			
		});
	}
	// 支払い依頼リクエスト
	handleClickRequestPayment (data) {
		let {estimate_natural_id} = data
		let url = "/requestpayment/parking/add/" + estimate_natural_id
		this.props.history.push({
			pathname:url,
			transition_source:this.props.location.pathname
		})
	}
	// 失注リクエスト
	handleClickLostOrder (data) {
		this.setState({
			dialogData:{
				values:data,
				errors:{},
				requiredData:{}
			}
		},()=>{
			this.dialogLostOrder.current.show()
		})
	}

	//顧客メモ登録
	updateMemoForCustomer(data){

		let { estimate_ulid, contact_memo } = data

		// 無効な文字列
		const max_length_validate = Validate.length(contact_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
			this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}

		Request.put(
		"/api/order_box/status/" + estimate_ulid,
		{
			request: "estimate_details",
			contact_memo
		},
		res=>{
			document.body.style.overflow = "auto";
//				console.log(res);
			this.props.alertModal.current.confirmCheck({
				title: "更新が完了しました。",
				messageNo: 2527,
				closeBtn: false
			}, ()=>{
//				this.memoPopup.current.toggleModal();
				this.search();
			}, false)
		})
	}

	getNumberForCalculation(number){
		return isNaN(parseInt(number)) ? 0 : parseInt(number)
	}    

	// 申請リクエスト
	handleClickApply (data) {
		// console.log(data)
		let error_message = [];
		let alert_message = [];

		// 提出区画図の確認
		if(data.latest_pdf_plotting_url == null || data.latest_pdf_plotting_url == ""){
			error_message.push(2537)
		}

		if(data.latest_pdf_supplier_invoice_url == null || data.latest_pdf_supplier_invoice_url == ""){
			error_message.push(2538)
		}

		// 実費専用項目
		if(data.survey_adjustment_amt != null && data.survey_adjustment_amt != ""){
			alert_message.push(2540)
		}

		// 上乗せ上限額確認
		const survey_parking_rent_profit = (data.request_type==3) 
		? 0 
		: ( 
			data.survey_parking_rent === null 
			? null
			: this.getNumberForCalculation(data.survey_parking_rent) - data.survey_cost_parking_rent 
		)
		if(data.upper_limit_additional_amt && (data.upper_limit_additional_amt < survey_parking_rent_profit)){
			alert_message.push(2541)
		}

		// 利益額確認
		const _CAL_profit_amt = data.quote_total_amt - data.quote_cost_total_amt
		if(_CAL_profit_amt < 0){
			alert_message.push(2542)
		}
		
		//支払額確認
		let _CAL_payment_amt = 0
		if(data.payment && data.payment.length > 0 ){
			data.payment.forEach((p)=>{	
				// console.log(p);
				_CAL_payment_amt += p.payment_amt
			}) 
		}

		// 仕入先からの請求額
		let _CAL_const_amt = Definition.item('___SUM_all_amt', data)

		// console.log(_CAL_payment_amt,data.quote_cost_total_amt)

		if(data.payment && data.payment.length > 0  && _CAL_payment_amt != _CAL_const_amt ||
			data.payment && data.payment.length == 0 || data.payment && data.payment.length == undefined ){
			error_message.push(2539)
		}		

		// エラー
		if(error_message.length > 0){

			this.props.alertModal.current.confirmCheck({
				title: "申請エラー",
				messageNo: error_message,
				closeBtn: false
			})
			return ;
		}
		// console.log(data);
		let special_agreement_for_invoice_created = data.special_agreement_flag == "1" && data.invoice_process_status != null;
		// アラート
		if(special_agreement_for_invoice_created) {
			// 特別承認で請求依頼済みの場合直接契約書BOXへ
			this.props.alertModal.current.confirmCheck({
				title: "申請前確認",
				message: "ステータスを「契約書BOX」に変更します。<br />よろしいですか？<br /><br />" +  GetMessage(alert_message),
				closeBtn: false,
			},()=>{
				this.handleClickApplication(data,true,7);
			})
		} else {
			if(alert_message.length > 0 || data.auto_approval_flag == "0"){
				this.props.alertModal.current.confirmCheck({
					title: "申請前確認",
					message: "ステータスを「承認BOX」に変更します。<br />よろしいですか？<br /><br />" +  GetMessage(alert_message),
					closeBtn: false,
				},()=>{
					this.handleClickApplication(data,true);
				})
			}else{
				this.props.alertModal.current.confirmCheck({
					title: "申請前確認",
					message: "自動承認により、ステータスを「納品BOX」に変更します。<br />よろしいですか？<br /><br />" +  GetMessage(alert_message),
					closeBtn: false,
				},()=>{
					this.handleClickApplication(data,false);
				})
			}
		}
	}
	// 申請
	handleClickApplication (data,exclude_auto_approval_flag,order_box_status=5) {
		Request.put(
			"/api/order_box/status/"+data.estimate_ulid,
		{
			...data,
			request:"box_status",
			order_box_status:order_box_status,
			exclude_auto_approval_flag:exclude_auto_approval_flag == true ?"1":"0"
		},
		res=>{
//				console.log(res);
			// this.props.alertModal.current.confirmCheck({
			// 	title: "更新が完了しました。",
			// 	messageNo: 2527,
			// 	closeBtn: false
			// }, ()=>{
				this.search();
			// }, false)
			return ;
		})
		return ;
	}
	
	// 承認リクエスト
	handleClickApproval (data) {
		let message = `ステータスを「${FormatCode.decode("cst_order_box_status",6)}BOX」に変更します。<br />よろしいですか？`

		this.props.alertModal.current.confirmCheck({
			message:message,
			title:"更新確認"
		},()=>{
			Request.put(
				"/api/order_box/status/"+data.estimate_ulid,
			{
				...data,
				request:"box_status",
				order_box_status:6,
			},
			res=>{
	//				console.log(res);
				// this.props.alertModal.current.confirmCheck({
				// 	title: "更新が完了しました。",
				// 	messageNo: 2527,
				// 	closeBtn: false
				// }, ()=>{
					this.search();
				// }, false)
			})
	
		})
	}
}
export default List;

export class DialogEstimateMemo extends DialogBase{
	constructor(props) {
	  super(props);
  
	  Object.assign(this.state, {
		title: '管理メモ登録',
		estimate_id: props.estimate_id,
		estimate_natural_id : props.estimate_natural_id,
		data: {
			values: {
				to_user: undefined,
				to_type: undefined,
				estimate_management_memo: ""
			},
			errors:{},
			requiredData:{},
		},
		landmark_user: props.landmark_user
	  });
	  this.validateCallback = this.validateCallback.bind(this)
	//   console.log(props.landmark_user);
	}
	componentDidUpdate(prevProps){
		if(prevProps.data!=this.props.data){
		  this.setState({
			data:this.props.data
		  })
		}
		if(prevProps.landmark_user!=this.props.landmark_user){
			this.setState({
			  landmark_user:this.props.landmark_user
			})
		  }
		  if(prevProps.estimate_id!=this.props.estimate_id){
			this.setState({
				estimate_id:this.props.estimate_id
			})
		  }
		  if(prevProps.estimate_natural_id!=this.props.estimate_natural_id){
			this.setState({
				estimate_natural_id:this.props.estimate_natural_id
			})
		  }
		}
	
	validateCallback(newData, callback=()=>{}){
		let errors = {}

		if ( newData.to_user && (newData.to_user == undefined || newData.to_user == null) ) {
			errors = {
				to_user : true
			}
		}
		if ( newData.to_type && (newData.to_type == undefined || newData.to_type == null) ) {
			errors = {
				...errors,
				to_type : true
			}
		}
		if ( newData.estimate_management_memo && newData.estimate_management_memo.length <= 0) {
			errors = {
				...errors,
				estimate_management_memo : true
			}
		}

		// console.log(errors, newData);

		this.setState({
		  data:{
			values: {
				...this.state.data.values,
				...newData.values,
				},
			errors: errors
		  }
		}, ()=>callback(
			// console.log(this.state.data)
		))
	}
	
	handleClickPositive(){
		//API estimatelist/status/:ulid
		let errors = {}
		let {
			to_user,
			to_type,
			estimate_management_memo,
		} = this.state.data.values
		if ( to_user == undefined || to_user == null) {
			errors = {
				to_user : true
			}
		}
		if ( to_type == undefined || to_type == null) {
			errors = {
				...errors,
				to_type : true
			}
		}
		if ( estimate_management_memo.length <= 0) {
			errors = {
				...errors,
				estimate_management_memo : true
			}
		}

		if (Object.keys(errors).length > 0 || Object.keys(this.state.data.errors).length>0){
//			console.log(errors,this.state.data);
			return
		}

		const param = {
			to_user : to_user,
			to_type : to_type,
			estimate_management_memo : estimate_management_memo,
			estimate_id : this.state.estimate_id,
			estimate_natural_id : this.state.estimate_natural_id,
			lastupdate_user_id : GsuiteAuth.get("id"),
		}

		// console.log(param);


		Request.post("/api/order_box/memo",param,res=>{
			// console.log(res.Data);
		})
/*
		const params = {
		  ...this.state.data.values,
		  estimate_status:'6'
		}
		Request.put('/api/order/status/' + this.state.data.values.ulid, params,()=>{
		  this.props.refreshCallback();this.toggleModal();
		})
*/
	}

	bodyContent() {
		return (
		  <>
			<Row style={{padding:"10px 0px"}}>
				<Col md="2">
					相手
				</Col>
				<Col md="4">
					<InputSelect
						label="相手"
						className="select-user-box"
						name="ESTIMATE_MANAGEMENT_MEMO_HISTORY__to_user"
						labelOn={false}
						options={this.state.landmark_user}
						validateCallback={(newData)=>{(this.validateCallback(newData))}}
						rootData={this.state.landmark_user}
						isSearchable={true}
						isCreatable={true}
						validateType={'search'}
					/>
				</Col>
				<Col md="2">
					分類
				</Col>
				<Col md="4">
					<InputSelect
						label="分類"
						className="select-user-box"
						name="ESTIMATE_MANAGEMENT_MEMO_HISTORY__to_type"
						labelOn={false}
						options={cst_estimate_management_memo_type}
						validateCallback={(newData)=>{(this.validateCallback(newData))}}
						rootData={this.state.data}
						isSearchable={false}
						validateType={'regist'}
					/>
				</Col>
			</Row>
			<Row>
				<Col md="2">コメント</Col>
				<Col md="10">
					<InputText multiline={true}
						labelOn={false}
						label='コメント'
						name='ESTIMATE_MANAGEMENT_MEMO_HISTORY__estimate_management_memo'
						validateCallback={(newData)=>{(this.validateCallback(newData))}} 
						rootData={this.state.data}
						validateType='regist'
						placeholder=" "
					/>
				</Col>
			</Row>
		  </>
		);
	}
}  
export class DialogUploadPurchaseOrder extends DialogBase{
	constructor(props) {
		super(props);
		// console.log(this.props.data)
		Object.assign(this.state, {
		  title: '発注書アップロード',
		  data: this.props.data,
		  cuFiles:[],
		});
		this.validateCallback = this.validateCallback.bind(this)
	  }
	
	  async componentDidUpdate(prevProps){
		if (prevProps.data !== this.props.data){
		  const isRequiredClient = this.props.data.values.construction_number_require_flag == 1 ? true : false;
		  const requiredAlert = isRequiredClient&&!this.props.data.values.construction_number
	
		  let order_schedule_date;
		  if(this.props.data.values.order_schedule_date){
			order_schedule_date = this.props.data.values.order_schedule_date;
		  } else {
			// ｎ日後の営業日取得
			order_schedule_date = await new Promise(resolve => {
			  Request.get('/api/workday', { add_day : 14 }, res => {
				resolve(moment(res.Data).format("YYYY-MM-DDT00:00:00"))
			  })
			})
		  }
	
		  const estimate_id = this.props.data.values.id;
		  const cuFiles = await new Promise(resolve => {
			Request.get('/api/cufile', { ref_id : estimate_id, file_type : 4, file_detail_type : 401, create_system_type : 2}, res => {
			  resolve(res.Data)
			})
		  })
		  this.setState({
			cuFiles : cuFiles
		  })
	
		  const {
			latest_pdf_purchase_order_url,
			quote_available_start_date,
			survey_available_start_date,
			estimate_change_flag,
			cannot_extention_flag,
		  } = this.props.data.values;

		  let order_start_date = this.props.data.values.order_start_date
		  let order_end_date = this.props.data.values.order_end_date
		  let order_capacity_qty = this.props.data.values.order_capacity_qty
	
		  order_start_date = order_start_date == null ? "" : order_start_date
		  order_end_date = order_end_date == null ? "" : order_end_date
	
		  this.setState({
			data: {
			  values:{
				...this.props.data.values,
				order_schedule_date : order_schedule_date,
				send_upload_notification : 0,
				latest_pdf_purchase_order_url: latest_pdf_purchase_order_url ? latest_pdf_purchase_order_url : "",
				estimate_change_flag: estimate_change_flag,
				order_start_date:order_start_date,
				order_end_date:order_end_date,
				order_capacity_qty:order_capacity_qty,
				cannot_extention_flag: cannot_extention_flag,
				contract_user_id:this.props.data.values.contract_user_id? this.props.data.values.contract_user_id: null,
			  },
			  errors:{
				...((this.props.data.values.latest_pdf_purchase_order_url || cuFiles.length > 0)?{latest_pdf_purchase_order_url:null}:{latest_pdf_purchase_order_url:[GetMessage(2024)]}),
				...((estimate_change_flag == "0" || order_start_date != null ) ?{order_start_date:null}:{order_start_date:[GetMessage(2024)]}),
				...((estimate_change_flag == "0" || order_end_date != null ) ?{order_end_date:null}:{order_end_date:[GetMessage(2024)]}),
				...((estimate_change_flag == "0" || order_capacity_qty != null )?{order_capacity_qty:null}:{order_capacity_qty:[GetMessage(2024)]})
		  
			  },
			  requiredData:{
				order_schedule_date: [GetMessage(2024)],
				latest_pdf_purchase_order_url: [GetMessage(2024)],
				order_start_date: [GetMessage(2024)],
				order_end_date: [GetMessage(2024)],
				order_capacity_qty: [GetMessage(2024)],
			  }
			},
		  },()=>{}
		  )
		}
	  }
	
	  validateCallback(newData, callback=()=>{}){
		// let errors = {}

		// console.log(newData);

		// let {estimate_change_flag: old_estimate_change_flag,
		// 	 order_start_date:old_order_start_date,
		// 	 order_end_date:old_order_end_date,
		// 	 order_capacity_qty:old_order_capacity_qty,
		// 	 cannot_extention_flag:old_cannot_extention_flag} = this.state.data.values;
		// let {estimate_change_flag: new_estimate_change_flag,
		// 	order_start_date:new_order_start_date,
		// 	order_end_date:new_order_end_date,
		// 	order_capacity_qty:new_order_capacity_qty,
		// 	cannot_extention_flag:cannot_extention_flag} = newData.values;
		// let new_cannot_extention_flag = cannot_extention_flag != undefined && cannot_extention_flag.length > 0 ? cannot_extention_flag[0]:"0";

		// if(new_estimate_change_flag == "1" || new_estimate_change_flag == undefined && old_estimate_change_flag == "1"){
		// 	const order_start_date = new_order_start_date ? new_order_start_date: old_order_start_date;
		// 	const order_end_date = new_order_end_date ? new_order_end_date: old_order_end_date;
		// 	const order_capacity_qty = new_order_capacity_qty ? new_order_capacity_qty: old_order_capacity_qty;

		// 	errors.order_start_date = order_start_date == null || order_start_date == "" ? [GetMessage(2024)] : JSON.stringify(errors.order_start_date) != JSON.stringify([GetMessage(2024)]) && errors.order_start_date != null ? errors.order_start_date : null;
		// 	errors.order_end_date = order_end_date == null || order_end_date == "" ? [GetMessage(2024)] : JSON.stringify(errors.order_end_date) != JSON.stringify([GetMessage(2024)]) && errors.order_end_date != null ? errors.order_end_date : null;
		// 	errors.order_capacity_qty = order_capacity_qty == null ? [GetMessage(2024)] : JSON.stringify(errors.order_capacity_qty) != JSON.stringify([GetMessage(2024)]) && errors.order_capacity_qty != null ? errors.order_capacity_qty : null;

		// }


		// this.setState({
		// 	data:{
		// 	  values: {
		// 		  ...this.state.data.values,
		// 		  ...newData.values,
		// 		  cannot_extention_flag: new_cannot_extention_flag ? new_cannot_extention_flag: old_cannot_extention_flag,
		// 		  },
		// 	  errors: errors
		// 	}
		//   }, ()=>callback(console.log(this.state.data)))

		
		let order_start_date = "";
		let order_end_date = "";
		let order_capacity_qty = "";
		let cannot_extention_flag = "0"
		let errors = newData.errors
		// console.log(newData.values.cannot_extention_flag)
		if(newData.values.cannot_extention_flag == "1"){
			cannot_extention_flag = newData.values.cannot_extention_flag 
		}

		if(newData.values.estimate_change_flag == "1"){
		  order_start_date = newData.values.order_start_date == "" || newData.values.order_start_date == null ? "" : newData.values.order_start_date;
		  order_end_date = newData.values.order_end_date == "" || newData.values.order_end_date == null ? "" : newData.values.order_end_date;
		  order_capacity_qty = newData.values.order_capacity_qty == "" || newData.values.order_capacity_qty == null ? "" : newData.values.order_capacity_qty;
	
		//   console.log(newData)
		  if(newData.values.estimate_change_flag != this.state.data.values.estimate_change_flag){
			errors.order_start_date = [GetMessage(2024)] ;
			errors.order_end_date =[GetMessage(2024)];
			errors.order_capacity_qty = [GetMessage(2024)];
		  } else {
			errors.order_start_date = order_start_date == "" ? [GetMessage(2024)] : JSON.stringify(errors.order_start_date) != JSON.stringify([GetMessage(2024)]) && errors.order_start_date != "" ? errors.order_start_date : "";
			errors.order_end_date = order_end_date == "" ? [GetMessage(2024)] : JSON.stringify(errors.order_end_date) != JSON.stringify([GetMessage(2024)]) && errors.order_end_date != "" ? errors.order_end_date : "";
			errors.order_capacity_qty = order_capacity_qty == "" ? [GetMessage(2024)] : JSON.stringify(errors.order_capacity_qty) != JSON.stringify([GetMessage(2024)]) && errors.order_capacity_qty != "" ? errors.order_capacity_qty : "";
		  }
	
		  if(order_start_date && order_end_date){
			// console.log(errors)
			// console.log(newData)
			if(this.alertDateCheck(newData.values,newData)){
			  errors.order_start_date = null
			  errors.order_end_date = null
			  this.setState({
				data:{
				  ...this.state.data,
				  ...newData,
				  errors:errors
				},
			  }, ()=>{
				callback();
			  })
			}
		  }else{
	  
			this.setState({
			  data:{
				...this.state.data,
				...newData,
				errors:errors
			  }
			}, ()=>callback())  
		  }
	
		}else{
		  let tmpData = newData
		  tmpData.values.order_start_date = ""
		  tmpData.values.order_end_date = ""
		  tmpData.values.order_capacity_qty = null
		  this.setState({
			data:{
			  ...this.state.data,
			  ...tmpData,
			  errors:{
				...newData.errors,
				order_start_date:null,
				order_end_date:null,
				order_capacity_qty:null,
			  }
			}
		  }, ()=>callback())        
		}



	  }  
	  alertDateCheck({
		order_start_date,
		order_end_date
	  },newData){
		const {
		  order_start_date:prev_order_start_date,
		} = this.state.data.values
		if(order_start_date && order_end_date){
		  if(moment(order_start_date) > moment(order_end_date)){
	
			this.setState({
			  data:{
				...this.state.data,
				...newData,
				errors:{
				  ...newData.errors,
				  ...{[(prev_order_start_date === order_start_date ? 'order_end_date' : 'order_start_date')]:[GetMessage(2462)]},
				}
			  }
			})
			return false
		  }
		}
		return true
	  }
	
	  validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	  }
	
	  handleClickNegative() {
		this.props.handleClickNegative && this.props.handleClickNegative();
		this.setState({})
		this.toggleModal();
		}	
	
	  async handleClickPositive(){
		if(!this.validate()){
		  return;
		}
		let messageNo = [2417]
		Request.setProgress(10)
		const sendUploadNotification = Boolean(this.state.data.values.send_upload_notification)
		const wasFileUploaded = this.state.data.values["latest_pdf_purchase_order_url_base64"] !== undefined

		const uploadParams = {
		  ...this.state.data.values,
		  parking_id: this.state.data.values.parking_id,
		  request_id: this.state.data.values.request_id,
		  update_timestamp : this.state.data.values.update_timestamp,
		  purchase_order_check_flag : 1,
		  login_user: localStorage.getItem("name")
		}
		Request.put('/api/order/file_upload/' + this.state.data.values.estimate_ulid, uploadParams, async res=>{
		},(err)=>{
		  Request.setProgress(0)
		})
	
		if(sendUploadNotification){
		  
		  const {
			want_guide_type,
			customer_branch_natural_id,
			customer_user_natural_id,
			project_natural_id,
			request_natural_id,
			subcontract_customer_branch_natural_id,
			subcontract_customer_user_natural_id,
			want_guide_type_subcontract,
			request_user_branch_natural_id:user_branch_natural_id,
			customer_system_use_flag,
			b_customer_system_use_flag
		  } = this.state.data.values
		//   console.log(this.state.data.values)
		  const estimateCommonParams = await Request.getEstimateCommon({
			  customer_branch_natural_id,
			  customer_user_natural_id,
			  project_natural_id,
			  request_natural_id,
			  subcontract_customer_branch_natural_id,
			  subcontract_customer_user_natural_id,
			  estimateObject: this.state.data.values,
			  user_branch_natural_id
		  })
		  const {
			CUSTOMER_USER__customer_reminder_sms_flag_code,
			CUSTOMER_USER__customer_user_tel
		  } = estimateCommonParams.object_customer
		  const {
			CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
			CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
		  } = estimateCommonParams.object_customer_subcontract
		  const {
			PROJECT__send_destination_type,
			PROJECT__site_customer_user_tel
		  } = estimateCommonParams.object_project
		  Request.setProgress(60)
		  // D01_MAIL_発注書受領 通知
		  let d01Mail = (
			((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0"))
			||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))
		  ) 
		  ? new Promise((resolve, reject)=>{
			const mailUrl = '/api/pout/D01_MAIL'
			const mailParams = {
			  format_url:GoogleDrive.getFormatUrl(format_url.D01_MAIL),
			  send_destination_type:PROJECT__send_destination_type,
			  want_guide_type:want_guide_type,
			  want_guide_type_subcontract:want_guide_type_subcontract,
			  ...estimateCommonParams
			}
			Request.post(mailUrl, mailParams, res=>{
	//          console.log(res)
			  resolve(res)
			}, err=>{
			  reject(err)
			})
		  })
		  :{Code:200}
	
		  // D01_FAX_発注書受領 通知
		  let d01Fax = (
			((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="2"||want_guide_type=="0"))
			||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0"))
		  ) 
		  ? new Promise((resolve, reject)=>{
			const faxUrl = '/api/pout/D01_FAX'
			const faxParams = {
			  format_url:GoogleDrive.getFormatUrl(format_url.D01_FAX),
			  send_destination_type : PROJECT__send_destination_type,
			  want_guide_type:want_guide_type,
			  want_guide_type_subcontract:want_guide_type_subcontract,
			  ...estimateCommonParams
			}
			Request.post(faxUrl, faxParams, res=>{
	//          console.log(res)
			  resolve(res)
			}, err=>{
			  reject(err)
			})
		  })
		  :{Code:200}
	
		  // D01_SMS_発注書受領 通知
		  let d01Sms = (
			( (PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) )
			|| ((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract))
			|| PROJECT__site_customer_user_tel
		  )
		  ? new Promise((resolve, reject)=>{
			const smsUrl = '/api/pout/D01_SMS'
			const smsParams = {
			  format_url:GoogleDrive.getFormatUrl(format_url.D01_SMS),
			  send_destination_type:PROJECT__send_destination_type,
			  want_guide_type:want_guide_type,
			  want_guide_type_subcontract:want_guide_type_subcontract,        
			  ...estimateCommonParams
			}
			Request.post(smsUrl, smsParams, res=>{
	//          console.log(res)
			  resolve(res)
			}, err=>{
			  reject(err)
			})
		  })
		  :{Code:200}
	
		  const d01Results = await Promise.all([d01Mail, d01Fax, d01Sms]).then(r=>r).catch(()=>{
			Request.setProgress(0)  
			return 
		  })
	
		  d01Mail = d01Results && d01Results[0]
		  d01Fax = d01Results && d01Results[1]
		  d01Sms = d01Results && d01Results[2]
	
		  Request.setProgress(60)

		  if (d01Mail.Code==200 && d01Fax.Code==200 && d01Sms.Code==200){

			const sendMailUrl = '/api/send/MAIL'
			d01Mail.Data&&d01Mail.Data.forEach((mailData)=>{
			  Request.post(sendMailUrl, mailData, res=>{}, err=>{}, undefined, true, false)
			})
			
			// 顧客システム利用の場合は送付先が下請け、両方の場合のみ送付状を送信する
			const sendFaxUrl = '/api/send/FAX'
			d01Fax.Data&&d01Fax.Data.forEach((faxData)=>{
			Request.post(sendFaxUrl, faxData, res=>{}, err=>{},undefined, true, false)})

			// 2520 対応
			const resultSms = await new Promise((resolve, reject) => {
				if (d01Sms.Data == undefined) {
				resolve({Code: 200})
				}        
				const sendSmsUrl = '/api/send/SMS'
				d01Sms.Data&&d01Sms.Data.forEach((smsData)=>{
				if (smsData.site_flag == true) {
					if (smsData.site_error == true) {
					const registerType = Number(estimateCommonParams.object_project.PROJECT__register_type);
					// console.log(smsData)
					if (registerType === 0) {
						resolve({Code: 200})
					}else{
						resolve({Code: 2631})
					}
					}else{
					Request.post(sendSmsUrl, smsData, res=>{
						if (res.Data && res.Data.sms_status == 'accepted'){
						resolve({Code: 200})
						}else{
						resolve({Code: 2631, data: res.Data})
						}
					}, err=>{
						resolve({Code: 2631, data: err})
					},undefined, true, false)
					}
				} else {
					Request.post(sendSmsUrl, smsData, res => {}, err => {}, undefined, true, false)
				}
				})
			})
	
			Request.setProgress(90)
	
			if(((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0")) 
			  ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
			  window.open(`https://mail.google.com/mail/u/0/#drafts`);
			  messageNo.push(2471)
			}

			Request.setProgress(0)
			if (resultSms.Code == 200) {
				this.props.alertModal.current.confirmCheck({
				title: "処理完了",
				messageNo: messageNo,
				closeBtn: false
				}, ()=>{
					this.props.refreshCallback()
					this.toggleModal();
				}, false)
			} else {
				console.log(resultSms);
				let title = "エラー"
				let message = GetMessage(2631)
				if (resultSms.data && resultSms.data.sms != "") {
					message = message + "<br />\n" + resultSms.data.sms
				}
				this.props.alertModal.current.confirmCheck({
				title: title,
				message: message ,
				closeBtn: false
				}, () => {
					this.props.refreshCallback()
					this.toggleModal();					
				}, false)
			}

	
		  }else{
			Request.setProgress(0)
		  }

		}
		document.body.style.overflow = "auto";
	
	  }
	
	  handleCheckboxChange=()=>{
		
		const newValue = this.state.data.values && !Boolean(this.state.data.values.purchase_order_check_flag);
	
		const params = {
		  purchase_order_check_flag:newValue
		}
	
		Request.put('/api/order/checked/' + this.state.data.values.ulid, params, res=>{
	
		  this.setState({
			data:{
			  ...this.state.data,
			  values : {
				...this.state.data.values,
				update_timestamp : res.Data.update_timestamp,
				purchase_order_check_flag : newValue
			  }
			}
		  })
	
		},(err)=>{
		  console.log(err)
		})
	
	  }
	
	  bodyContent() {
		const displayCheckbox = (index) => index === 0 ? "" : "d-none";
		// console.log(this.state.data.values.purchase_order_check_flag)
		const isChecked = this.state.data.values.purchase_order_check_flag != undefined ? Boolean(this.state.data.values.purchase_order_check_flag) : 0;
	
		return (
		  <>
			<InputFile 
			  label="発注書"
			  name="ESTIMATE__latest_pdf_purchase_order_url"
			  copy={false}
			  showLink={true}
			  validateCallback={this.validateCallback} 
			  rootData={this.state.data} 
			  disabled={this.state.cuFiles.length > 0}
			  filename={`発注書_${moment().format("YYYYMMDDHHmmss")}&extension=true`}
			  />
	
			{this.state.cuFiles.length > 0 &&
			  <>
				<Row>
				  <Col>
					顧客システムファイル
				  </Col>
				</Row>
				{this.state.cuFiles.map((file, index) => (
				  <Row key={index}>
					<Col>
					  <a href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">
						  {file.file_name}
					  </a>
					</Col>
					<Col className={displayCheckbox(index)} >
					 <Label >
					 <Input type="checkbox" defaultChecked={isChecked} onChange={this.handleCheckboxChange} />
						確認済み
					  </Label>
					</Col>
				  </Row>
				))}
				<br/>
			  </>
			}
			<Row>
			  <Col md="12">
				<InputDatetime
				  label='受注予定日'
				  name='ESTIMATE__order_schedule_date'
				  labelOn={true}
				  validateCallback={this.validateCallback}
				  rootData={this.state.data}
				  validateType="regist"
				/>
			  </Col>
			</Row>
			  <Col md="12" style={{padding:'5px 0 0'}}>
			  <InputCheckBox
				label='見積からの内容変更あり'
				name='ESTIMATE__estimate_change_flag'
				labelOn={false}
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				disabled={this.props.data.values.estimate_change_flag==1}
				checkedValue={1}
				uncheckedValue={0}
			  />
			</Col>        
			<Row>
			  <Col md="4">
			  契約開始日:{Format.format_date_en(this.state.data.values.survey_available_start_date)}
			  <InputDatetime
				label='契約開始日'
				name='ESTIMATE__order_start_date'
				labelOn={false}
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				disabled={this.state.data.values.estimate_change_flag == "0" ? true : false}
				validateType="regist"
			  />
			  </Col>
			  <Col md="4">
			  契約終了日:{Format.format_date_en(this.state.data.values.survey_available_end_date)}
			  <InputDatetime
				label='契約終了日'
				name='ESTIMATE__order_end_date'
				labelOn={false}
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				disabled={this.state.data.values.estimate_change_flag == "0" ? true : false}
				validateType="regist"
			  />
			  </Col>
			  <Col md="4">
			  台数:{this.state.data.values.survey_capacity_qty}台
			  <InputNumber
				unit='台'
				label='台数'
				name='ESTIMATE__order_capacity_qty'
				labelOn={false}
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				disabled={this.state.data.values.estimate_change_flag == "0" ? true : false}
				validateType="regist"
			  />
			  </Col>
			  <Col md="12">
			  <InputCheckBox
					label='延長不可'
					name='ESTIMATE__cannot_extention_flag'
					labelOn={false}
					validateCallback={this.validateCallback}
					rootData={this.state.data}
					checkedValue={1}
					uncheckedValue={0}
				/>
			  </Col>
			</Row>
			<Row>
			  <Col md="12">
			  <InputText multiline={true}
				labelOn={true}
				label='顧客からの連絡事項'
				name='ESTIMATE__order_contact_memo'
				validateCallback={this.validateCallback} 
				rootData={this.state.data}
				validateType='regist'
				disabled={true}
				placeholder=" "
			  />
			  </Col>
			</Row>
	
			<Row>
			  <Col md="12">
				<InputCheckBox
				  label='発注書受領通知を送る'
				  name='NODB__send_upload_notification'
				  labelOn={false}
				  checkedValue={1}
				  uncheckedValue={0}
				  validateCallback={this.validateCallback}
				  rootData={this.state.data}
				/>
			  </Col>
			</Row>
		  </>
		);
	  }	
}  
export class DialogCreateApplication extends DialogBase{
	constructor(props) {
	  super(props);
  
	  Object.assign(this.state, {
		title: '申込書作成',
		data: {
			...this.props.data,
			values: {
				...this.props.data.values,
			},
			errors:{},
			requiredData:{},
		},
		landmark_user: props.landmark_user
	  });
	  this.validateCallback = this.validateCallback.bind(this)

	}
	componentDidUpdate(prevProps){
		if (prevProps.data !== this.props.data){
			// console.log(prevProps.data)
			const {
				send_mail,
				send_fax,
				return_deadline
			} = this.props.data.values;

			this.setState({
				data: {
				values:{
					...this.props.data.values,
					application_form_auto_send_flag:this.props.data.values.application_form_auto_send_flag?this.props.data.values.application_form_auto_send_flag:0,
					application_form_send_target_status:this.props.data.values.application_form_send_target_status?this.props.data.values.application_form_send_target_status:0,
					return_deadline:this.props.data.values.return_deadline? this.props.data.values.return_deadline: "",
					application_form_email:this.props.data.values.application_form_email? this.props.data.values.application_form_email:null,
					application_form_fax:this.props.data.values.application_form_fax? this.props.data.values.application_form_fax:null,
					send_mail:this.props.data.values.application_form_send_target_status==1 || this.props.data.values.application_form_send_target_status==3?1: 0,
					send_fax:this.props.data.values.application_form_send_target_status==2 || this.props.data.values.application_form_send_target_status==3?1: 0,
					send_fixed_notification:this.props.data.values.send_fixed_notification ? this.props.data.values.send_fixed_notification : 0,
					attach_invoice_pdf: this.props.data.values.attach_invoice_pdf ? this.props.data.values.attach_invoice_pdf : 1,
					unspecified_flag: 1,
				},
				errors:{
					...((return_deadline == null || return_deadline == "") ? {return_deadline:[GetMessage(2024)]}:{application_form_email:null}),
					...((send_mail == 1) ?{application_form_email:[GetMessage(2024)]}:{application_form_email:null}),
					...((send_fax == 1) ?{application_form_fax:[GetMessage(2024)]}:{application_form_fax:null}),
			
				},
				requiredData:{
					return_deadline:[GetMessage(2024)] ,
					application_form_email:[GetMessage(2024)] ,
					application_form_fax:[GetMessage(2024)] ,						
				}
				},
			},()=>{}
			)
		}			
	}
	
	handleClickNegative(){
		this.toggleModal();
	  }

	validateCallback(newData, callback=()=>{}){
		// console.log(newData.getErrorCodes)
		let errors = newData.errors
		let tmpData = this.state.data;
		let send_mail = newData.values.send_mail != undefined ? newData.values.send_mail : 0;
		let send_fax = newData.values.send_fax != undefined ? newData.values.send_fax : 0;
		const is_empty_application_form_email = (newData.values.application_form_email === null 
			|| newData.values.application_form_email === undefined
			|| newData.values.application_form_email === "") ? true : false;
		const is_empty_application_form_fax = (newData.values.application_form_fax === null 
			|| newData.values.application_form_fax === undefined
			|| newData.values.application_form_fax === "") ? true : false;
		const is_empty_return_deadline = (newData.values.return_deadline === null 
			|| newData.values.return_deadline === undefined
			|| newData.values.return_deadline === "") ? true : false;
		
		let application_form_send_target_status = 0;
		if(send_mail == 1 && send_fax == 1){
			application_form_send_target_status = 3
		}else if(send_mail == 1 && send_fax == 0){
			application_form_send_target_status = 1
		}else if(send_mail == 0 && send_fax == 1){
			application_form_send_target_status = 2
		}
		let limit_date = this.state.data.values.limit_date;
		let limit_time = this.state.data.values.limit_time;
		if(newData.values.return_deadline != undefined){
			[limit_date,limit_time] = newData.values.return_deadline.split("T")
		}
		
			
		// console.log(errors)
		this.setState({
			data:{
			...tmpData,
			...newData,
			values:{
				...tmpData.values,
				...newData.values,
				application_form_send_target_status,
				limit_date,
				limit_time,
			},
			errors:{
				...errors,
				...(is_empty_return_deadline ? {return_deadline : [GetMessage(2024)]} : undefined),
				...(send_mail == 1 && is_empty_application_form_email ? {application_form_email : [GetMessage(2024)]} : undefined),
				...(send_fax == 1 && is_empty_application_form_fax ? {application_form_fax : [GetMessage(2024)]} : undefined) 
			},
			requiredData:{
				...(send_mail == 1 ? {application_form_email : [GetMessage(2024)]} : undefined) ,
				...(send_fax == 1 ? {application_form_fax : [GetMessage(2024)]} : undefined) 
			},
			}
		}, ()=>callback())  
	}

	validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	  }	
	
	async handleClickPositive(){
		if (!this.validate()){
			return;
		}
		const {
			customer_branch_natural_id,
			customer_user_natural_id,
			project_natural_id,
			request_natural_id,
			subcontract_customer_branch_natural_id,
			subcontract_customer_user_natural_id,
			user_branch_natural_id,
			application_form_auto_send_flag,
			application_form_send_target_status,
			application_form_email,
			application_form_fax,
			estimate_natural_id,
			return_deadline,
			update_timestamp,
			supplier_name,
			supplier_name_kana,
			supplier_user_name,
			supplier_tel,
			supplier_tel2,
			supplier_fax,
			request_user_branch_natural_id
		} = this.state.data.values

		const estimateCommonParams = await Request.getEstimateCommon({
			customer_branch_natural_id,
			customer_user_natural_id,
			project_natural_id,
			request_natural_id,
			subcontract_customer_branch_natural_id,
			subcontract_customer_user_natural_id,
			estimateObject: this.state.data.values,
			user_branch_natural_id: request_user_branch_natural_id
		})

		Request.setProgress(10)

		const estimate_detail_data = await new Promise(resolve=>{
			// 調査見積詳細取得API呼び出し
			Request.get(`/api/estimate/detail/survey/${estimate_natural_id}`, {}, res=>{
			  if (!res.Data[0]){
				Request.setProgress(0)
				throw {
				  name:'Data Error!',
				  message:'estimate detail not exist'
				}
			  }
			  resolve(res.Data.map(datum=>{
				const {
				  estimate_detail_name,
				  estimate_detail_qty,
				  estimate_detail_unit_cost,
				  estimate_detail_term,
				  estimate_detail_term_type,
				  estimate_detail_amt
				} = datum
				return{
				  estimate_detail_name,
				  quote_capacity_qty:estimate_detail_qty, // ESTIMATE__survey_capacity_qty
				  estimate_detail_unit_cost,
				  estimate_detail_term,
				  estimate_detail_term_type,
				  estimate_detail_amt
				}
			  }))
			})
		  })

        Request.setProgress(20)

		const estimateData = {
			...this.state.data.values,
			estimate_details:estimate_detail_data
		  }
		  
		const d02pdf = await new Promise( async (resolve, reject)=>{      
			const {
 			  estimate_id,
			  survey_capacity_qty_type,
			  survey_tax_in_flag,
			  survey_discount_amt,
			  survey_key_money,
			  survey_commission_discount_amt,
			  survey_adjustment_amt,
			  estimate_details,
			  invoice_customer_user_setting,
			  customer_branch_invoice_zip_code,
			  customer_branch_invoice_prefecture,
			  customer_branch_invoice_city,
			  customer_branch_invoice_address,
			  invoice_customer_user_name,
			  customer_user_name,
			  estimate_natural_id,
			  survey_parking_name,
			  survey_available_start_date,
			  survey_available_end_date,
			  survey_capacity_qty,
			  request_natural_id,
			  return_deadline,
			  application_form_email,
			  application_form_fax,
			  application_form_auto_send_flag,
			  application_form_send_target_status,
			  order_start_date,
			  order_end_date,
			  order_capacity_qty,
			  request_user_branch_natural_id
 			} = estimateData

			const request_user_data = await Request.getUserParameters(request_user_branch_natural_id);
			const user_branch_name = request_user_data.USER_BRANCH__user_branch_name;
			const user_branch_tel = request_user_data.USER_BRANCH__user_branch_tel;
			const user_branch_zip_code = request_user_data.USER_BRANCH__user_branch_zip_code;
			const user_branch_user_addr = request_user_data.JOIN_user_branch_user_addr;

			 let limit_date = estimateData.limit_date;
			 let limit_time = estimateData.limit_time;
			 if(limit_date == undefined && limit_time == undefined && return_deadline != undefined){
				 [limit_date,limit_time] = return_deadline.split("T")
			 }

			const invoice_user_name = invoice_customer_user_setting == 1 
			? invoice_customer_user_name
			: invoice_customer_user_setting == 2 
			  ? customer_user_name
			  : ""
	  
			let object_array_detail = {}
			let array_count = 1
			object_array_detail[`row_start_1`] = {
				ESTIMATE__estimate_natural_id: estimate_natural_id,
				ESTIMATE__survey_parking_name: survey_parking_name,
				ESTIMATE__survey_available_start_date: order_start_date? order_start_date: survey_available_start_date,
				ESTIMATE__survey_available_end_date: order_end_date? order_end_date : survey_available_end_date,
				ESTIMATE__survey_capacity_qty: order_capacity_qty? order_capacity_qty : survey_capacity_qty,
				ESTIMATE__survey_capacity_qty_type: FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
			}
			// 見積2件～3件目確認
			object_array_detail[`row_start_2`] = {
				ESTIMATE__estimate_natural_id: "",
				ESTIMATE__survey_parking_name: "",
				ESTIMATE__survey_available_start_date: "",
				ESTIMATE__survey_available_end_date: "",
				ESTIMATE__survey_capacity_qty: "",
				ESTIMATE__survey_capacity_qty_type:"",
			}
			object_array_detail[`row_start_3`] = {
				ESTIMATE__estimate_natural_id: "",
				ESTIMATE__survey_parking_name: "",
				ESTIMATE__survey_available_start_date: "",
				ESTIMATE__survey_available_end_date: "",
				ESTIMATE__survey_capacity_qty: "",
				ESTIMATE__survey_capacity_qty_type:"",
			}			
			

			estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id
			estimateCommonParams["object_request"]["REQUEST__request_natural_id"] = request_natural_id
			// console.log(estimateCommonParams);
			let supplier_invoice_enable = (this.state.data.values.supplier_invoice_business_type == null || this.state.data.values.supplier_invoice_business_type == 0 || this.state.data.values.supplier_invoice_business_type == 1 && (this.state.data.values.supplier_invoice_registration_number != "" && this.state.data.values.supplier_invoice_registration_number != null));
			let unspecified_flag = this.state.data.values.unspecified_flag ? "（不特定）":""
			const pdfParams = {
			  ...estimateCommonParams,
			  format_url:GoogleDrive.getFormatUrl(format_url.D02_PDF), 
			  fax: application_form_fax,
			  fax_subcontract: "",
			  object_each_data:{
				limit_date,
				limit_time,
				REQUEST_USER_BRANCH__user_branch_name:user_branch_name,
				REQUEST_USER_BRANCH__user_branch_tel:user_branch_tel,
				REQUEST_USER_BRANCH__user_branch_zip_code:user_branch_zip_code,
				REQUEST_USER_BRANCH__user_branch_user_addr:user_branch_user_addr,
				unspecified_flag,
				object_array_detail
			  },
			  object_common:{
				...estimateCommonParams.object_common,
				array_count
			  },
			  customer_system_use_flag:estimateData["customer_system_use_flag"],
			  attach_invoice_pdf: (supplier_invoice_enable ? this.state.data.values.attach_invoice_pdf : 0)
			}
			
			const pdfUrl = '/api/pout/D02_PDF';
			Request.post(pdfUrl, pdfParams, res=>{
			  if (res.Code>=800){
				Request.setProgress(0)
				resolve(undefined)
			  } else {
				resolve(res.Data)
			  }
			}, err => {
			  reject(err)
			})
		  }).then((resolvedData)=>{
				// console.log(resolvedData);
				return resolvedData;
				
			})
		  Request.setProgress(30)
		// console.log(d02pdf);
		const d02pdf_url = d02pdf.result.file_id&&`https://drive.google.com/uc?export=download&id=${d02pdf.result.file_id}`
		d02pdf&&window.open(d02pdf_url)

		// TODO :自動送付対応
		// console.log(estimateData);
		let history_message = null; // メール、FAX送信履歴
		if(application_form_auto_send_flag == 1){
			let supplier_invoice_enable = (this.state.data.values.supplier_invoice_business_type == null || this.state.data.values.supplier_invoice_business_type == 0 || this.state.data.values.supplier_invoice_business_type == 1 && (this.state.data.values.supplier_invoice_registration_number != "" && this.state.data.values.supplier_invoice_registration_number != null));
			const supplierCommonParams = {
				...estimateCommonParams,
				format_url:GoogleDrive.getFormatUrl(format_url.D02_MAIL),
				ESTIMATE__latest_pdf_application_form_url: d02pdf.result.spreadsheet_id,
				object_each_data:{
					APPLICATION__EMAIL: application_form_email,
					APPLICATION__FAX: application_form_fax,
					ESTIMATE__supplier_name: supplier_name,
					ESTIMATE__supplier_name_kana: supplier_name_kana,
					ESTIMATE__supplier_user_name: supplier_user_name,
					ESTIMATE__supplier_tel: supplier_tel,
					ESTIMATE__supplier_tel2: supplier_tel2,
					ESTIMATE__supplier_fax: supplier_fax,
  				},
				attach_invoice_pdf: (supplier_invoice_enable ? this.state.data.values.attach_invoice_pdf : 0)
			};
			Request.setProgress(40)
			// D02_MAIL_申込書 通知
			let d02Mail = (
				(application_form_send_target_status == 1 || application_form_send_target_status == 3)
			) 
			? new Promise((resolve, reject)=>{
				const mailUrl = '/api/pout/D02_MAIL'
				const mailParams = supplierCommonParams;
				Request.post(mailUrl, mailParams, res=>{
		//          console.log(res)
				resolve(res)
				}, err=>{
				reject(err)
				})
			})
			:{Code:200}
			Request.setProgress(50)

			const d02Results = await Promise.all([d02Mail]).then(r=>r).catch(()=>{
				Request.setProgress(0)  
				return 
			  })
		
			  d02Mail = d02Results && d02Results[0]

			let mail_send = false;
			let message = ""
			if (application_form_send_target_status == 1 || application_form_send_target_status == 3){
				// console.log(d02Mail);
				if(d02Mail.Code == 200){
					
					const sendMailUrl = '/api/send/MAIL'
					const list = d02Mail.Data || []
					const mailResult = await Promise.all(list.map((mailData)=>{
						return new Promise((resolve) => {
							Request.post(sendMailUrl, mailData, 
								res=>resolve(res), 
								err=>resolve({ Code: 900 }),
								undefined, true, false)
						})
					}))
					const success = mailResult.length > 0 && mailResult.every(r => r && r.Code == 200)
					console.log(mailResult,success)
					if (success){
						window.open(`https://mail.google.com/mail/u/0/#drafts`);
  						mail_send = true
					}else{
						this.props.alertModal.current.showErrorModal({
						message: GetMessage("2632")
						})
					}

				}
			}
			Request.setProgress(70)

			let fax_send = false;
			if(application_form_send_target_status == 2 || application_form_send_target_status == 3){
				const faxData = d02pdf.fax_data[0]
				// console.log(faxData);
				fax_send = true;
				const sendFaxUrl = '/api/send/FAX'
				Request.post(sendFaxUrl, faxData, res=>{
				
				}, err=>{
					
				},undefined, true, false)
			}

			// Mail,Faxを送信したなら履歴登録APIを呼び出す
			if(mail_send || fax_send) {
// 2024-03-23　14:00:00
// 　送信区分　　　：メール
// 　メールアドレス：test@test.jp
// 　送信内容　　　：申込書、インボイス対応請求書発行のお願いＰＤＦ
// 　ステータス　　：送付済み（下書き）
//
// 　送信区分　　　：ＦＡＸ
// 　ＦＡＸ番号　　：0300000000
//   送信内容　　　：申込書、インボイス対応請求書発行のお願いＰＤＦ
// 　ステータス　　：送付済み
				const now = new Date();
				const year = now.getFullYear();
				const month = ('0' + (now.getMonth() + 1)).slice(-2); // getMonth()は0を基準とするため、+1します
				const day = ('0' + now.getDate()).slice(-2);
				const hours = ('0' + now.getHours()).slice(-2);
				const minutes = ('0' + now.getMinutes()).slice(-2);
				const seconds = ('0' + now.getSeconds()).slice(-2);

				history_message = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				if(mail_send) {
					history_message = history_message + "\n" +
						"　送信区分　　　：メール\n" +
						"　メールアドレス：" + application_form_email + "\n" +
						"　送信内容　　　：申込書" + (supplierCommonParams.attach_invoice_pdf == 0 ? "" : "、インボイス対応請求書発行のお願いＰＤＦ") + "\n" +
						"　ステータス　　：送付済み（下書き）\n";
				}
				if(fax_send) {
					history_message = history_message + "\n" +
						"　送信区分　　　：ＦＡＸ\n" +
						"　メールアドレス：" + application_form_fax + "\n" +
						"　送信内容　　　：申込書" + (supplierCommonParams.attach_invoice_pdf == 0 ? "" : "、インボイス対応請求書発行のお願いＰＤＦ") + "\n" +
						"　ステータス　　：送付済み\n";
				}
				history_message = history_message + "\n";
			}
			Request.setProgress(80)
	
		}
		// console.log(this.state.data.values)
		// 確定通知
		const sendFixedNotification = Boolean(this.state.data.values.send_fixed_notification)

		if(sendFixedNotification){
			let messageNo = [2417];
			const {
				want_guide_type,
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				want_guide_type_subcontract,
				request_user_branch_natural_id:user_branch_natural_id,
				customer_system_use_flag
			  } = this.state.data.values
		
			  const estimateCommonParams = await Request.getEstimateCommon({
				  customer_branch_natural_id,
				  customer_user_natural_id,
				  project_natural_id,
				  request_natural_id,
				  subcontract_customer_branch_natural_id,
				  subcontract_customer_user_natural_id,
				  estimateObject: this.state.data.values,
				  user_branch_natural_id
			  })
			  const {
				CUSTOMER_USER__notification_flag,
				CUSTOMER_USER__customer_reminder_sms_flag_code,
				CUSTOMER_USER__customer_user_tel
			  } = estimateCommonParams.object_customer
			  const {
				CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
				CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
			  } = estimateCommonParams.object_customer_subcontract
			  const {
				PROJECT__send_destination_type
			  } = estimateCommonParams.object_project
			  Request.setProgress(60)
			  // D03_MAIL_確定通知
			  let d03Mail = (
				((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0"))
				||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))
			  ) 
			  ? new Promise((resolve, reject)=>{
				const mailUrl = '/api/pout/D03_MAIL'
				const mailParams = {
				  format_url:GoogleDrive.getFormatUrl(format_url.D03_MAIL),
				  send_destination_type:PROJECT__send_destination_type,
				  want_guide_type:want_guide_type,
				  want_guide_type_subcontract:want_guide_type_subcontract,
				  ...estimateCommonParams
				}
				Request.post(mailUrl, mailParams, res=>{
		//          console.log(res)
				  resolve(res)
				}, err=>{
				  reject(err)
				})
			  })
			  :{Code:200}
		
			  // D03_FAX_確定通知
			  let d03Fax = (
				((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="2"||want_guide_type=="0"))
				||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0"))
			  ) 
			  ? new Promise((resolve, reject)=>{
				const faxUrl = '/api/pout/D03_FAX'
				const faxParams = {
				  format_url:GoogleDrive.getFormatUrl(format_url.D03_FAX),
				  // 顧客システム利用の場合は元請けのFAXは作成しない
				  send_destination_type : customer_system_use_flag === 1 ? 1 : PROJECT__send_destination_type,
				  want_guide_type:want_guide_type,
				  want_guide_type_subcontract:want_guide_type_subcontract,        
				  ...estimateCommonParams
				}
				Request.post(faxUrl, faxParams, res=>{
		//          console.log(res)
				  resolve(res)
				}, err=>{
				  reject(err)
				})
			  })
			  :{Code:200}
		
			  // D03_SMS_確定通知
			  let isPushAllowedCust = estimateCommonParams.object_customer.CUSTOMER_USER__notification_flag=="1" ? true : false;
			  let isSmsAllowedCust = (estimateCommonParams.object_customer.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer.CUSTOMER_USER__customer_user_tel) ? true : false;
			  if(isPushAllowedCust){
				isSmsAllowedCust = false;
			  }
			  let d03Sms = (isSmsAllowedCust || isPushAllowedCust)
			  ? new Promise((resolve, reject)=>{
				const smsUrl = '/api/pout/D03_SMS'
				const smsParams = {
				  format_url:GoogleDrive.getFormatUrl(format_url.D03_SMS),
				  send_destination_type:PROJECT__send_destination_type,
				  want_guide_type:want_guide_type,
				  want_guide_type_subcontract:want_guide_type_subcontract,        
				  ...estimateCommonParams
				}
				Request.post(smsUrl, smsParams, res=>{
		//          console.log(res)
				  resolve(res)
				}, err=>{
				  reject(err)
				})
			  })
			  :{Code:200}
		
			  const d03Results = await Promise.all([d03Mail, d03Fax, d03Sms]).then(r=>r).catch(()=>{
				Request.setProgress(0)  
				return 
			  })
		
			  d03Mail = d03Results && d03Results[0]
			  d03Fax = d03Results && d03Results[1]
			  d03Sms = d03Results && d03Results[2]
		
			  Request.setProgress(60)
	
			  if (d03Mail.Code==200 && d03Fax.Code==200 && d03Sms.Code==200){
	
				const sendMailUrl = '/api/send/MAIL'
				d03Mail.Data&&d03Mail.Data.forEach((mailData)=>{
				  Request.post(sendMailUrl, mailData, res=>{
				  }, err=>{
					
				  },undefined, true, false)
				})
				
				// 顧客システム利用の場合は送付先が下請け、両方の場合のみ送付状を送信する
				if(customer_system_use_flag === 0){
				  const sendFaxUrl = '/api/send/FAX'
				  d03Fax.Data&&d03Fax.Data.forEach((faxData)=>{
					Request.post(sendFaxUrl, faxData, res=>{
					
					}, err=>{
					  
					},undefined, true, false)
				  })
				}

				const sendPush = isPushAllowedCust && d03Sms && 
					d03Sms.Data&&d03Sms.Data.forEach((smsData)=>{
						const sendPushParams = {...smsData,customer_user_id:estimateCommonParams.object_customer.CUSTOMER_USER__id}
						Request.post('/api/send/PUSH', sendPushParams, res=>{}, err=>{},undefined, true, false)
					})
					 

				const sendSms = isSmsAllowedCust && d03Sms && 
					d03Sms.Data&&d03Sms.Data.forEach((smsData)=>{
					  Request.post('/api/send/SMS', smsData, res=>{}, err=>{},undefined, true, false)
					})

		
				Request.setProgress(90)
		
				if(((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0")) 
				  ||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
				  window.open(`https://mail.google.com/mail/u/0/#drafts`);
				  messageNo.push(2471)
				}
		
			  }else{
				Request.setProgress(0)
			  }


			Request.setProgress(90)
		}

		let params = {
			order_box_status:2,
			// latest_pdf_application_form_url:d02pdf.result.file_id,
			latest_pdf_application_form_url:d02pdf.result.spreadsheet_id,
			return_deadline: return_deadline,
			application_form_email: application_form_email?application_form_email:"",
			application_form_fax: application_form_fax?application_form_fax:"",
			application_form_auto_send_flag: application_form_auto_send_flag?application_form_auto_send_flag:0,
			application_form_send_target_status: application_form_send_target_status?application_form_send_target_status:0,
			update_timestamp:update_timestamp,
	  	}
		if(history_message != null) {
			params.history_message = history_message;
		}


		const resultCode = await new Promise((resolve, reject)=>{
			Request.put('/api/order_box/application/' + this.state.data.values.estimate_ulid, params, async (res)=>{
			  resolve(res.Code)
		  },(err)=>{
			Request.setProgress(0)
			// reject(err)
		  })
		})
		Request.setProgress(0)
		
		document.body.style.overflow = "auto";
		this.props.alertModal.current.confirmCheck({
			title: "処理完了",
			messageNo: (application_form_send_target_status == 1 || application_form_send_target_status == 3) ? [2417,2471] : [2417],
			closeBtn: false
		  }, ()=>{
			this.props.refreshCallback()
			this.toggleModal();
		  }, false)
	}
	
	bodyContent() {
		let {application_form_auto_send_flag,application_form_send_target_status,
			supplier_invoice_business_type,
			supplier_invoice_registration_number,
			application_form_send_history,
		} = this.state.data.values;
		application_form_auto_send_flag = application_form_auto_send_flag == undefined ? 0 :application_form_auto_send_flag;
		// application_form_send_target_status = application_form_send_target_status == undefined ? 0:application_form_send_target_status;

		let supplier_invoice_enable = (supplier_invoice_business_type == null || supplier_invoice_business_type == 0 || supplier_invoice_business_type == 1 && (supplier_invoice_registration_number != "" && supplier_invoice_registration_number != null));
		// console.log(supplier_invoice_business_type);
		// console.log(supplier_invoice_enable,supplier_invoice_business_type == 0);

		return (
		  <>
			<Row>
  			  <Col md="3" style={{marginTop:"1rem"}}>
				返送期限
			  </Col>
			  <Col md="9" style={{marginTop:"1rem"}}>
				<InputDatetime
				  label='返送期限'
				  name='ESTIMATE__return_deadline'
				  labelOn={false}
				  validateCallback={this.validateCallback}
				  rootData={this.state.data}
				  validateType="regist"
				  timeFormat={true}
				/>
			  </Col>
			  <Col md="3" style={{marginTop:"1rem"}}>
				駐車車両
  			  </Col>
			  <Col md="9" style={{marginTop:"1rem"}}>
					<InputCheckBox
					label='不特定'
					name='NODB__unspecified_flag'
					labelOn={false}
					checkedValue={1}
					uncheckedValue={0}
					validateCallback={this.validateCallback}
					rootData={this.state.data}
					/>				
			  </Col>		
			  <Col md="3" style={{marginTop:"1rem"}}>
				  メールアドレス
			  </Col>
			  <Col md="9" style={{marginTop:"1rem"}}>
				<InputText
					label='メールアドレス'
					labelOn={false}
					name='ESTIMATE__application_form_email'
					validateCallback={this.validateCallback}
					rootData={this.state.data}
					validateType="regist"
					disabled={application_form_auto_send_flag==0}
				/>
			  </Col>
			  <Col md="3" style={{marginTop:"1rem"}}>
				FAX
			  </Col>
			  <Col md="9" style={{marginTop:"1rem"}}>
				<InputText
					label='FAX'
					labelOn={false}
					name='ESTIMATE__application_form_fax'
					validateCallback={this.validateCallback}
					rootData={this.state.data}
					validateType="regist"
					disabled={application_form_auto_send_flag==0}
				/>
			  </Col>
			  <Col md="3" style={{marginTop:"1rem"}}>
				自動送信選択
			  </Col>
			  <Col md="9" style={{marginTop:"1rem"}}>
			  	<InputRadio
					options={cst_application_form_auto_send_flag}
					name='ESTIMATE__application_form_auto_send_flag'
					validateCallback={this.validateCallback}
					validateType='regist'
					rootData={this.state.data}
				/>
			  </Col>
			  <Col md="3" style={{marginTop:"1rem"}}>
				送信対象
			  </Col>
			  <Col md="9" style={{marginTop:"1rem"}}>
			 	 <InputCheckBox
				  label='メール'
				  name='NODB__send_mail'
				  labelOn={false}
				  checkedValue={1}
				  uncheckedValue={0}
				  validateCallback={this.validateCallback}
				  rootData={this.state.data}
				  disabled={application_form_auto_send_flag==0}
				/>				
			 	 <InputCheckBox
				  label='FAX'
				  name='NODB__send_fax'
				  labelOn={false}
				  checkedValue={1}
				  uncheckedValue={0}
				  validateCallback={this.validateCallback}
				  rootData={this.state.data}
				  disabled={application_form_auto_send_flag==0}
				/>
			  </Col>
			  <Col md="3" style={{marginTop:"1rem"}}>
				
			  </Col>
			  {/* <Col md="9" style={{marginTop:"1rem"}}>
			 	 <InputCheckBox
				  label='駐車場の確定通知を送る'
				  name='NODB__send_fixed_notification'
				  labelOn={false}
				  checkedValue={1}
				  uncheckedValue={0}
				  validateCallback={this.validateCallback}
				  rootData={this.state.data}
				/>				
			  </Col> */}
			  {supplier_invoice_enable && application_form_auto_send_flag == 1 && <>
				<Col md="3" style={{marginTop:"1rem"}}>
					
				</Col>
				<Col md="9" style={{marginTop:"1rem"}}>
					<InputCheckBox
					label='インボイス発行対応請求書発行のお願いPDFも出力する'
					name='NODB__attach_invoice_pdf'
					labelOn={false}
					checkedValue={1}
					uncheckedValue={0}
					validateCallback={this.validateCallback}
					rootData={this.state.data}
					/>				
				</Col>
			  </>}
			  <Col md="12" style={{marginTop:"1rem"}}>
				送信履歴
			  </Col>
			  <Col md="12" style={{marginTop:"1rem"}}>
				<Input
					type={"textarea"}
					value={application_form_send_history}
					onChange={()=>{}}
					disabled={true}
				/>
			  </Col>
			</Row>		  
		  </>
		);
	}
}

export class DialogUploadFileOther extends DialogBase{
	constructor(props) {
	  super(props);
  
	  Object.assign(this.state, {
		title: 'その他資料アップロード',
		data: this.props.data,
		landmark_user: props.landmark_user,
		cuFiles: []
	  });
	  this.validateCallback = this.validateCallback.bind(this)

	  this.DELETE_LINK_STATUS = 0
	  this.REACTIVATE_LINK_STATUS = 1
	  this.FILE_TYPE = 3
	  this.FILE_DETAIL_TYPE = 309
	  this.EXEC_REPORT = "Z99" // レポートを出すわけではないが　file_type:3, file_detail_type:309でファイルをアップロードするためにはたまたま一致しているこれを使う（custorder_settings.py: cu_file_settings）
	}
	componentDidUpdate(prevProps){
	  const {FILE_TYPE, FILE_DETAIL_TYPE} = this
  
	  if (prevProps.data !== this.props.data){
  
		// ファイル情報取得
		Request.get('/api/cufile', { ref_id : this.props.data.values.estimate_id, file_detail_type : FILE_DETAIL_TYPE, file_type : FILE_TYPE  }, res => {
		  this.setState({
			cuFiles : res.Data
		  })
		})
  
		this.setState({
		  data: {
			values:{
			  ...this.props.data.values,
			},
			errors:{
			  otherfile:[GetMessage(2024)]
			},
			requiredData:{
			  otherfile:[GetMessage(2024)],
			}
		  },
		})
	  }
	}
	
	validateCallback(newData, callback=()=>{}){
	  this.setState({
		data:{
		  ...this.state.data,
		  ...newData
		},
	  }, ()=>callback())
	}
	validate(){
	  let message = getErrorCodes(this.state.data.errors)
  
	  if(message.length > 0){
		this.props.alertModal.current.showErrorModal({messageNo:message});
		return false;
	  }
	  return true;
	}

	async handleClickPositive(){
	  const {EXEC_REPORT} = this
  
	  if(!this.validate()){
		return;
	  }
	  Request.setProgress(10)
  
	  const {
		customer_id,
		customer_branch_id,
		customer_user_id,
		otherfile,
		otherfile_base64,
		estimate_id
	  } = this.state.data.values    
  
	  Request.setProgress(20)
  
	  try {
		// const useCustomerSystem = Boolean(this.state.data.values.customer_system_use_flag)
		const wasFileUploaded = this.state.data.values["otherfile_base64"] !== undefined
  
		const file_upload = wasFileUploaded && await new Promise((resolve, reject)=>{
		  const file_upload_url = "/api/gcs_upload/attach"
		  const uploadParams = {
			customer_id,
			ref_id:estimate_id,
			customer_branch_id,
			exec_report:EXEC_REPORT,
			customer_user_id,
			fileName:otherfile,
			base64_str:otherfile_base64
		  }
		  Request.post(file_upload_url, uploadParams, res => resolve(res), err => reject(err))
		})
		
		Request.setProgress(0)
	
		document.body.style.overflow = "auto";
		this.props.alertModal.current.confirmCheck({
		  title: "処理完了",
		  messageNo: 2417,
		  closeBtn: false
		}, ()=>{
		  this.props.refreshCallback()
		  this.toggleModal();
		},false)
  
	  } catch (error) {
		Request.setProgress(0)
		document.body.style.overflow = "auto";
		this.props.alertModal.current.showErrorModal({
		  messageNo: 2476
		})
	  }
	}

	handleClickNegative(){
	  this.props.handleClickNegative && this.props.handleClickNegative();
	  this.setState({
		data:{
		  ...this.state.data,
		  otherfile:"",
		  otherfile_base64:"",
		}
	  })
  
	  this.toggleModal()
	}
  
	handleDeleteLink(fileId){
  
	  const [targetFile] = this.state.cuFiles.filter(file => file.file_id === fileId)
	  targetFile["status"] = this.DELETE_LINK_STATUS
  
	  Request.put(`/api/cufile/${fileId}`,targetFile,(res)=>{
		const updatedCuFiles = this.state.cuFiles.map(file =>{
		  if(file.file_id === fileId){
			file.status = this.DELETE_LINK_STATUS
		  }
		  return file
		})
		
		this.setState({
		  cuFiles:updatedCuFiles
		})
	  })
	}
  
	handleReactivateLink(fileId){
  
	  const [targetFile] = this.state.cuFiles.filter(file => file.file_id === fileId)
	  targetFile["status"] = this.REACTIVATE_LINK_STATUS
  
	  Request.put(`/api/cufile/${fileId}`,targetFile,(res)=>{
  
		const updatedCuFiles = this.state.cuFiles.map(file =>{
		  if(file.file_id === fileId){
			file.status = this.REACTIVATE_LINK_STATUS
		  }
		  return file
		})
		
		this.setState({
		  cuFiles:updatedCuFiles
		})
	  })
	}
	
	bodyContent() {
	  return (
		<>
		  <InputFile 
			label="その他資料"
			name="CU_FILE__otherfile"
			copy={false}
			showLink={true}
			validateCallback={this.validateCallback} 
			rootData={this.state.data} />
  
		  {this.state.cuFiles.map((file, index) => (
			<Row key={index}>
				<Col>
				  <a className={file.status === 0 ? "disabled-link":""} href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">{file.file_name}</a>      
				</Col>
				<Col>
				  <Button onClick={()=>{this.handleDeleteLink(file.file_id)}}color="danger" size="sm" disabled={file.status === 0}>削除</Button>
				  <Button onClick={()=>{this.handleReactivateLink(file.file_id)}} className="ml-3" color="secondary" size="sm" disabled={file.status === 1}>戻す</Button>
				</Col>
			</Row>
		  ))}
		  <br/>
		</>
	  );
	}
}


export class DialogUploadFileInvoice extends DialogBase{
	constructor(props) {
	  super(props);
  
	//   console.log(this.props.data);
	  Object.assign(this.state, {
		title: 'ファイルアップロード',
		data: this.props.data,
		landmark_user: props.landmark_user,
	  });
	  this.validateCallback = this.validateCallback.bind(this)

	}
	componentDidUpdate(prevProps){
		if (prevProps.data !== this.props.data){
			const estimate_id = this.props.data.values.id;
			const {
				latest_pdf_supplier_invoice_url,
				survey_parking_address_contract,
				request_type,
				survey_cost_parking_rent,
				survey_cost_parking_rent_payment_type,
				survey_cost_parking_rent_invoice_business_type,
				survey_cost_commission,
				survey_cost_commission_payment_type,
				survey_cost_commission_invoice_business_type,
				survey_cost_key_money,
				survey_cost_key_money_payment_type,
				survey_cost_key_money_invoice_business_type,
				survey_cost_other,
				survey_cost_other_payment_type,
				survey_cost_other_invoice_business_type,
				survey_subtotal_amt,
			} = this.props.data.values;
			let supplier_error =  this.valicateSupplierInvoiceNumber(this.props.data.values)

			this.setState({
				data: {
				values:{
					...this.props.data.values,
					latest_pdf_supplier_invoice_url: latest_pdf_supplier_invoice_url ? latest_pdf_supplier_invoice_url : "",
					survey_parking_address_contract: survey_parking_address_contract ? survey_parking_address_contract : "",
				},
				errors:{
					...((this.props.data.values.latest_pdf_supplier_invoice_url)?{latest_pdf_supplier_invoice_url:null}:{latest_pdf_supplier_invoice_url:[GetMessage(2024)]}),
					...((this.props.data.values.survey_parking_address_contract)?{survey_parking_address_contract:null}:{survey_parking_address_contract:[GetMessage(2024)]}),
					// survey_cost_parking_rent_payment_type: survey_cost_parking_rent > 0 || request_type == 3 && survey_subtotal_amt > 0 ? 
					survey_cost_parking_rent_payment_type: survey_cost_parking_rent > 0 ? 
					survey_cost_parking_rent_payment_type == 0 && supplier_error == true ?
															[GetMessage(2602)] :
															 	survey_cost_parking_rent_payment_type == null || 
															 	survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == null || 
															 	survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == 0 ? 
																	[GetMessage(2603)] : "" : "",
					// survey_cost_commission_payment_type: request_type != 3 && survey_cost_commission > 0 ?  
					survey_cost_commission_payment_type: survey_cost_commission > 0 ?  
															survey_cost_commission_payment_type == 0 && supplier_error == true ?
															[GetMessage(2602)] :
																survey_cost_commission_payment_type == null || 
																survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == null || 
																survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == 0 ? 
																	[GetMessage(2603)] : "" : "",
					survey_cost_key_money_payment_type: survey_cost_key_money > 0 ?  
															survey_cost_key_money_payment_type == 0 && supplier_error == true ?
															[GetMessage(2602)] :
																survey_cost_key_money_payment_type == null || 
																survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == null || 
																survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == 0 ? 
																	[GetMessage(2603)] : "" : "",
					survey_cost_other_payment_type: survey_cost_other > 0 ? 
															survey_cost_other_payment_type == 0 && supplier_error == true ? 
															[GetMessage(2602)] :
																survey_cost_other_payment_type == null  || 
																survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == null || 
																survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == 0 ? 
																	[GetMessage(2603)] : "" : "",
				
				},
				requiredData:{
					latest_pdf_supplier_invoice_url: [GetMessage(2024)],
					survey_parking_address_contract: [GetMessage(2024)],
				}
				},
			},()=>{}
			)
		}		
	}
	// 適格事業者番号のバリデーションチェック
	// 区分が1の場合=>適格事業者番号のバリデーションチェックを行う、エラーの場合はエラーコードを返す
	// 区分が2の場合=>""空を返す
	validateInvoiceNumber (type,number) {
		if ( type == 1) {
			if (!number)  {
			return [GetMessage(2601)]
			}
			if (!number.match(/^T\d{13}$/)) {
			return [GetMessage(2035)]
			}
			return ""
		}
		else if ( type == 2 ) {
			return ""
		} 
	}
	
	validateCallback(newData, callback=()=>{}){
		let errors = newData.errors
		// console.log(this.state.data)

		let {
			request_type,
			survey_cost_parking_rent,
			survey_cost_commission,
			survey_cost_key_money,
			survey_cost_parking_rent_payment_type,
			survey_cost_parking_rent_invoice_business_type,
			survey_cost_parking_rent_invoice_registration_number,
			survey_cost_commission_payment_type,
			survey_cost_commission_invoice_business_type,
			survey_cost_commission_invoice_registration_number,
			survey_cost_key_money_payment_type,
			survey_cost_key_money_invoice_business_type,
			survey_cost_key_money_invoice_registration_number,
			survey_cost_other,
			survey_cost_other_payment_type,
			survey_cost_other_invoice_business_type,
			survey_cost_other_invoice_registration_number,
			survey_subtotal_amt,
		} = newData.values;

		// console.log(newData.values);
		let supplier_error =  this.valicateSupplierInvoiceNumber(newData.values)

		this.setState({
			data:{
			...this.state.data,
			...newData,
			errors:{
				...errors,
				// survey_cost_parking_rent_payment_type: survey_cost_parking_rent > 0 || request_type == 3 && survey_subtotal_amt > 0 ? 
				survey_cost_parking_rent_payment_type: survey_cost_parking_rent > 0 ? 
														survey_cost_parking_rent_payment_type == 0 && supplier_error == true ? 
															[GetMessage(2602)] :
															survey_cost_parking_rent_payment_type == null || 
															survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == null || 
															survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == 0 ? 
																[GetMessage(2603)] : "" :"",
				// survey_cost_commission_payment_type: request_type != 3 && survey_cost_commission > 0 ? 
				survey_cost_commission_payment_type: survey_cost_commission > 0 ? 
														survey_cost_commission_payment_type == 0 && supplier_error == true ? 
															[GetMessage(2602)] :
															survey_cost_commission_payment_type == null || 
															survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == null || 
															survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == 0 ? 
																[GetMessage(2603)] :"":"",
				// survey_cost_key_money_payment_type: request_type != 3 && survey_cost_key_money > 0 ? 
				survey_cost_key_money_payment_type: survey_cost_key_money > 0 ? 
														survey_cost_key_money_payment_type == 0 && supplier_error == true ? 
															[GetMessage(2602)] :
															survey_cost_key_money_payment_type == null || 
															survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == null || 
															survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == 0 ? 
																[GetMessage(2603)] : "":"",
				survey_cost_other_payment_type: survey_cost_other > 0 ? 
														survey_cost_other_payment_type == 0 && supplier_error == true ? 
															[GetMessage(2602)] :
															survey_cost_other_payment_type == null || 
															survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == null || 
															survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == 0 ? 
																[GetMessage(2603)] : "":"",
				survey_cost_parking_rent_invoice_registration_number: survey_cost_parking_rent_payment_type==1? this.validateInvoiceNumber(survey_cost_parking_rent_invoice_business_type,survey_cost_parking_rent_invoice_registration_number):"",
				survey_cost_commission_invoice_registration_number: survey_cost_commission_payment_type==1? this.validateInvoiceNumber(survey_cost_commission_invoice_business_type,survey_cost_commission_invoice_registration_number):"",
				survey_cost_key_money_invoice_registration_number: survey_cost_key_money_payment_type==1? this.validateInvoiceNumber(survey_cost_key_money_invoice_business_type,survey_cost_key_money_invoice_registration_number):"",
				survey_cost_other_invoice_registration_number: survey_cost_other_payment_type==1? this.validateInvoiceNumber(survey_cost_other_invoice_business_type,survey_cost_other_invoice_registration_number):"",					
				}
			}
		}, ()=>callback())  
	
	}
	validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	}
	
	valicateSupplierInvoiceNumber(values){
		let {
			supplier_invoice_business_type,
			supplier_invoice_registration_number
		} = values;
		return  (supplier_invoice_business_type == null || supplier_invoice_business_type == 0 || (supplier_invoice_business_type == 1 && (supplier_invoice_registration_number == "" || supplier_invoice_registration_number == null)))
		
	}


	handleClickPositive(){
		if(!this.validate()){
			return;
		  }
		  Request.setProgress(10)
		  const uploadParams = {
			// ...this.state.data.values,
			request_id: this.state.data.values.request_id,
			latest_pdf_supplier_invoice_url_base64: this.state.data.values.latest_pdf_supplier_invoice_url_base64,
			survey_parking_address_contract: this.state.data.values.survey_parking_address_contract,
			parking_id: this.state.data.values.parking_id,
			update_timestamp : this.state.data.values.update_timestamp,
			estimate_id: this.state.data.values.estimate_id,
			survey_cost_commission_payment_type: this.state.data.values.survey_cost_commission_payment_type,
			survey_cost_commission_invoice_business_type: this.state.data.values.survey_cost_commission_invoice_business_type,
			survey_cost_commission_invoice_registration_number: this.state.data.values.survey_cost_commission_invoice_registration_number,
			survey_cost_key_money_payment_type: this.state.data.values.survey_cost_key_money_payment_type,
			survey_cost_key_money_invoice_business_type: this.state.data.values.survey_cost_key_money_invoice_business_type,
			survey_cost_key_money_invoice_registration_number: this.state.data.values.survey_cost_key_money_invoice_registration_number,
			survey_cost_parking_rent_payment_type: this.state.data.values.survey_cost_parking_rent_payment_type,
			survey_cost_parking_rent_invoice_business_type: this.state.data.values.survey_cost_parking_rent_invoice_business_type,
			survey_cost_parking_rent_invoice_registration_number: this.state.data.values.survey_cost_parking_rent_invoice_registration_number,
			survey_cost_other_payment_type: this.state.data.values.survey_cost_other_payment_type,
			survey_cost_other_invoice_business_type: this.state.data.values.survey_cost_other_invoice_business_type,
			survey_cost_other_invoice_registration_number: this.state.data.values.survey_cost_other_invoice_registration_number,
		}

		  Request.put('/api/order/file_upload/' + this.state.data.values.estimate_ulid, uploadParams, async res=>{
		  },(err)=>{
			Request.setProgress(0)
		  })
		  Request.setProgress(0)
		  document.body.style.overflow = "auto";
		  this.props.alertModal.current.confirmCheck({
			title: "処理完了",
			messageNo: [2417],
			closeBtn: false
		  }, ()=>{
			this.props.refreshCallback()
			this.toggleModal();
		  }, false)
  
	}
	
	bodyContent() {
		let {
			request_type,
			survey_cost_parking_rent,
			survey_cost_commission,
			survey_cost_key_money,
			survey_cost_other,
			survey_cost_total_amt,
			quote_cost_total_amt:_quote_cost_total_amt
		} = this.state.data.values

		survey_cost_parking_rent = survey_cost_parking_rent && survey_cost_parking_rent != null ? parseInt(survey_cost_parking_rent): 0
		survey_cost_commission = survey_cost_commission && survey_cost_commission != null ? parseInt(survey_cost_commission): 0
		survey_cost_key_money = survey_cost_key_money && survey_cost_key_money != null ? parseInt(survey_cost_key_money): 0
		survey_cost_other = survey_cost_other && survey_cost_other != null ? parseInt(survey_cost_other): 0
		let quote_cost_total_amt = _quote_cost_total_amt ? _quote_cost_total_amt : survey_cost_total_amt

		return (
		  <>
			<InputFile 
			  label="受領請求書"
			  name="ESTIMATE__latest_pdf_supplier_invoice_url"
			  copy={false}
			  showLink={true}
			  validateCallback={this.validateCallback} 
			  rootData={this.state.data} 
			  filename={`受領請求書_${moment().format("YYYYMMDDHHmmss")}&extension=true`}
			  />
			<span>支払先：</span>
			<InputInvoice
				// label={request_type == 3 ? "　":"　　賃料　　"}
				label={"　　賃料　　"}
				labelOn={true}
				names={{
					payment_type: "ESTIMATE__survey_cost_parking_rent_payment_type",
					business_type: "ESTIMATE__survey_cost_parking_rent_invoice_business_type",
					registration_number: "ESTIMATE__survey_cost_parking_rent_invoice_registration_number",
					with_unconfirmed: "ESTIMATE__survey_cost_parking_rent_invoice_business_type"
				}}
				rootData={this.state.data}
				validateCallback={this.validateCallback}
				visible={true}
				viewUntax={true}
				// disabled={request_type == 3 ? quote_cost_total_amt <= 0 : survey_cost_parking_rent <= 0}
				disabled={survey_cost_parking_rent <= 0}
			/>
			{this.state.data.errors.survey_cost_parking_rent_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_parking_rent_payment_type}</p> : ""}
			{/* {request_type != 3 &&(<> */}
				<InputInvoice
					label="　手数料　　"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_commission_payment_type",
						business_type: "ESTIMATE__survey_cost_commission_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_commission_invoice_registration_number",
						with_unconfirmed: "ESTIMATE__survey_cost_commission_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={survey_cost_commission <= 0}
					viewUntax={true}
					/>
				{this.state.data.errors.survey_cost_commission_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_commission_payment_type}</p> : ""}

				<InputInvoice
					label="　　礼金　　"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_key_money_payment_type",
						business_type: "ESTIMATE__survey_cost_key_money_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_key_money_invoice_registration_number",
						with_unconfirmed: "ESTIMATE__survey_cost_key_money_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={survey_cost_key_money <= 0}
					viewUntax={true}						
					/>
				{this.state.data.errors.survey_cost_key_money_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_key_money_payment_type}</p> : ""}

				<InputInvoice
					label="　その他　　"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_other_payment_type",
						business_type: "ESTIMATE__survey_cost_other_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_other_invoice_registration_number",
						with_unconfirmed: "ESTIMATE__survey_cost_other_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={survey_cost_other <= 0}
					viewUntax={true}
					/>
				{this.state.data.errors.survey_cost_other_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_other_payment_type}</p> : ""}


			{/* </>)} */}
			  <InputText
					label='土地の地番（契約書記載の所在地）'
					labelOn={true}
					name='ESTIMATE__survey_parking_address_contract'
					validateCallback={this.validateCallback} 
					rootData={this.state.data}
					validateType='regist'
				/>
		  </>
		);
	}
}
export class DialogOrderConfirm extends DialogBase{
	constructor(props) {
		super(props);
		const now = new Date();
		const buf = moment(now);
		this.defaultData = buf.format("YYYY-MM-DD")
		// console.log(this.props.data);
		Object.assign(this.state, {
		  title: '受注確認',
		  size: "xlg",
		  data:{
			...this.props.data,
			values:{
			  ...this.props.data.values,
			  quote_available_start_date : this.defaultData ,
			  quote_available_end_date : this.defaultData ,
			  quote_capacity_qty : 0,
			},
			errors:{}
		  },
		  cuEstimate :{
			values:{},
			errors:{},
			requiredData:{},
			check:false,  
		  },
		  latest_pdf_plotting_url: undefined,
		  latest_pdf_quote_url: undefined,
		  latest_pdf_quote_file: undefined,
		  contract_pdf_url: undefined,
		  contract_pdf_file: undefined,
		  payment_deadline: undefined,
		  pdf_created: false,
		  pdf_registed: false,
		  estimateData:{},
		  pdfParams:{},
		});
		// console.log(this.props.data)
		this.validateCallback = this.validateCallback.bind(this)
		this.invoiceValidateCallback = this.invoiceValidateCallback.bind(this)
		this.getCountsFromDuration = this.getCountsFromDuration.bind(this)
		this.createCustomEstimateDetails = this.createCustomEstimateDetails.bind(this)
		this.validate = this.validate.bind(this)
		this.requestEstimatePDF = this.requestEstimatePDF.bind(this)

		this.togglePdfRegistModal = this.togglePdfRegistModal.bind(this)
		this.pdfCreateReqest = this.pdfCreateReqest.bind(this)
		this.pdfCreate = this.pdfCreate.bind(this)
		this.fileUpload = this.fileUpload.bind(this)
		this.updateStatus = this.updateStatus.bind(this)

		this.EstimateQuoteCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].customer_natural_id; // 共ショウ

		this.customerUseCustomizedEstimate = custom_report.estimate.survey["アイダ設計"].customer_natural_id // アイダ設計
		this.customerUseCustomizedEstimateForTouken = custom_report.estimate.survey["東建コーポレーション"].customer_natural_id // 東建コーポレーション

	  }
	
	valicateSupplierInvoiceNumber(values){
		let {
			supplier_invoice_business_type,
			supplier_invoice_registration_number
		} = values;
		return  (supplier_invoice_business_type == null || supplier_invoice_business_type == 0 || (supplier_invoice_business_type == 1 && (supplier_invoice_registration_number == "" || supplier_invoice_registration_number == null)))
	
	}

	  async componentDidUpdate(prevProps, prevState){
		if(prevProps.data!=this.props.data){
		//   console.log(this.props.data)
		  const estimate_id = this.props.data.values.id;

		  const {
			request_type,
			survey_tax_in_flag,
			quote_available_start_date,
			survey_available_start_date,
			order_start_date,
			quote_available_end_date,
			survey_available_end_date,
			order_end_date,
			quote_capacity_qty,
			order_capacity_qty,
			survey_capacity_qty,
			survey_cost_security_deposit,
			quote_cost_security_deposit_total_amt,
			quote_cost_total_amt,
			survey_cost_parking_rent,
			survey_cost_parking_rent_payment_type,
			survey_cost_parking_rent_invoice_business_type,
			survey_cost_commission,
			survey_cost_commission_payment_type,
			survey_cost_commission_invoice_business_type,
			survey_cost_key_money,
			survey_cost_key_money_payment_type,
			survey_cost_key_money_invoice_business_type,
			survey_cost_other,
			survey_cost_other_payment_type,
			survey_cost_other_invoice_business_type,
			survey_subtotal_amt,
			survey_estimate_detail_amt,
			survey_estimate_detail_amt_ex
		  } = this.props.data.values

		  let supplier_error =  this.valicateSupplierInvoiceNumber(this.props.data.values)

		  //   console.log(this.props.data.values.quote_capacity_qty,this.props.data.values.order_start_date);

		  let tmp_quote_available_start_date = quote_available_start_date ? quote_available_start_date : order_start_date ? order_start_date : survey_available_start_date
		  let tmp_quote_available_end_date = quote_available_end_date ? quote_available_end_date : order_end_date ? order_end_date : survey_available_end_date
		  let tmp_quote_capacity_qty = quote_capacity_qty ? quote_capacity_qty : order_capacity_qty ? order_capacity_qty : survey_capacity_qty ? survey_capacity_qty: ""
		  
		  // #1546 一条工務店、東建口座チェック対応
		  let bank_required_error = false;
		  let cf = custom_report.contract.filter((c)=>{
			return c.customer_natural_id == this.props.data.values.customer_natural_id
		  })

		  if (cf.length > 0 && cf[0].bank_required_checkflg == true) {
			let {
				invoice_bank_name,
				invoice_bank_branch_name,
				invoice_bank_account_type,
				invoice_bank_account_number
			} = this.props.data.values
			// 口座情報が登録されていない→エラー表示
			if (invoice_bank_name==null || 
				invoice_bank_branch_name==null ||
				invoice_bank_account_type==null ||
				invoice_bank_account_number==null) 
			{
				bank_required_error = true;
			}
		  }
		//   console.log(this.props.data.values)

		  //   課税項目
		  const estimate_detail_amt = this.props.data.values.estimate_detail_id != null ? this.props.data.values.estimate_detail_amt : this.props.data.values.survey_estimate_detail_amt != null ? this.props.data.values.survey_estimate_detail_amt : ""
		  //   非課税項目
		  const estimate_detail_amt_ex = this.props.data.values.estimate_detail_id_ex  != null ? this.props.data.values.estimate_detail_amt_ex : this.props.data.values.survey_estimate_detail_amt_ex != null ? this.props.data.values.survey_estimate_detail_amt_ex : ""

		//   契約書>確定見積モーダルの「はい」ボタンは初期表示時非活性
		  const no_protting_number_change = this.props.data.values.order_box_status >= 7 &&this.props.data.values.order_box_status <= 10;
		  this.setState({
			disablePositive: no_protting_number_change || bank_required_error, // 口座未登録時の対応
			data:{
			  ...this.props.data,
			  values:{
				...this.props.data.values,
				old_quote_available_start_date : this.props.data.values.survey_available_start_date,
				old_quote_available_end_date : this.props.data.values.survey_available_end_date,
				old_quote_capacity_qty : this.props.data.values.survey_capacity_qty,
				estimate_change_flag: this.props.data.values.estimate_change_flag,
				quote_available_start_date : tmp_quote_available_start_date,
				quote_available_end_date : tmp_quote_available_end_date,
				quote_capacity_qty : tmp_quote_capacity_qty ,
				order_contact_memo: this.props.data.values.order_contact_memo,
				non_taxable_flag : this.props.data.values.non_taxable_flag != null ? this.props.data.values.non_taxable_flag : cst_non_taxable_flag[0].default, 
				quote_term_month_flag : this.props.data.values.quote_term_month_flag,
				quote_cost_total_amt : undefined,
				quote_subtotal_amt : undefined,
				quote_total_amt : undefined,
				quote_estimate_amt : undefined,
				// quote_subtotal_amt : (request_type == 3 && survey_tax_in_flag == 0) ? this.props.data.values.survey_subtotal_amt : undefined,
				// quote_total_amt : (request_type == 3 && survey_tax_in_flag == 1) ? this.props.data.values.survey_total_amt : undefined,
				survey_cost_security_deposit: survey_cost_security_deposit,
				payment_deadline: this.props.data.values.payment_deadline == null? "" :  this.props.data.values.payment_deadline,
				quote_plotting_number: this.props.data.values.quote_plotting_number,
				estimate_detail_amt,
				estimate_detail_amt_ex,
				estimate_detail_name:this.props.data.values.estimate_detail_id  != null? this.props.data.values.estimate_detail_name : this.props.data.values.survey_estimate_detail_name,
				estimate_detail_name_ex:this.props.data.values.estimate_detail_id_ex  != null ? this.props.data.values.estimate_detail_name_ex : this.props.data.values.survey_estimate_detail_name_ex
			  },
			  errors:{
				quote_plotting_number:this.props.data.values.quote_plotting_number == null || this.props.data.values.quote_plotting_number == "" ?[GetMessage(2024)] : undefined,
				bank_required_error : bank_required_error,
				survey_cost_parking_rent_payment_type: survey_cost_parking_rent > 0  ? 
															survey_cost_parking_rent_payment_type == 0 && supplier_error == true ? 
																[GetMessage(2602)] :
																	survey_cost_parking_rent_payment_type == null || 
																	survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == null || 
																	survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_commission_payment_type: survey_cost_commission > 0 ? 
															survey_cost_commission_payment_type == 0 && supplier_error == true ? 
																[GetMessage(2602)] :
																	survey_cost_commission_payment_type == null || 
																	survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == null || 
																	survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_key_money_payment_type: survey_cost_key_money > 0 ? 
															survey_cost_key_money_payment_type == 0 && supplier_error == true ?
																[GetMessage(2602)] :
																	survey_cost_key_money_payment_type == null  || 
																	survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == null || 
																	survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_other_payment_type: survey_cost_other > 0 ? 
															survey_cost_other_payment_type == 0 && supplier_error == true ?
																[GetMessage(2602)] :
																	survey_cost_other_payment_type == null  || 
																	survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == null || 
																	survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_parking_rent: survey_cost_parking_rent == null ? [GetMessage(2024)] : undefined,
				survey_cost_commission: survey_cost_commission == null ? [GetMessage(2024)] : undefined,
				survey_cost_key_money: survey_cost_key_money == null ? [GetMessage(2024)] : undefined,
				survey_cost_other: survey_cost_other == null ? [GetMessage(2024)] : undefined,
				},
			  requiredData:{
				// latest_pdf_supplier_invoice_url:[GetMessage(2024)],
				quote_available_start_date:[GetMessage(2024)],
				quote_available_end_date:[GetMessage(2024)],
				quote_capacity_qty:[GetMessage(2024)],
				quote_cost_total_amt:[GetMessage(2024)],
				quote_subtotal_amt:[GetMessage(2024)],
				quote_total_amt:[GetMessage(2024)],
				quote_plotting_number: [GetMessage(2024)],
				survey_cost_parking_rent: [GetMessage(2024)],
				survey_cost_commission: [GetMessage(2024)],
				survey_cost_key_money: [GetMessage(2024)],
				survey_cost_other: [GetMessage(2024)],
			  }
			}
		  })
		}
	
		const prevStateData = prevState.data.values
		const {
		  quote_available_start_date,
		  quote_available_end_date,
		  quote_term_month_flag,
		  quote_capacity_qty,
		  survey_parking_rent,
		  survey_key_money,
		  survey_discount_amt,
		  survey_adjustment_amt,
		  survey_fraction_amt_flag,
		  survey_tax_in_flag,
		  survey_commission_discount_amt,
		  customer_branch_natural_id,
		  customer_natural_id,
		  request_type,
		  survey_cost_parking_rent,
		  survey_cost_security_deposit,
		  survey_cost_key_money,
		  survey_cost_commission,
		  survey_cost_other,
		  quote_cost_adjustment,
		  survey_term_month_flag,
		  change_invoice_flag,
		  order_capacity_qty,
		  survey_capacity_qty,
		  estimate_detail_amt,
		  estimate_detail_amt_ex
		} = this.state.data.values
		let { 
		  quote_cost_total_amt,
		  quote_subtotal_amt,
		  quote_total_amt,
		  tax_in_flag,
		  quote_estimate_amt
		} = this.state.data.values;
		// 仕入額の変更対応
		if (
		  (quote_available_start_date!=prevStateData.quote_available_start_date)||
		  (quote_available_end_date!=prevStateData.quote_available_end_date) ||
		  (quote_term_month_flag!=prevStateData.quote_term_month_flag) ||
		  (quote_capacity_qty!=prevStateData.quote_capacity_qty) ||
		  (quote_cost_total_amt!=prevStateData.quote_cost_total_amt) ||
		  (quote_subtotal_amt!=prevStateData.quote_subtotal_amt) ||
		  (quote_total_amt!=prevStateData.quote_total_amt) ||
		  (survey_cost_parking_rent!=prevStateData.survey_cost_parking_rent) ||
		  (survey_cost_commission!=prevStateData.survey_cost_commission) ||
		  (survey_cost_security_deposit!=prevStateData.survey_cost_security_deposit) ||
		  (survey_cost_key_money!=prevStateData.survey_cost_key_money) ||
		  (survey_cost_other!=prevStateData.survey_cost_other) ||
		  (quote_cost_adjustment!=prevStateData.quote_cost_adjustment) ||
		  (estimate_detail_amt!=prevStateData.estimate_detail_amt) ||
		  (estimate_detail_amt_ex!=prevStateData.estimate_detail_amt_ex) || 
		  (quote_estimate_amt != prevStateData.quote_estimate_amt)
		){
		  // const survey_cost_parking_rent = this.getNumberForCalculation(raw_survey_cost_parking_rent)
		  const endDate = new Date(quote_available_end_date)
		  const startDate = new Date(quote_available_start_date)
		//   console.log(startDate,endDate,quote_term_month_flag)
		  const {
			monthCount,
			days,
			startDays,
			endDays
		  } = await this.getCountsFromDuration(startDate, endDate, quote_term_month_flag)
		//   console.log(monthCount,days)
		  const hasFullLastMonth = days==0
		  const quote_month_qty = this.getNumberForCalculation(monthCount)
		  const quote_day_qty = (!hasFullLastMonth&&days>0 ? this.getNumberForCalculation(days) : 0)
		  const survey_cost_other_amt = this.getNumberForCalculation(survey_cost_other)
		  const firstDay = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
		  const lastDay = new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0);
		  
		  quote_cost_total_amt = //(request_type==3) ? 0 : 
			( survey_cost_parking_rent * quote_month_qty * quote_capacity_qty + parseInt(survey_cost_parking_rent / 30) * quote_day_qty * quote_capacity_qty + survey_cost_commission * quote_capacity_qty + survey_cost_key_money * quote_capacity_qty + survey_cost_other_amt)
		
		  const capacity_qty = quote_capacity_qty != undefined && quote_capacity_qty != null 
		                    ? quote_capacity_qty : order_capacity_qty != undefined && order_capacity_qty != null 
							? order_capacity_qty : survey_capacity_qty

		  const quote_cost_security_deposit_total_amt = survey_cost_security_deposit * capacity_qty

		
          // 非課税項目を除外したトータル
		  const _summed_quote_subtotal_amt = survey_parking_rent * quote_month_qty * quote_capacity_qty
			   + parseInt(survey_parking_rent / 30) * quote_day_qty * quote_capacity_qty
			   + survey_commission_discount_amt * quote_capacity_qty
			   + survey_key_money * quote_capacity_qty
			   + survey_discount_amt + this.getNumberForCalculation(survey_adjustment_amt)
			   + (estimate_detail_amt ? estimate_detail_amt : 0)

  		  // 小計   
		  const summed_quote_subtotal_amt = _summed_quote_subtotal_amt + (estimate_detail_amt_ex ? estimate_detail_amt_ex : 0)
	    //  console.log('summed_quote_subtotal_amt', summed_quote_subtotal_amt)
		  
	      let _quote_subtotal_amt = quote_estimate_amt + (estimate_detail_amt ? estimate_detail_amt : 0)
		  quote_subtotal_amt = survey_fraction_amt_flag == "1" 
			? parseInt(summed_quote_subtotal_amt/100)*100 
			: summed_quote_subtotal_amt
	    //  console.log('quote_subtotal_amt', quote_subtotal_amt)
		  
		  _quote_subtotal_amt = (survey_fraction_amt_flag == "1" 
			? parseInt(_summed_quote_subtotal_amt/100)*100 
			: _summed_quote_subtotal_amt)
	
		  const quote_tax_amt = (survey_tax_in_flag == "1")
			? parseInt(_quote_subtotal_amt / 11)
			: parseInt(_quote_subtotal_amt * 0.1)
			// console.log('quote_tax_amt', quote_tax_amt)
	
		  quote_total_amt = ((survey_tax_in_flag == "1")
			  ? _quote_subtotal_amt
			  : parseInt(_quote_subtotal_amt * 1.1)) + (estimate_detail_amt_ex ? estimate_detail_amt_ex : 0)
		//   console.log(quote_tax_amt)
	
		  const _CAL_profit_amt = quote_total_amt - quote_cost_total_amt
		  const _CAL_profit_rate = this.getNumberForCalculation(_CAL_profit_amt / quote_total_amt * 10000)/100
	
		  const totalCountForDetails = (startDays?1:0)+(endDays?1:0)+monthCount
		//   const incrementalMonthCount = totalCountForDetails>11?2:1
		  const incrementalMonthCount = Math.ceil(totalCountForDetails/11)

		  let estimate_details = []
		
			const startDays_start = startDate;
			const startDays_end =  (startDays_start.getFullYear() === endDate.getFullYear() && startDays_start.getMonth() === endDate.getMonth()) ? endDate : new Date(startDays_start.getFullYear(), startDays_start.getMonth() + 1 , 0)
			startDays && (estimate_details.push(
			{
				estimate_detail_name: `${Format.dateToString(startDays_start, 'YYYY年M月分賃料')} (${Format.dateToString(startDays_start, 'M月D日')} ～ ${Format.dateToString(startDays_end, 'M月D日')})`,
				estimate_detail_qty: quote_capacity_qty,
				estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
				estimate_detail_term: `${startDays}`,
				estimate_detail_term_type:'日',
				estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
				estimate_type: 1
			}
			))
			if(Number(quote_term_month_flag) == 0){
				for (let i = 0; i<monthCount; i+=incrementalMonthCount){
					const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount !=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
					const calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 1)
					const calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+(startDays?1:0), 0)
					let estimate_detail_name = ''
					if(incrementalMonthCount === 1){
						estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
					} else {
					if(calculatedMonth_start.getMonth() === calculatedMonth_end.getMonth()){
						estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
					} else {
						estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月')}・${(calculatedMonth_start.getFullYear() !== calculatedMonth_end.getFullYear() ? Format.dateToString(calculatedMonth_end, 'YYYY年') : '')}${Format.dateToString(calculatedMonth_end, 'M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
					}
					}
					estimate_details.push({
					estimate_detail_name: estimate_detail_name,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: survey_parking_rent,
					estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
					estimate_detail_term_type:'月',
					estimate_detail_amt: survey_parking_rent * quote_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
					estimate_type: 1
					})
				}
			} else if(Number(quote_term_month_flag) == 1) {

				for (let i = 0; i<monthCount; i+=incrementalMonthCount){

					const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
					let calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
					let calculatedMonth_end = "";

					if(startDate.getDate() === 31){
						// #2054 【20240809-02】【基幹】G04_PDF_請求書：不要な行が出力される
						// 見積開始日が31日の場合、かつ
						// 最終行月の末日が31日の場合、見積終了日は見積開始日-1とする
						// 見積開始日が31日の場合、かつ
						// 最終行月の末日が30日の場合、見積終了日は-1しない
						// （30日とする）
			
						if(i == 0){
							calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
						}else{
							calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+1, 0)
						}
		
						const calculatedMonth_e = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+1, 0)
						calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), calculatedMonth_e.getDate()-1)
						if(endDate.getMonth() === calculatedMonth_e.getMonth() && endDate.getDate() != calculatedMonth_end.getDate()){
							calculatedMonth_end = calculatedMonth_e;
						}
					}else if(startDate.getDate() === 30){
						calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
						
						const calculatedMonth_e = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+1, 0)
						if(calculatedMonth_e.getDate() > 30){
						  calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), 30-1)
						}else{
						  calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), calculatedMonth_e.getDate()-1)
						}
						// console.log(calculatedMonth_start,calculatedMonth_end,calculatedMonth_e)
						if(endDate.getMonth() === calculatedMonth_e.getMonth() && endDate.getDate() != calculatedMonth_end.getDate()){
						  calculatedMonth_end = calculatedMonth_e;
						}
					}else{
						calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
						calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth, (startDate.getDate() === 1 ? 0 : endDate.getDate()))
					}
			
					let estimate_detail_name = ''
					if(incrementalMonthCount === 1){
					estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
					} else {
					if(calculatedMonth_start.getMonth() === calculatedMonth_end.getMonth()){
						estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
					} else {
						estimate_detail_name = `${Format.dateToString(calculatedMonth_start, 'YYYY年M月')}・${(calculatedMonth_start.getFullYear() !== calculatedMonth_end.getFullYear() ? Format.dateToString(calculatedMonth_end, 'YYYY年') : '')}${Format.dateToString(calculatedMonth_end, 'M月分賃料')} (${Format.dateToString(calculatedMonth_start, 'M月D日')} ～ ${Format.dateToString(calculatedMonth_end, 'M月D日')})`
					}
					}
					estimate_details.push({
					estimate_detail_name: estimate_detail_name,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: survey_parking_rent,
					estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
					estimate_detail_term_type:'月',
					estimate_detail_amt: survey_parking_rent * quote_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
					estimate_type: 1
					})
				}
			} else {
				console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag)
				this.props.alertModal.current.confirmCheck({
					messageNo: 2428,
					closeBtn: false
				}, ()=>{
					// this.props.refreshCallback()
					window.location.reload()
				})
			}
			const endDays_start = new Date(endDate.getFullYear(), endDate.getMonth(), 1);
			const endDays_end =  endDate;
			endDays && (estimate_details.push({
			estimate_detail_name: `${Format.dateToString(endDays_start, 'YYYY年M月分賃料')} (${Format.dateToString(endDays_start, 'M月D日')} ～ ${Format.dateToString(endDays_end, 'M月D日')})`,
			estimate_detail_qty: quote_capacity_qty,
			estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
			estimate_detail_term: `${endDays}`,
			estimate_detail_term_type:'日',
			estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
			estimate_type: 1
			}))
		
	
		  // 独自帳票 
		  // 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : customer_natural_id 6 customer_branch_natural_id 6024
		  // 三井ホーム　株式会社 -> 埼玉支店 : customer_natural_id 6 customer_branch_natural_id 6, 6017, 6018, 6025, 6026
		  // 三井ホーム　株式会社 -> その他 : customer_natural_id 6
		  // 住友不動産　株式会社 : customer_natural_id 119
		  const customEstimateDetails = this.createCustomEstimateDetails({
			customer_natural_id,
			customer_branch_natural_id,
			survey_parking_rent,
			quote_capacity_qty,
			quote_subtotal_amt,
			incrementalMonthCount,
			startDate,
			endDate,
			monthCount,
			startDays,
			endDays,
			request_type,
			survey_tax_in_flag,
			quote_total_amt,
			quote_term_month_flag
		  })
	
	//      console.log('estimate_details ', estimate_details)
	//      console.log('customEstimateDetails ', customEstimateDetails)
	
		  estimate_details = [
			...estimate_details,
			...customEstimateDetails
		  ]
		//   console.log(quote_term_month_flag,hasFullLastMonth)
		  const alert = Number(quote_term_month_flag) == 0 ? (
			//通し無
			(
			  (endDate.getTime() != lastDay.getTime())
			) ? {
			  quote_term_month_flag:[GetMessage(2425), {notIgnore:false}],
			} : ( hasFullLastMonth
			  ? {
				quote_term_month_flag:[GetMessage(2426), {notIgnore:false}],
			  }
			  : {
				quote_term_month_flag:undefined,
			  }
			  )
		  ):Number(quote_term_month_flag) == 1 ? (
			//通し有
			!hasFullLastMonth?{
			  quote_term_month_flag:[GetMessage(2427),{notIgnore:true}],
			}:{
			  quote_term_month_flag:undefined,
			}
		  ) : (
			console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag),
			{ quote_term_month_flag: [GetMessage(2428),{notIgnore:true}],}
		)
	
		  this.setState({
			data:{
			  ...this.state.data,
			  values:{
				...this.state.data.values,
				quote_month_qty,
				quote_day_qty,
				quote_cost_total_amt,
				quote_subtotal_amt,
				quote_subtotal_amt_ex:summed_quote_subtotal_amt,
				quote_tax_amt,
				quote_total_amt,
				quote_cost_security_deposit_total_amt,
				_CAL_profit_amt,
				_CAL_profit_rate,
				estimate_details,
				quote_cost_total_amt_add_deposit_and_adjust:(quote_cost_total_amt+quote_cost_security_deposit_total_amt+quote_cost_adjustment)
			  },
			  errors:{
				...this.state.data.errors,
				...alert,
				...{_CAL_profit_amt:_CAL_profit_amt<0?[GetMessage(2430), {notIgnore:false}]:undefined},
				// latest_pdf_supplier_invoice_url : !this.state.data.values.latest_pdf_supplier_invoice_url ? [GetMessage(2024)] : undefined
				survey_commission_amount : (parseInt(quote_cost_total_amt) * 1.02) > parseInt(quote_total_amt)? [GetMessageWithParam(2037, {amount: Format.format_number_with_commas(parseInt(quote_cost_total_amt) * 1.02 - parseInt(quote_total_amt))}), {notIgnore:false}]: undefined
			  }
			}
		  })
		}
	  }
	
	  createCustomEstimateDetails(estimateDataWithDays){
		const {
		  customer_natural_id,
		  customer_branch_natural_id,
		  quote_capacity_qty,
		  survey_parking_rent,
		  quote_subtotal_amt,
		  incrementalMonthCount,
		  startDate,
		  endDate,
		  monthCount,
		  startDays,
		  endDays,
		  request_type,
		  survey_tax_in_flag,
		  quote_total_amt,
		  quote_term_month_flag
		} = estimateDataWithDays
		let estimate_details = []
		const customReportCustomerObject = custom_report.estimate.quote
		switch(customer_natural_id){
		  case customReportCustomerObject["三井ホーム"].customer_natural_id:
			if (customReportCustomerObject["三井ホーム"]["東北支店リフォーム営業室"].customer_branch_natural_id.includes(customer_branch_natural_id)) {
				// 三井ホーム　株式会社 -> 東北支店リフォーム営業室 : 6024
				// 明細1行まとめ表示
				estimate_details.push({
					estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JY/M/D')}～${Format.dateToString(endDate, 'JY/M/D')})`,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: parseInt(quote_subtotal_amt / quote_capacity_qty),
					estimate_detail_term: null,
					estimate_detail_term_type: null,
					estimate_detail_amt: quote_subtotal_amt,
					estimate_type: 2
				})
				return estimate_details
			} else if (customReportCustomerObject["三井ホーム"]["埼玉支店"].customer_branch_natural_id.includes(customer_branch_natural_id)) {
				// 明細行に日付指定なし
				startDays && (estimate_details.push(
				  {
					estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JJ年M月')}分賃料（${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(),startDate.getMonth()+1,0), 'M/D')}分日割り））`,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
					estimate_detail_term: `${startDays}`,
					estimate_detail_term_type:'日',
					estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
					estimate_type: 2
				  }
				))
				for (let i = 1; i<=monthCount; i+=1){
				  const calculatedMonth = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
				  estimate_details.push({
					estimate_detail_name: `駐車場代（${Format.dateToString(calculatedMonth, 'JJ年M月')}分賃料）`,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: survey_parking_rent,
					estimate_detail_term: 1,
					estimate_detail_term_type:'月',
					estimate_detail_amt: survey_parking_rent * quote_capacity_qty,
					estimate_type: 2
				  })
				}
				endDays && (estimate_details.push({
				  estimate_detail_name: `駐車場代（${Format.dateToString(endDate, 'JJ年M月')}分賃料（${Format.dateToString(new Date(endDate.getFullYear(),endDate.getMonth(),1), 'M/D')}～${Format.dateToString(endDate, 'M/D')}分日割り））`,
				  estimate_detail_qty: quote_capacity_qty,
				  estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
				  estimate_detail_term: `${endDays}`,
				  estimate_detail_term_type:'日',
				  estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
				  estimate_type: 2
				}))
				return estimate_details
			} else {
				// 明細1行まとめ表示
				estimate_details.push(
				  {
					estimate_detail_name: `駐車場代（${Format.dateToString(startDate, 'JY/M/D')}～${Format.dateToString(endDate, 'JY/M/D')})`,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: parseInt(quote_subtotal_amt / quote_capacity_qty),
					estimate_detail_term: null,
					estimate_detail_term_type: null,
					estimate_detail_amt: quote_subtotal_amt,
					estimate_type: 2
				  }
				)
			  return estimate_details
			}
		  case customReportCustomerObject["住友不動産"].customer_natural_id:
			  const rowCount = (startDays?1:0)+(endDays?1:0)+monthCount
			  if (rowCount>4){
				startDays && (estimate_details.push(
				  {
					estimate_detail_name: `${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(),startDate.getMonth()+1,0), 'M/D')}分賃料等`,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
					estimate_detail_term: `${startDays}`,
					estimate_detail_term_type:'日',
					estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
					estimate_type: 2
				  }
				))
				// 通し無
				if(Number(quote_term_month_flag) == 0){
					monthCount && (estimate_details.push({
						estimate_detail_name: `${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+(startDays?1:0), 1), 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(), startDate.getMonth()+monthCount+(startDays?1:0), 0), 'M/D')}分賃料等`,
						estimate_detail_qty: quote_capacity_qty,
						estimate_detail_unit_cost: survey_parking_rent,
						estimate_detail_term: monthCount,
						estimate_detail_term_type:'月',
						estimate_detail_amt: survey_parking_rent * quote_capacity_qty * monthCount,
						estimate_type: 2
					}))
				}else if (Number(quote_term_month_flag) == 1){
				// 通し有
					monthCount && (estimate_details.push({
						estimate_detail_name: `${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(endDate, 'M/D')}分賃料等`,
						estimate_detail_qty: quote_capacity_qty,
						estimate_detail_unit_cost: survey_parking_rent,
						estimate_detail_term: monthCount,
						estimate_detail_term_type:'月',
						estimate_detail_amt: survey_parking_rent * quote_capacity_qty * monthCount,
						estimate_type: 2
					}))
				} else {
					console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag)
					this.props.alertModal.current.confirmCheck({
						messageNo: 2428,
						closeBtn: false
					}, ()=>{
						// this.props.refreshCallback()
						window.location.reload()
					})
				}
				endDays && (estimate_details.push({
				  estimate_detail_name: `${Format.dateToString(new Date(endDate.getFullYear(),endDate.getMonth(),1), 'M/D')}～${Format.dateToString(endDate, 'M/D')}分賃料等`,
				  estimate_detail_qty: quote_capacity_qty,
				  estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
				  estimate_detail_term: `${endDays}`,
				  estimate_detail_term_type:'日',
				  estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
				  estimate_type: 2
				}))
				return estimate_details
			  } else {
				startDays && (estimate_details.push(
				  {
					estimate_detail_name: `${Format.dateToString(startDate, 'M/D')}～${Format.dateToString(new Date(startDate.getFullYear(),startDate.getMonth()+1,0), 'M/D')}分賃料等`,
					estimate_detail_qty: quote_capacity_qty,
					estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
					estimate_detail_term: `${startDays}`,
					estimate_detail_term_type:'日',
					estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
					estimate_type: 2
				  }
				))

				let incrementalMonthCount = 1
				for (let i = 0; i<monthCount; i+=incrementalMonthCount){
					const addMonth = (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount
					let calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 1)
					let calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+addMonth+(startDays?1:0), 0)

					if(Number(quote_term_month_flag) == 0){
					// 通し無
						estimate_details.push({
							estimate_detail_name: `${Format.dateToString(new Date(calculatedMonth_start.getFullYear(),calculatedMonth_start.getMonth(),1), 'M/D')}～${Format.dateToString(new Date(calculatedMonth_end.getFullYear(),calculatedMonth_end.getMonth()+1,0), 'M/D')}分賃料等`,
							estimate_detail_qty: quote_capacity_qty,
							estimate_detail_unit_cost: survey_parking_rent,
							estimate_detail_term: 1,
							estimate_detail_term_type:'月',
							estimate_detail_amt: survey_parking_rent * quote_capacity_qty,
							estimate_type: 2
						})
					}else if(Number(quote_term_month_flag) == 1){
						// 通し有
						if(startDate.getDate() === 31){
							// #2054 【20240809-02】【基幹】G04_PDF_請求書：不要な行が出力される
							// 見積開始日が31日の場合、かつ
							// 最終行月の末日が31日の場合、見積終了日は見積開始日-1とする
							// 見積開始日が31日の場合、かつ
							// 最終行月の末日が30日の場合、見積終了日は-1しない
							// （30日とする）			
							if(i == 0){
								calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
							}else{
								calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
							}

							const calculatedMonth_e = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0)+1, 0)
							calculatedMonth_end = new Date(calculatedMonth_e.getFullYear(), calculatedMonth_e.getMonth(), calculatedMonth_e.getDate()-1)
							if(endDate.getMonth() === calculatedMonth_e.getMonth() && endDate.getDate() != calculatedMonth_end.getDate()){
								calculatedMonth_end = calculatedMonth_e;
							}

						}else{
							calculatedMonth_start = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), startDate.getDate())
							calculatedMonth_end = new Date(startDate.getFullYear(), startDate.getMonth()+i+1, (startDate.getDate() === 1 ? 0 : endDate.getDate()))
						}

						estimate_details.push({
							estimate_detail_name: `${Format.dateToString(new Date(calculatedMonth_start.getFullYear(),calculatedMonth_start.getMonth(),calculatedMonth_start.getDate()), 'M/D')}～${Format.dateToString(new Date(calculatedMonth_end.getFullYear(),calculatedMonth_end.getMonth(),calculatedMonth_end.getDate()), 'M/D')}分賃料等`,
							estimate_detail_qty: quote_capacity_qty,
							estimate_detail_unit_cost: survey_parking_rent,
							estimate_detail_term: 1,
							estimate_detail_term_type:'月',
							estimate_detail_amt: survey_parking_rent * quote_capacity_qty,
							estimate_type: 2
						})
					} else {
						console.error('quote_term_month_flag が 0 または 1 ではありません:', quote_term_month_flag)
						this.props.alertModal.current.confirmCheck({
							messageNo: 2428,
							closeBtn: false
						}, ()=>{
							// this.props.refreshCallback()
							window.location.reload()
						})
					}

				}
				endDays && (estimate_details.push({
				  estimate_detail_name: `${Format.dateToString(new Date(endDate.getFullYear(),endDate.getMonth(),1), 'M/D')}～${Format.dateToString(endDate, 'M/D')}分賃料等`,
				  estimate_detail_qty: quote_capacity_qty,
				  estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
				  estimate_detail_term: `${endDays}`,
				  estimate_detail_term_type:'日',
				  estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
				  estimate_type: 2
				}))
				return estimate_details
			  }
		  default:
			  startDays && (estimate_details.push(
				{
				  estimate_detail_name: `${Format.dateToString(startDate, 'YYYY年M月分賃料')}(${startDays}日)`,
				  estimate_detail_qty: quote_capacity_qty,
				  estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
				  estimate_detail_term: `${startDays}`,
				  estimate_detail_term_type:'日',
				  estimate_detail_amt: parseInt(survey_parking_rent / 30) * startDays * quote_capacity_qty,
				  estimate_type: 2
				}
			  ))
			  for (let i = 1; i<=monthCount; i+=incrementalMonthCount){
				const calculatedMonth = new Date(startDate.getFullYear(), startDate.getMonth()+i+(startDays?1:0), 0)
				
				estimate_details.push({
				  estimate_detail_name: Format.dateToString(calculatedMonth, 'YYYY年M月分賃料'),
				  estimate_detail_qty: quote_capacity_qty,
				  estimate_detail_unit_cost: survey_parking_rent,
				  estimate_detail_term: (monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount,
				  estimate_detail_term_type:'月',
				  estimate_detail_amt: survey_parking_rent * quote_capacity_qty * ((monthCount-incrementalMonthCount<i && monthCount%incrementalMonthCount!=0) ? monthCount%incrementalMonthCount : incrementalMonthCount),
				  estimate_type: 2
				})
			  }
			  endDays && (estimate_details.push({
				estimate_detail_name: `${Format.dateToString(endDate, 'YYYY年M月分賃料')}(${endDays}日)`,
				estimate_detail_qty: quote_capacity_qty,
				estimate_detail_unit_cost: parseInt(survey_parking_rent / 30),
				estimate_detail_term: `${endDays}`,
				estimate_detail_term_type:'日',
				estimate_detail_amt: parseInt(survey_parking_rent / 30) * endDays * quote_capacity_qty,
				estimate_type: 2
			  }))
			  return estimate_details
		}
		
	  }
	
	  getCountsFromDuration(startDate, endDate, quote_term_month_flag){
		return new Promise(async resolve=>{
	
		  startDate.setHours(0)
		  endDate.setHours(0)
	
		  if (quote_term_month_flag=="0"){
			const startMonthEndDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 1)
			const endDateIsLast = (endDate.getTime() == (new Date(endDate.getFullYear(), endDate.getMonth() + 1, 0)).getTime())
			const startDays = await (()=>{
			  if (startMonthEndDate>endDate && !endDateIsLast){
				return ((endDate - startDate) /1000/60/60/24) + 1
			  }else if ( startDate.getDate()=="1"){
				return 0
			  } else {
				return ((startMonthEndDate - startDate) /1000/60/60/24)
			  }
			})()
			const startDateOfEndDate = new Date(endDate.getFullYear(), endDate.getMonth(), 0)
			const endDays = (endDateIsLast || (startDate.getFullYear() == endDate.getFullYear() && startDate.getMonth()==endDate.getMonth()))
			  ? 0
			  : ((endDate-startDateOfEndDate)/1000/60/60/24)
			let monthCount = 0
			while ( new Date(startDate.getFullYear(), startDate.getMonth() + 1 + monthCount, 1) < new Date(endDate.getFullYear(), endDate.getMonth() + 1, 1) ){
			  monthCount += 1
			}
	
			const days = startDays + endDays
	
			endDateIsLast && (startDays==0&&endDays==0) && monthCount++;
	
			(startDays!==0&&endDays!==0) && monthCount--;
	
	
			resolve({
			  monthCount:monthCount<0?0:monthCount,
			  days:parseInt(days),
			  startDays:parseInt(startDays),
			  endDays:parseInt(endDays)
			})
		  } else {
			let monthCount = 0
			while ( new Date(startDate.getFullYear(), startDate.getMonth() + monthCount, (startDate.getDate()-1) ) < endDate ){
			  monthCount += 1
			}
			const checkDate = new Date(startDate.getFullYear(), startDate.getMonth() + monthCount, (startDate.getDate()-1) );
			let days = (endDate - checkDate ) /1000/60/60/24; 

			// 下記の場合は通し有エラーとしない
			// 見積開始日が30or31日の場合、かつ
			// 最終行月の末日が見積開始日-1日の日付(29,30日)が存在しない場合、見積終了日は月の末日（28or29日）とする
			// （2月のみの想定）
			// console.log(startDate.getMonth(),endDate.getMonth());
			if(endDate.getMonth() == 1 ){
				if( endDate.getDate() == 28 || endDate.getDate() == 29 ){
					if ( startDate.getDate() == 30 || startDate.getDate() == 31 ){
						days = 0
					}
				} 
			}else{
				// エラーになるように調整3月2日、（うるう年対策）3月1日
				if(startDate.getDate() == 31){
					if(endDate.getMonth() == 2){
						if( endDate.getDate() == 2 || endDate.getDate() == 1 ){
						days = 1
						}
					}
				}
			}

			resolve({
			  monthCount,
			  days:parseInt(days),
			})
		  }
		})
	  }
	
	  getNumberForCalculation(number){
		return isNaN(parseInt(number)) ? 0 : parseInt(number)
	  }
	  
	  invoiceValidateCallback(newData, callback=()=>{}){
		const change_invoice_flag = newData.values.change_invoice_flag
		const is_empty_change_invoice_name = 
		  (newData.values.change_invoice_name === null 
		  || newData.values.change_invoice_name === undefined
		  || newData.values.change_invoice_name === "") ? true : false;
		this.setState({
		  data:{
			...this.state.data,
			...newData,
			values: {
 			  ...this.state.data.values,
			  ...newData.values,
			  change_invoice_name : change_invoice_flag == 1 ? newData.values.change_invoice_name : null
			},
			errors:{ 
			  ...(change_invoice_flag == 1 ? newData.errors : undefined),
			  ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) 
			},
			requiredData : { ...(change_invoice_flag == 1 ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
		  }
		}, ()=>callback())
	  }

	  isNull(value){
		if(value === undefined || value === null || value === ""){
		  return true
		}
		return false;
	  }
	// 適格事業者番号のバリデーションチェック
	// 区分が1の場合=>適格事業者番号のバリデーションチェックを行う、エラーの場合はエラーコードを返す
	// 区分が2の場合=>""空を返す
	validateInvoiceNumber (type,number) {
		if ( type == 1) {
			if (!number)  {
			return [GetMessage(2601)]
			}
			if (!number.match(/^T\d{13}$/)) {
			return [GetMessage(2035)]
			}
			return ""
		}
		else if ( type == 2 ) {
			return ""
		} 
	}

	validateIntegerValue (value) {
		if ( value && value.length == 0 || value == null ) {
			return [GetMessage(2024)]
		}
		if (parseInt(value) < 0) {
			return [GetMessage(2401)]
		}
		return undefined
	}

	  validateCallback(newData, callback=()=>{}){
		const prev_quote_plotting_number = this.state.data.values.quote_plotting_number  != undefined && this.state.data.values.quote_plotting_number != null ? this.state.data.values.quote_plotting_number : ""
		const new_quote_plotting_number = newData.values.quote_plotting_number != undefined && newData.values.quote_plotting_number != null ? newData.values.quote_plotting_number : prev_quote_plotting_number ? prev_quote_plotting_number : ""

		const prev_quote_capacity_qty = this.state.data.values.quote_capacity_qty  != undefined && this.state.data.values.quote_capacity_qty != null && this.state.data.values.quote_capacity_qty != "" ? this.state.data.values.quote_capacity_qty : 0
		const new_quote_capacity_qty = newData.values.quote_capacity_qty == undefined  ? prev_quote_capacity_qty : newData.values.quote_capacity_qty ? newData.values.quote_capacity_qty : 0
		
		const prev_survey_cost_parking_rent = this.state.data.values.survey_cost_parking_rent
		const new_survey_cost_parking_rent = newData.values.survey_cost_parking_rent == undefined ? prev_survey_cost_parking_rent : newData.values.survey_cost_parking_rent
		const prev_survey_cost_commission = this.state.data.values.survey_cost_commission
		const new_survey_cost_commission = newData.values.survey_cost_commission == undefined ? prev_survey_cost_commission : newData.values.survey_cost_commission 
		const prev_survey_cost_security_deposit = this.state.data.values.survey_cost_security_deposit
		const new_survey_cost_security_deposit = newData.values.survey_cost_security_deposit == undefined ? prev_survey_cost_security_deposit : newData.values.survey_cost_security_deposit
		const prev_survey_cost_key_money = this.state.data.values.survey_cost_key_money
		const new_survey_cost_key_money = newData.values.survey_cost_key_money == undefined ? prev_survey_cost_key_money : newData.values.survey_cost_key_money
		const prev_survey_cost_other = this.state.data.values.survey_cost_other
		const new_survey_cost_other = newData.values.survey_cost_other == undefined ? prev_survey_cost_other : newData.values.survey_cost_other

		const prev_quote_cost_adjustment = this.state.data.values.quote_cost_adjustment
		const new_quote_cost_adjustment = newData.values.quote_cost_adjustment == undefined? prev_quote_cost_adjustment : newData.values.quote_cost_adjustment

		let {
			quote_capacity_qty,
			request_type,
			survey_cost_security_deposit,
			survey_cost_key_money,
			survey_cost_commission,
			survey_cost_other,
			order_capacity_qty,
			survey_capacity_qty,
			quote_cost_total_amt,
			quote_cost_security_deposit_total_amt,
			quote_cost_adjustment,
			quote_available_end_date,
			quote_available_start_date,
			quote_term_month_flag
		} = this.state.data.values

		  // const survey_cost_parking_rent = this.getNumberForCalculation(raw_survey_cost_parking_rent)
		  const endDate = new Date(quote_available_end_date)
		  const startDate = new Date(quote_available_start_date)

		  const {
			monthCount,
			days,
			startDays,
			endDays
		  } = this.getCountsFromDuration(startDate, endDate, quote_term_month_flag)

		  const hasFullLastMonth = days==0
		  const quote_month_qty = this.getNumberForCalculation(monthCount)
		  const quote_day_qty = (!hasFullLastMonth&&days>0 ? this.getNumberForCalculation(days) : 0)
		  const survey_cost_other_amt = this.getNumberForCalculation(survey_cost_other)

		if ( prev_survey_cost_parking_rent != new_survey_cost_parking_rent ) {
			quote_cost_total_amt = ( new_survey_cost_parking_rent * quote_month_qty * quote_capacity_qty + parseInt(new_survey_cost_parking_rent / 30) * quote_day_qty * quote_capacity_qty + survey_cost_commission * quote_capacity_qty + survey_cost_key_money * quote_capacity_qty + survey_cost_other_amt)
		}
		if (prev_survey_cost_security_deposit != new_survey_cost_security_deposit) {
			const capacity_qty = quote_capacity_qty != undefined && quote_capacity_qty != null 
			? quote_capacity_qty : order_capacity_qty != undefined && order_capacity_qty != null 
			? order_capacity_qty : survey_capacity_qty;

			quote_cost_security_deposit_total_amt = survey_cost_security_deposit * capacity_qty
		}
		if (prev_quote_cost_adjustment != new_quote_cost_adjustment) {
			quote_cost_adjustment = new_quote_cost_adjustment
		}
		// 必須チェック
		const isDateNull = this.isNull(newData.values.quote_available_start_date)
		// 日付チェック
		const isDateError = this.alertDateCheck(newData.values) == false ?  [GetMessage(2462)] : undefined
		// let errors = this.state.data.errors
		let errors = newData.errors
		// errors.quote_plotting_number = new_quote_plotting_number == "" ? [GetMessage(2024)] : undefined
		// console.log(newData.values.quote_capacity_qty)
		errors.quote_capacity_qty = (newData.values.quote_capacity_qty && newData.values.quote_capacity_qty.length == 0 || newData.values.quote_capacity_qty == null || new_quote_capacity_qty == 0 )? [GetMessage(2024)] : undefined
		
		errors.quote_available_start_date = isDateNull ? [GetMessage(2024)] : isDateError
//		errors.survey_cost_parking_rent = newData.values.survey_cost_parking_rent && newData.values.survey_cost_parking_rent.length == 0 || newData.values.survey_cost_parking_rent == null ? [GetMessage(2024)] : undefined
		errors.survey_cost_parking_rent = this.validateIntegerValue(newData.values.survey_cost_parking_rent)
		errors.survey_cost_commission = newData.values.survey_cost_commission && newData.values.survey_cost_commission.length == 0 || newData.values.survey_cost_commission == null ? [GetMessage(2024)] : undefined
		errors.survey_cost_other = newData.values.survey_cost_other && newData.values.survey_cost_other.length == 0 || newData.values.survey_cost_other == null ? [GetMessage(2024)] : undefined
		// errors.survey_cost_commission = undefined
		errors.survey_cost_security_deposit = newData.values.survey_cost_security_deposit && newData.values.survey_cost_security_deposit.length == 0 || newData.values.survey_cost_security_deposit == null ? [GetMessage(2024)] : undefined
		// errors.survey_cost_security_deposit = undefined
		errors.survey_cost_key_money = newData.values.survey_cost_key_money && newData.values.survey_cost_key_money.length == 0 || newData.values.survey_cost_key_money == null ? [GetMessage(2024)] : undefined
		// errors.survey_cost_key_money = undefined

		errors.quote_cost_total_amt_add_deposit_and_adjust = this.validateIntegerValue(quote_cost_total_amt+quote_cost_security_deposit_total_amt+quote_cost_adjustment)

//		console.log(quote_cost_total_amt+quote_cost_security_deposit_total_amt+quote_cost_adjustment,errors)

		let tmpData = newData
		tmpData.survey_cost_parking_rent = new_survey_cost_parking_rent
		tmpData.survey_cost_commission = new_survey_cost_commission
		tmpData.survey_cost_other = new_survey_cost_other
		tmpData.survey_cost_security_deposit = new_survey_cost_security_deposit
		tmpData.survey_cost_key_money = new_survey_cost_key_money


		let {
			survey_cost_parking_rent_payment_type,
			survey_cost_parking_rent_invoice_business_type,
			survey_cost_parking_rent_invoice_registration_number,
			survey_cost_commission_payment_type,
			survey_cost_commission_invoice_business_type,
			survey_cost_commission_invoice_registration_number,
			survey_cost_key_money_payment_type,
			survey_cost_key_money_invoice_business_type,
			survey_cost_key_money_invoice_registration_number,
			survey_cost_other_payment_type,
			survey_cost_other_invoice_business_type,
			survey_cost_other_invoice_registration_number,
			quote_subtotal_amt,
		} = newData.values;

		let supplier_error =  this.valicateSupplierInvoiceNumber(newData.values)		

/* 免税事業者を選択時に適格事業者番号を空にする処理
		tmpData.values = {
			...tmpData.values,
			survey_cost_parking_rent_invoice_registration_number: survey_cost_parking_rent_invoice_business_type == 2? "":survey_cost_parking_rent_invoice_registration_number,
			survey_cost_commission_invoice_registration_number: survey_cost_commission_invoice_business_type == 2? "":survey_cost_commission_invoice_registration_number,
			survey_cost_key_money_invoice_registration_number: survey_cost_key_money_invoice_business_type == 2? "":survey_cost_key_money_invoice_registration_number,
		}
*/
		// console.log(request_type,quote_subtotal_amt)

		// 契約書の場合、契約番号が変わっていれば、「はい」ボタンを活性にする
		const no_protting_number_change =
			this.props.data.values.order_box_status >= 7 &&
			this.props.data.values.order_box_status <= 10 &&
			(
				newData.values.quote_plotting_number === null ||
				newData.values.quote_plotting_number === undefined ||
				newData.values.quote_plotting_number === "" ||
				this.props.data.values.quote_plotting_number === newData.values.quote_plotting_number
			);

		this.setState({
			disablePositive: no_protting_number_change, // 口座未登録時の対応
			data:{
			  ...this.state.data,
			  ...tmpData,
			  values:{
				...this.state.data.values,
				...tmpData.values,
				quote_cost_total_amt_add_deposit_and_adjust:(quote_cost_total_amt+quote_cost_security_deposit_total_amt+quote_cost_adjustment),
			  },
			  errors:{
				...errors,
				estimate_detail_amt:this.isNull(newData.values.estimate_detail_amt) && !this.isNull(newData.values.estimate_detail_name) ?[GetMessage(2547)]: undefined,
				estimate_detail_name:this.isNull(newData.values.estimate_detail_name) && !this.isNull(newData.values.estimate_detail_amt) ?[GetMessage(2546)]: undefined,
				estimate_detail_amt_ex:this.isNull(newData.values.estimate_detail_amt_ex) && !this.isNull(newData.values.estimate_detail_name_ex) ?[GetMessage(2547)]: undefined,
				estimate_detail_name_ex:this.isNull(newData.values.estimate_detail_name_ex) && !this.isNull(newData.values.estimate_detail_amt_ex) ?[GetMessage(2546)]: undefined,
				survey_cost_parking_rent_payment_type: new_survey_cost_parking_rent > 0 ? 
															survey_cost_parking_rent_payment_type == 0 && supplier_error == true ? 
																[GetMessage(2602)] :
																	survey_cost_parking_rent_payment_type == null || 
																	survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == null || 
																	survey_cost_parking_rent_payment_type == 1 && survey_cost_parking_rent_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_commission_payment_type: new_survey_cost_commission > 0 ? 
															survey_cost_commission_payment_type == 0 && supplier_error == true ? 
																[GetMessage(2602)] :
																	survey_cost_commission_payment_type == null || 
																	survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == null || 
																	survey_cost_commission_payment_type == 1 && survey_cost_commission_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_key_money_payment_type: new_survey_cost_key_money > 0 ? 
															survey_cost_key_money_payment_type == 0 && supplier_error == true ?
																[GetMessage(2602)] :
																	survey_cost_key_money_payment_type == null  || 
																	survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == null || 
																	survey_cost_key_money_payment_type == 1 && survey_cost_key_money_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_other_payment_type: new_survey_cost_other > 0 ? 
															survey_cost_other_payment_type == 0 && supplier_error == true ?
																[GetMessage(2602)] :
																	survey_cost_other_payment_type == null  || 
																	survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == null || 
																	survey_cost_other_payment_type == 1 && survey_cost_other_invoice_business_type == 0 ? 
																		[GetMessage(2603)] : "" : "",
				survey_cost_parking_rent_invoice_registration_number: survey_cost_parking_rent_payment_type==1? this.validateInvoiceNumber(survey_cost_parking_rent_invoice_business_type,survey_cost_parking_rent_invoice_registration_number):"",
				survey_cost_commission_invoice_registration_number: survey_cost_commission_payment_type==1? this.validateInvoiceNumber(survey_cost_commission_invoice_business_type,survey_cost_commission_invoice_registration_number):"",
				survey_cost_key_money_invoice_registration_number: survey_cost_key_money_payment_type==1? this.validateInvoiceNumber(survey_cost_key_money_invoice_business_type,survey_cost_key_money_invoice_registration_number):"",
				survey_cost_other_invoice_registration_number: survey_cost_other_payment_type==1? this.validateInvoiceNumber(survey_cost_other_invoice_business_type,survey_cost_other_invoice_registration_number):"",
				}
			},
		}, ()=>{
			callback()
		// console.log(this.state)
	  })
	}
	
	  validate(){
		const invoice_created = this.state.data.values.invoice_process_status != null;
		// 請求依頼済ならバリデーションチェックスキップ
		if(invoice_created) {
			return true;
		}

		let message = getErrorCodes(this.state.data.errors, this.state.data.values.ignore_error)

		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	  }
	
	  alertDateCheck({
		quote_available_start_date,
		quote_available_end_date
	  }){
		const {
		  quote_available_start_date:prev_quote_available_start_date,
		  quote_available_end_date:prev_quote_available_end_date,
		} = this.state.data.values
		const check_quote_available_start_date = quote_available_start_date != undefined && quote_available_start_date != null ? quote_available_start_date : prev_quote_available_start_date
		const check_quote_available_end_date = quote_available_end_date != undefined && quote_available_end_date != null ? quote_available_end_date : prev_quote_available_end_date

		if(check_quote_available_start_date && check_quote_available_end_date){
			if(moment(check_quote_available_start_date) > moment(check_quote_available_end_date)){
				return false
			}
		}
		return true
	  }
	
	  handleClickNegative(){
		//いいえを押した場合、入力値初期化
		this.setState({
		  data:{
			...this.props.data,
			values:{
			  ...this.props.data.values,
			  quote_available_start_date : null,
			  quote_available_end_date : null,
			  quote_capacity_qty : null,
			  non_taxable_flag : null, 
			  quote_term_month_flag : null,
			}
		  }
		})
		this.toggleModal();
	  }

	  requestEstimatePDF(estimateCommonParams, estimateData){
		//console.log(this.EstimateQuoteCustomizedForTomosho)
		//console.log(estimateData)
		return (this.EstimateQuoteCustomizedForTomosho==estimateData.customer_natural_id)
		? new Promise((resolve, reject)=>{      
		  const {
			estimate_id,
			survey_capacity_qty_type,
			survey_tax_in_flag,
			quote_available_start_date,
			quote_available_end_date,
			survey_discount_amt,
			survey_key_money,
			survey_commission_discount_amt,
			survey_adjustment_amt,
			quote_subtotal_amt,
			quote_tax_amt,
			quote_total_amt,
			estimate_details,
			latest_pdf_quote_url: original_latest_pdf_quote_url,
			invoice_customer_user_setting,
			customer_branch_invoice_zip_code,
			customer_branch_invoice_prefecture,
			customer_branch_invoice_city,
			customer_branch_invoice_address,
			invoice_customer_user_name,
			customer_user_name,
			request_type,
			estimate_detail_name,
			estimate_detail_name_ex,
			estimate_detail_amt,
			estimate_detail_amt_ex,
		  } = estimateData
		  
		  const invoice_user_name = invoice_customer_user_setting == 1 
		  ? invoice_customer_user_name
		  : invoice_customer_user_setting == 2 
			? customer_user_name
			: ""
	
		  let object_array_detail = {}
		  let array_count = 0

		//   console.log(estimate_details)
		  for(let i=1;i<=11;i++){
			const estimateDetail = estimate_details[i-1]
			// console.log(estimateDetail.estimate_type);
			if (estimateDetail && estimateDetail.estimate_type == "1"){
			  array_count++
			  object_array_detail[`row_start_${i}`] = {
				ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
				ESTIMATE__quote_capacity_qty: estimateDetail.estimate_detail_qty, // ESTIMATE__survey_capacity_qty
				ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
				ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
				ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
				ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt
			  }
			} else {
			  object_array_detail[`row_start_${i}`] = {
				ESTIMATE_DETAIL__estimate_detail_name: "",
				ESTIMATE__quote_capacity_qty: "",
				ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
				ESTIMATE_DETAIL__estimate_detail_term: "",
				ESTIMATE_DETAIL__estimate_detail_term_type: "",
				ESTIMATE_DETAIL__estimate_detail_amt: ""
			  }
			}
		  }
		  
		  estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id
		  estimateCommonParams["object_estimate"]["ESTIMATE__quote_subtotal_amt"] = quote_subtotal_amt;
	
		  const pdfParams = {
			...estimateCommonParams,
			format_url:GoogleDrive.getFormatUrl(format_url.Y13_PDF), 
			object_each_data:{
			  CUSTOMER_BRANCH__tax_in_flag:survey_tax_in_flag,
			  ESTIMATE__quote_available_start_date:quote_available_start_date,
			  ESTIMATE__quote_available_end_date: quote_available_end_date,
			  ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
			  ESTIMATE__survey_discount_amt: survey_discount_amt,
			  ESTIMATE__survey_key_money:survey_key_money,
			  ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
			  ESTIMATE__survey_adjustment_amt:survey_adjustment_amt,
			  ESTIMATE__quote_subtotal_amt:quote_subtotal_amt,
			  ESTIMATE__quote_tax_amt:quote_tax_amt,
			  ESTIMATE__quote_total_amt: quote_total_amt,
			  CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
			  JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
			  CUSTOMER_USER__customer_user_name : invoice_user_name,
			  ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
			  ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
			  ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
			  ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
			  ESTIMATE__other_tax_total_amt: quote_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
			  ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計		  
			  object_array_detail
			},
			object_common:{
			  ...estimateCommonParams.object_common,
			  array_count
			},
		
		  }
		  
		  const pdfUrl = '/api/pout/Y13_PDF'+(original_latest_pdf_quote_url?`?sheet_id=${original_latest_pdf_quote_url}`:"")
		  Request.post(pdfUrl, pdfParams, res=>{
			if (res.Code>=800){
			  Request.setProgress(0)
			  resolve(undefined)
			} else {
			  resolve(res.Data)
			}
		  }, err => {
			reject(err)
		  })
		})
		:
		 new Promise((resolve, reject)=>{      
		  const {
			estimate_id,
			survey_capacity_qty_type,
			survey_tax_in_flag,
			quote_available_start_date,
			quote_available_end_date,
			survey_discount_amt,
			survey_key_money,
			survey_commission_discount_amt,
			survey_adjustment_amt,
			quote_subtotal_amt,
			quote_tax_amt,
			quote_total_amt,
			estimate_details,
			latest_pdf_quote_url: original_latest_pdf_quote_url,
			invoice_customer_user_setting,
			customer_branch_invoice_zip_code,
			customer_branch_invoice_prefecture,
			customer_branch_invoice_city,
			customer_branch_invoice_address,
			invoice_customer_user_name,
			customer_user_name,
			request_type,
			estimate_detail_name,
			estimate_detail_name_ex,
			estimate_detail_amt,
			estimate_detail_amt_ex,
		  } = estimateData

		  const invoice_user_name = invoice_customer_user_setting == 1 
		  ? invoice_customer_user_name
		  : invoice_customer_user_setting == 2 
			? customer_user_name
			: ""
	
		  let object_array_detail = {}
		  let array_count = 0
		//   console.log(estimate_details);
		  for(let i=1;i<=11;i++){
			const estimateDetail = estimate_details[i-1]
			if (estimateDetail && estimateDetail.estimate_type == "1"){
			  array_count++
			  object_array_detail[`row_start_${i}`] = {
				ESTIMATE_DETAIL__estimate_detail_name: estimateDetail.estimate_detail_name,
				ESTIMATE__quote_capacity_qty: estimateDetail.estimate_detail_qty, // ESTIMATE__survey_capacity_qty
				ESTIMATE_DETAIL__estimate_detail_unit_cost: estimateDetail.estimate_detail_unit_cost,
				ESTIMATE_DETAIL__estimate_detail_term: estimateDetail.estimate_detail_term,
				ESTIMATE_DETAIL__estimate_detail_term_type: estimateDetail.estimate_detail_term_type,
				ESTIMATE_DETAIL__estimate_detail_amt: estimateDetail.estimate_detail_amt
			  }
			} else {
			  object_array_detail[`row_start_${i}`] = {
				ESTIMATE_DETAIL__estimate_detail_name: "",
				ESTIMATE__quote_capacity_qty: "",
				ESTIMATE_DETAIL__estimate_detail_unit_cost: "",
				ESTIMATE_DETAIL__estimate_detail_term: "",
				ESTIMATE_DETAIL__estimate_detail_term_type: "",
				ESTIMATE_DETAIL__estimate_detail_amt: ""
			  }
			}
		  }
		  estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id
		  estimateCommonParams["object_estimate"]["ESTIMATE__quote_subtotal_amt"] = quote_subtotal_amt;

		  const pdfParams = {
			...estimateCommonParams,
			format_url:GoogleDrive.getFormatUrl(format_url.F01_PDF), 
			object_each_data:{
			  CUSTOMER_BRANCH__tax_in_flag:survey_tax_in_flag,
			  ESTIMATE__quote_available_start_date:quote_available_start_date,
			  ESTIMATE__quote_available_end_date: quote_available_end_date,
			  ESTIMATE__survey_capacity_qty_type:FormatCode.decode("cst_survey_capacity_qty_type",survey_capacity_qty_type),
			  ESTIMATE__survey_discount_amt: survey_discount_amt,
			  ESTIMATE__survey_key_money:survey_key_money,
			  ESTIMATE__survey_commission_discount_amt: survey_commission_discount_amt,
			  ESTIMATE__survey_adjustment_amt:survey_adjustment_amt,
			  ESTIMATE__quote_subtotal_amt:quote_subtotal_amt,
			  ESTIMATE__quote_tax_amt:quote_tax_amt,
			  ESTIMATE__quote_total_amt: quote_total_amt,
			  CUSTOMER_BRANCH__customer_branch_invoice_zip_code : customer_branch_invoice_zip_code,
			  JOIN_invoice_addr: FormatCode.decode("cst_prefecture", customer_branch_invoice_prefecture) + (customer_branch_invoice_city||"") + (customer_branch_invoice_address||""),
			  CUSTOMER_USER__customer_user_name : invoice_user_name,
			  ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
			  ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
			  ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
			  ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
			  ESTIMATE__other_tax_total_amt: quote_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
			  ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計		  
			  object_array_detail
			},
			object_common:{
			  ...estimateCommonParams.object_common,
			  array_count
			},
			customer_system_use_flag:estimateData["customer_system_use_flag"],
			pdf_upload_off:true,
		  }
		//   console.log(pdfParams);
		  const pdfUrl = '/api/pout/F01_PDF'+(original_latest_pdf_quote_url?`?sheet_id=${original_latest_pdf_quote_url}`:"")
		  Request.post(pdfUrl, pdfParams, res=>{
			if (res.Code>=800){
			  Request.setProgress(0)
			  resolve(undefined)
			} else {
			  resolve(res.Data)
			}
		  }, err => {
			reject(err)
		  })
		})
	  }	  



	// #1873 警告バナー対応
	togglePdfRegistModal(regist_check){
		let pdf_created = regist_check !== undefined ? this.state.pdf_created : false;
		let pdf_registed = regist_check !== undefined ? this.state.pdf_registed : false;		
		this.setState({
			pdf_regist_modal: !this.state.pdf_regist_modal,
			pdf_created,
			pdf_registed
		});
	}

	async pdfCreateReqest(){
		if(!this.state.latest_pdf_plotting_url){
		Request.setProgress(0)
		return undefined;
		}
		let params = this.state.pdfParams
		// let params = dataList[Object.keys(dataList)[0]]
		params["main_sheet"] = "F02_PDF"
		params["sheet_id"] = this.state.latest_pdf_plotting_url ? this.state.latest_pdf_plotting_url: ""
		params["pdf_upload_off"] = true;		
		// console.log(params)

		return new Promise((resolve, reject)=>{ 
		Request.post("/api/pout/pdf_create", params, res=>{
			if (res.Code>=800){
			Request.setProgress(0)
			resolve(undefined)
			} else {
			resolve(res.Data)
			}
		}, err=>{
			reject(err)
		})
		})
	}

	//PDF作成
	async pdfCreate(){
		const {latest_pdf_plotting_request_status,
		} = this.state.data.values

		let pdf_registed = true;
		let new_latest_pdf_plotting_url = undefined; 
		const invoice_created = this.state.data.values.invoice_process_status != null;

		if(latest_pdf_plotting_request_status == 3 || invoice_created){
			let PdfData = await this.pdfCreateReqest()
// 			console.log(PdfData.file_id)
			if(PdfData == undefined || !PdfData.file_id ){
				this.props.alertModal.current.showErrorModal({messageNo:2406})
				return ;
			}
			// console.log(Pdf02Result)
		
			PdfData && window.open(`https://drive.google.com/uc?export=download&id=${PdfData.file_id}`)
			if(!PdfData.file_id){
				pdf_registed = false;
			}

			new_latest_pdf_plotting_url = pdf_registed && PdfData.file_id ? PdfData.file_id : undefined
			// console.log(new_latest_pdf_plotting_url)
	
		}
		this.state.latest_pdf_quote_file && window.open(`https://drive.google.com/uc?export=download&id=${this.state.latest_pdf_quote_file}`)
		this.state.contract_pdf_file && window.open(`https://drive.google.com/uc?export=download&id=${this.state.contract_pdf_file}`)
		this.state.application_pdf_file && window.open(`https://drive.google.com/uc?export=download&id=${this.state.application_pdf_file}`)
		
		this.setState({
			pdf_registed: pdf_registed,
			new_latest_pdf_plotting_url
		});
	}

	async fileUpload(ulid=""){

		try {

			const {estimateData, new_latest_pdf_plotting_url:latest_pdf_plotting_url , payment_deadline} = this.state;

			return await new Promise((resolve,reject)=>{
				
				const url = '/api/quote/file_upload/' + estimateData.estimate_ulid
				const latest_pdf_plotting_request_status = latest_pdf_plotting_url?4:undefined
				const update_timestamp = this.state.data.values.update_timestamp;

				const uploadParams = {
					...estimateData,
					latest_pdf_plotting_url,
					latest_pdf_plotting_request_status,
					payment_deadline,
					update_timestamp
				}

				Request.put(url, uploadParams, res =>{
					if(res.Code != "200"){
						reject(res)
					}
					this.setState( prevState => ({
						...prevState,
						data:{
						...prevState.data,
						values:{
							...prevState.data.values,
							latest_pdf_plotting_request_status,
							update_timestamp: res.Data.update_timestamp
						}
						}
					}), () => {
						console.log(res.Data.update_timestamp);
						resolve(res)
					})
				}, err => reject(err),undefined,true,false);
			})
		} catch (err) {
			console.log("File upload failed:", err);
			Request.setProgress(0)
			this.props.alertModal.current.confirmCheck({
				title: "エラーが発生しました。",
				message: err.Status ? err.Data && err.Data.error + "<br />"+GetMessage(2625).replace(/STATUS_CODE/g, err.Status).split("]")[1]
								    : err.Message 
										? err.Message
										: "処理中にエラーが発生しました。",
				closeBtn: false,
				titleBtn: "閉じる"
			}, ()=>{
				// window.location.reload()
				this.props.refreshCallback();
				this.toggleModal();
			}, false)
		}
	}

	async updateStatus(){
		try{
			const with_pdf = this.props.data.from != 'juchu_confirm';
			Request.setProgress(80)
			// console.log(with_pdf,this.state.data.values,latest_pdf_quote_url,contract_pdf_url)
			const update_timestamp = this.state.data.values.update_timestamp;
			console.log(this.state.data.values)
			const params = with_pdf ? {
				...this.state.data.values,
				latest_pdf_quote_url : this.state.latest_pdf_quote_url,
				latest_pdf_plotting_url : this.state.latest_pdf_plotting_url,
				contract_pdf_url : this.state.contract_pdf_url,			
				estimate_status: this.state.data.values.order_box_status >= '7' ? this.state.data.values.estimate_status : '4', //不具合1925、1931により調整
				old_quote_plotting_number: this.props.data.values.quote_plotting_number, // 契約区画番号の変更を知るための旧値（file_upload apiがDBを更新してしまうためフロントから旧値を渡す）
				login_user: localStorage.getItem("name"),
				payment_deadline:this.state.payment_deadline,
				update_timestamp
			} : {
				...this.state.data.values,
				old_quote_plotting_number: this.props.data.values.quote_plotting_number, // 契約区画番号の変更を知るための旧値（file_upload apiがDBを更新してしまうためフロントから旧値を渡す）
				login_user: localStorage.getItem("name"),
				payment_deadline:this.state.payment_deadline,
				update_timestamp
			}
			console.log(params);
			// console.log('call order/status');
			const resultCode = await new Promise((resolve, reject)=>{
				Request.put('/api/order/status/' + this.state.data.values.estimate_ulid, params, async (res)=>{
					resolve(res.Code)
				},(err)=>{
					// Request.setProgress(0)
					reject(err)
				}, undefined,true,false);
			})
			
			Request.setProgress(90)
			if (resultCode == 200){
		
				Request.setProgress(0)
				document.body.style.overflow = "auto";

				this.props.alertModal.current.confirmCheck({
					title: "処理完了",
					messageNo: [2417],
					closeBtn: false
				}, ()=>{
					this.props.refreshCallback()
					this.toggleModal();
				}, false)
			}
		} catch (err){
			console.log("Status update failed:",err);
			Request.setProgress(0)
			this.props.alertModal.current.confirmCheck({
				title: "エラーが発生しました。",
				message: err.Status ? err.Data && err.Data.error + "<br />"+GetMessage(2625).replace(/STATUS_CODE/g, err.Status).split("]")[1]
								: err.Message 
									? err.Message
									: "処理中にエラーが発生しました。",
				closeBtn: false,
				titleBtn: "閉じる"
			}, ()=>{
				// window.location.reload()
				this.props.refreshCallback();
				this.toggleModal();
			}, false)
		}
		Request.setProgress(0)
	}


	  async handleClickPositive(){
		//API estimatelist/mail/:ulid
		if (!this.validate()){
		  return;
		}

		const with_pdf = this.props.data.from != 'juchu_confirm';

		const {
			estimate_id,
			customer_natural_id,
			customer_branch_natural_id,
			customer_user_natural_id,
			subcontract_customer_branch_natural_id,
			subcontract_customer_user_natural_id,
			request_natural_id,
			project_natural_id,
			invoice_natural_id,
			invoice_process_pdf_date,
			estimate_natural_id,
			quote_available_start_date,
			quote_available_end_date,
			request_type,
			invoice_closing_date,
			invoice_amt,
			contract_create_flag,
			change_invoice_flag,
			change_invoice_name,
			contract_format_url,
			survey_capacity_flag_car,
			survey_capacity_flag_light_truck,
			quote_plotting_number,
			quote_capacity_qty,
			survey_parking_picture_url,
			survey_route_picture_url,
			survey_route_zoom_picture_url,
			quote_plotting_picture_url,
			survey_parking_address_contract,
			survey_site_distance_meter,
			survey_site_distance_minute,
			latest_pdf_plotting_url: original_latest_pdf_plotting_url,
			user_branch_natural_id,
			parking_latitude,
			parking_longitude,
			project_latitude,
			project_longitude,
			want_guide_type,
			want_guide_type_subcontract,			
			latest_plotting_picture_url,
			latest_pdf_plotting_request_status,
			payment_due_rule_month,
			payment_due_rule_day,
			survey_route_zoom_qr_url,
			payment_deadline:tmp_payment_deadline,
			request_user_branch_natural_id,
			order_box_status,
			latest_pdf_quote_url,
			latest_pdf_quote_file,
		} = this.state.data.values
		
		try{
				
			const estimateCommonParams = await Request.getEstimateCommon({
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				estimateObject: this.state.data.values,
				user_branch_natural_id:request_user_branch_natural_id
			})
			// console.log(estimateCommonParams);

			let origin_invoice_closing_date = invoice_closing_date ? invoice_closing_date : moment().format("YYYY-MM-DD") 

			// 締日定義
			let payment_deadline = tmp_payment_deadline != "" && tmp_payment_deadline != null ? tmp_payment_deadline : moment(origin_invoice_closing_date);
			if (tmp_payment_deadline == "" || tmp_payment_deadline == null){
				// 日付を取得
				let now_date = moment().format("DD") ;

				// console.log(payment_due_rule_month,now_date)
				let tmp_payment_due_rule_month = payment_due_rule_month ;
				if( parseInt(now_date) >= 25){
					tmp_payment_due_rule_month = tmp_payment_due_rule_month + 1;
				}

				// 支払期限日ルール：月
				payment_deadline.add(tmp_payment_due_rule_month, 'months');
				// 支払期限日ルール：日が「月末」の場合、当月の最終日を設定する
				if(payment_due_rule_day == 0){
				const endOfMonth = payment_deadline.endOf('month').format('DD');
				payment_deadline.date(endOfMonth);
				} else {
				payment_deadline.date(payment_due_rule_day);
				}
				payment_deadline = payment_deadline.format("YYYY-MM-DDT00:00:00") 

			}

			Request.setProgress(20)
			let routeData;
			let estimateData = {
				...this.state.data.values,
				quote_route_picture_url: null,
				ESTIMATE__quote_route_picture_url: null,
				quote_route_zoom_picture_url: null,
				ESTIMATE__quote_route_zoom_picture_url: null,
			} ;

			let latest_pdf_quote_url = undefined;
			let latest_pdf_quote_file = undefined;
			let latest_pdf_plotting_url = undefined;

			let contract_pdf_url = null;
			let contract_pdf_file = null;
			let application_pdf_file = null;
			// console.log(latest_pdf_plotting_request_status)
			let pdf_created = (latest_pdf_plotting_request_status == 3 || latest_pdf_plotting_request_status == 4) && quote_plotting_picture_url ? false: true;

			if(with_pdf) {
				//提出用区画図ステータスがアップロード済み 
				if((latest_pdf_plotting_request_status == 3 || latest_pdf_plotting_request_status == 4) && quote_plotting_picture_url){
					Request.setProgress(30)

					estimateData = {
						...estimateData,
						quote_route_picture_url: "",
						ESTIMATE__quote_route_picture_url: "",
						quote_route_zoom_picture_url: survey_route_zoom_picture_url,
						ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
						// estimate_details:estimate_detail_data
					}

					estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id

					Request.setProgress(40)
					// 区画図作成
					const Pdf02Result = await new Promise((resolve, reject)=>{
						let locationOrigin = window.location.origin;
						//    let keys = Object.keys(dataList)
						let qr_url = "/api/qrcode?url="
						let quote_parking_qr_url = "https://www.google.com/maps/search/?api=1&query=" + parking_latitude + "," + parking_longitude
						let quote_site_qr_url = "https://www.google.com/maps/search/?api=1&query=" + project_latitude + "," + project_longitude
						
						const pdfUrl = '/api/pout/F02_PDF'
						const pdfParams = {
						...estimateCommonParams,
						format_url:GoogleDrive.getFormatUrl(format_url.F02_PDF),
   						pdf_upload_off: true,		
						object_each_data:{
							ESTIMATE__survey_capacity_flag_car:survey_capacity_flag_car,
							ESTIMATE__survey_capacity_flag_light_truck:survey_capacity_flag_light_truck,
							ESTIMATE__quote_plotting_number:quote_plotting_number,
							ESTIMATE__quote_capacity_qty:quote_capacity_qty,
							ESTIMATE__quote_available_start_date:quote_available_start_date,
							ESTIMATE__quote_available_end_date:quote_available_end_date,
							ESTIMATE__survey_parking_picture_url:GoogleDrive.getDownloadUrl(survey_parking_picture_url),
							ESTIMATE__latest_pdf_route_url:survey_route_picture_url,
							ESTIMATE__quote_plotting_picture_url:GoogleDrive.getDownloadUrl(quote_plotting_picture_url),
							ESTIMATE__survey_parking_address_contract:survey_parking_address_contract,
							JOIN_parking_addr: estimateCommonParams.object_estimate.JOIN_parking_addr,
							REQUEST_PARKING__site_distance_minute:survey_site_distance_minute,
							REQUEST_PARKING__site_distance_meter:survey_site_distance_meter,
							ESTIMATE__quote_route_picture_url: " ",
							ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
							ESTIMATE__quote_parking_qr_url: locationOrigin + qr_url + encodeURIComponent(quote_parking_qr_url),
							ESTIMATE__quote_site_qr_url: locationOrigin + qr_url + encodeURIComponent(quote_site_qr_url)
						},
						customer_system_use_flag:estimateData["customer_system_use_flag"],
						}

						this.setState({
							pdfParams: pdfParams,
						});

						Request.post(pdfUrl, pdfParams, res=>{
						if (res.Code>=800){
							Request.setProgress(0)
							resolve(undefined)
						} else {
							resolve(res.Data)
						}
						}, err=>{
						reject(err)
						})
					})
					if (!Pdf02Result){
						Request.setProgress(0)
						this.props.alertModal.current.showErrorModal({
						messageNo: 2475
						})
						return;
					}
					latest_pdf_plotting_url = Pdf02Result&&Pdf02Result.spreadsheet_id
					
				}
				if(order_box_status < 7){
					// 確定見積作成
					Request.setProgress(60)
					const Pdf01Result = await this.requestEstimatePDF(estimateCommonParams, estimateData)
					if (!Pdf01Result){
						Request.setProgress(0)
						this.props.alertModal.current.showErrorModal({
							messageNo: 2474
						})
						return 
					}

					latest_pdf_quote_url = Pdf01Result&&Pdf01Result.spreadsheet_id
					latest_pdf_quote_file =  Pdf01Result&&Pdf01Result.file_id
					this.setState({
						latest_pdf_quote_url,
						latest_pdf_quote_file,
					});
				}

				// 契約書作成
				// 契約書送付有無が有りのもの
				// 東建コーポレーションの場合は、作成済みなので、再作成しない。
				contract_pdf_url = this.customerUseCustomizedEstimateForTouken == customer_natural_id? this.state.data.values.contract_pdf_url : null;
				let skip_contract = this.customerUseCustomizedEstimateForTouken == customer_natural_id;
				// console.log(this.customerUseCustomizedEstimateForTouken,customer_natural_id,skip_contract,contract_create_flag)
				// console.log(contract_create_flag,skip_contract)
				if(contract_create_flag == "1" && skip_contract == false){
					
					// 	contract_pdf_url = G15_PDF.Data ? G15_PDF.Data.spreadsheet_id : null;
					// }else{
						let G05_PDF = {};
						//契約書送付有無が有りのもの
						if(contract_create_flag == "1"){
							//契約共通パラメータ取得
							const contractCommon = await Request.getContractCommon({
								customer_branch_natural_id,
								customer_user_natural_id,
								subcontract_customer_branch_natural_id,
								subcontract_customer_user_natural_id,
								request_natural_id,
								project_natural_id,
								invoice_natural_id,
								invoice_process_pdf_date,
								estimate_natural_id,
								quote_available_start_date,
								quote_available_end_date,
								request_type,
								payment_deadline,
								invoice_closing_date,
								invoice_amt,
							})
					
							// 独自契約書
							let customContract = CustomReport.contract.find(item => {
								return item.customer_natural_id === customer_natural_id 
								&& item.customer_branch_natural_id === customer_branch_natural_id
							})
					
							customContract = customContract || CustomReport.contract.find(item => {
								return item.customer_natural_id === customer_natural_id 
							})
							// console.log("customContract ", customContract)
							// console.log(contractCommon);

							const {
								survey_parking_rent,
								survey_tax_in_flag,
								quote_subtotal_amt,
								estimate_detail_name,
								estimate_detail_name_ex,
								estimate_detail_amt,
								estimate_detail_amt_ex,
							  } = estimateData

							let mergeContractCommon = {
								...contractCommon,
								object_estimate:{
									...estimateCommonParams.object_estimate,
									ESTIMATE__survey_parking_rent: survey_parking_rent,
									ESTIMATE__quote_subtotal_amt: quote_subtotal_amt
								},
								object_invoice:{
									...contractCommon.object_invoice,
									INVOICE__invoice_natural_id: estimate_natural_id,
									INVOICE__invoice_closing_date: origin_invoice_closing_date,
									INVOICE__invoice_amt: estimateCommonParams.object_estimate.ESTIMATE__quote_total_amt,
									INVOICE__payment_deadline: payment_deadline,
								},
								object_each_data:{
									ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
									ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
									ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
									ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
									ESTIMATE__other_tax_total_amt: quote_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
									// ESTIMATE__other_tax_total_amt:quote_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
									ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計	
								},
							}

							// G05_PDF_契約書
							G05_PDF = await new Promise((resolve, reject)=>{
								const pdfParams = {
									...mergeContractCommon,
									format_url:GoogleDrive.getFormatUrl((contract_format_url
										?contract_format_url
										:customContract ? format_url[customContract.format] :format_url.G05_PDF)),
								    pdf_upload_off: true,		
								}

								Request.post( `/api/pout/${customContract ? customContract.format : "G05_PDF"}`, pdfParams, res=>{
									if (res.Code>=800){
										Request.setProgress(0)
										resolve(undefined)
									} else {
										if(customContract && customContract.format == "Y08_PDF"){
											Request.post('/api/pout/Y08_PDF', {custom_template_pdf : true, ...pdfParams}, res2=>{
												if (res2.Code>=800){
													Request.setProgress(0)
													resolve(undefined)
												} else {
													resolve([res, res2])
												}
											}, err => {
												console.log(err)
												reject(err)
											})
										}else{
											resolve([res])
										}
									}

									// Request.setProgress(70)
									// resolve(res)
								}, err => {
									console.log(err)
									resolve({
										estimate_natural_id : estimate_natural_id,
										Code : 805,
									})
								})
							})
							// console.log(G05_PDF)
							if(G05_PDF[0].Code >= 800){
								return G05_PDF[0];
							}
							if(G05_PDF[1] && G05_PDF[1].Code >= 800){
								return G05_PDF[1];
							}
							contract_pdf_url = G05_PDF[0] && G05_PDF[0].Data ? G05_PDF[0].Data.spreadsheet_id : null;
							application_pdf_file = G05_PDF[1] && G05_PDF[1].Data ? G05_PDF[1].Data.file_id : null;
							contract_pdf_file =  G05_PDF[0] && G05_PDF[0].Data ? G05_PDF[0].Data.file_id : null;
						}

						
						this.setState({
							contract_pdf_url,
							contract_pdf_file,
							application_pdf_file,
						});
					}
			// }

				this.setState({
					latest_pdf_plotting_url,
					latest_pdf_quote_url,
					latest_pdf_quote_file,
					contract_pdf_url,
					contract_pdf_file,
					application_pdf_file,
					payment_deadline,
					pdf_created,
					estimateData: estimateData,
				});
				Request.setProgress(0)
				this.togglePdfRegistModal(false)
			
				
			}else{

				this.setState({
					latest_pdf_plotting_url,
					latest_pdf_quote_url,
					contract_pdf_url,
					payment_deadline,
					estimateData: estimateData,
				});
				this.updateStatus()
			}

			
		}catch(err){
			console.log(err);
			Request.setProgress(0)
			this.props.alertModal.current.showErrorModal({
			  messageNo: 2476
			})
		}
	  }

	  bodyContent() {
	//    console.log('dialog state', this.state)
		const {
			change_invoice_flag,
			request_type,
			estimate_detail_amt_ex,
			estimate_detail_amt,
			quote_subtotal_amt,
			quote_subtotal_amt_ex
			} = this.state.data.values
		
		// console.log(this.state.data.values);
		const _quote_subtotal_amt = quote_subtotal_amt;
		const non_taxable_total = this.isNull(estimate_detail_amt_ex) ? 0 : estimate_detail_amt_ex
		const taxable_total = (this.isNull(_quote_subtotal_amt) ? 0 : _quote_subtotal_amt) - estimate_detail_amt_ex
		const invoice_created = this.state.data.values.invoice_process_status != null
		// 不具合表1615　請求書生成済以降は区画番号も非活性
		// #1918 請求済みでも変更可能にする
		// const after_invoice_create = this.state.data.values.invoice_process_status != null && this.state.data.values.invoice_process_status >= 2
		return (
		  <>
			<Row>
			  <Col md="4" style={{wordBreak: "break-all"}}>
			  見積ID：{this.state.data.values.estimate_natural_id}<br />
			  駐車場：{this.state.data.values.survey_parking_name}
			  </Col>
			  <Col md="4" style={{wordBreak: "break-all"}}>
			  現場名：{this.state.data.values.site_name}
			  </Col>
			  <Col md="4">
			  <InputText
				label='契約区画番号'
				labelOn={true}
				name='ESTIMATE__quote_plotting_number'
				// validateCallback={this.validateCallback}
				validateCallback={(e)=>this.validateCallback(e)}
				rootData={this.state.data}
				// disabled={after_invoice_create}
				validateType="regist"
			  />
			</Col>          
			</Row>
			<Row>
			<Col md="3">
			  契約開始日:{Format.format_date_en(this.state.data.values.old_quote_available_start_date)}
			  <InputDatetime
				label='契約開始日'
				labelOn={false}
				name='ESTIMATE__quote_available_start_date'
				rootData={this.state.data}
				validateCallback={this.validateCallback}
				validateType="regist"
				disabled={invoice_created}
				// disabled={this.state.data.values.request_type=="2"}
			  />
			</Col>
			<Col md="3">
			  契約終了日:{Format.format_date_en(this.state.data.values.old_quote_available_end_date)}
			  <InputDatetime
				label='契約終了日'
				labelOn={false}
				name='ESTIMATE__quote_available_end_date'
				rootData={this.state.data}
				validateCallback={this.validateCallback}
				validateType="regist"
				disabled={invoice_created}
				// disabled={this.state.data.values.request_type=="2"}
			  />
			</Col>
			<Col md="3">
			台数:{this.state.data.values.old_quote_capacity_qty}台
			  <InputNumber
				unit='台'
				label='台数'
				labelOn={false}
				name='ESTIMATE__quote_capacity_qty'
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				validateType="regist"
				size={12}
				disabled={invoice_created}
				// disabled={this.state.data.values.request_type=="2"}
			  />
			</Col>
			<Col md="3">
			支払期限日:
			  <InputDatetime
				label='支払期限日'
				labelOn={false}
				name='ESTIMATE__payment_deadline'
				rootData={this.state.data}
				validateCallback={this.validateCallback}
				validateType="regist"
				disabled={invoice_created}
			  />
			</Col>
			{(this.state.data.values.estimate_change_flag == "1" &&<Col md="12" style={{color:'red'}}>
			顧客より受注内容変更の要望があります
			</Col>)}
			</Row>
			<Row>
			  <Col md="12">
			  <InputText multiline={true}
				labelOn={true}
				label='顧客からの連絡事項'
				name='ESTIMATE__order_contact_memo'
				validateCallback={this.validateCallback} 
				rootData={this.state.data}
				validateType='regist'
				disabled={true}
				placeholder=" "
			  />
			  </Col>
			</Row>        
	
			<Row>
			<Col md="3">
			  <InputRadio options={cst_non_taxable_flag}
				validateCallback={this.validateCallback} 
				rootData={this.state.data}
				labelOn={true}
				validateType="regist"
				label="非課税対象"
				name="ESTIMATE__non_taxable_flag"
				disabled={invoice_created}
				/>
			</Col>
			<Col md="3">
			  <InputRadio
				options={cst_term_month_flag}
				validateCallback={this.validateCallback} 
				validateType='regist'
				labelOn={true}
				rootData={this.state.data}
				label='通し有無'
				name='ESTIMATE__quote_term_month_flag'
				disabled={invoice_created}
			  />
			</Col>
			<Col md="3">
			  <InputNumberChange
				unit='ヶ月'
				label='実質月数'
				labelOn={true}
				disabled={true}
				name='ESTIMATE__quote_month_qty'
				value={(this.state.data.errors.quote_term_month_flag&&this.state.data.errors.quote_term_month_flag[1].notIgnore)?"":this.state.data.values.quote_month_qty}
				validateType="regist"
				size={12}
			  />
			</Col>
			<Col md="3">
			  <InputNumberChange
				label='実質日数'
				labelOn={true}
				name='ESTIMATE__quote_day_qty'
				value={(this.state.data.errors.quote_term_month_flag&&this.state.data.errors.quote_term_month_flag[1].notIgnore)?"":this.state.data.values.quote_day_qty}
				disabled={true}
				validateType="regist"
				size={12}
			  />
			</Col>
			</Row>
			<Row>
			<Col md="3">
			  <InputNumber
				unit='円'
				label={'仕入賃料（月単価）'}
				labelOn={true}
				name={'ESTIMATE__survey_cost_parking_rent'}
				validateCallback={this.validateCallback}
				// disabled={request_type==3}
				disabled={invoice_created}
				rootData={this.state.data}
				validateType="regist"
				size={12}
			  />
			</Col>
			<Col md="9">
				<InputInvoice
					label="支払先&nbsp;"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_parking_rent_payment_type",
						business_type: "ESTIMATE__survey_cost_parking_rent_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_parking_rent_invoice_registration_number",
						with_unconfirmed : "ESTIMATE__survey_cost_parking_rent_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={invoice_created || (this.state.data.values.survey_cost_parking_rent > 0 ? false:true)}
					viewUntax={true}
				/>
				{this.state.data.errors.survey_cost_parking_rent_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_parking_rent_payment_type}</p> : ""}
			</Col>
			</Row>
			<Row>
				<Col md="3">
				<InputNumber
					unit='円'
					label='仕入手数料'
					labelOn={true}
					name='ESTIMATE__survey_cost_commission'
					validateCallback={this.validateCallback}
					disabled={invoice_created}
					rootData={this.state.data}
					validateType="regist"
					size={12}
				/>
				</Col>
				<Col md="9">
					<InputInvoice
					label="支払先&nbsp;"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_commission_payment_type",
						business_type: "ESTIMATE__survey_cost_commission_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_commission_invoice_registration_number",
						with_unconfirmed : "ESTIMATE__survey_cost_commission_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={invoice_created || (this.state.data.values.survey_cost_commission > 0? false:true)}
					viewUntax={true}
					/>
					{this.state.data.errors.survey_cost_commission_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_commission_payment_type}</p> : ""}

				</Col>
			</Row>
			<Row>
				<Col md="3">
				<InputNumber
					unit='円'
					label='仕入礼金'
					labelOn={true}
					name='ESTIMATE__survey_cost_key_money'
					validateCallback={this.validateCallback}
					disabled={invoice_created}
					rootData={this.state.data}
					validateType="regist"
					size={12}
				/>
				</Col>
				<Col md="9">
					<InputInvoice
					label="支払先&nbsp;"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_key_money_payment_type",
						business_type: "ESTIMATE__survey_cost_key_money_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_key_money_invoice_registration_number",
						with_unconfirmed : "ESTIMATE__survey_cost_key_money_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={invoice_created || (this.state.data.values.survey_cost_key_money > 0? false:true)}
					viewUntax={true}
					/>
					{this.state.data.errors.survey_cost_key_money_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_key_money_payment_type}</p> : ""}

				</Col>
			</Row>
			<Row>
				<Col md="3">
				<InputNumber
					unit='円'
					label='仕入その他'
					labelOn={true}
					name='ESTIMATE__survey_cost_other'
					validateCallback={this.validateCallback}
					disabled={invoice_created}
					rootData={this.state.data}
					validateType="regist"
					size={12}
				/>
				</Col>
				<Col md="9">
					<InputInvoice
					label="支払先&nbsp;"
					labelOn={true}
					names={{
						payment_type: "ESTIMATE__survey_cost_other_payment_type",
						business_type: "ESTIMATE__survey_cost_other_invoice_business_type",
						registration_number: "ESTIMATE__survey_cost_other_invoice_registration_number",
						with_unconfirmed : "ESTIMATE__survey_cost_other_invoice_business_type"
					}}
					rootData={this.state.data}
					validateCallback={this.validateCallback}
					visible={true}
					disabled={invoice_created || (this.state.data.values.survey_cost_other > 0? false:true)}
					viewUntax={true}
					/>
					{this.state.data.errors.survey_cost_other_payment_type ? <p style={{ color: "red" }}>{this.state.data.errors.survey_cost_other_payment_type}</p> : ""}

				</Col>
			</Row>

			<Row>
				<Col md="3">
				<InputNumber
					unit='円'
					label='仕入敷金'
					labelOn={true}
					name='ESTIMATE__survey_cost_security_deposit'
					validateCallback={this.validateCallback}
					disabled={invoice_created}
					rootData={this.state.data}
					validateType="regist"
					size={12}
				/>
				</Col>
				<Col md="3">
				<InputNumber
					unit='円'
					label='仕入調整金額'
					labelOn={true}
					name='ESTIMATE__quote_cost_adjustment'
					validateCallback={this.validateCallback}
					disabled={invoice_created}
					rootData={this.state.data}
					validateType="regist"
					size={12}
				/>
				</Col>
				<Col md="3">
				<InputNumber
					unit='円'
					label='仕入合計'
					labelOn={true}
					name='ESTIMATE__quote_cost_total_amt'
					validateCallback={this.validateCallback}
					disabled={true}
					{
					...{value:Format.comma_delimited(this.state.data.values.quote_cost_total_amt)}
					}
					validateType="regist"
					size={12}
				/>
				</Col>
				<Col md="6">
					<InputNumber
						unit='円'
						label='仕入合計＋仕入敷金＋仕入調整金額の合計金額'
						labelOn={true}
						name='ESTIMATE__quote_cost_total_amt_add_deposit_and_adjust'
						validateCallback={this.validateCallback}
						disabled={true}
						rootData={this.state.data}
	/*
						value={
							Format.comma_delimited(
								this.state.data.values.quote_cost_total_amt
								+ this.state.data.values.quote_cost_security_deposit_total_amt
								+ this.state.data.values.quote_cost_adjustment
							)
						}*/
						validateType="regist"
						size={7}
					/>
				</Col>
			</Row>
			<Row>
				<Col md="3">
				    <InputText
					  label='その他課税項目名'
					  labelOn={true}
					  rootData={this.state.data}
					  name='ESTIMATE_DETAIL__estimate_detail_name'
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      disabled={true}
                    />
				</Col>
				<Col md="3">
                    <InputNumber
					  label='非課税金額'
					  emptyLabel={true}
					  labelOn={true}
					  name='ESTIMATE_DETAIL__estimate_detail_amt'
					  rootData={this.state.data}
                      unit="円"
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      disabled={true}
					  size={12}
                    />
				</Col>
				<Col md="3">
				    <InputText
					  label='その他非課税項目名'
					  labelOn={true}
					  rootData={this.state.data}
					  name='ESTIMATE_DETAIL__estimate_detail_name_ex'
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      disabled={true}
                    />
				</Col>
				<Col md="3">
                    <InputNumber
					  label='非課税金額'
					  emptyLabel={true}
					  labelOn={true}
					  name='ESTIMATE_DETAIL__estimate_detail_amt_ex'
					  rootData={this.state.data}
                      unit="円"
                      validateCallback={this.validateCallback} 
                      validateType='regist'
                      disabled={true}
					  size={12}
                    />
				</Col>
			</Row>
			<Row>
			<Col md="3">
			  <InputNumber
				unit='円'
				label='見積小計'
				labelOn={true}
				name={'ESTIMATE__quote_subtotal_amt'}
				validateCallback={this.validateCallback}
				disabled={true}
				// disabled={!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="0")}
				{
				  ...{rootData:this.state.data}
				}
			  	// rootData={this.state.data}
				validateType="regist"
				size={12}
			  />
			</Col>
			<Col>
			<span><br/><br/>{
				"(課税項目小計: "+
				Format.format_number_with_commas(taxable_total)+"円、非課税項目小計: " +
				Format.format_number_with_commas(non_taxable_total)+"円)"
			}</span>
			</Col>
			</Row>
			<Row>
			<Col md="3">
			  <InputRadio
				options={cst_tax_in_flag}
				validateCallback={this.validateCallback} 
				validateType='regist'
				labelOn={true}
				rootData={this.state.data}
				disabled={true}
				label='税込フラグ'
				name='ESTIMATE__survey_tax_in_flag'
			  />
			</Col>
			<Col md="3">
			  <InputNumber
				unit='円'
				label='税額'
				labelOn={true}
				name='ESTIMATE__quote_tax_amt'
				validateCallback={this.validateCallback}
				disabled={true}
				// value={Format.comma_delimited(this.state.data.values.quote_tax_amt)}
				rootData={this.state.data}
				validateType="regist"
				size={12}
			  />
			</Col>
			<Col md="3">
			  <InputNumber
				unit='円'
				label='見積合計'
				labelOn={true}
				name='ESTIMATE__quote_total_amt'
				validateCallback={this.validateCallback}
				disabled={true}
				// disabled={!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="1")}
				// {
				//   ...((!(this.state.data.values.request_type==3&&this.state.data.values.survey_tax_in_flag=="1"))
				//   ? {value:Format.comma_delimited(this.state.data.values.quote_total_amt)}
				//   : {rootData:this.state.data})
				// }
				rootData={this.state.data}
				validateType="regist"
				size={12}
			  />
			</Col>
			</Row>
			<Row>
			<Col md="3">
			  <InputNumber
				unit='円'
				label='利益額 '
				labelOn={true}
				name='___CAL_profit_amt'
				validateCallback={this.validateCallback}
				disabled={true}
				value={Format.comma_delimited(this.state.data.values._CAL_profit_amt)}
				size={12}
			  />
			</Col>
			<Col md="3">
			  <InputNumber
				unit='%'
				label='利益率 '
				labelOn={true}
				name='___CAL_profit_rate'
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				disabled={true}
				size={12}
			  />
			</Col>
			<Col md="3">
			  <InputCheckBox
					label='延長不可'
					name='ESTIMATE__cannot_extention_flag'
					labelOn={false}
					validateCallback={this.validateCallback}
					rootData={this.state.data}
					checkedValue={1}
					uncheckedValue={0}
					disabled={invoice_created}
				/>
			  </Col>			
			  <Col md="3">
				<InputCheckBox 
				  label="エラーを無視する"
				  name="TEMP__ignore_error" 
				  validateCallback={this.validateCallback} 
				  checkedValue={1}
				  uncheckedValue={0}
				  rootData={this.state.data}
				  disabled={invoice_created}
				  />
			  </Col>
			</Row>
			{
				this.state.data.errors._CAL_profit_amt
					? <Row style={{margin: "0.5rem",color:"red"}}>{this.state.data.errors._CAL_profit_amt[0]}</Row>
					: ""
			}
			{
				this.state.data.errors.survey_commission_amount
					? <Row style={{margin: "0.5rem",color:"red"}}>{this.state.data.errors.survey_commission_amount[0]}</Row>
					: ""
			}
			<Row style={{marginBottom: "0.5rem",marginTop: "1rem"}}>
				<Col md="3">
				請求先情報
				</Col>
				<Col md="8">
				<InputRadio
				options={cst_invoice_change_flag}
				name='ESTIMATE__change_invoice_flag'
				validateCallback={this.invoiceValidateCallback} 
				validateType='regist'
				rootData={this.state.data}
				disabled={invoice_created}
				/>
			</Col>
			</Row>
			
			<Row style={{marginBottom: "0.5rem"}}>
				<Col md="3">
				請求先名
				</Col>
				<Col md="8">
				<InputText 
					name='ESTIMATE__change_invoice_name'
					validateCallback={this.invoiceValidateCallback} 
					validateType='regist'
					rootData={this.state.data}
					disabled={invoice_created || change_invoice_flag == 0}
				/>
				</Col>
			</Row>			
			<Row>
				<Col md="12">
					<InputText multiline={true}
						disabled={true}
						labelOn={true}
						label='受注管理メモ'
						name='ESTIMATE__order_memo'
						rootData={this.state.data}
						validateType='regist'
						className="modal-upper-memo"
					/>
				</Col>
			</Row>
			<Row>
				<Col md="12">
					<InputText multiline={true}
						labelOn={true}
						label='コメント'
						name='TEMP__add_memo'
						validateCallback={this.validateCallback} 
						rootData={this.state.data}
						validateType='regist'
						disabled={invoice_created}
					/>

				</Col>
			</Row>
			{this.state.data.values.order_box_status >= '7' && (<>
			<Row>
				<Col md="12">
					<font color="red">※契約区画番号を変更した場合は納品BOXへ移動します</font>
				</Col>
			</Row>
			</>)}
			{/* 契約書（契約書UL待ち、チェック待ち、調整中）の時だけ出す */}
			{/* #1732 #1918  */}
			{/* (this.state.data.values.order_box_status == 7 || this.state.data.values.order_box_status == 8 || this.state.data.values.order_box_status == 9) &&
			<Row>
				<Col md="12" style={{color:"red",textAlign:"left",fontSize:"medium",marginTop:"2rem"}}>
					※契約区画番号を変更した場合はチェックBOXへ移動します
				</Col>
			</Row>
			*/}
			{this.state.data.errors.bank_required_error &&(<>
			<Row>
				<Col md="12" style={{color:"red",textAlign:"right",fontSize:"medium",marginTop:"2rem"}}>
					※顧客支店情報の請求情報：振込口座が未設定です
				</Col>
			</Row>
			</>)}


				{/** #1873 警告バナー対応 */}

				<Modal isOpen={this.state.pdf_regist_modal}>
					<div className="modal-header">
						<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=>{this.togglePdfRegistModal(undefined)}}>
						<i className="tim-icons icon-simple-remove"></i>
						</button>
						<h5 className="modal-title">アクセス許可確認</h5>
					</div>
					<ModalBody style={{textAlign:"center"}}>
						<p>アクセス許可後にPDFを作成してください。</p><br />

						{this.state.latest_pdf_quote_url && (
							<Button 
								color="info" 
								style={{minWidth:"140px",padding:"11px"}}
								onClick={() => { 
									this.state.latest_pdf_quote_url && window.open(`https://docs.google.com/spreadsheets/d/${this.state.latest_pdf_quote_url}`)
								}}>
								確定見積を確認
							</Button>
						)}
						&nbsp;&nbsp;
						{this.state.latest_pdf_plotting_url && (
						<Button 
							color="info" 
							style={{minWidth:"140px",padding:"11px"}}
							onClick={() => { 
								this.state.latest_pdf_plotting_url && window.open(`https://docs.google.com/spreadsheets/d/${this.state.latest_pdf_plotting_url}`)
								this.setState({
								pdf_created: true
								});
							}}>
							区画図を確認
						</Button>
						)}
						{this.state.contract_pdf_url && (
						<>
							&nbsp;&nbsp;
							<Button 
								color="info" 
								style={{minWidth:"140px",padding:"11px"}}
								onClick={() => { 
									this.state.contract_pdf_url && window.open(`https://docs.google.com/spreadsheets/d/${this.state.contract_pdf_url}`)
								}}>
								契約書を確認
							</Button>
						</>
						)}
						<br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						disabled={!this.state.pdf_created}
						onClick={() => { 
							this.pdfCreate()
						}}>
						PDF作成
						</Button><br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						disabled={!this.state.pdf_registed}
						onClick={async () =>  { 
							this.setState({
							pdf_registed: false
							});

							this.togglePdfRegistModal();
							await this.fileUpload(this.state.estimateData.estimate_ulid);
							this.updateStatus()
						}}>
						完了
						</Button>
					</ModalBody>
				</Modal>

			</>
		);
	  }
}  
export class DialogSendQuote extends DialogBase{
	constructor(props) {
		super(props);
	
		const {
		  send_destination_type,
		  customer_branch_cc_email_quote,
		  subcontract_customer_branch_cc_email_quote,
		  customer_branch_fax,
		  subcontract_customer_branch_fax,
		  cc_email
		} = this.props.data.values;
	
	
		var email = [];
		//  console.log(this.props.data.values);
		var sub_email = [];
		// console.log(this.props.data);
	
		// console.log(send_destination_type);
		// console.log(cc_email);
	
		if(send_destination_type =="1"){
		  if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			sub_email.push(cc_email)
		  }
		  
		  if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			sub_email.push(subcontract_customer_branch_cc_email_quote)
		  }
		}else{
		  if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			email.push(cc_email)
		  }
		  if (customer_branch_cc_email_quote !== null && customer_branch_cc_email_quote !== undefined && customer_branch_cc_email_quote.length>0) {
			email.push(customer_branch_cc_email_quote)
		  }
	
		  if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			sub_email.push(subcontract_customer_branch_cc_email_quote)
		  }
	
		}
	
	
		Object.assign(this.state, {
		  title: '確定見積書送付',
		  data: this.props.data,
		  fax_pdf_create_flag: false,
		  fax_send_data: [],
		  set_send_contract: 0,
		  set_fax:"",
		  set_subcon_fax:"",
		  notification: {
			values: {
			  customer_user_email:(this.props.data.values.customer_user_email)? this.props.data.values.customer_user_email: "",
			  subcontract_customer_user_email:(this.props.data.values.subcontract_customer_user_email)? this.props.data.values.subcontract_customer_user_email: "",
			  want_guide_type: (this.props.data.values.want_guide_type)? parseInt( this.props.data.values.want_guide_type ): 0,
			  want_guide_type_subcontract: (this.props.data.values.want_guide_type_subcontract)? parseInt( this.props.data.values.want_guide_type_subcontract ): 0,
			  send_destination_type: (this.props.data.values.send_destination_type)? parseInt(this.props.data.values.send_destination_type): 0,
			  cc_email: (email.length>0)?email.join(","):"",
			  cc_email_subcon: (sub_email.length>0)?sub_email.join(","):"",
			  fax: (customer_branch_fax && customer_branch_fax != null)? customer_branch_fax: "",
			  subcon_fax: (subcontract_customer_branch_fax && subcontract_customer_branch_fax != null)? subcontract_customer_branch_fax: "",
			  send_contract: 0,
			},
			errors: {},
			requiredData:{}
		  }
		});
	
		this.EstimateQuoteCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].customer_natural_id; // 共ショウ
		this.DocumentNameCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].document_name; // 共ショウ

		this.customerUseCustomizedEstimate = custom_report.estimate.survey["アイダ設計"].customer_natural_id // アイダ設計
		this.customerUseCustomizedEstimateForTouken = custom_report.estimate.survey["東建コーポレーション"].customer_natural_id // 東建コーポレーション
		this.customerUseCustomizedContractData = custom_report.contract;
		this.customerUseCustomizedContract = this.customerUseCustomizedContractData.filter((c)=>{return c.cufile_option==true}); //一条工務店対応
	
		this.memoValidateCallback = this.memoValidateCallback.bind(this)
		this.validateCallback = this.validateCallback.bind(this)
		this.handleClickPositive = this.handleClickPositive.bind(this)
		this.subconSendSettingDisabled = this.subconSendSettingDisabled.bind(this);
		this.sendSettingDisabledOptions = this.sendSettingDisabledOptions.bind(this);
		this.validateSendContact = this.validateSendContact.bind(this);
		this.renderSendSetting = this.renderSendSetting.bind(this);
		this.validNotificateStatus = this.validNotificateStatus.bind(this);
		this.siteAlertModal = React.createRef();
	}
	
	
	  componentDidUpdate(prevProps){
		
		if (prevProps.data !== this.props.data){
		  const {
			send_destination_type,
			want_guide_type,
			want_guide_type_subcontract,
			customer_branch_cc_email_quote,
			subcontract_customer_branch_cc_email_quote,
			customer_branch_fax,
			subcontract_customer_branch_fax,
			customer_user_email,
			subcontract_customer_user_email,
			cc_email
		  } = this.props.data.values;
		  var email = [];
		  var sub_email = [];
		  let set_send_destination_type;
		  // console.log(cc_email);
		  if(send_destination_type == "" || send_destination_type == null){
			set_send_destination_type = 0;
		  }else{
			set_send_destination_type = parseInt(send_destination_type);
		  }
	
		  if(set_send_destination_type == 1){
			if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			  sub_email.push(cc_email)
			}
			
			if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			  sub_email.push(subcontract_customer_branch_cc_email_quote)
			}
		  }else{
			if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			  email.push(cc_email)
			}
			if (customer_branch_cc_email_quote !== null && customer_branch_cc_email_quote !== undefined && customer_branch_cc_email_quote.length>0) {
			  email.push(customer_branch_cc_email_quote)
			}
	
			if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			  sub_email.push(subcontract_customer_branch_cc_email_quote)
			}
	  
		  }
	
		//   console.log("componentDidUpdate",this.props.data);
	
		  this.setState({
			data: {
			  ...this.props.data,
			  values : {
				...this.props.data.values,
				invoice_user_memo : this.props.data.values.order_memo
			  }
		   },
		   notification: {
			 ...this.state.notification,
			values: {
				...this.state.notification.values,
				customer_user_email:customer_user_email,
				subcontract_customer_user_email:subcontract_customer_user_email,
				send_destination_type:set_send_destination_type,
				want_guide_type:(want_guide_type)? parseInt( want_guide_type ): this.state.notification.values.want_guide_type,
				want_guide_type_subcontract:(want_guide_type_subcontract)? parseInt( want_guide_type_subcontract ): this.state.notification.values.want_guide_type_subcontract,
				cc_email: (email.length>0)?email.join(","):"",
				cc_email_subcon:  (sub_email.length>0)?sub_email.join(","):"",
				fax: (customer_branch_fax && customer_branch_fax != null)? customer_branch_fax: "",
				subcon_fax: (subcontract_customer_branch_fax && subcontract_customer_branch_fax != null)? subcontract_customer_branch_fax: "",
			}
		   }
		  }/*,()=>console.log(this.state.notification.values)*/)
		}
	  }
	  validateSendContact ( newData, callback=()=>{}) {
	//    console.log("validateSendContact",newData);
		this.setState({ notification: {
		  ...this.state.notification,
		  ...newData
	/*
		  values: {
			...this.state.notification.values,
			...newData.values
		  },
	*/
		}
	  },/*()=>console.log(this.state.notification)*/);
	  
	  }
	  sendSettingDisabledOptions(distinate_type="contract"){
		const EmailSendEnabled = this.subconSendSettingDisabled("email",distinate_type) ;
		const FaxSendEnabled = this.subconSendSettingDisabled("fax",distinate_type) ;
		// console.log(EmailSendEnabled,FaxSendEnabled)
		if(!EmailSendEnabled && FaxSendEnabled){
		  return [0,2]
		}else if(EmailSendEnabled && !FaxSendEnabled){
		  return [0,1]
		}else{
		  return []
		}
	
	  } 

	  // #1034 案内設定 0:PCのみ  1:FAXのみ  2:両方
	  subconSendSettingDisabled (send_type="email",distinate_type="contract") {
		// console.log(this.state.notification);
		// console.log(this.state.data.values)
		const {register_type} = this.state.data.values
		switch (send_type){
		  case "email":{
			const {
			  send_destination_type,
			  customer_user_email,
			  subcontract_customer_user_email
			}=this.state.notification.values
			
			let validCheck
			let sendSettingCheck
			if (distinate_type=="contract") {
			  validCheck = customer_user_email != null && customer_user_email.length > 0
			  sendSettingCheck = send_destination_type == 2 || send_destination_type == 0
			}
			else {
			  validCheck = subcontract_customer_user_email != null && subcontract_customer_user_email.length > 0
			  sendSettingCheck = send_destination_type == 2 || send_destination_type == 1
			}
			return !sendSettingCheck || !validCheck
		  }
		  case "fax":{
			const {
			  send_destination_type
			}=this.state.notification.values
			
			let sendSettingCheck
	
			if (distinate_type=="contract") {
			  sendSettingCheck = register_type == 0 && (send_destination_type == 2 || send_destination_type == 0)
			}
			else {
			  sendSettingCheck = send_destination_type == 2 || send_destination_type == 1
			}
			return !sendSettingCheck
		  }
		  // 案内送信設定 0:元請のみ 1:下請のみ 2:両方
		  case "dist": {
			// 元請、下請双方に送信
			if (this.state.notification.values.send_destination_type == 2) return false;
			// 元請送信設定
			if (distinate_type == "contract") {
			  return (this.state.notification.values.send_destination_type != 0)
			}
			else 
			  return (this.state.notification.values.send_destination_type != 1)
			}
		}
	  }
	
	  validNotificateStatus ( checkValidError = true, contract = true,subcon = true ) {
		let valid = true
		if ( checkValidError ) {
		  let message = getErrorCodes(this.state.notification.errors)
		  if(message.length > 0){
			valid = false;
		  }
		}
		const {
		  send_destination_type,
		  want_guide_type,
		  want_guide_type_subcontract,
		  fax,
		  subcon_fax
		}=this.state.notification.values
		//send_destination_type 0:元請のみ 1:下請のみ  2:両方
		//want_guide_type 0:両方 1:メールのみ  2:ファックスのみ
		
		if ( contract ) {
		  // 元請のファックス案内=>ファックスのNULLチェック
		  if ((send_destination_type==0 || send_destination_type == 2) && (want_guide_type == 0 || want_guide_type == 2)) {
			if (fax.length == 0) { valid = false }
		  }
		}
		if ( subcon ) {
		  // 元請のファックス案内=>ファックスのNULLチェック
		  if ((send_destination_type==1 || send_destination_type == 2) && (want_guide_type_subcontract == 0 || want_guide_type_subcontract == 2)) {
			if (subcon_fax.length == 0 ) { valid = false }
		  }
		}
		return valid;
	  }
	
	  validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	  }
	
	  async handleClickPositive(){
			try {
				if ( !this.validNotificateStatus() ) {
				return false;
				}
			
				if (!this.validate()) {
				return false;
				}
			
				const {
				customer_natural_id,
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
			
				latest_pdf_quote_url,
				latest_pdf_plotting_url,
				invoice_status_flag,
				user_branch_natural_id,
				invoice_user_memo,
				change_invoice_flag,
				change_invoice_name,
				contract_pdf_url,
				add_memo,
				request_user_branch_natural_id,
				estimate_id,
				register_type
				} = this.state.data.values

				Request.setProgress(10)
				const estimateCommonParams = await Request.getEstimateCommon({
					customer_branch_natural_id,
					customer_user_natural_id,
					project_natural_id,
					request_natural_id,
					subcontract_customer_branch_natural_id,
					subcontract_customer_user_natural_id,
					estimateObject: this.state.data.values,
					user_branch_natural_id: request_user_branch_natural_id
				})

				Request.setProgress(20)
				const ESTIMATE__latest_pdf_quote_url = latest_pdf_quote_url
				const ESTIMATE__latest_pdf_plotting_url = latest_pdf_plotting_url
				const ESTIMATE__contract_pdf_url = this.customerUseCustomizedEstimateForTouken==customer_natural_id ? "" : contract_pdf_url == null ? "" : contract_pdf_url
				const {
				CUSTOMER_USER__customer_reminder_sms_flag_code,
				CUSTOMER_USER__customer_user_tel
				} = estimateCommonParams.object_customer
				const {
				CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
				CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
				} = estimateCommonParams.object_customer_subcontract

				const {
					PROJECT__site_customer_user_tel
				} = estimateCommonParams.object_project

				// #1034 送信設定　DB参照→手動設定
				const {
				customer_user_email,
				subcontract_customer_user_email,
				want_guide_type,
				want_guide_type_subcontract,
				fax,
				subcon_fax,
				send_contract
				}=this.state.notification.values
			
				let {
				send_destination_type,
				send_destination_type:PROJECT__send_destination_type,
				} = this.state.notification.values
			
				// 顧客システム情報利用有無
				const useCustomerSystem = this.state.data.values.register_type === 1 ? 1 : 0;
				// 通知フラグ
				const sendUploadNotification = this.state.notification.values.send_upload_notification;
				const custSendFlag = (useCustomerSystem === 1) ? true : false;
			
				// #1034 入力されたメール・ファックス番号に変更
				const castEstimateParameters = {
				...estimateCommonParams,
				object_customer: {
					...estimateCommonParams.object_customer, 
					CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email,
					CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.fax,
				},
				object_customer_subcontract: {
					...estimateCommonParams.object_customer_subcontract, 
					CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email_subcon,
					CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.subcon_fax,
				}
				}
			
				const subcontract_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)? false : undefined;
				const application_flag = (this.customerUseCustomizedContract.map((c)=>{return c.customer_natural_id === customer_natural_id })[0] === true ) ? true : false;
			
				const send_document_1_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_1:"";
				const send_document_2_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_2:"";
				const send_document_3_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "": ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
				const subcontract_send_document_1_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_1:"";
				const subcontract_send_document_2_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_2:"";
				const subcontract_send_document_3_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
			
				const send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_1:"";
				const send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_2:"";
				const send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
				const subcontract_send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_1:"";
				const subcontract_send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_2:"";
				const subcontract_send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
			
				const send_document_1_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_1:"";
				const send_document_2_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_2:"";
				const send_document_3_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
				const subcontract_send_document_1_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_1:"";
				const subcontract_send_document_2_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_2:"";
				const subcontract_send_document_3_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
			
				const send_customized_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?"1":"0";
			
				const report_name = this.EstimateQuoteCustomizedForTomosho==customer_natural_id ? "Y13_PDF": "F01_PDF";
				let contract_name = "G05_PDF";
				let cufile_option = false;
				
				const match = this.customerUseCustomizedContractData.find(
					c => c.customer_natural_id === customer_natural_id
				);

				contract_name = match ? match.format : "G05_PDF";
				cufile_option = match ? match.cufile_option : false;

				let f03Mail =  register_type == 0 && ((want_guide_type=="1"||want_guide_type=="0")  && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && customer_user_email != null && customer_user_email.length > 0) 
				|| ((want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0")  && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcontract_customer_user_email != null && subcontract_customer_user_email.length > 0) 
				? new Promise((resolve, reject)=>{
			
				// 依頼元担当者のメールアドレスがNullでは無い AND 「メールを送信する」（REQUEST__want_guide_type）となっていること
				const mailUrl = '/api/pout/F03_MAIL'
				const mailParams = {
					...castEstimateParameters,
					send_destination_type:PROJECT__send_destination_type,
					want_guide_type:want_guide_type,
					want_guide_type_subcontract:want_guide_type_subcontract,
					format_url:GoogleDrive.getFormatUrl(format_url.F03_MAIL),
					ESTIMATE__latest_pdf_quote_url,
					ESTIMATE__latest_pdf_plotting_url,
					ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
					send_customized_flag,
					object_each_data:{
					send_document_1:send_document_1_mail,
					send_document_2:send_document_2_mail,
					send_document_3: send_contract == "1" ? send_document_3_mail: null,
					subcontract_send_document_1:subcontract_send_document_1_mail,
					subcontract_send_document_2:subcontract_send_document_2_mail,
					subcontract_send_document_3: send_contract == "1" ? subcontract_send_document_3_mail: null
					},
					cufile_option
				}
				Request.post(mailUrl, mailParams, res=>{
					if(res.Code != 200){
						reject(res)
					}else{
						resolve(res)
					}
				}, err=>{
					reject(err)
				})
				})
				:{Code:200}
			
				let f03Fax =  register_type == 0 && ((want_guide_type=="2"||want_guide_type=="0") && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && fax.length>0) 
				|| ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcon_fax.length>0) 
				? new Promise((resolve, reject)=>{
						const faxUrl = '/api/pout/F03_FAX'
						const faxCreate = this.state.fax_pdf_create_flag == true && (this.state.set_send_contract != this.state.notification.values.send_contract 
							|| this.state.set_fax != this.state.notification.values.fax
							|| this.state.set_subcon_fax != this.state.notification.values.subcon_fax ) || this.state.fax_send_data.length == 0

						const faxParams = {
							...castEstimateParameters,
							send_destination_type:PROJECT__send_destination_type,
							want_guide_type:want_guide_type,
							want_guide_type_subcontract:want_guide_type_subcontract,
							format_url:GoogleDrive.getFormatUrl(format_url.F03_FAX),
							ESTIMATE__latest_pdf_quote_url,
							ESTIMATE__latest_pdf_plotting_url,
							ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
							send_customized_flag,
							object_each_data:{
							send_document_1:send_document_1_fax,
							send_document_2:send_document_2_fax,
							send_document_3: send_contract == "1" ? send_document_3_fax: null,
							subcontract_send_document_1:subcontract_send_document_1_fax,
							subcontract_send_document_2:subcontract_send_document_2_fax,
							subcontract_send_document_3: send_contract == "1" ? subcontract_send_document_3_fax: null
							},
							force: faxCreate,
							cufile_option,
						}

						if (faxCreate == false){
							resolve(this.state.fax_send_data)
						}else{
							Request.post(faxUrl, faxParams, res=>{
								//console.log(res)
								if (res.Code == 200 && res.Data.length > 0){
									this.setState({
										data:{
										...this.state.data,
										values: {
											...this.state.data.values,
											update_timestamp:res.Data[0]["update"] != "" && res.Data[0]["update"] != null ? res.Data[0]["update"] : this.state.data.values.update_timestamp
										}
										}
									})
								}else{
									const messageNo = "2406"
									this.props.alertModal.current.showErrorModal({messageNo});
									Request.setProgress(0)
									reject({"Code":res.Data && res.Data.status ? res.Data.status : 500 })
								}
								resolve(res)
							}, err=>{
								reject(err)
							})
						}
					})
				:{Code:200}
			
				let f03Sms = register_type == 0 && ((PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) 
				|| ((PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract)
				? new Promise((resolve, reject)=>{
					// need to fix condition
					const smsUrl = '/api/pout/F03_SMS'
					const smsParams = {
						...estimateCommonParams,
						send_destination_type:PROJECT__send_destination_type,
						want_guide_type:want_guide_type,
						want_guide_type_subcontract:want_guide_type_subcontract,
						format_url:GoogleDrive.getFormatUrl(format_url.F03_SMS),        
						ESTIMATE__latest_pdf_quote_url,
						ESTIMATE__latest_pdf_plotting_url,
						ESTIMATE__contract_pdf_url,
						send_customized_flag,
						object_each_data:{
							send_document_1:send_document_1_sms,
							send_document_2:send_document_2_sms,
							send_document_3:send_contract == "1" ? send_document_3_sms:"",
							subcontract_send_document_1:subcontract_send_document_1_sms,
							subcontract_send_document_2:subcontract_send_document_2_sms,
							subcontract_send_document_3:send_contract == "1" ? subcontract_send_document_3_sms:""
						}
					}
					Request.post(smsUrl, smsParams, res=>{
				//        console.log(res)
						if(res.Code != 200){
							reject(res)
						}else{
							resolve(res)
						}
					}, err=>{
						reject(err)
					})
				})
				:{Code:200}
			
				const f0304results = await Promise.all([f03Mail, f03Fax, f03Sms]).then(r=>r)
				f03Mail = f0304results[0]
				f03Fax = f0304results[1]
				f03Sms = f0304results[2]
			
				let isPushAllowedCust = false;
				let isSmsAllowedCust = false;

				// 顧客システム通知用メール取得
				Request.setProgress(30,"送付状作成中")

				let f10_mail = register_type == 1 && custSendFlag 
					? await new Promise((resolve, reject)=>{
						const mailUrl = '/api/pout/F03_MAIL'
						const mailParams = {
							//        ...estimateCommonParams,
							...castEstimateParameters,
							send_destination_type:0,
							want_guide_type:want_guide_type,
							want_guide_type_subcontract:want_guide_type_subcontract,
							format_url:GoogleDrive.getFormatUrl(format_url.F03_MAIL),
							ESTIMATE__latest_pdf_quote_url,
							ESTIMATE__latest_pdf_plotting_url,
							ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
							object_each_data:{
								send_document_1:send_document_1_mail,
								send_document_2:send_document_2_mail,
								send_document_3:send_contract == "1" ? send_document_3_mail : null,
								subcontract_send_document_1:null,
								subcontract_send_document_2:null,
								subcontract_send_document_3:null
							},
							cufile_option
						}
						
						Request.post(mailUrl, mailParams, res=> {
							if(res.Code != 200){
								reject(res)
							}else{
								resolve(res)
							}
						}, err=> reject(err))
					}) 
					: {Code:200}

				
				// 顧客システム通知用SMS・PUSH取得
				isPushAllowedCust = estimateCommonParams.object_customer.CUSTOMER_USER__notification_flag=="1" ? true : false;
				isSmsAllowedCust = (estimateCommonParams.object_customer.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer.CUSTOMER_USER__customer_user_tel) ? true : false;
				if(isPushAllowedCust){
					isSmsAllowedCust = false;
				}
				if(estimateCommonParams.object_project.PROJECT__site_customer_user_tel){
					isSmsAllowedCust = true;
				}
		
				let	f10_sms = register_type == 1 && ( isSmsAllowedCust || isPushAllowedCust ) 
						? await new Promise((resolve, reject)=>{
							const smsUrl = '/api/pout/F10_SMS'
							const smsParams = {
								...estimateCommonParams,
								send_destination_type:0,
								want_guide_type:want_guide_type,
								want_guide_type_subcontract:want_guide_type_subcontract,
								format_url:GoogleDrive.getFormatUrl(format_url.F10_SMS),
								object_each_data:{
									send_document_1:send_document_1_sms,
									send_document_2:send_document_2_sms,
									send_document_3:send_contract == "1" ? send_document_3_sms: ""
								},
								push_flag: isPushAllowedCust ? 1 : 0,
							}
							Request.post(smsUrl, smsParams, res =>{
								if(res.Code != 200){
									reject(res)
								}else{
									resolve(res)
								}
							}, err=> reject(err))
						})
						: {Code:200}
				let openGoogleDraft = false;
				let messageNo = [2417];
				// console.log(f03Mail,f03Fax,f03Sms,f10_mail,f10_sms)
				if (f03Mail.Code==200 && f03Fax.Code==200 && f03Sms.Code==200 && f10_mail.Code==200 && f10_sms.Code==200){

					estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id
					console.log(this.customerUseCustomizedEstimateForTouken==customer_natural_id)
					
					let cu_file_regist = register_type == 1 ?
					 	await new Promise((resolve, reject)=>{
						// データファイル連携
						Request.setProgress(50, `ファイル連携中`)

						const mailUrl = '/api/cufile'
						const mailParams = {
							...estimateCommonParams,
							ESTIMATE__latest_pdf_quote_url,
							ESTIMATE__latest_pdf_plotting_url,
							ESTIMATE__contract_pdf_url:this.customerUseCustomizedEstimateForTouken==customer_natural_id ? undefined : ESTIMATE__contract_pdf_url == null ? undefined : ESTIMATE__contract_pdf_url,
							// ESTIMATE__contract_pdf_url:send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
							customer_system_use_flag:useCustomerSystem,
							subcontract_flag,
							application_flag,
							report_name,
							contract_name,
							cufile_option
						}
						
							Request.post(mailUrl, mailParams, res=> resolve(res), err=> reject(err))
						})
						: {Code: 200}

					Request.setProgress(60, `送付処理中`)
					const sendMailUrl = '/api/send/MAIL'
					let mail_send_cust = register_type == 1 && custSendFlag && cu_file_regist.Code == 200 
						? await new Promise((resolve, reject)=>{
							f10_mail.Data&&f10_mail.Data.forEach((mailData)=>{
								openGoogleDraft = true;
								Request.post(sendMailUrl, mailData, res=>{
									messageNo.push(2471);
									resolve(res)
								}, err=> reject(err),undefined, true, false)
							})
							
						})
						: {Code: 200}
					
					let	mail_send = register_type == 0 && f03Mail && f03Mail.Data ?
							await new Promise((resolve, reject)=>{
								openGoogleDraft = true;
								f03Mail.Data.forEach((mailData)=>{
									Request.post(sendMailUrl, mailData, res=>{
										messageNo.push(2471);
										resolve(res)
									}, err=>{
										reject(err)
									},undefined, true, false)
								})
							})
							: {Code:200}
							
					const sendFaxUrl = '/api/send/FAX'
					let	fax_send = register_type == 0 && f03Fax && f03Fax.Data ? 
							await new Promise((resolve, reject)=>{
								f03Fax.Data.forEach((faxData)=>{
									Request.post(sendFaxUrl, faxData, res=>{
										this.setState({
											fax_send_data: []
										})
										resolve(res)
									}, err=>{
										reject(err)
									},undefined, true, false)
								})
							}) 
							: {Code:200}
					
					if(mail_send.Code==200 && mail_send_cust.Code==200 && fax_send.Code==200){

						Request.setProgress(80, `ステータス更新中`)
						const {update_timestamp} = this.state.data.values
						const url = '/api/quote/send/'+this.props.data.values.estimate_ulid
						
						Request.put(url, {
							...this.props.data.values,
							order_box_status:7,
							update_timestamp: update_timestamp ? update_timestamp : this.props.data.values.update_timestamp,
							latest_pdf_quote_url,
							latest_pdf_plotting_url,
							invoice_status_flag,
							invoice_user_memo,
							change_invoice_flag,
							change_invoice_name,
							contract_pdf_url,
							add_memo,
							login_user: localStorage.getItem("name")
						}, async (res)=>{
							
							openGoogleDraft = true;
							let resultSms = {Code:200}

							if(useCustomerSystem == 1){
						
								// 顧客システム利用かつ通知を送る
								if(register_type == 1 && custSendFlag && cu_file_regist.Code == 200){
				
									const sendPush = isPushAllowedCust && f10_sms && new Promise((resolve, reject)=>{
										const sendSmsUrl = '/api/send/PUSH'
										f10_sms.data && f10_sms.data.forEach((smsData)=>{
											if( smsData.type == "push"){
												const sendPushParams = {...smsData,customer_user_id:estimateCommonParams.object_customer.CUSTOMER_USER__id}
												Request.post(sendSmsUrl, sendPushParams, res=> {}, err=> {},undefined, true, false)
											}
										})
									})
									if (isSmsAllowedCust && f10_sms){
										const sendSmsUrl = '/api/send/SMS'
										resultSms = await new Promise((resolve, reject) => {
											f10_sms.Data&&f10_sms.Data.forEach((smsData)=>{
												if( smsData.type == "sms"){
													if (smsData.site_flag == true) {
														if (smsData.site_error == true) {
															resolve({Code: 2631})
														}else{
															Request.post(sendSmsUrl, smsData, res => {
															if (res.Data && res.Data.sms_status == 'accepted'){
																resolve({Code: 200})
															}else{
																resolve({Code: 2631, data: res.Data})
															}
															}, err => {
																resolve({Code: 2631, data: err})
															}, undefined, true, false)
														}
													} else {
														Request.post(sendSmsUrl, smsData, res=> {}, err=> {},undefined, true, false)
													}
												}
											})
										})
									}
								}
							
							}
						
							if(register_type == 0) {
							
								const sendSmsUrl = '/api/send/SMS'
								f03Sms.Data&&f03Sms.Data.forEach((smsData)=>{
									 if( smsData.type == "sms" && smsData.site_flag == false){
										Request.post(sendSmsUrl, smsData, res=>{
										}, err=>{
										},undefined, true, false)
									}
								})
							}
							// }
							Request.setProgress(0)
							if (res.data.Code==200){
								if(openGoogleDraft){
									window.open(`https://mail.google.com/mail/u/0/#drafts`);
								}
								document.body.style.overflow = "auto";

								// #1674 ANDPAD連携
								const {ex_andpad_use_flag,
									ex_andpad_quote_file_flag,
									ex_andpad_access_token_key,
									ex_andpad_system_id,
									register_type,
									request_natural_id,
									estimate_natural_id,
									quote_available_start_date,
									quote_available_end_date,
									survey_parking_name,
									survey_parking_prefecture,
									survey_parking_city,
									survey_parking_address,
									estimate_id,
									parking_latitude,
									parking_longitude
									} = this.state.data.values

								const andpad_use_flag = ex_andpad_use_flag == 1 && 
														ex_andpad_access_token_key != "" && 
														ex_andpad_access_token_key != null &&
														ex_andpad_system_id != "" && 
														ex_andpad_system_id != null &&
														parseInt(register_type) == 1 ? true : false;


								if (andpad_use_flag) {
									const cu_file_regist = await new Promise((resolve, reject)=>{
										const andpadUrl = '/api/cufile'
										let json_data = andpad_json_data
										let estimate_data = andpad_json_data_estimate
										const moment = require("moment");
										estimate_data["parking_estimate_id"] = estimate_natural_id
										estimate_data["parking_start_date"] = moment(quote_available_start_date).format("YYYY-MM-DD")
										estimate_data["parking_end_date"] = moment(quote_available_end_date).format("YYYY-MM-DD")
										estimate_data["parking_name"] = survey_parking_name
										estimate_data["prefecture_code"] = survey_parking_prefecture
										estimate_data["city"] = survey_parking_city
										estimate_data["street"] = survey_parking_address
										estimate_data["latitude"] = String(parking_latitude)
										estimate_data["longitude"] = String(parking_longitude)

										json_data["parking_requests"][0]["parking_request_id"] = request_natural_id
										json_data["parking_requests"][0]["estimates"] = [estimate_data]	

										const andpadParams = {
											andpad:{
												access_token_key: ex_andpad_access_token_key,
												system_id: ex_andpad_system_id,
												ex_adnpad_plotting_file_flag: true,
												ex_andpad_quote_file_flag: ex_andpad_quote_file_flag == 1 ? true : false,
												estimate_id: estimate_id,
												json_data
											}
										}
										console.log(andpadParams)
										
										Request.post(andpadUrl, andpadParams, res=> resolve(res), err=> reject(err),undefined, true, false)
									})
									console.log(cu_file_regist)
									this.props.alertModal.current.confirmCheck({
										title: cu_file_regist.Code == "200" || cu_file_regist.Code == "204" ? "処理完了" : "エラーが発生しました。",
										messageNo: cu_file_regist.Code == "200" || cu_file_regist.Code == "204" ? messageNo : cu_file_regist.Code == "819" ? "2630" : ex_andpad_quote_file_flag == 1 ? "2626" : "2627",
										closeBtn: false
									}, ()=>{
										if (resultSms.Code == 200) {
											this.props.refreshCallback()
											this.toggleModal()
										} else {
											console.log(resultSms);
											let title = "エラー"
											let message = GetMessage(2631)
											if (resultSms.data && resultSms.data.sms != "") {
												message = message + "<br />\n" + resultSms.data.sms
											}
											this.siteAlertModal.current.confirmCheck({
												title: title,
												message: message ,
												closeBtn: false
											}, () => {
												this.props.refreshCallback()
												this.toggleModal()
											}, false) 
										}
									}, false)
								} else {
									Request.setProgress(0)
									if (resultSms.Code == 200) {
										this.props.alertModal.current.confirmCheck({
											title: "処理完了",
											messageNo: messageNo,
											closeBtn: false
										}, ()=>{
											this.props.refreshCallback()
											this.toggleModal()
										}, false)
									} else {
										console.log(resultSms);
										let title = "エラー"
										let message = GetMessage(2631)
										if (resultSms.data && resultSms.data.sms != "") {
											message = message + "<br />\n" + resultSms.data.sms
										}
										this.props.alertModal.current.confirmCheck({
											title: title,
											message: message ,
											closeBtn: false
										}, () => {
											this.props.refreshCallback()
											this.toggleModal()
										}, false)
						
									}

								}
							}
						})
					}

				}else{
					Request.setProgress(0)
				}
			} catch (err) {
				Request.setProgress(0)
				console.log(err);
				this.props.alertModal.current.confirmCheck({
					title: "エラーが発生しました。",
					message: err.Message ? err.Message : "処理中にエラーが発生しました。",
					closeBtn: false,
					titleBtn: "閉じる"
				}, ()=>window.location.reload(), false)
			}
	  }

	  async handleClickCreateFax(){
		//    console.log("handleClickPositive",this.state.data.values);
			if ( !this.validNotificateStatus() ) {
			  return false;
			}
		
			if (!this.validate()) {
			  return false;
			}
		
			const {
		//      want_guide_type,
		//      want_guide_type_subcontract,
		
			  customer_natural_id,
			  customer_branch_natural_id,
			  customer_user_natural_id,
			  project_natural_id,
			  request_natural_id,
			  subcontract_customer_branch_natural_id,
			  subcontract_customer_user_natural_id,
		
			  latest_pdf_quote_url,
			  latest_pdf_plotting_url,
			  contract_pdf_url,
			  request_user_branch_natural_id,
			  register_type
			} = this.state.data.values
			// console.log(this.state.data.values)
	
			Request.setProgress(10)
			const estimateCommonParams = await Request.getEstimateCommon({
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				estimateObject: this.state.data.values,
				user_branch_natural_id: request_user_branch_natural_id
			})
			// console.log(request_user_branch_natural_id);
			// console.log(user_branch_natural_id);
	
			Request.setProgress(20)
			const ESTIMATE__latest_pdf_quote_url = latest_pdf_quote_url
			const ESTIMATE__latest_pdf_plotting_url = latest_pdf_plotting_url
			const ESTIMATE__contract_pdf_url = this.customerUseCustomizedEstimateForTouken==customer_natural_id ? "" : contract_pdf_url == null ? "" : contract_pdf_url

			// #1034 送信設定　DB参照→手動設定
			const {
			  customer_user_email,
			  subcontract_customer_user_email,
			  want_guide_type,
			  want_guide_type_subcontract,
			  fax,
			  subcon_fax,
			  send_contract
			}=this.state.notification.values
		
			let {
			  send_destination_type,
			  send_destination_type:PROJECT__send_destination_type,
			} = this.state.notification.values
		
			// 顧客システム情報利用有無
			// const useCustomerSystem = this.state.data.values.customer_system_use_flag === 1 && this.state.data.values.b_customer_system_use_flag === 1 ? 1 : 0;
			const useCustomerSystem = this.state.data.values.register_type === 1 ? 1 : 0;

			// 通知フラグ
			const sendUploadNotification = this.state.notification.values.send_upload_notification;
			const custSendFlag = (useCustomerSystem === 1) ? true : false;
		
			// #1034 入力されたメール・ファックス番号に変更
			const castEstimateParameters = {
			  ...estimateCommonParams,
			  object_customer: {
				...estimateCommonParams.object_customer, 
				CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email,
				CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.fax,
			  },
			  object_customer_subcontract: {
				...estimateCommonParams.object_customer_subcontract, 
				CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email_subcon,
				CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.subcon_fax,
			  }
			}
		
			const send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_1:"";
			const send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_2:"";
			const send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
			const subcontract_send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_1:"";
			const subcontract_send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_2:"";
			const subcontract_send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		
			const send_customized_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?"1":"0";
		
			let f03Fax
	
			// if(register_type == 0) {

				f03Fax = ((want_guide_type=="2"||want_guide_type=="0") && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && fax.length>0) 
				|| ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcon_fax.length>0) 
				? new Promise((resolve, reject)=>{
				const faxUrl = '/api/pout/F03_FAX'
				const faxParams = {
			//        ...estimateCommonParams,
					...castEstimateParameters,
					send_destination_type:PROJECT__send_destination_type,
					want_guide_type:want_guide_type,
					want_guide_type_subcontract:want_guide_type_subcontract,
					format_url:GoogleDrive.getFormatUrl(format_url.F03_FAX),
					ESTIMATE__latest_pdf_quote_url,
					ESTIMATE__latest_pdf_plotting_url,
					ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
					send_customized_flag,
					object_each_data:{
					send_document_1:send_document_1_fax,
					send_document_2:send_document_2_fax,
					send_document_3: send_contract == "1" ? send_document_3_fax: null,
					subcontract_send_document_1:subcontract_send_document_1_fax,
					subcontract_send_document_2:subcontract_send_document_2_fax,
					subcontract_send_document_3: send_contract == "1" ? subcontract_send_document_3_fax: null
					},
					force:true
				}
				Request.post(faxUrl, faxParams, res=>{
					// console.log(res,this.props.data.values)
					if (res.Code == 200 && res.Data.length > 0){
						this.setState({
							data:{
							...this.state.data,
							values: {
								...this.state.data.values,
								update_timestamp: res.Data[0]["update"] != null ? res.Data[0]["update"] : this.state.data.values.update_timestamp,
							}
							},
							fax_pdf_create_flag: true,
							set_send_contract: send_contract,
							set_fax:this.state.notification.values.fax,
							set_subcon_fax:this.state.notification.values.subcon_fax,
							fax_send_data:{...res}
						})
					}else{
						const messageNo = "2406"
						this.props.alertModal.current.showErrorModal({messageNo});
						Request.setProgress(0)
						reject(res)
					}

					resolve(res)
				}, err=>{
					reject(err)
				})
				})
				:{Code:200}
			
				Request.setProgress(40)
				const f0304results = await Promise.all([f03Fax]).then(r=>r)
				Request.setProgress(70)
				f03Fax = f0304results[0]
			// }
		
			Request.setProgress(0)

			// console.log(f03Fax);
			f03Fax != undefined && f03Fax["Data"].forEach(data => {
                const a = document.createElement('a');
                a.href = data.pdf_file;
                a.download = data.name;  // ファイル名を指定
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);  // ダウンロード後にリンクを削除
            });
			let messageNo = [2417];
			this.props.alertModal.current.confirmCheck({
				title: "処理完了",
				messageNo: messageNo,
				closeBtn: false
			}, ()=>{
				this.props.refreshCallback()
			}, false)
			
		  }
	
	  memoValidateCallback(newData, callback=()=>{}){
		this.setState({
		  data:newData
		}, ()=>callback())
	  }
	
	  validateCallback(newData, callback=()=>{}){
		const change_invoice_flag = newData.values.change_invoice_flag
		const is_empty_change_invoice_name = 
		  (newData.values.change_invoice_name === null 
		  || newData.values.change_invoice_name === undefined
		  || newData.values.change_invoice_name === "") ? true : false;
		this.setState({
		  data:{
			...this.state.data,
			...newData,
			values: {
			  ...newData.values,
			  change_invoice_name : change_invoice_flag == 1 ? newData.values.change_invoice_name : null
			},
			errors:{ 
			  ...(change_invoice_flag == 1 ? newData.errors : undefined),
			  ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) 
			},
			requiredData : { ...(change_invoice_flag == 1 ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
		  }
		}, ()=>callback())
	  }
	
	  bodyContent() {
		const { change_invoice_flag } = this.state.data.values;
		return (
		  <>
			{this.renderSendSetting()}
			<InputText multiline={true}
			    disabled={true}
				labelOn={true}
				label='経理課への請求メモ（確定見積送付時に入力）'
				name='INVOICE__invoice_user_memo'
				rootData={this.state.data}
				validateType='regist'
				className="modal-upper-memo"
			  />

			<InputText multiline={true}
			  labelOn={true}
			  label='コメント'
			  name='TEMP__add_memo'
			  copy="false"
			  validateCallback={this.memoValidateCallback} 
			  rootData={this.state.data}
			  validateType='regist'
			/>
			<InputCheckBox 
			  label="仕入が未完了でも請求依頼済にする"
			  name="TEMP__invoice_status_flag" 
			  validateCallback={this.memoValidateCallback} 
			  checkedValue={1}
			  uncheckedValue={0}
			  rootData={this.state.data}
			/>
		  </>
		);
	  }
	  renderSendSetting () {
		//console.log("renderSendSetting",this.state.notification.values);
		const {send_destination_type,want_guide_type,want_guide_type_subcontract} = this.state.notification.values
		const createFaxButtonEnabled = send_destination_type == 0 ? want_guide_type != 1
																  : send_destination_type == 1 ? want_guide_type_subcontract != 1 
																  							   : want_guide_type != 1 || want_guide_type_subcontract != 1

		return (<>
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="12">連絡先情報：</Col>
		  </Row>
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="3">
			CCメールアドレス
			</Col>      
			<Col md="8">
			  <InputText
				label='CCメールアドレス'
				labelOn={false}
				name='NOTIFICATION__cc_email'
				default={this.state.notification.values.cc_email}
				validateCallback={this.validateSendContact}
				rootData={this.state.notification}
				validateType="regist"
				disabled={this.subconSendSettingDisabled()}
			  />
			</Col>      
		  </Row>
			<Row style={{marginBottom: "0.5rem"}}>
			  <Col md="3">
			  FAX番号
			  </Col>
			  <Col md="8">
				<InputText
				  label='FAX番号'
				  labelOn={false}
				  name='NOTIFICATION__fax'
				  default={this.state.notification.values.fax}
				  validateCallback={this.validateSendContact}
				  rootData={this.state.notification}
				  validateType="regist"
				  disabled={this.subconSendSettingDisabled("fax")}
				/>
				{!this.validNotificateStatus(false,true,false)&&(<p style={{color:"red"}}>
				  {GetMessage(["2024"])}
				</p>)}
			  </Col>
			</Row>
			<Row style={{marginBottom: "0.5rem"}}>
			  <Col md="3">
			  案内方法
			  </Col>
			  <Col md="8">
				<InputRadio
				  name='NOTIFICATION__want_guide_type'
				  disabled={this.subconSendSettingDisabled("dist")}
				  disabled_options={this.sendSettingDisabledOptions("contract")}
				  options={
					[
					  {
						  default : this.state.notification.values.want_guide_type,
						  label : "両方",
						  value : 0,
					  },
					  {
						label : "Eメール案内希望",
						value : 1
					  },
					  {
						label : "FAX案内希望",
						value : 2,
					  },
					]
				  }
				  validateCallback={this.validateSendContact} 
				  validateType='regist'
				  rootData={this.state.notification}
				  />
			  </Col>
			</Row>
			{this.state.data.values.register_type == 1 ? 
		        <Row style={{marginBottom: "2rem"}}>
				<p style={{color:"red"}}>{GetMessage(["2614"])}</p>
				</Row>
			:""
			}

		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="3">
			CCメールアドレス（下請）
			</Col>      
			<Col md="8">
			  <InputText
				disabled={this.subconSendSettingDisabled("email","subcon")}
				label='CCメールアドレス（下請）'
				labelOn={false}
				name='NOTIFICATION__cc_email_subcon'
				default={this.state.notification.values.cc_email_subcon}
				validateCallback={this.validateSendContact}
				rootData={this.state.notification}
				validateType="regist"
			  />
			</Col>      
		  </Row>
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="3">
			FAX番号（下請）
			</Col>      
			<Col md="8">
			  <InputText
				disabled={this.subconSendSettingDisabled("fax","subcon")}
				label='FAX番号（下請）'
				labelOn={false}
				name='NOTIFICATION__subcon_fax'
				default={this.state.notification.values.fax}
				validateCallback={this.validateSendContact}
				rootData={this.state.notification}
				validateType="regist"
			  />
			  {!this.validNotificateStatus(false,false,true)&&(<p style={{color:"red"}}>
				{GetMessage(["2024"])}
			  </p>)}
			</Col>
		  </Row>
		  <Row style={{marginBottom: "2rem"}}>
			<Col md="3">
			案内方法（下請）
			</Col>      
			<Col md="8">
			  <InputRadio
				name='NOTIFICATION__want_guide_type_subcontract'
				disabled={this.subconSendSettingDisabled("dist","subcon")}
				disabled_options={this.sendSettingDisabledOptions("subcon")}
				options={
				  [
					{
						default : this.state.notification.values.want_guide_type_subcontract,
						label : "両方",
						value : 0,
					},
					{
					  label : "Eメール案内希望",
					  value : 1
					},
					{
					  label : "FAX案内希望",
					  value : 2,
					},
				  ]
				}
				validateCallback={this.validateSendContact} 
				validateType='regist'
				rootData={this.state.notification}
				/>          
			</Col>
		  </Row>
		  <Row style={{marginBottom: "2rem"}}>
			<Col md="3">
			契約書送付
			</Col>      
			<Col md="5">
			  <InputRadio
				name='NOTIFICATION__send_contract'
				disabled={this.state.data.values.contract_create_flag != 1}
				options={
				  [
					{
						default : this.state.notification.values.send_contract,
						label : "送付しない",
						value : 0,
					},
					{
					  label : "送付する",
					  value : 1
					},
				  ]
				}
				validateCallback={this.validateSendContact} 
				validateType='regist'
				rootData={this.state.notification}
				/>
			</Col>
			{createFaxButtonEnabled && (<Col md="3">
				<Button 
					// color="info" 
					style={{minWidth:"200px",padding:"10px 30px"}}
					disabled={this.state.data.values.contract_create_flag != 1}
					onClick={() => {
						this.handleClickCreateFax();
					}}>
					FAX用確定見積送付状作成
				</Button>
			</Col>)}
		  </Row>
		  {this.state.data.values.contract_create_flag != 1 && <Row style={{marginBottom: "2rem"}}>
		  	{GetMessage(["2610"])}
		  </Row>}
		  <AlertModal ref={this.siteAlertModal}/>
		</>);
	  }
}  

export class DialogUploadBlockMap extends DialogBase{
	constructor(props) {
	  super(props);

	  const {quote_plotting_number} = this.props.data.values
	
	  Object.assign(this.state, {
		title: '区画図ダイアログ',
		data: {
			values:this.props.data.values,
			errors:{
				quote_plotting_number: quote_plotting_number ? null : [GetMessage(2024)],
			},
			requiredData:{},
		},
		landmark_user: props.landmark_user
	  });
	  this.validateCallback = this.validateCallback.bind(this)
	  this.validateCallBackForDialog = this.validateCallBackForDialog.bind(this)
	}
	componentDidUpdate(prevProps){
		if (prevProps.data !== this.props.data){
			const estimate_id = this.props.data.values.id;
			const {
				latest_pdf_supplier_plotting_url,
				quote_plotting_number,
			} = this.props.data.values;

			this.setState({
				data: {
				values:{
					...this.props.data.values,
					// latest_pdf_supplier_plotting_url: latest_pdf_supplier_plotting_url ? latest_pdf_supplier_plotting_url : "",
					quote_plotting_number: quote_plotting_number ? quote_plotting_number : "",
				},
				errors:{
					// ...((latest_pdf_supplier_plotting_url)?{latest_pdf_supplier_plotting_url:null}:{latest_pdf_supplier_plotting_url:[GetMessage(2024)]}),
					quote_plotting_number: quote_plotting_number ? null : [GetMessage(2024)],
				},
				requiredData:{
					// latest_pdf_supplier_plotting_url: [GetMessage(2024)],
					quote_plotting_number: [GetMessage(2024)],
				}
				},
			},()=>{}
			)
		}

	}
	
	validateCallback(newData, callback=()=>{}){
		let errors = newData.errors
		// console.log(this.state.data)
		this.setState({
			data:{
			...this.state.data,
			...newData,
			errors:errors
			}
		}, ()=>callback())  
	}

	validateCallBackForDialog(newData, callback=()=>{}){
		const { quote_plotting_number,latest_pdf_supplier_plotting_url } = newData.values;
		let requiredData = {}
		if(quote_plotting_number === undefined || quote_plotting_number === null || quote_plotting_number === ""){
			requiredData["quote_plotting_number"] = [GetMessage(2024)];
		}else{
			requiredData["quote_plotting_number"] = undefined;
		}
		this.setState({
			data:{
			...this.state.data,
			...newData,
			errors : {
			  ...newData.errors,
			  ...requiredData,
			}
		  }
		}, ()=>callback())
	}	
	validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	}	
	handleClickPositive(){
		if(!this.validate()){
			return;
		  }
		//   console.log(this.state.data.values);
		  let blockmap_user_id = this.state.data.values.blockmap_user_id == 0 
		  						? 0 
								:this.state.data.values.latest_pdf_plotting_request_status == 2 
								 ? this.state.data.values.blockmap_user_id
								 : 0
		//   console.log(blockmap_user_id,this.state.data.values.latest_pdf_plotting_request_status)
		  Request.setProgress(10)
		  const uploadParams = {
			...this.state.data.values,
			update_timestamp : this.state.data.values.update_timestamp,
			blockmap_user_id:blockmap_user_id
		  }
		  Request.put('/api/order_box/supplier_plotting_upload/' + this.state.data.values.estimate_ulid, uploadParams, async res=>{
			Request.setProgress(0)
			if(res.Code == "200"){
				document.body.style.overflow = "auto";
				this.props.alertModal.current.confirmCheck({
				  title: "処理完了",
				  messageNo: [2417],
				  closeBtn: false
				}, ()=>{
				  this.props.refreshCallback()
				  this.toggleModal();
				}, false)		
			}else{
				this.props.alertModal.current.showErrorModal(
					( res.Message != "" ? { message :res.Message} : {messageNo : 2403})
				)
			}
		  },(err)=>{
			Request.setProgress(0)
			console.log(err)
			this.props.alertModal.current.showErrorModal(
				{messageNo : 2403}
			)
		  })

	}
	
	bodyContent() {
		return (
		  <>
			<Row>
			  <Col md="12">
				{/* <InputFile 
				label="受領区画図"
				name="ESTIMATE__latest_pdf_supplier_plotting_url"
				copy={false}
				showLink={true}
				validateCallback={this.validateCallback} 
				rootData={this.state.data} 
				filename={`受領区画図_${moment().format("YYYYMMDDHHmmss")}&extension=true`}
				/>		   */}
				<Label>区画図：</Label>
				{
					this.state.data.values.latest_pdf_supplier_plotting_url &&
					<a className="link" target='_blank' href={GoogleDrive.getDownloadUrl(this.state.data.values.latest_pdf_supplier_plotting_url, `区画図_${moment().format("YYYYMMDDHHmmss")}`)}>区画図確認</a>
				}
				<span style={{ float: "right" }}>
					<ImageControl
						gcs_path="q_plotting_picture"
						uploadCallback={(croppedImageObject) => {
							const {
								id,
							} = croppedImageObject
							this.validateCallBackForDialog({
								...this.state.data,
								values: {
									...this.state.data.values,
									latest_pdf_supplier_plotting_url: id
								}
							})
						}}
						buttonName={"ファイル選択"}
						cropData={{
							unit: '%',
							width: 30,
							aspect: (1260 / 1260),
						}}
					/>
				</span>
				{/* <p style={{ color: "red" }}>{!this.state.data.values.latest_pdf_supplier_plotting_url && GetMessage(2024)}</p> */}
			  </Col>
			  {/*　2170　失注に伴い切り戻し  */}
			  <Col md="12">
			  <InputText
				label='契約区画番号'
				labelOn={true}
				name='ESTIMATE__quote_plotting_number'
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				validateType="regist"
				disabled={true}
			  />				
			  </Col>
			  <Col md="12">
			  <InputRadio options={cst_latest_pdf_plotting_request_status}
				validateCallback={this.validateCallback} 
				disabled_options={this.state.data.values.blockmap_user_id != 0 ? "0,3,4" :"3,4"}
				rootData={this.state.data}
				labelOn={true}
				validateType="regist"
				label="提出区画図依頼ステータス"
				name="ESTIMATE__latest_pdf_plotting_request_status"
				/>
			  </Col>
			  <Col md="12">
			  <InputText multiline={true}
				labelOn={true}
				label='コメント'
				name='ESTIMATE__plotting_memo'
				copy="false"
				validateCallback={this.validateCallback} 
				rootData={this.state.data}
				validateType='regist'
				/>				
			  </Col>

			</Row>
		  </>
		);
	}
}
export class DialogSubmissionBlockMap extends DialogBase{
	constructor(props) {
	  super(props);
	  Object.assign(this.state, {
		title: '提出区画図登録・更新',
		data: {
			values: {},
			errors:{},
			requiredData:{},
		},
		quote_plotting_number_flag: false,
		landmark_user: props.landmark_user,
		Pdf01Result:undefined,
		Pdf02Result:undefined,
		pdf_created:false,
		pdf_registed:false,
		estimate_regist_flg:false,
		new_latest_pdf_plotting_url:undefined,
		estimateData:{},
		pdfParams: {}
	  });

	  this.validateCallBackForDialog = this.validateCallBackForDialog.bind(this)
	  this.togglePdfRegistModal = this.togglePdfRegistModal.bind(this);
	  this.pdfCreateReqest = this.pdfCreateReqest.bind(this);
	  this.pdfCreate = this.pdfCreate.bind(this);
	  this.fileUpload = this.fileUpload.bind(this)
	  this.customerUseCustomizedEstimateForTouken = custom_report.estimate.survey["東建コーポレーション"].customer_natural_id // 東建コーポレーション
	}
	componentDidUpdate(prevProps){
        if (prevProps.data !== this.props.data) {

			this.setState({
                data: {
                    ...this.props.data,
                    values: this.props.data.values,
                    errors: {
                        // quote_plotting_number: this.props.data.errors.quote_plotting_number || (this.props.data.values.quote_plotting_number ? undefined : [GetMessage(2024)]),
                        ...(this.props.data.values.quote_plotting_picture_url ? {} : { quote_plotting_picture_url: [GetMessage(2024)] }),
                        ...(this.props.data.values.quote_plotting_number ? {} : { quote_plotting_number: [GetMessage(2024)] })
                    },
                    requiredData: {
                        quote_plotting_number: [GetMessage(2024)],
                        quote_plotting_picture_url: [GetMessage(2024)],
                    }
                },
				// quote_plotting_number_flag: (this.props.data.values.quote_plotting_number == null || this.props.data.values.quote_plotting_number == "" || this.props.data.values.quote_plotting_number == undefined ) ? false : true,
            })
        }		
	}
    validate() {
        let message = getErrorCodes(this.state.data.errors)

        if (message.length > 0) {
            this.props.alertModal.current.showErrorModal({ messageNo: message });
            return false;
        }
        return true;
    }

	
	validateCallBackForDialog(newData, callback=()=>{}){
		const { quote_plotting_number,quote_plotting_picture_url } = newData.values;
		this.setState({
			data:{
			...this.state.data,
			...newData,
			errors : {
				...newData.errors,
				quote_plotting_number:quote_plotting_number === undefined || quote_plotting_number === null || quote_plotting_number === ""?[GetMessage(2024)]: undefined,
				quote_plotting_picture_url:quote_plotting_picture_url === undefined || quote_plotting_picture_url === null || quote_plotting_picture_url === ""?[GetMessage(2024)]: undefined,
			}
		  }
		}, ()=>callback())
	}
	
	togglePdfRegistModal(regist_check){
		let pdf_created = regist_check !== undefined ? this.state.pdf_created : false;
		let pdf_registed = regist_check !== undefined ? this.state.pdf_registed : false;		
		this.setState({
			pdf_regist_modal: !this.state.pdf_regist_modal,
			pdf_created,
			pdf_registed
		});
	}

	async pdfCreateReqest(){
		if(!this.state.Pdf02Result || !this.state.Pdf02Result.spreadsheet_id){
		  Request.setProgress(0)
		  return undefined;
		}
		let params = this.state.pdfParams
		// let params = dataList[Object.keys(dataList)[0]]
		params["main_sheet"] = "F02_PDF"
		params["sheet_id"] = this.state.Pdf02Result && this.state.Pdf02Result.spreadsheet_id ? this.state.Pdf02Result.spreadsheet_id : ""
		params["pdf_upload_off"] = true;
		console.log(params)
  
		return new Promise((resolve, reject)=>{ 
		  Request.post("/api/pout/pdf_create", params, res=>{
			if (res.Code>=800){
			  Request.setProgress(0)
			  resolve(undefined)
			} else {
			  resolve(res.Data)
			}
		  }, err=>{
			reject(err)
		  })
		})
	}

	//PDF作成
	async pdfCreate(){

		Request.setProgress(50,"PDF生成中");
		let PdfData = await this.pdfCreateReqest()

		let {Pdf02Result,
			contract_pdf_file,
			contract_pdf_url
		} = this.state;
		if(PdfData == undefined || !PdfData.file_id ){
			this.props.alertModal.current.showErrorModal({messageNo:2406})
			return ;
		}

		Request.setProgress(80,"PDFダウンロード開始");

		// console.log(Pdf02Result)
		Pdf02Result["file_id"] = PdfData.file_id;
		
		Pdf02Result && window.open(`https://drive.google.com/uc?export=download&id=${Pdf02Result.file_id}`)

		contract_pdf_file && window.open(`https://drive.google.com/uc?export=download&id=${contract_pdf_file}`)

		Request.setProgress(0);

		let pdf_registed = true;
		if(!Pdf02Result.file_id){
			pdf_registed = false;
		}

		this.setState({
			pdf_registed: pdf_registed,
			new_latest_pdf_plotting_url: pdf_registed && Pdf02Result.spreadsheet_id ? Pdf02Result.spreadsheet_id : undefined,
			new_latest_pdf_contract_url: pdf_registed && contract_pdf_url ? contract_pdf_url : undefined
		});
  	}

	async fileUpload(ulid="",latest_pdf_plotting_request_status=""){
		try {
			const latest_pdf_plotting_url = this.state.new_latest_pdf_plotting_url
			const latest_pdf_contract_url = this.state.new_latest_pdf_contract_url
			const update_timestamp = this.state.data.values.update_timestamp;


			const file_upload = await new Promise((resolve, reject) => {
				const url = '/api/quote/file_upload/' +ulid;
				const uploadParams = {
					...this.state.estimateData,
					latest_pdf_plotting_url,
					contract_pdf_url:latest_pdf_contract_url,
					update_timestamp,
					latest_pdf_plotting_request_status:latest_pdf_plotting_request_status!=""?latest_pdf_plotting_request_status:3,
					blockmap_user_id: 0
					
				}

				Request.put(url, uploadParams, res => {
					if(res.Code != "200"){
						reject(res)
					}

					this.setState(prevState => ({
						...prevState,
						data: {
							...prevState.data,
							values: {
								...prevState.data.values,
								update_timestamp: res.Data.update_timestamp
							}
						}
					}))
					resolve(res)
				}, err => reject(err),undefined,true,false);

			})
		} catch (err) {
			console.log("File upload failed:", err);
			Request.setProgress(0)
			this.props.alertModal.current.confirmCheck({
				title: "エラーが発生しました。",
				message: err.Status ? err.Data && err.Data.error + "<br />"+GetMessage(2625).replace(/STATUS_CODE/g, err.Status).split("]")[1]
								    : err.Message 
										? err.Message
										: "処理中にエラーが発生しました。",
				closeBtn: false,
				titleBtn: "閉じる"
			}, ()=>{
				// window.location.reload()
				this.props.refreshCallback();
				this.toggleModal();
			}, false)
		}
			
	}


	async handleClickPositive() {
        if (!this.validate()) {
            return;
        }

        const {
			estimate_id,
            estimate_natural_id,
            customer_branch_natural_id,
            customer_user_natural_id,
            project_natural_id,
            request_natural_id,
            subcontract_customer_branch_natural_id,
            subcontract_customer_user_natural_id,

            survey_capacity_flag_car,
            survey_capacity_flag_light_truck,
            quote_plotting_number,
            quote_capacity_qty,
            quote_available_start_date,
            quote_available_end_date,
            survey_parking_picture_url,
            survey_route_picture_url,
			survey_route_zoom_picture_url,
            quote_plotting_picture_url,
            survey_parking_address_contract,
            survey_site_distance_meter,
            survey_site_distance_minute,
            latest_pdf_plotting_url: original_latest_pdf_plotting_url,
            user_branch_natural_id,
            parking_latitude,
            parking_longitude,
            project_latitude,
            project_longitude,
            want_guide_type,
            want_guide_type_subcontract,
			survey_route_zoom_qr_url,
			request_user_branch_natural_id,
			latest_pdf_plotting_request_status,
			latest_plotting_picture_timestamp,
			invoice_closing_date,
			invoice_amt,
			contract_create_flag,
			customer_natural_id,
			invoice_natural_id,
			invoice_process_pdf_date,
			request_type,
			payment_deadline,
			contract_format_url,
			order_capacity_qty,
			survey_capacity_qty,
			survey_available_end_date,
			order_end_date,
			order_start_date,
			survey_available_start_date
        } = this.state.data.values
        Request.setProgress(10)

        try {
            const estimateCommonParams = await Request.getEstimateCommon({
                customer_branch_natural_id,
                customer_user_natural_id,
                project_natural_id,
                request_natural_id,
                subcontract_customer_branch_natural_id,
                subcontract_customer_user_natural_id,
                estimateObject: this.state.data.values,
                user_branch_natural_id:request_user_branch_natural_id
            })

		
			const estimateData = {
				...this.state.data.values,
				quote_route_picture_url: "",
				ESTIMATE__quote_route_picture_url: "",
				quote_route_zoom_picture_url: survey_route_zoom_picture_url,
				ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
				// estimate_details: estimate_detail_data
			}
			estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id

            Request.setProgress(30,"ファイルアップロード中")
			this.setState({
				estimateData: estimateData
			}, async () => {
				let ulid = estimateData.estimate_ulid ? estimateData.estimate_ulid : estimateData.ulid; 

				await this.fileUpload(ulid);

				Request.setProgress(60,"帳票区画図作成中")

				// 2023 帳票区画図を作る
                const Pdf02Result = await new Promise((resolve, reject) => {
					// console.log(uploadResult,zoomedUploadResult)
					let locationOrigin = window.location.origin;
					let qr_url = "/api/qrcode?url="
					let quote_parking_qr_url = "https://www.google.com/maps/search/?api=1&query=" + parking_latitude + "," + parking_longitude
					let quote_site_qr_url = "https://www.google.com/maps/search/?api=1&query=" + project_latitude + "," + project_longitude
										
					let tmp_quote_available_start_date = quote_available_start_date ? quote_available_start_date : order_start_date ? order_start_date : survey_available_start_date
					let tmp_quote_available_end_date = quote_available_end_date ? quote_available_end_date : order_end_date ? order_end_date : survey_available_end_date
					let tmp_quote_capacity_qty = quote_capacity_qty ? quote_capacity_qty : order_capacity_qty ? order_capacity_qty : survey_capacity_qty ? survey_capacity_qty: ""
					console.log(tmp_quote_capacity_qty,tmp_quote_available_start_date,tmp_quote_available_end_date)
					const pdfUrl = '/api/pout/F02_PDF'
                    const pdfParams = {
                        ...estimateCommonParams,
                        format_url: GoogleDrive.getFormatUrl(format_url.F02_PDF),
						object_estimate:{
							...estimateCommonParams.object_estimate,
                            ESTIMATE__quote_plotting_number: quote_plotting_number,
                            ESTIMATE__quote_capacity_qty: tmp_quote_capacity_qty,
                            ESTIMATE__quote_available_start_date: tmp_quote_available_start_date,
                            ESTIMATE__quote_available_end_date: tmp_quote_available_end_date,
						},
                        object_each_data: {
                            ESTIMATE__survey_capacity_flag_car: survey_capacity_flag_car,
                            ESTIMATE__survey_capacity_flag_light_truck: survey_capacity_flag_light_truck,
                            ESTIMATE__quote_plotting_number: quote_plotting_number,
                            ESTIMATE__quote_capacity_qty: tmp_quote_capacity_qty,
                            ESTIMATE__quote_available_start_date: tmp_quote_available_start_date,
                            ESTIMATE__quote_available_end_date: tmp_quote_available_end_date,
                            ESTIMATE__survey_parking_picture_url: GoogleDrive.getDownloadUrl(survey_parking_picture_url),
                            ESTIMATE__latest_pdf_route_url: survey_route_picture_url,
                            ESTIMATE__quote_plotting_picture_url: GoogleDrive.getDownloadUrl(quote_plotting_picture_url),
                            ESTIMATE__survey_parking_address_contract: survey_parking_address_contract,
                            JOIN_parking_addr: estimateCommonParams.object_estimate.JOIN_parking_addr,
                            REQUEST_PARKING__site_distance_minute: survey_site_distance_minute,
                            REQUEST_PARKING__site_distance_meter: survey_site_distance_meter,
                            ESTIMATE__quote_route_picture_url: " ",
                            ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
                            ESTIMATE__quote_parking_qr_url: locationOrigin + qr_url + encodeURIComponent(quote_parking_qr_url),
                            ESTIMATE__quote_site_qr_url: locationOrigin + qr_url + encodeURIComponent(quote_site_qr_url)
                        },
						estimate_pdf_check: false,
						pdf_upload_off: true,
                        customer_system_use_flag: estimateData["customer_system_use_flag"],
                    }

					this.setState({
						pdfParams
					},()=>{
						console.log(pdfParams)
						Request.post(pdfUrl, pdfParams, res => {
							if (res.Code >= 800) {
								Request.setProgress(0)
								resolve(undefined)
							} else {
								resolve(res.Data)
							}
						}, err => {
							reject(err)
						})
					});

                })

				if (!Pdf02Result) {
                    this.props.alertModal.current.showErrorModal({
                        messageNo: 2475
                    })
                    return;
                }
				
				this.setState({
					Pdf02Result,
					// contract_pdf_url,
					// contract_pdf_file,
				});
				this.togglePdfRegistModal()

				Request.setProgress(0);
				document.body.style.overflow = "auto";
	
			});

        } catch (err) {
			console.log(err);
            Request.setProgress(0)
            this.props.alertModal.current.showErrorModal({
                messageNo: 2476
            })
        }
    }
	
	bodyContent() {

        return (
            <>
                <div>
                    <Label>アップロード済区画図：</Label>
                    {
                        this.state.data.values.quote_plotting_picture_url &&
                        <a className="link" target='_blank' href={GoogleDrive.getDownloadUrl(this.state.data.values.quote_plotting_picture_url, `区画図_${moment().format("YYYYMMDDHHmmss")}`)}>区画図確認</a>
                    }
                    <span style={{ float: "right" }}>
                        <ImageControl
                            gcs_path="q_plotting_picture"
                            uploadCallback={(croppedImageObject) => {
                                const {
                                    id,
                                } = croppedImageObject
                                this.validateCallBackForDialog({
                                    ...this.state.data,
                                    values: {
                                        ...this.state.data.values,
                                        quote_plotting_picture_url: id
                                    }
                                })
                            }}
                            buttonName={"ファイル選択"}
                            cropData={{
                                unit: '%',
                                width: 30,
                                aspect: (1260 / 1260),
                            }}
                        />
                    </span>
                    <p style={{ color: "red" }}>{!this.state.data.values.quote_plotting_picture_url && GetMessage(2024)}</p>
                </div>
				<div>
					<InputText
						label='契約区画番号'
						labelOn={true}
						name='ESTIMATE__quote_plotting_number'
						validateCallback={this.validateCallBackForDialog}
						rootData={this.state.data}
						disabled={true}
						validateType="regist"
					/>
				</div>
                <div id="googlemap" style={{display:"none"}}>
                </div>

				<Modal isOpen={this.state.pdf_regist_modal}>
					<div className="modal-header">
						<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=>{this.togglePdfRegistModal(undefined)}}>
						<i className="tim-icons icon-simple-remove"></i>
						</button>
						<h5 className="modal-title">アクセス許可確認</h5>
					</div>
					<ModalBody style={{textAlign:"center"}}>
						<p>アクセス許可後にPDFを作成してください。</p><br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						onClick={() => { 
							this.state.Pdf02Result && window.open(`https://docs.google.com/spreadsheets/d/${this.state.Pdf02Result.spreadsheet_id}`)
							this.setState({
							pdf_created: true
							});
						}}>
						区画図を確認
						</Button>

						<br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						disabled={!this.state.pdf_created}
						onClick={() => { 
							this.pdfCreate()
						}}>
						PDF作成
						</Button><br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						disabled={!this.state.pdf_registed}
						onClick={async () =>  { 
							this.setState({
							pdf_registed: false,
							pdf_created:false
							});
							this.togglePdfRegistModal();
							Request.setProgress(50,"ファイルアップロード中");
							await this.fileUpload(this.state.estimateData.estimate_ulid,4);
							Request.setProgress(0);
							document.body.style.overflow = "auto";
							this.props.alertModal.current.confirmCheck({
								title: "処理完了",
								messageNo: 2417,
								closeBtn: false
							}, () => {
								this.toggleModal()
								this.props.refreshCallback()
							}, false)

						}}>
						完了
						</Button>
					</ModalBody>
				</Modal>
            </>
        );
    }
}  
export class DialogSubmissionBlockMapReport extends DialogBase{
	constructor(props) {
	  super(props);
  
	  Object.assign(this.state, {
		title: '帳票区画図作成',
		data: {
			values: {},
			errors:{},
			requiredData:{},
		},
		quote_plotting_number_flag: false,
		landmark_user: props.landmark_user,
		Pdf01Result:undefined,
		Pdf02Result:undefined,
		pdf_created:false,
		pdf_registed:false,
		estimate_regist_flg:false,
		new_latest_pdf_plotting_url:undefined,
		estimateData:{},
		pdfParams: {}
	  });

	  this.validateCallBackForDialog = this.validateCallBackForDialog.bind(this)
	  this.togglePdfRegistModal = this.togglePdfRegistModal.bind(this);
	  this.pdfCreateReqest = this.pdfCreateReqest.bind(this);
	  this.pdfCreate = this.pdfCreate.bind(this);
	  this.fileUpload = this.fileUpload.bind(this);

	}
	componentDidUpdate(prevProps){
        if (prevProps.data !== this.props.data) {
			this.setState({
                data: {
                    ...this.props.data,
                    values: this.props.data.values,
                    errors: {
                        ...(this.props.data.values.quote_plotting_number ? {} : { quote_plotting_number: [GetMessage(2024)] })
                    },
                    requiredData: {
                        quote_plotting_number: [GetMessage(2024)],
                    }
                },
            })
        }		
	}
    validate() {
        let message = getErrorCodes(this.state.data.errors)

        if (message.length > 0) {
            this.props.alertModal.current.showErrorModal({ messageNo: message });
            return false;
        }
        return true;
    }

	
	validateCallBackForDialog(newData, callback=()=>{}){
		const { quote_plotting_number,quote_plotting_picture_url } = newData.values;
		let requiredData = {}
		if(quote_plotting_picture_url === undefined || quote_plotting_picture_url === null || quote_plotting_picture_url === ""){
			requiredData["quote_plotting_picture_url"] = [GetMessage(2024)] 
		}
	
		this.setState({
			data:{
			...this.state.data,
			...newData,
			errors : {
			  ...requiredData,
			}
		  }
		}, ()=>callback())
	}	

	// #1873 警告バナー対応
	togglePdfRegistModal(regist_check){
		let pdf_created = regist_check !== undefined ? this.state.pdf_created : false;
		let pdf_registed = regist_check !== undefined ? this.state.pdf_registed : false;		
		this.setState({
			pdf_regist_modal: !this.state.pdf_regist_modal,
			pdf_created,
			pdf_registed
		});
	}
	
	async pdfCreateReqest(){
		if(!this.state.Pdf02Result || !this.state.Pdf02Result.spreadsheet_id){
		  Request.setProgress(0)
		  return undefined;
		}
		let params = this.state.pdfParams
		params["main_sheet"] = "F02_PDF"
		params["sheet_id"] = this.state.Pdf02Result && this.state.Pdf02Result.spreadsheet_id ? this.state.Pdf02Result.spreadsheet_id : ""
		params["pdf_upload_off"] = true;
		console.log(params)
  
		return new Promise((resolve, reject)=>{ 
		  Request.post("/api/pout/pdf_create", params, res=>{
			if (res.Code>=800){
			  Request.setProgress(0)
			  resolve(undefined)
			} else {
			  resolve(res.Data)
			}
		  }, err=>{
			reject(err)
		  })
		})
	}

	async fileUpload(ulid=""){
		try {
			const latest_pdf_plotting_url = this.state.new_latest_pdf_plotting_url
			const update_timestamp = this.state.data.values.update_timestamp;

			const file_upload = await new Promise((resolve, reject) => {
				const url = '/api/quote/file_upload/' +ulid;
				const uploadParams = {
					...this.state.estimateData,
					latest_pdf_plotting_url,
					update_timestamp,
					latest_pdf_plotting_request_status:4,
					blockmap_user_id: 0
				}

				Request.put(url, uploadParams, res => {
					if(res.Code != 200){
						reject(res)
					}
					this.setState(prevState => ({
						...prevState,
						data: {
							...prevState.data,
							values: {
								...prevState.data.values,
								update_timestamp: res.Data.update_timestamp
							}
						}
					}))
					resolve(res)
				}, err => reject(err),undefined,true,false);

			})

			Request.setProgress(0);
			document.body.style.overflow = "auto";

			this.props.alertModal.current.confirmCheck({
				title: "処理完了",
				messageNo: 2417,
				closeBtn: false
			}, () => {
				this.toggleModal()
				this.props.refreshCallback()
			}, false)				
		} catch (err) {
			console.log("File upload failed:", err);
			Request.setProgress(0);
			this.props.alertModal.current.confirmCheck({
				title: "エラーが発生しました。",
				message: err.Status ? err.Data && err.Data.error + "<br />"+GetMessage(2625).replace(/STATUS_CODE/g, err.Status).split("]")[1]
									: err.Message 
										? err.Message
										: "処理中にエラーが発生しました。",
				closeBtn: false,
				titleBtn: "閉じる"
			}, ()=>{
				// window.location.reload()
				this.props.refreshCallback();
				this.toggleModal();
			}, false)
		}

	}

	//PDF作成
	async pdfCreate(){
		let PdfData = await this.pdfCreateReqest()

		let Pdf02Result = this.state.Pdf02Result;
		if(PdfData == undefined || !PdfData.file_id ){
			this.props.alertModal.current.showErrorModal({messageNo:2406})
			return ;
		}
		console.log(Pdf02Result)
		Pdf02Result["file_id"] = PdfData.file_id;
		
		Pdf02Result && window.open(`https://drive.google.com/uc?export=download&id=${Pdf02Result.file_id}`)
		let pdf_registed = true;
		if(!Pdf02Result.file_id){
			pdf_registed = false;
		}

		this.setState({
			pdf_registed: pdf_registed,
			new_latest_pdf_plotting_url: pdf_registed && Pdf02Result.spreadsheet_id ? Pdf02Result.spreadsheet_id : undefined
		});
  	}


	async handleClickPositive() {
        if (!this.validate()) {
            return;
        }

        const {
			estimate_id,
            estimate_natural_id,
            customer_branch_natural_id,
            customer_user_natural_id,
            project_natural_id,
            request_natural_id,
            subcontract_customer_branch_natural_id,
            subcontract_customer_user_natural_id,

            survey_capacity_flag_car,
            survey_capacity_flag_light_truck,
            quote_plotting_number,
            quote_capacity_qty,
            quote_available_start_date,
            quote_available_end_date,
            survey_parking_picture_url,
            survey_route_picture_url,
			survey_route_zoom_picture_url,
            quote_plotting_picture_url,
            survey_parking_address_contract,
            survey_site_distance_meter,
            survey_site_distance_minute,
            latest_pdf_plotting_url: original_latest_pdf_plotting_url,
            user_branch_natural_id,
            parking_latitude,
            parking_longitude,
            project_latitude,
            project_longitude,
            want_guide_type,
            want_guide_type_subcontract,
			survey_route_zoom_qr_url,
			request_user_branch_natural_id,
			latest_pdf_plotting_request_status,
			latest_plotting_picture_timestamp,
			invoice_closing_date,
			invoice_amt,
			contract_create_flag,
			customer_natural_id,
			invoice_natural_id,
			invoice_process_pdf_date,
			request_type,
			payment_deadline,
			contract_format_url,
			order_capacity_qty,
			survey_capacity_qty,
			survey_available_end_date,
			order_end_date,
			order_start_date,
			survey_available_start_date
        } = this.state.data.values
        Request.setProgress(10)

        try {
            const estimateCommonParams = await Request.getEstimateCommon({
                customer_branch_natural_id,
                customer_user_natural_id,
                project_natural_id,
                request_natural_id,
                subcontract_customer_branch_natural_id,
                subcontract_customer_user_natural_id,
                estimateObject: this.state.data.values,
                user_branch_natural_id:request_user_branch_natural_id
            })


            let routeData;
			
			const estimateData = {
				...this.state.data.values,
				quote_route_picture_url: "",
				ESTIMATE__quote_route_picture_url: "",
				quote_route_zoom_picture_url: survey_route_zoom_picture_url,
				ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
				// estimate_details: estimate_detail_data
			}
			estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id

			let contract_pdf_url = null;
			let contract_pdf_file = null;
			let application_pdf_file = null;

            Request.setProgress(60,"帳票区画図作成中")
            // if(quote_available_start_date != null && quote_available_end_date !=null && quote_capacity_qty != null){
			{
                const Pdf02Result = await new Promise((resolve, reject) => {
					// console.log(uploadResult,zoomedUploadResult)
					let locationOrigin = window.location.origin;
					let qr_url = "/api/qrcode?url="
					let quote_parking_qr_url = "https://www.google.com/maps/search/?api=1&query=" + parking_latitude + "," + parking_longitude
					let quote_site_qr_url = "https://www.google.com/maps/search/?api=1&query=" + project_latitude + "," + project_longitude
										
					let tmp_quote_available_start_date = quote_available_start_date ? quote_available_start_date : order_start_date ? order_start_date : survey_available_start_date
					let tmp_quote_available_end_date = quote_available_end_date ? quote_available_end_date : order_end_date ? order_end_date : survey_available_end_date
					let tmp_quote_capacity_qty = quote_capacity_qty ? quote_capacity_qty : order_capacity_qty ? order_capacity_qty : survey_capacity_qty ? survey_capacity_qty: ""

					const pdfUrl = '/api/pout/F02_PDF'
                    const pdfParams = {
                        ...estimateCommonParams,
                        format_url: GoogleDrive.getFormatUrl(format_url.F02_PDF),
						object_estimate:{
							...estimateCommonParams.object_estimate,
                            ESTIMATE__quote_plotting_number: quote_plotting_number,
                            ESTIMATE__quote_capacity_qty: tmp_quote_capacity_qty,
                            ESTIMATE__quote_available_start_date: tmp_quote_available_start_date,
                            ESTIMATE__quote_available_end_date: tmp_quote_available_end_date,
						},
                        object_each_data: {
                            ESTIMATE__survey_capacity_flag_car: survey_capacity_flag_car,
                            ESTIMATE__survey_capacity_flag_light_truck: survey_capacity_flag_light_truck,
                            ESTIMATE__quote_plotting_number: quote_plotting_number,
                            ESTIMATE__quote_capacity_qty: quote_capacity_qty,
                            ESTIMATE__quote_available_start_date: quote_available_start_date,
                            ESTIMATE__quote_available_end_date: quote_available_end_date,
                            ESTIMATE__survey_parking_picture_url: GoogleDrive.getDownloadUrl(survey_parking_picture_url),
                            ESTIMATE__latest_pdf_route_url: survey_route_picture_url,
                            ESTIMATE__quote_plotting_picture_url: GoogleDrive.getDownloadUrl(quote_plotting_picture_url),
                            ESTIMATE__survey_parking_address_contract: survey_parking_address_contract,
                            JOIN_parking_addr: estimateCommonParams.object_estimate.JOIN_parking_addr,
                            REQUEST_PARKING__site_distance_minute: survey_site_distance_minute,
                            REQUEST_PARKING__site_distance_meter: survey_site_distance_meter,
                            ESTIMATE__quote_route_picture_url: " ",
                            ESTIMATE__quote_route_zoom_picture_url: GoogleDrive.getDownloadUrl(survey_route_zoom_picture_url),
                            ESTIMATE__quote_parking_qr_url: locationOrigin + qr_url + encodeURIComponent(quote_parking_qr_url),
                            ESTIMATE__quote_site_qr_url: locationOrigin + qr_url + encodeURIComponent(quote_site_qr_url)
                        },
						estimate_pdf_check: false,
						pdf_upload_off: true,
                        customer_system_use_flag: estimateData["customer_system_use_flag"],
                    }

					this.setState({
						pdfParams
					},()=>{
						console.log(pdfParams)
						Request.post(pdfUrl, pdfParams, res => {
							if (res.Code >= 800) {
								Request.setProgress(0)
								resolve(undefined)
							} else {
								resolve(res.Data)
							}
						}, err => {
							reject(err)
						})
					});

                })
				// Request.setProgress(0)
                if (!Pdf02Result) {
                    this.props.alertModal.current.showErrorModal({
                        messageNo: 2475
                    })
                    return;
                }

				let contract_pdf_url = null;
				let contract_pdf_file = null;
				let origin_invoice_closing_date = invoice_closing_date ? invoice_closing_date : moment().format("YYYY-MM-DD") 

				// 契約書作成
				// 契約書送付有無が有りのもの
				// 東建コーポレーションの場合は、作成済みなので、再作成しない。
				contract_pdf_url = this.customerUseCustomizedEstimateForTouken == customer_natural_id? this.state.data.values.contract_pdf_url : null;
				let skip_contract = this.customerUseCustomizedEstimateForTouken == customer_natural_id;
				
				// 確定見積もり作成前はスキップ
				skip_contract = quote_available_start_date ? false: true;
				if(contract_create_flag == 1 && skip_contract == false){
					Request.setProgress(80,"契約書作成中")
					let G05_PDF = {};
					//契約共通パラメータ取得
					const contractCommon = await Request.getContractCommon({
						customer_branch_natural_id,
						customer_user_natural_id,
						subcontract_customer_branch_natural_id,
						subcontract_customer_user_natural_id,
						request_natural_id,
						project_natural_id,
						invoice_natural_id,
						invoice_process_pdf_date,
						estimate_natural_id,
						quote_available_start_date,
						quote_available_end_date,
						request_type,
						payment_deadline,
						invoice_closing_date,
						invoice_amt,
					})

					// 独自契約書
					let customContract = CustomReport.contract.find(item => {
						return item.customer_natural_id === customer_natural_id 
						&& item.customer_branch_natural_id === customer_branch_natural_id
					})
					customContract = customContract || CustomReport.contract.find(item => {
						return item.customer_natural_id === customer_natural_id 
					})
					const {
						survey_parking_rent,
						survey_tax_in_flag,
						quote_subtotal_amt,
						estimate_detail_name,
						estimate_detail_name_ex,
						estimate_detail_amt,
						estimate_detail_amt_ex,
					  } = estimateData

					let mergeContractCommon = {
						...contractCommon,
						object_estimate:{
							...estimateCommonParams.object_estimate,
							ESTIMATE__survey_parking_rent: survey_parking_rent,
							ESTIMATE__quote_subtotal_amt: quote_subtotal_amt
						},
						object_invoice:{
							...contractCommon.object_invoice,
							INVOICE__invoice_natural_id: estimate_natural_id,
							INVOICE__invoice_closing_date: origin_invoice_closing_date,
							INVOICE__invoice_amt: estimateCommonParams.object_estimate.ESTIMATE__quote_total_amt,
							INVOICE__payment_deadline: payment_deadline,
						},
						object_each_data:{
							ESTIMATE_DETAIL__other_tax_detail_name:estimate_detail_name?estimate_detail_name:"", //その他課税項目名
							ESTIMATE_DETAIL__other_tax_detail_amt:estimate_detail_amt?estimate_detail_amt:"", //その他課税金額
							ESTIMATE_DETAIL__other_nontax_detail_name:estimate_detail_name_ex?estimate_detail_name_ex:"", //その他非課税項目名
							ESTIMATE_DETAIL__other_nontax_detail_amt:estimate_detail_amt_ex?estimate_detail_amt_ex:"", //その他非課税金額
							ESTIMATE__other_tax_total_amt: quote_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
							// ESTIMATE__other_tax_total_amt:quote_subtotal_amt - (estimate_detail_amt_ex?estimate_detail_amt_ex:0) , //その他課税小計（税別）
							ESTIMATE__other_nontax_total_amt:estimate_detail_amt_ex ? estimate_detail_amt_ex: "", //その他非課税小計	
						},
					}
					// G05_PDF_契約書
					G05_PDF = await new Promise((resolve, reject)=>{
						const pdfParams = {
							...mergeContractCommon,
							format_url:GoogleDrive.getFormatUrl((contract_format_url
								?contract_format_url
								:customContract ? format_url[customContract.format] :format_url.G05_PDF)),
  					        pdf_upload_off: true,		
						}


						Request.post( `/api/pout/${customContract ? customContract.format : "G05_PDF"}`, pdfParams, res=>{
							if (res.Code>=800){
								Request.setProgress(0)
								resolve(undefined)
							} else {
								if(customContract && customContract.format == "Y08_PDF"){
									Request.post('/api/pout/Y08_PDF', {custom_template_pdf : true, ...pdfParams}, res2=>{
										if (res2.Code>=800){
											Request.setProgress(0)
											resolve(undefined)
										} else {
											resolve([res, res2])
										}
									}, err => {
										reject(err)
									})
								}else{
									resolve([res])
								}
							}
						// Request.setProgress(70)
						}, err => {
						resolve({
							estimate_natural_id : estimate_natural_id,
							Code : 805,
						})
						})
					})
					// console.log(G05_PDF)
					if(G05_PDF[0] && G05_PDF[0].Code >= 800){
						return G05_PDF[0];
					}
					if(G05_PDF[1] && G05_PDF[1].Code >= 800){
						return G05_PDF[1];
					}
					
					contract_pdf_url = G05_PDF[0] && G05_PDF[0].Data ? G05_PDF[0].Data.spreadsheet_id : null;
					application_pdf_file = G05_PDF[1] && G05_PDF[1].Data ? G05_PDF[1].Data.file_id : null;
					contract_pdf_file =  G05_PDF[0] && G05_PDF[0].Data ? G05_PDF[0].Data.file_id : null;
					this.setState({
						contract_pdf_url,
						contract_pdf_file,
						application_pdf_file,
					});
				}

				this.setState({
					Pdf02Result,
					contract_pdf_url,
					contract_pdf_file,
					application_pdf_file,
					estimateData
				});

				this.togglePdfRegistModal()
				Request.setProgress(0);
				document.body.style.overflow = "auto";
            }

        } catch (err) {
			console.log(err);
            Request.setProgress(0)
            this.props.alertModal.current.showErrorModal({
                messageNo: 2476
            })
        }
    }
	
	bodyContent() {

        return (
            <>
				帳票区画図を作成しますか？<br /><br />
                <InputText
                    label='契約区画番号'
                    labelOn={true}
                    name='ESTIMATE__quote_plotting_number'
                    validateCallback={this.validateCallBackForDialog}
                    rootData={this.state.data}
					disabled={true}
                    validateType="regist"
                />
                <div id="googlemap" style={{display:"none"}}>
                </div>


				{/** #1873 警告バナー対応 */}

				<Modal isOpen={this.state.pdf_regist_modal}>
					<div className="modal-header">
						<button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={()=>{this.togglePdfRegistModal(undefined)}}>
						<i className="tim-icons icon-simple-remove"></i>
						</button>
						<h5 className="modal-title">アクセス許可確認</h5>
					</div>
					<ModalBody style={{textAlign:"center"}}>
						<p>アクセス許可後にPDFを作成してください。</p><br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						onClick={() => { 
							this.state.Pdf02Result && window.open(`https://docs.google.com/spreadsheets/d/${this.state.Pdf02Result.spreadsheet_id}`)
							this.setState({
							pdf_created: true
							});
						}}>
						区画図を確認
						</Button>
						{this.state.contract_pdf_url && (
						<>
							&nbsp;&nbsp;
							<Button 
								color="info" 
								style={{minWidth:"200px"}}
								onClick={() => { 
									this.state.contract_pdf_url && window.open(`https://docs.google.com/spreadsheets/d/${this.state.contract_pdf_url}`)
								}}>
								契約書を確認
							</Button>
						</>
						)}						
						<br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						disabled={!this.state.pdf_created}
						onClick={() => { 
							this.pdfCreate()
						}}>
						PDF作成
						</Button><br />
						<Button 
						color="info" 
						style={{minWidth:"200px"}}
						disabled={!this.state.pdf_registed}
						onClick={async () =>  { 
							this.setState({
							pdf_registed: false,
							pdf_created:false
							});
							this.togglePdfRegistModal();
							await this.fileUpload(this.state.estimateData.estimate_ulid);
						}}>
						完了
						</Button>
					</ModalBody>
				</Modal>
            </>
        );
    }
}  
export class DialogUploadFileContract extends DialogBase{
	constructor(props) {
		super(props);
	
		// console.log(this.props.data);
		Object.assign(this.state, {
		  title: 'ファイルアップロード',
		  data: this.props.data,
		  landmark_user: props.landmark_user,
		});
		this.validateCallback = this.validateCallback.bind(this)
  
	  }
	  componentDidUpdate(prevProps){
		  if (prevProps.data !== this.props.data){
			  const estimate_id = this.props.data.values.id;
			  const {
				supplier_contract_pdf_url,
			  } = this.props.data.values;
  
			  this.setState({
				  data: {
				  values:{
					  ...this.props.data.values,
					  supplier_contract_pdf_url: supplier_contract_pdf_url ? supplier_contract_pdf_url : "",
				  },
				  errors:{
					  ...((this.props.data.values.supplier_contract_pdf_url)?{supplier_contract_pdf_url:null}:{supplier_contract_pdf_url:[GetMessage(2024)]}),
			  
				  },
				  requiredData:{
					supplier_contract_pdf_url: [GetMessage(2024)],
				  }
				  },
			  },()=>{}
			  )
		  }		
	  }
	  
	  validateCallback(newData, callback=()=>{}){
		  let errors = newData.errors
		//   console.log(this.state.data)
		  this.setState({
			  data:{
			  ...this.state.data,
			  ...newData,
			  errors:errors
			  }
		  }, ()=>callback())  
	  
	  }
	  validate(){
		  let message = getErrorCodes(this.state.data.errors)
	  
		  if(message.length > 0){
			this.props.alertModal.current.showErrorModal({messageNo:message});
			return false;
		  }
		  return true;
	  }
	  
	  handleClickPositive(){
		  if(!this.validate()){
			  return;
			}
			Request.setProgress(10)
			const uploadParams = {
			  // ...this.state.data.values,
			  order_box_status: 8,
			  supplier_contract_pdf_url_base64: this.state.data.values.supplier_contract_pdf_url_base64,
			  request_id: this.state.data.values.request_id,
			  parking_id: this.state.data.values.parking_id,
			  update_timestamp : this.state.data.values.update_timestamp,
			}
			Request.put('/api/order/file_upload/' + this.state.data.values.estimate_ulid, uploadParams, async res=>{
			},(err)=>{
			  Request.setProgress(0)
			})
			Request.setProgress(0)
			document.body.style.overflow = "auto";
			this.props.alertModal.current.confirmCheck({
			  title: "処理完了",
			  messageNo: [2417],
			  closeBtn: false
			}, ()=>{
			  this.props.refreshCallback()
			  this.toggleModal();
			}, false)
	
	  }
	  
	bodyContent() {
		return (
		  <>
			<InputFile 
			  label=""
			  name="ESTIMATE__supplier_contract_pdf_url"
			  copy={false}
			  showLink={true}
			  validateCallback={this.validateCallback} 
			  rootData={this.state.data} 
			  filename={`仕入契約書_${moment().format("YYYYMMDDHHmmss")}&extension=true`}
			  />		  
		  </>
		);
	}
}
export class DialogUploadFileCustomerContract extends DialogBase{
	constructor(props) {
		super(props);
		Object.assign(this.state, {
		  title: '契約書アップロード',
		  data: this.props.data,
		  cuFiles : []
		  // disablePositive:false
		});
		this.validateCallback = this.validateCallback.bind(this)
		// console.log(this.props.data)
	}
	
	  async componentDidUpdate(prevProps){
		if (prevProps.data !== this.props.data){
	
		  let contract_receive_deadline;
		  if(this.props.data.values.contract_receive_deadline){
			contract_receive_deadline = this.props.data.values.contract_receive_deadline;
		  } else {
			// ｎ日後の営業日取得
			contract_receive_deadline = await new Promise(resolve => {
			  Request.get('/api/workday', { add_day : 14 }, res => {
				resolve(moment(res.Data).format("YYYY-MM-DDT00:00:00"))
			  })
			})
		  }
	
		  this.setState({
			data: {
			  values:{
				...this.props.data.values,
				contract_receive_deadline : contract_receive_deadline
			  },
			  errors:{
			  },
			  requiredData:{
			  }
			},
		  })
	
		  // ファイル情報取得
		  Request.get('/api/cufile', { ref_id : this.props.data.values.estimate_id, file_type : 5, file_detail_type : 502 }, res => {
			this.setState({
			  cuFiles : res.Data
			})
		  })
		}
	  }
	
	  validateCallback(newData, callback=()=>{}){
		this.setState({
		  data:{
			...this.state.data,
			...newData
		  },
		}, ()=>callback())
	  }
	
	  validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	  }
	
	  async handleClickPositive(){
		if(!this.validate()){
		  return;
		}
		Request.setProgress(10)
		
		const params = {
		  ...this.state.data.values,
		  request_id:this.state.data.values.request_id,
		  parking_id:this.state.data.values.parking_id,
		  update_timestamp: this.state.data.values.invoice_update_timestamp,
		  order_box_status: 8,
		}
		Request.setProgress(80)
		// console.log(this.state.data.values.invoice_ulid);
		Request.put('/api/invoice/file_upload/' + this.state.data.values.invoice_ulid, params, async res=>{
		  Request.setProgress(0)
		  this.props.refreshCallback();
		  this.toggleModal();
		},(err)=>{
		  Request.setProgress(0)
		})
	  }
	
	  bodyContent() {
		return (
		  <>
			<InputFile 
			  label="契約書"
			  name="CU_FILE__sealing_contract"
			  copy={false}
			  showLink={true}
			  validateCallback={this.validateCallback} 
			  rootData={this.state.data} />
	
			{this.state.cuFiles.map((file, index) => (
			  <Row key={index}>
				<a href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">
				  <Col>
					{file.file_name}
				  </Col>
				</a>
				</Row>
			))}
			<br/>
			<InputDatetime
			  label='契約書提出期限'
			  name='INVOICE__contract_receive_deadline'
			  labelOn={true}
			  validateCallback={this.validateCallback}
			  rootData={this.state.data}
			  validateType="regist"
			/>
		  </>
		);
	  }
}
export class DialogLostOrder extends DialogBase{
	constructor(props) {
	  super(props);
  
	  Object.assign(this.state, {
		title: '失注処理を実行します。よろしいですか？',
		data: this.props.data? props.data:{
			values: {},
			errors:{},
			requiredData:{},
		},
		landmark_user: props.landmark_user
	  });
	  this.handleClickPositive = this.handleClickPositive.bind(this)
	  this.validateCallback = this.validateCallback.bind(this)
	  this.alertAndpadModal = React.createRef();
	}
	componentDidUpdate(prevProps){
		if (prevProps != this.props && this.props != null) {
			this.setState({
				data: this.props.data
			})
		}
	}
	
	validateCallback(newData, callback=()=>{}){
		// console.log(newData)
		let {add_memo} = newData.values
		this.setState({
			data: {
				...this.state.data,
				values: {
					...this.state.data.values,
					add_memo: add_memo
				}
			}
		})
	}
	
	handleClickPositive(){
		/*
			見積ステータス ESTIMATE__estimate_status
			受注管理メモ   ESTIMATE__order_memo
		 */
		// console.log(this.state.data.values)
		let {
			estimate_ulid,
			order_memo,
			add_memo,
			estimate_natural_id,
			register_type,
			ex_andpad_use_flag,
			ex_andpad_access_token_key,
			ex_andpad_quote_file_flag,
			ex_andpad_estimate_delete_flag,
			ex_andpad_plotting_delete_flag,
			ex_andpad_quote_delete_flag,
			ex_andpad_system_id
		} = this.state.data.values
		Request.put(
		"/api/order_box/status/" + estimate_ulid,
		{
			request: "estimate_lost_order",
			// order_memo,
			add_memo,
			login_user: localStorage.getItem("name")
		},
		res=>{
//				console.log(res);
			document.body.style.overflow = "auto";
			this.props.alertModal.current.confirmCheck({
				title: "更新が完了しました。",
				messageNo: 2527,
				closeBtn: false
			}, ()=>{
				const andpad_use_flag = ex_andpad_use_flag == 1 && 
										ex_andpad_access_token_key != "" && 
										ex_andpad_access_token_key != null &&
										ex_andpad_system_id != "" && 
										ex_andpad_system_id != null &&
										parseInt(register_type) == 1 &&
										ex_andpad_estimate_delete_flag == 0 &&
										ex_andpad_plotting_delete_flag == 0 ? true : false;
				// console.log("andpad_use_flag ", andpad_use_flag)
				if(andpad_use_flag){
					this.alertAndpadModal.current.toggleErrorModal(
						{
						estimate: [estimate_natural_id],
						}
					);
				} else {
					this.props.refreshCallback();
					this.toggleModal()
				}
			}, false)
		})
	}
	
	bodyContent() {
		let {
			values: {
				customer_system_use_flag,
				order_box_status,
				survey_status
			}
		} = this.state.data
		// console.log(customer_system_use_flag,survey_status)
		return (<>
			<Row>
				<Col md="12">
					※仕入NG処理を実行する場合：
					{customer_system_use_flag == 1?(<>
						{survey_status >= 1 && survey_status <= 5 ? (<Button size="sm" onClick={()=>{this.sendSupplierNgMail()}}>仕入NG</Button>):(<Button size="sm" disabled>仕入NG</Button>)}
					</>):(<Button size="sm" disabled>仕入NG</Button>)}
				</Col>
				<Col md="12">
					<InputText multiline={true}
						disabled={true}
						labelOn={true}
						label='受注管理メモ'
						name='ESTIMATE__order_memo'
						rootData={this.state.data}
						validateType='regist'
						className="modal-upper-memo"
					/>					
					<InputText multiline={true}
						label="コメント"
						name="TEMP__add_memo"
						labelOn={true}
						validateCallback={this.validateCallback}
						rootData={this.state.data}
						validateType="regist"
						/>		  
				</Col>
			</Row>
			<AlertAndpadModal
				ref={this.alertAndpadModal} 
				returnCallback={() => {
					this.props.refreshCallback();
					this.toggleModal()     
				}}
			/>
		</>);
	}
	async sendSupplierNgMail(){
		let {values} = this.state.data
		const {
		  customer_branch_natural_id,
		  customer_user_natural_id,
		  project_natural_id,
		  request_natural_id,
		  subcontract_customer_branch_natural_id,
		  subcontract_customer_user_natural_id,
		  request_user_branch_natural_id:user_branch_natural_id,
		  send_destination_type,
		  want_guide_type,
		  want_guide_type_subcontract,
		} = values;
	
		Request.setProgress(10)
		const estimateCommonParams = await Request.getEstimateCommon({
		  customer_branch_natural_id,
		  customer_user_natural_id,
		  project_natural_id,
		  request_natural_id,
		  subcontract_customer_branch_natural_id,
		  subcontract_customer_user_natural_id,
		  estimateObject: values,
		  user_branch_natural_id
		})
	
		Request.setProgress(20)
		const mailData = await new Promise((resolve, reject)=>{
		  const mailUrl = '/api/pout/D10_MAIL'
		  const mailParams = {
			format_url:GoogleDrive.getFormatUrl(format_url.D10_MAIL),
			send_destination_type:send_destination_type,
			want_guide_type:want_guide_type,
			want_guide_type_subcontract:want_guide_type_subcontract,
			...estimateCommonParams
		  }
		  Request.post(mailUrl, mailParams, res=>{
			resolve(res)
		  }, err=>{
			reject(err)
		  })
		})
		Request.setProgress(80)
		const sendMailUrl = '/api/send/MAIL';
		Request.post(sendMailUrl, mailData.Data, res=>{
		  window.open(`https://mail.google.com/mail/u/0/#drafts`);
		  this.props.alertModal.current.confirmCheck({
			title: "処理完了",
			messageNo: [2417,2471],
			closeBtn: false
		  }, ()=>{
			
		  }, false)		  
		}, err=>{}, () => {
		  Request.setProgress(0)
		})
	}
}
export class DialogMessageToCustomerUser extends DialogBase{
	constructor(props) {
	  super(props);
  
	  Object.assign(this.state, {
		title: '顧客連絡メモ',
		positive_label :"更新する",
		data: props.data? props.data:{},
		landmark_user: props.landmark_user,
		tmp_data: {
			values: {},
			errors:{},
			requiredData:{},
		}
	  });
	  this.handleClickPositive = this.handleClickPositive.bind(this)
	  this.validateCallback = this.validateCallback.bind(this)
	  this.onchangeCommentList = this.onchangeCommentList.bind(this)

	}
	componentDidUpdate(prevProps){
		if (prevProps != this.props && this.props != null) {
			this.setState({
				data: this.props.data
			})
		}
	}
	
	onchangeCommentList(newData, callback=()=>{}){
		this.setState({
			tmp_data: {
				...this.state.data,
				values: {
					...this.state.data.values,
					contact_memo: FormatCode.decode("cst_contact_memo_for_customer_user",newData.values.contact_memo)
				}
			}
		})
	}
	validateCallback (newData, callback=()=>{}) {
		this.setState({
			tmp_data: {
				...this.state.data,
				values: {
					...this.state.data.values,
					contact_memo: newData.values.contact_memo
				}
			}
		})
	}
	handleClickPositive(){
		let { estimate_ulid } = this.state.data.values
		let { contact_memo } = this.state.tmp_data.values

		// 無効な文字列
		const max_length_validate = Validate.length(contact_memo, "", "text_ja_20000")
		if(!max_length_validate.valid){
			this.props.alertModal.current.showErrorModal({message:max_length_validate.message});
			return;
		}

		Request.put(
		"/api/order_box/status/" + estimate_ulid,
		{
			request: "estimate_details",
			contact_memo
		},
		res=>{
			document.body.style.overflow = "auto";
//				console.log(res);
			this.props.alertModal.current.confirmCheck({
				title: "更新が完了しました。",
				messageNo: 2527,
				closeBtn: false
			}, ()=>{
				this.props.refreshCallback();
				this.toggleModal();
			}, false)
		})
	}
	
	bodyContent() {
		return (<>
			<Row>
				<Col md="12" style={{color:"red"}}>
					顧客システムの利用者へ通知されます
				</Col>
				<Col md="12" >
					<InputSelect label="顧客連絡用コメント候補"
						name="ESTIMATE__contact_memo"
						labelOn={true} 
						validateCallback={this.onchangeCommentList} 
						options={cst_contact_memo_for_customer_user}
						enterSearch={false}
					/>
				</Col>
				<Col md="12">
					<InputText 
						label="顧客連絡用コメント"
						name="ESTIMATE__contact_memo"
						labelOn={true}
						multiline={true}
						validateCallback={this.validateCallback}
						rootData={this.state.tmp_data}
						validateType="regist"
						/>		  
				</Col>
			</Row>
		</>);
	}

}

// 特別承認時の送信
export class DialogSendApproval extends DialogBase{
	constructor(props) {
		super(props);
	
		const {
		  send_destination_type,
		  customer_branch_cc_email_quote,
		  subcontract_customer_branch_cc_email_quote,
		  customer_branch_fax,
		  subcontract_customer_branch_fax,
		  cc_email,
		} = this.props.data.values;
	
	
		var email = [];
		//  console.log(this.props.data.values);
		var sub_email = [];
		// console.log(this.props.data);

		// console.log(send_destination_type);
		// console.log(cc_email);
	
		if(send_destination_type =="1"){
		  if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			sub_email.push(cc_email)
		  }
		  
		  if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			sub_email.push(subcontract_customer_branch_cc_email_quote)
		  }
		}else{
		  if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			email.push(cc_email)
		  }
		  if (customer_branch_cc_email_quote !== null && customer_branch_cc_email_quote !== undefined && customer_branch_cc_email_quote.length>0) {
			email.push(customer_branch_cc_email_quote)
		  }
	
		  if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			sub_email.push(subcontract_customer_branch_cc_email_quote)
		  }
	
		}
	
	
		Object.assign(this.state, {
		  title: '特別承認:確定見積書送付',
		  data: this.props.data,
		  fax_pdf_create_flag: false,
		  fax_send_data: [],
		  set_send_contract: 0,
		  set_fax:"",
		  set_subcon_fax:"",		  
		  notification: {
			values: {
			  customer_user_email:(this.props.data.values.customer_user_email)? this.props.data.values.customer_user_email: "",
			  subcontract_customer_user_email:(this.props.data.values.subcontract_customer_user_email)? this.props.data.values.subcontract_customer_user_email: "",
			  want_guide_type: (this.props.data.values.want_guide_type)? parseInt( this.props.data.values.want_guide_type ): 0,
			  want_guide_type_subcontract: (this.props.data.values.want_guide_type_subcontract)? parseInt( this.props.data.values.want_guide_type_subcontract ): 0,
			  send_destination_type: (this.props.data.values.send_destination_type)? parseInt(this.props.data.values.send_destination_type): 0,
			  cc_email: (email.length>0)?email.join(","):"",
			  cc_email_subcon: (sub_email.length>0)?sub_email.join(","):"",
			  fax: (customer_branch_fax && customer_branch_fax != null)? customer_branch_fax: "",
			  subcon_fax: (subcontract_customer_branch_fax && subcontract_customer_branch_fax != null)? subcontract_customer_branch_fax: "",
			  create_invoice_flag: 0,
			  send_contract: 0
			},
			errors: {},
			requiredData:{}
		  }
		});
	
		this.EstimateQuoteCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].customer_natural_id; // 共ショウ
		this.DocumentNameCustomizedForTomosho = custom_report.estimate.quote["共ショウ"].document_name; // 共ショウ
		this.customerUseCustomizedContractData = custom_report.contract;
		this.customerUseCustomizedContract = this.customerUseCustomizedContractData.filter((c)=>{return c.cufile_option==true}); //一条工務店対応
		this.customerUseCustomizedEstimateForTouken = custom_report.estimate.survey["東建コーポレーション"].customer_natural_id; // 東建コーポレーション

		this.memoValidateCallback = this.memoValidateCallback.bind(this)
		this.validateCallback = this.validateCallback.bind(this)
		this.handleClickPositive = this.handleClickPositive.bind(this)
		this.subconSendSettingDisabled = this.subconSendSettingDisabled.bind(this);
		this.sendSettingDisabledOptions = this.sendSettingDisabledOptions.bind(this);
		this.validateSendContact = this.validateSendContact.bind(this);
		this.renderSendSetting = this.renderSendSetting.bind(this);
		this.validNotificateStatus = this.validNotificateStatus.bind(this);
		this.siteAlertModal = React.createRef();
	  }

	  componentDidUpdate(prevProps){
		
		if (prevProps.data !== this.props.data){
		  const {
			send_destination_type,
			want_guide_type,
			want_guide_type_subcontract,
			customer_branch_cc_email_quote,
			subcontract_customer_branch_cc_email_quote,
			customer_branch_fax,
			subcontract_customer_branch_fax,
			customer_user_email,
			subcontract_customer_user_email,
			cc_email
		  } = this.props.data.values;
		  var email = [];
		  var sub_email = [];
		  let set_send_destination_type;
		  // console.log(cc_email);
		  if(send_destination_type == "" || send_destination_type == null){
			set_send_destination_type = 0;
		  }else{
			set_send_destination_type = parseInt(send_destination_type);
		  }
	
		  if(set_send_destination_type == 1){
			if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			  sub_email.push(cc_email)
			}
			
			if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			  sub_email.push(subcontract_customer_branch_cc_email_quote)
			}
		  }else{
			if (cc_email !== null && cc_email !== undefined && cc_email.length>0) {
			  email.push(cc_email)
			}
			if (customer_branch_cc_email_quote !== null && customer_branch_cc_email_quote !== undefined && customer_branch_cc_email_quote.length>0) {
			  email.push(customer_branch_cc_email_quote)
			}
	
			if (subcontract_customer_branch_cc_email_quote !== null && subcontract_customer_branch_cc_email_quote !== undefined && subcontract_customer_branch_cc_email_quote.length>0) {
			  sub_email.push(subcontract_customer_branch_cc_email_quote)
			}
	  
		  }
	
		//   console.log("componentDidUpdate",this.props.data);
	
		  this.setState({
			data: {
			  ...this.props.data,
			  values : {
				...this.props.data.values,
				invoice_user_memo : this.props.data.values.order_memo
			  }
		   },
		   notification: {
			 ...this.state.notification,
			values: {
				...this.state.notification.values,
				customer_user_email:customer_user_email,
				subcontract_customer_user_email:subcontract_customer_user_email,
				send_destination_type:set_send_destination_type,
				want_guide_type:(want_guide_type)? parseInt( want_guide_type ): this.state.notification.values.want_guide_type,
				want_guide_type_subcontract:(want_guide_type_subcontract)? parseInt( want_guide_type_subcontract ): this.state.notification.values.want_guide_type_subcontract,
				cc_email: (email.length>0)?email.join(","):"",
				cc_email_subcon:  (sub_email.length>0)?sub_email.join(","):"",
				fax: (customer_branch_fax && customer_branch_fax != null)? customer_branch_fax: "",
				subcon_fax: (subcontract_customer_branch_fax && subcontract_customer_branch_fax != null)? subcontract_customer_branch_fax: "",
				create_invoice_flag: 0,
			}
		   }
		  })
		}
	  }
	  validateSendContact ( newData, callback=()=>{}) {
	//    console.log("validateSendContact",newData);
		this.setState({ notification: {
		  ...this.state.notification,
		  ...newData
		}
	  },);
	  
	  }
	  sendSettingDisabledOptions(distinate_type="contract"){
		const EmailSendEnabled = this.subconSendSettingDisabled("email",distinate_type) ;
		const FaxSendEnabled = this.subconSendSettingDisabled("fax",distinate_type) ;
		// console.log(distinate_type,EmailSendEnabled,FaxSendEnabled)
		if(!EmailSendEnabled && FaxSendEnabled){
		  return [0,2]
		}else if(EmailSendEnabled && !FaxSendEnabled){
		  return [0,1]
		}else{
		  return []
		}
	
	  } 

	  // #1034 案内設定 0:PCのみ  1:FAXのみ  2:両方
	  subconSendSettingDisabled (send_type="email",distinate_type="contract") {
		// console.log(this.state.notification);
		// console.log(this.state.data.values)
		const {register_type} = this.state.data.values
		switch (send_type){
		  case "email":{
			const {
			  send_destination_type,
			  customer_user_email,
			  subcontract_customer_user_email
			}=this.state.notification.values
			
			let validCheck
			let sendSettingCheck
			if (distinate_type=="contract") {
			  validCheck = customer_user_email != null && customer_user_email.length > 0
			  sendSettingCheck = send_destination_type == 2 || send_destination_type == 0
			}
			else {
			  validCheck = subcontract_customer_user_email != null && subcontract_customer_user_email.length > 0
			  sendSettingCheck = send_destination_type == 2 || send_destination_type == 1
			}
			return !sendSettingCheck || !validCheck
		  }
		  case "fax":{
			const {
			  send_destination_type
			}=this.state.notification.values
	
			let sendSettingCheck
	
			if (distinate_type=="contract") {
			  sendSettingCheck = register_type == 0 && (send_destination_type == 2 || send_destination_type == 0)
			}
			else {
			  sendSettingCheck = send_destination_type == 2 || send_destination_type == 1
			}
			return !sendSettingCheck
		  }
		  // 案内送信設定 0:元請のみ 1:下請のみ 2:両方
		  case "dist": {
			// 元請、下請双方に送信
			if (this.state.notification.values.send_destination_type == 2) return false;
			// 元請送信設定
			if (distinate_type == "contract") {
			  return (this.state.notification.values.send_destination_type != 0)
			}
			else 
			  return (this.state.notification.values.send_destination_type != 1)
			}
		}
	  }
	
	  validNotificateStatus ( checkValidError = true, contract = true,subcon = true ) {
		let valid = true
		if ( checkValidError ) {
		  let message = getErrorCodes(this.state.notification.errors)
		  if(message.length > 0){
			valid = false;
		  }
		}
		const {
		  send_destination_type,
		  want_guide_type,
		  want_guide_type_subcontract,
		  fax,
		  subcon_fax
		}=this.state.notification.values
		//send_destination_type 0:元請のみ 1:下請のみ  2:両方
		//want_guide_type 0:両方 1:メールのみ  2:ファックスのみ
		
		if ( contract ) {
		  // 元請のファックス案内=>ファックスのNULLチェック
		  if ((send_destination_type==0 || send_destination_type == 2) && (want_guide_type == 0 || want_guide_type == 2)) {
			if (fax.length == 0) { valid = false }
		  }
		}
		if ( subcon ) {
		  // 元請のファックス案内=>ファックスのNULLチェック
		  if ((send_destination_type==1 || send_destination_type == 2) && (want_guide_type_subcontract == 0 || want_guide_type_subcontract == 2)) {
			if (subcon_fax.length == 0 ) { valid = false }
		  }
		}
		return valid;
	  }
	
	  validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	  }
	
	  async handleClickPositive(){
	//    console.log("handleClickPositive",this.state.data.values);

		console.log(this.validNotificateStatus() ,this.validate());
		if ( !this.validNotificateStatus()) {
		  return false;
		}
	
		if (!this.validate()) {
		  return false;
		}
	
		const {
	//      want_guide_type,
	//      want_guide_type_subcontract,
	
		  customer_natural_id,
		  customer_branch_natural_id,
		  customer_user_natural_id,
		  project_natural_id,
		  request_natural_id,
		  subcontract_customer_branch_natural_id,
		  subcontract_customer_user_natural_id,
	
		  latest_pdf_quote_url,
		  latest_pdf_plotting_url,
		  invoice_status_flag,
		  user_branch_natural_id,
		  invoice_user_memo,
		  change_invoice_flag,
		  change_invoice_name,
		  contract_pdf_url,
		  request_user_branch_natural_id,
		  estimate_id,
		  register_type
		} = this.state.data.values

		// console.log(this.state.data.values)

		Request.setProgress(10)
		const estimateCommonParams = await Request.getEstimateCommon({
			customer_branch_natural_id,
			customer_user_natural_id,
			project_natural_id,
			request_natural_id,
			subcontract_customer_branch_natural_id,
			subcontract_customer_user_natural_id,
			estimateObject: this.state.data.values,
			user_branch_natural_id: request_user_branch_natural_id
		})
		
		Request.setProgress(20)
		const ESTIMATE__latest_pdf_quote_url = latest_pdf_quote_url
		const ESTIMATE__latest_pdf_plotting_url = latest_pdf_plotting_url
		const ESTIMATE__contract_pdf_url = this.customerUseCustomizedEstimateForTouken==customer_natural_id ? "" : contract_pdf_url == null ? "" : contract_pdf_url
		// console.log(contract_pdf_url)
		const {
		  CUSTOMER_USER__customer_reminder_sms_flag_code,
		  CUSTOMER_USER__customer_user_tel
		} = estimateCommonParams.object_customer
		const {
		  CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
		  CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
		} = estimateCommonParams.object_customer_subcontract

		const {
			PROJECT__site_customer_user_tel
		} = estimateCommonParams.object_project

		// #1034 送信設定　DB参照→手動設定
		const {
		  customer_user_email,
		  subcontract_customer_user_email,
		  want_guide_type,
		  want_guide_type_subcontract,
		  fax,
		  subcon_fax,
		  send_contract
		}=this.state.notification.values
		let {
		  send_destination_type,
		  send_destination_type:PROJECT__send_destination_type,
		} = this.state.notification.values

		const useCustomerSystem = this.state.data.values.register_type === 1 ? 1 : 0;
		// 通知フラグ
		const sendUploadNotification = this.state.notification.values.send_upload_notification;
		const custSendFlag = (useCustomerSystem === 1) ? true : false;

		// #1034 入力されたメール・ファックス番号に変更
		const castEstimateParameters = {
		  ...estimateCommonParams,
		  object_customer: {
			...estimateCommonParams.object_customer, 
			CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email,
			CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.fax,
		  },
		  object_customer_subcontract: {
			...estimateCommonParams.object_customer_subcontract, 
			CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email_subcon,
			CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.subcon_fax,
		  }
		}
		// console.log(estimateCommonParams);
		// console.log(castEstimateParameters);
	
		const subcontract_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)? false : undefined;
			
		const send_document_1_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_1:"";
		const send_document_2_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_2:"";
		const send_document_3_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "": ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		const subcontract_send_document_1_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_1:"";
		const subcontract_send_document_2_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_2:"";
		const subcontract_send_document_3_mail = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.mail.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		
		const send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_1:"";
		const send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_2:"";
		const send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		const subcontract_send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_1:"";
		const subcontract_send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_2:"";
		const subcontract_send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		
		const send_document_1_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_1:"";
		const send_document_2_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_2:"";
		const send_document_3_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		const subcontract_send_document_1_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_1:"";
		const subcontract_send_document_2_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_2:"";
		const subcontract_send_document_3_sms = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.sms.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		// console.log(this.state.notification, this.state.notification.values.create_invoice_flag)

		// 請求処理を実施するのチェック有無
		let create_invoice = this.state.notification.values.create_invoice_flag == 1;

		const send_customized_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?"1":"0";
	
		let f03Mail = {Code:200};
		let f03Fax = {Code:200};
		let f03Sms = {Code:200};

		const report_name = this.EstimateQuoteCustomizedForTomosho==customer_natural_id ? "Y13_PDF": "F01_PDF";
		let contract_name = "G05_PDF";
		let cufile_option = false;

		const match = this.customerUseCustomizedContractData.find(
			c => c.customer_natural_id === customer_natural_id
		);

		contract_name = match ? match.format : "G05_PDF";
		cufile_option = match ? match.cufile_option : false;

		if(register_type == 0) {
			f03Mail =  ((want_guide_type=="1"||want_guide_type=="0")  && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && customer_user_email != null && customer_user_email.length > 0) 
			|| ((want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0")  && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcontract_customer_user_email != null && subcontract_customer_user_email.length > 0) 
			? new Promise((resolve, reject)=>{

			// 依頼元担当者のメールアドレスがNullでは無い AND 「メールを送信する」（REQUEST__want_guide_type）となっていること
			const mailUrl = '/api/pout/F03_MAIL'
			const mailParams = {
		//        ...estimateCommonParams,
				...castEstimateParameters,
				send_destination_type:PROJECT__send_destination_type,
				want_guide_type:want_guide_type,
				want_guide_type_subcontract:want_guide_type_subcontract,
				format_url:GoogleDrive.getFormatUrl(format_url.F03_MAIL),
				ESTIMATE__latest_pdf_quote_url,
				ESTIMATE__latest_pdf_plotting_url,
				ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
				// ESTIMATE__contract_pdf_url:create_invoice ? ESTIMATE__contract_pdf_url : this.state.data.values.invoice_process_status != null ? ESTIMATE__contract_pdf_url : "",
				send_customized_flag,
				object_each_data:{
				send_document_1:send_document_1_mail,
				send_document_2:send_document_2_mail,
				send_document_3: send_contract == "1" ? send_document_3_mail : null,
				subcontract_send_document_1:subcontract_send_document_1_mail,
				subcontract_send_document_2:subcontract_send_document_2_mail,
				subcontract_send_document_3: send_contract == "1" ? subcontract_send_document_3_mail : null,
				cufile_option
				}
			}
			Request.post(mailUrl, mailParams, res=>{
		//        console.log(res)
				resolve(res)
			}, err=>{
				reject(err)
			})
			})
			:{Code:200}
			
			f03Fax = ((want_guide_type=="2"||want_guide_type=="0") && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && fax.length>0) 
			|| ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcon_fax.length>0) 
			? new Promise((resolve, reject)=>{
			const faxUrl = '/api/pout/F03_FAX'
			const faxCreate = this.state.fax_pdf_create_flag == true && (this.state.set_send_contract != this.state.notification.values.send_contract 
				|| this.state.set_fax != this.state.notification.values.fax
				|| this.state.set_subcon_fax != this.state.notification.values.subcon_fax) || this.state.fax_send_data.length == 0
			const faxParams = {
		//        ...estimateCommonParams,
				...castEstimateParameters,
				send_destination_type:PROJECT__send_destination_type,
				want_guide_type:want_guide_type,
				want_guide_type_subcontract:want_guide_type_subcontract,
				format_url:GoogleDrive.getFormatUrl(format_url.F03_FAX),
				ESTIMATE__latest_pdf_quote_url,
				ESTIMATE__latest_pdf_plotting_url,
				ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
				// ESTIMATE__contract_pdf_url:create_invoice ? ESTIMATE__contract_pdf_url : this.state.data.values.invoice_process_status != null ? ESTIMATE__contract_pdf_url : "",
				send_customized_flag,
				object_each_data:{
				send_document_1:send_document_1_fax,
				send_document_2:send_document_2_fax,
				send_document_3: send_contract == "1" ? send_document_3_fax : null,
				subcontract_send_document_1:subcontract_send_document_1_fax,
				subcontract_send_document_2:subcontract_send_document_2_fax,
				subcontract_send_document_3: send_contract == "1" ? subcontract_send_document_3_fax : null,
				},
				force: faxCreate,
				cufile_option
			}
			console.log(this.state.fax_pdf_create_flag,
				this.state.set_send_contract != this.state.notification.values.send_contract ,
				this.state.set_fax != this.state.notification.values.fax,
				this.state.set_subcon_fax != this.state.notification.values.subcon_fax,
				faxCreate,
				this.state.fax_send_data)

			if (faxCreate == false){
				resolve(this.state.fax_send_data)
				return ;
			}else{

				Request.post(faxUrl, faxParams, res=>{
					//console.log(res)
					if (res.Code == 200 && res.Data.length > 0){
						this.setState({
							data:{
							  ...this.state.data,
							  values: {
								...this.state.data.values,
								update_timestamp:res.Data[0]["update"] != "" && res.Data[0]["update"] != null ? res.Data[0]["update"] : this.state.data.values.update_timestamp
							  }
							}
						  })
					}else{
						const messageNo = "2406"
						this.props.alertModal.current.showErrorModal({messageNo});
						Request.setProgress(0)
						reject(res)
					}
					resolve(res)
				}, err=>{
					reject(err)
				})
			}

			})
			:{Code:200}
		
			f03Sms = ((PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && CUSTOMER_USER__customer_user_tel) 
			|| ((PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract=="1" && CUSTOMER_USER__customer_user_tel_subcontract) 
			? new Promise((resolve, reject)=>{
			// need to fix condition
			const smsUrl = '/api/pout/F03_SMS'
			const smsParams = {
				...estimateCommonParams,
				send_destination_type:PROJECT__send_destination_type,
				want_guide_type:want_guide_type,
				want_guide_type_subcontract:want_guide_type_subcontract,
				format_url:GoogleDrive.getFormatUrl(format_url.F03_SMS),        
				ESTIMATE__latest_pdf_quote_url,
				ESTIMATE__latest_pdf_plotting_url,
				send_customized_flag,
				object_each_data:{
				send_document_1:send_document_1_sms,
				send_document_2:send_document_2_sms,
				send_document_3:send_contract == "1" ? send_document_3_sms : "",
				subcontract_send_document_1:subcontract_send_document_1_sms,
				subcontract_send_document_2:subcontract_send_document_2_sms,
				subcontract_send_document_3:send_contract == "1" ? subcontract_send_document_3_sms : ""
				}
			}
			Request.post(smsUrl, smsParams, res=>{
		//        console.log(res)
				resolve(res)
			}, err=>{
				reject(err)
			})
			})
			:{Code:200}
		
			Request.setProgress(40)
			const f0304results = await Promise.all([f03Mail, f03Fax, f03Sms]).then(r=>r)
			Request.setProgress(70)
			f03Mail = f0304results[0]
			f03Fax = f0304results[1]
			f03Sms = f0304results[2]
		}
	
		let f10_mail = {Code:200};
		let f10_sms = {Code:200};
		let isPushAllowedCust = false;
		let isSmsAllowedCust = false;		
		estimateCommonParams["object_estimate"]["ESTIMATE__id"] = estimate_id
		if(useCustomerSystem == 1){
			console.log(this.customerUseCustomizedEstimateForTouken,customer_natural_id)
			
			const cu_file_regist = await new Promise((resolve, reject)=>{
				const mailUrl = '/api/cufile'
				const mailParams = {
					...estimateCommonParams,
					ESTIMATE__latest_pdf_quote_url,
					ESTIMATE__latest_pdf_plotting_url,
					ESTIMATE__contract_pdf_url:this.customerUseCustomizedEstimateForTouken==customer_natural_id ? undefined : ESTIMATE__contract_pdf_url == null ? undefined : ESTIMATE__contract_pdf_url,
					// ESTIMATE__contract_pdf_url:send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
					customer_system_use_flag:useCustomerSystem,
					subcontract_flag,
					report_name,
					contract_name,
					// contract_name:send_contract == "1" ? contract_name : null,
					cufile_option
					
				}
				console.log(mailParams)
				
				Request.post(mailUrl, mailParams, res=> resolve(res), err=> reject(err))
			})
			console.log(cu_file_regist)
			if(register_type == 1 && cu_file_regist) {
				// 顧客システムへの通知がある場合

				if(custSendFlag){
					// 顧客システム通知用メール取得

					f10_mail = await new Promise((resolve, reject)=>{
						const mailUrl = '/api/pout/F03_MAIL'
						const mailParams = {
							//        ...estimateCommonParams,
							...castEstimateParameters,
							send_destination_type:0,
							want_guide_type:want_guide_type,
							want_guide_type_subcontract:want_guide_type_subcontract,
							format_url:GoogleDrive.getFormatUrl(format_url.F03_MAIL),
							ESTIMATE__latest_pdf_quote_url,
							ESTIMATE__latest_pdf_plotting_url,
							ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
							cufile_option,					
							object_each_data:{
								send_document_1:send_document_1_mail,
								send_document_2:send_document_2_mail,
								send_document_3:send_contract == "1" ? send_document_3_mail : null,
								subcontract_send_document_1:null,
								subcontract_send_document_2:null,
								subcontract_send_document_3:null
							}
						}
						
						Request.post(mailUrl, mailParams, res=> resolve(res), err=> reject(err))
					})  
					
					// 顧客システム通知用SMS・PUSH取得
					isPushAllowedCust = estimateCommonParams.object_customer.CUSTOMER_USER__notification_flag=="1" ? true : false;
					isSmsAllowedCust = (estimateCommonParams.object_customer.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer.CUSTOMER_USER__customer_user_tel) ? true : false;
					if(isPushAllowedCust){
						isSmsAllowedCust = false;
					}
					if(estimateCommonParams.object_project.PROJECT__site_customer_user_tel){
						isSmsAllowedCust = true;
					}					
					if  (isSmsAllowedCust || isPushAllowedCust) {
						f10_sms = await new Promise((resolve, reject)=>{
							const smsUrl = '/api/pout/F10_SMS'
							const smsParams = {
								...estimateCommonParams,
								send_destination_type:0,
								want_guide_type:want_guide_type,
								want_guide_type_subcontract:want_guide_type_subcontract,
								format_url:GoogleDrive.getFormatUrl(format_url.F10_SMS),
								object_each_data:{
									send_document_1:send_document_1_sms,
									send_document_2:send_document_2_sms,
									send_document_3:send_contract == "1" ? send_document_3_sms : ""
								},
								push_flag: isPushAllowedCust ? 1 : 0,
							}
							Request.post(smsUrl, smsParams, res => resolve(res), err=> reject(err))
						})
					}
				}
			}
		}

		Request.setProgress(80)
		let messageNo = [2417];
		// console.log(f03Mail,f03Fax,f03Sms,f10_mail,f10_sms)
		if (f03Mail.Code==200 && f03Fax.Code==200 && f03Sms.Code==200 && f10_mail.Code==200 && f10_sms.Code==200){
			const url = '/api/quote/send/'+this.props.data.values.estimate_ulid
			const {update_timestamp} = this.state.data.values
			// console.log(this.props.data.values.update_timestamp)
			Request.put(url, {
				...this.props.data.values,
				// order_box_status:7,
				update_timestamp: update_timestamp ? update_timestamp : this.props.data.values.update_timestamp,
				latest_pdf_quote_url,
				latest_pdf_plotting_url,
				invoice_user_memo,
				change_invoice_flag,
				change_invoice_name,
				contract_pdf_url,
				send_only:1,
				create_invoice: create_invoice
			}, async (res)=>{
				let openGoogleDraft = true;
				// 顧客システム利用かつ通知を送る
				let resultSms = {Code:200};
				if(register_type == 1 && custSendFlag){
					const sendMailUrl = '/api/send/MAIL'

					f10_mail.Data&&f10_mail.Data.forEach((mailData)=>{
						openGoogleDraft = true;
						Request.post(sendMailUrl, mailData, res=>{
							messageNo.push(2471);
						}, err=> {},undefined, true, false)
					})
					// 顧客システム利用かつ通知を送る場合、SMSとPUSHの送信は同時に行う
					const sendPush = isPushAllowedCust && f10_sms && new Promise((resolve, reject)=>{
						const sendSmsUrl = '/api/send/PUSH'
						f10_sms.data && f10_sms.data.forEach((smsData)=>{
							if( smsData.type == "push"){
								const sendPushParams = {...smsData,customer_user_id:estimateCommonParams.object_customer.CUSTOMER_USER__id}
								Request.post(sendSmsUrl, sendPushParams, res=> {}, err=> {},undefined, true, false)
							}
						})
					})
					resultSms = isSmsAllowedCust && f10_sms && await new Promise((resolve, reject)=>{
						const sendSmsUrl = '/api/send/SMS'
						f10_sms.data && f10_sms.data.forEach((smsData)=>{
							if( smsData.type == "sms"){
								if (smsData.site_flag == true) {
									if (smsData.site_error == true) {
										resolve({Code: 2631})
									}else{
									Request.post(sendSmsUrl, smsData, res => {
										if (res.Data && res.Data.sms_status == 'accepted'){
										resolve({Code: 200})
										}else{
										resolve({Code: 2631, data: res.Data})
										}
									}, err => {
										resolve({Code: 2631, data: err})
									}, undefined, true, false)
									}
				
								} else {
									Request.post(sendSmsUrl, smsData, res => {}, err => {}, undefined, true, false)
								}
							}
						})
					})
				}
		
				Request.setProgress(90)
		
				if(register_type == 0) {
					// 顧客システム利用時は送付状を送らず、通知メールとSMSを送る（元請けのみ）
					// 顧客システム利用かつ元請けのみの場合、送付状不要
					// if(!(useCustomerSystem && send_destination_type == 0)){
					// 顧客システム未利用又は顧客システム利用且つ下請け、両方の場合
					const sendMailUrl = '/api/send/MAIL'
					f03Mail.Data&&f03Mail.Data.forEach((mailData)=>{
						openGoogleDraft = true;
						Request.post(sendMailUrl, mailData, res=>{
							messageNo.push(2471);
						}, err=>{
						},undefined, true, false)
					})
					
					const sendFaxUrl = '/api/send/FAX'
					f03Fax.Data&&f03Fax.Data.forEach((faxData)=>{
						Request.post(sendFaxUrl, faxData, res=>{
							this.setState({
								fax_send_data: []
							})
						}, err=>{
						},undefined, true, false)
					})
			
					const sendSmsUrl = '/api/send/SMS'
					f03Sms.Data&&f03Sms.Data.forEach((smsData)=>{
						 if( smsData.type == "sms" && smsData.site_flag == false){
							Request.post(sendSmsUrl, smsData, res=>{
							}, err=>{
							},undefined, true, false)
						}
					})
				}
				// }
				Request.setProgress(0)
				// console.log(res.data.Code==200,res.data.Code);
				if (res.data.Code==200){
					if(openGoogleDraft){
						window.open(`https://mail.google.com/mail/u/0/#drafts`);
					}
					document.body.style.overflow = "auto";

					// #1674 ANDPAD連携
					const {ex_andpad_use_flag,
						ex_andpad_quote_file_flag,
						ex_andpad_access_token_key,
						ex_andpad_system_id,
						register_type,
						request_natural_id,
						estimate_natural_id,
						quote_available_start_date,
						quote_available_end_date,
						survey_parking_name,
						survey_parking_prefecture,
						survey_parking_city,
						survey_parking_address,
						estimate_id,
						parking_latitude,
						parking_longitude
						} = this.state.data.values

					const andpad_use_flag = ex_andpad_use_flag == 1 && 
											ex_andpad_access_token_key != "" && 
											ex_andpad_access_token_key != null &&
											ex_andpad_system_id != "" && 
											ex_andpad_system_id != null &&
											parseInt(register_type) == 1 ? true : false;
					if (andpad_use_flag) {
						const cu_file_regist = await new Promise((resolve, reject)=>{
							const andpadUrl = '/api/cufile'
							let json_data = andpad_json_data
							let estimate_data = andpad_json_data_estimate
							const moment = require("moment");
							estimate_data["parking_estimate_id"] = estimate_natural_id
							estimate_data["parking_start_date"] = moment(quote_available_start_date).format("YYYY-MM-DD")
							estimate_data["parking_end_date"] = moment(quote_available_end_date).format("YYYY-MM-DD")
							estimate_data["parking_name"] = survey_parking_name
							estimate_data["prefecture_code"] = survey_parking_prefecture
							estimate_data["city"] = survey_parking_city
							estimate_data["street"] = survey_parking_address
							estimate_data["latitude"] = String(parking_latitude)
							estimate_data["longitude"] = String(parking_longitude)

							json_data["parking_requests"][0]["parking_request_id"] = request_natural_id
							json_data["parking_requests"][0]["estimates"] = [estimate_data]	

							const andpadParams = {
								andpad:{
									access_token_key: ex_andpad_access_token_key,
									system_id: ex_andpad_system_id,
									ex_adnpad_plotting_file_flag: true,
									ex_andpad_quote_file_flag: ex_andpad_quote_file_flag == 1 ? true : false,
									estimate_id: estimate_id,
									json_data
								}
							}
							console.log(andpadParams)
							
							Request.post(andpadUrl, andpadParams, res=> resolve(res), err=> reject(err),undefined, true, false)
						})
						console.log(cu_file_regist)
						
						this.props.alertModal.current.confirmCheck({
							title: cu_file_regist.Code == "200" || cu_file_regist.Code == "204" ? "処理完了" : "エラーが発生しました。",
							messageNo: cu_file_regist.Code == "200" || cu_file_regist.Code == "204" ? messageNo : cu_file_regist.Code == "819" ? "2630" : ex_andpad_quote_file_flag == 1 ? "2626" : "2627",
							closeBtn: false
						}, ()=>{
							if (resultSms.Code == 200){
								this.props.refreshCallback()
								this.toggleModal()
							} else {
								let title = "エラー"
								let message = GetMessage(2631)
								if (resultSms.data && resultSms.data.sms != "") {
									message = message + "<br />\n" + resultSms.data.sms
								}
								this.siteAlertModal.current.confirmCheck({
									title: title,
									message: message ,
									closeBtn: false
								}, ()=>{
									this.props.refreshCallback()
									this.toggleModal()
								}, false) 

							}
						}, false)
					} else {
						Request.setProgress(0)
						if (resultSms.Code == 200) {
							this.props.alertModal.current.confirmCheck({
								title: "処理完了",
								messageNo: messageNo,
								closeBtn: false
							}, ()=>{
								this.props.refreshCallback()
								this.toggleModal()
							}, false)
						} else {
							console.log(resultSms);
							let title = "エラー"
							let message = GetMessage(2631)
							if (resultSms.data && resultSms.data.sms != "") {
								message = message + "<br />\n" + resultSms.data.sms
							}
							this.props.alertModal.current.confirmCheck({
								title: title,
								message: message ,
								closeBtn: false
							}, ()=>{
								this.props.refreshCallback()
								this.toggleModal()
							}, false)
						}
					}

				}
			})
		}else{
			Request.setProgress(0)
		}
	  }
	
	  memoValidateCallback(newData, callback=()=>{}){
		this.setState({
		  data:newData
		}, ()=>callback())
	  }
	
	  validateCallback(newData, callback=()=>{}){
		const change_invoice_flag = newData.values.change_invoice_flag
		const is_empty_change_invoice_name = 
		  (newData.values.change_invoice_name === null 
		  || newData.values.change_invoice_name === undefined
		  || newData.values.change_invoice_name === "") ? true : false;
		this.setState({
		  data:{
			...this.state.data,
			...newData,
			values: {
			  ...newData.values,
			  change_invoice_name : change_invoice_flag == 1 ? newData.values.change_invoice_name : null
			},
			errors:{ 
			  ...(change_invoice_flag == 1 ? newData.errors : undefined),
			  ...(change_invoice_flag == 1 && is_empty_change_invoice_name ? {change_invoice_name : [GetMessage(2024)]} : undefined) 
			},
			requiredData : { ...(change_invoice_flag == 1 ? {change_invoice_name : [GetMessage(2024)]} : undefined) },
		  }
		}, ()=>callback())
	  }
	
	  async handleClickCreateFax(){
		//    console.log("handleClickPositive",this.state.data.values);
			if ( !this.validNotificateStatus() ) {
			  return false;
			}
		
			if (!this.validate()) {
			  return false;
			}
		
			const {
		//      want_guide_type,
		//      want_guide_type_subcontract,
		
			  customer_natural_id,
			  customer_branch_natural_id,
			  customer_user_natural_id,
			  project_natural_id,
			  request_natural_id,
			  subcontract_customer_branch_natural_id,
			  subcontract_customer_user_natural_id,
		
			  latest_pdf_quote_url,
			  latest_pdf_plotting_url,
			  contract_pdf_url,
			  request_user_branch_natural_id,
			  register_type
			} = this.state.data.values
			// console.log(this.state.data.values)
	
			Request.setProgress(10)
			const estimateCommonParams = await Request.getEstimateCommon({
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				estimateObject: this.state.data.values,
				user_branch_natural_id: request_user_branch_natural_id
			})
			// console.log(request_user_branch_natural_id);
			// console.log(user_branch_natural_id);
	
			Request.setProgress(20)
			const ESTIMATE__latest_pdf_quote_url = latest_pdf_quote_url
			const ESTIMATE__latest_pdf_plotting_url = latest_pdf_plotting_url
			const ESTIMATE__contract_pdf_url = this.customerUseCustomizedEstimateForTouken==customer_natural_id ? "" : contract_pdf_url == null ? "" : contract_pdf_url

			// #1034 送信設定　DB参照→手動設定
			const {
			  customer_user_email,
			  subcontract_customer_user_email,
			  want_guide_type,
			  want_guide_type_subcontract,
			  fax,
			  subcon_fax,
			  send_contract
			}=this.state.notification.values
		
			// console.log(ESTIMATE__contract_pdf_url,send_contract,send_contract==="1")

			let {
			  send_destination_type,
			  send_destination_type:PROJECT__send_destination_type,
			} = this.state.notification.values
		
			// 顧客システム情報利用有無
			const useCustomerSystem = this.state.data.values.register_type === 1 ? 1 : 0;
			// 通知フラグ
			const sendUploadNotification = this.state.notification.values.send_upload_notification;
			const custSendFlag = (useCustomerSystem === 1) ? true : false;
		
			// #1034 入力されたメール・ファックス番号に変更
			const castEstimateParameters = {
			  ...estimateCommonParams,
			  object_customer: {
				...estimateCommonParams.object_customer, 
				CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email,
				CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.fax,
			  },
			  object_customer_subcontract: {
				...estimateCommonParams.object_customer_subcontract, 
				CUSTOMER_BRANCH__customer_branch_cc_email_quote:this.state.notification.values.cc_email_subcon,
				CUSTOMER_BRANCH__customer_branch_fax:this.state.notification.values.subcon_fax,
			  }
			}
		
			const send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_1:"";
			const send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_2:"";
			const send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
			const subcontract_send_document_1_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_1:"";
			const subcontract_send_document_2_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_2:"";
			const subcontract_send_document_3_fax = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?this.DocumentNameCustomizedForTomosho.fax.subcontract_send_document_3:(this.customerUseCustomizedEstimateForTouken==customer_natural_id) ? "":  ESTIMATE__contract_pdf_url != "" ? "駐車場賃貸借契約書": "";
		
			const send_customized_flag = (this.EstimateQuoteCustomizedForTomosho==customer_natural_id)?"1":"0";
		
			let f03Fax
	
			// if(register_type == 0) {

				f03Fax = ((want_guide_type=="2"||want_guide_type=="0") && (PROJECT__send_destination_type=="0"||PROJECT__send_destination_type=="2") && fax.length>0) 
				|| ((want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0") && (PROJECT__send_destination_type=="1"||PROJECT__send_destination_type=="2") && subcon_fax.length>0) 
				? new Promise((resolve, reject)=>{
				const faxUrl = '/api/pout/F03_FAX'
				const faxParams = {
			//        ...estimateCommonParams,
					...castEstimateParameters,
					send_destination_type:PROJECT__send_destination_type,
					want_guide_type:want_guide_type,
					want_guide_type_subcontract:want_guide_type_subcontract,
					format_url:GoogleDrive.getFormatUrl(format_url.F03_FAX),
					ESTIMATE__latest_pdf_quote_url,
					ESTIMATE__latest_pdf_plotting_url,
					ESTIMATE__contract_pdf_url: send_contract == "1" ? ESTIMATE__contract_pdf_url : null,
					send_customized_flag,
					object_each_data:{
					send_document_1:send_document_1_fax,
					send_document_2:send_document_2_fax,
					send_document_3: send_contract == "1" ? send_document_3_fax : null,
					subcontract_send_document_1:subcontract_send_document_1_fax,
					subcontract_send_document_2:subcontract_send_document_2_fax,
					subcontract_send_document_3: send_contract == "1" ? subcontract_send_document_3_fax : null
					},
					force:true
				}
				Request.post(faxUrl, faxParams, res=>{
					// console.log(res.Data)
					if(res.Code == 200 && res.Data.length > 0){
						this.setState({
							data:{
							...this.state.data,
							values: {
								...this.state.data.values,
								update_timestamp: res.Data[0] && res.Data[0]["update"] && res.Data[0]["update"] != null ? res.Data[0]["update"] : this.state.data.values.update_timestamp
							}
							},
							fax_pdf_create_flag: true,
							set_send_contract: send_contract,
							set_fax:this.state.notification.values.fax,
							set_subcon_fax:this.state.notification.values.subcon_fax,
							fax_send_data:{...res}
						})					
					}else{
						const messageNo = "2406"
						this.props.alertModal.current.showErrorModal({messageNo});
						Request.setProgress(0)
						reject()
					}
					resolve(res)
				}, err=>{
					reject(err)
				})
				})
				:{Code:200}
			
				Request.setProgress(40)
				const f0304results = await Promise.all([f03Fax]).then(r=>r)
				Request.setProgress(70)
				f03Fax = f0304results[0]
			// }
		
			Request.setProgress(0)
			// console.log(f03Fax)

			f03Fax != undefined && f03Fax["Data"].forEach(data => {
                const a = document.createElement('a');
                a.href = data.pdf_file;
                a.download = data.name;  // ファイル名を指定
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);  // ダウンロード後にリンクを削除
            });
			let messageNo = [2417];
			this.props.alertModal.current.confirmCheck({
				title: "処理完了",
				messageNo: messageNo,
				closeBtn: false
			}, ()=>{
				this.props.refreshCallback()
			}, false)
			
		  }

	  bodyContent() {
		const { change_invoice_flag } = this.state.data.values;
		return (
		  <>
			{this.renderSendSetting()}
		  </>
		);
	  }
	  renderSendSetting () {
		//console.log("renderSendSetting",this.state.notification.values);
		const {send_destination_type,want_guide_type,want_guide_type_subcontract} = this.state.notification.values
		const createFaxButtonEnabled = send_destination_type == 0 ? want_guide_type != 1
																  : send_destination_type == 1 ? want_guide_type_subcontract != 1 
																  							   : want_guide_type != 1 || want_guide_type_subcontract != 1

		return (<>
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="12">連絡先情報：</Col>
		  </Row>
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="3">
			CCメールアドレス
			</Col>      
			<Col md="8">
			  <InputText
				label='CCメールアドレス'
				labelOn={false}
				name='NOTIFICATION__cc_email'
				default={this.state.notification.values.cc_email}
				validateCallback={this.validateSendContact}
				rootData={this.state.notification}
				validateType="regist"
				disabled={this.subconSendSettingDisabled()}
			  />
			</Col>      
		  </Row>
			<Row style={{marginBottom: "0.5rem"}}>
			  <Col md="3">
			  FAX番号
			  </Col>
			  <Col md="8">
				<InputText
				  label='FAX番号'
				  labelOn={false}
				  name='NOTIFICATION__fax'
				  default={this.state.notification.values.fax}
				  validateCallback={this.validateSendContact}
				  rootData={this.state.notification}
				  validateType="regist"
				  disabled={this.subconSendSettingDisabled("fax")}
				/>
				{!this.validNotificateStatus(false,true,false)&&(<p style={{color:"red"}}>
				  {GetMessage(["2024"])}
				</p>)}
			  </Col>
			</Row>
			<Row style={{marginBottom: "0.5rem"}}>
			  <Col md="3">
			  案内方法
			  </Col>
			  <Col md="8">
				<InputRadio
				  name='NOTIFICATION__want_guide_type'
				  disabled={this.subconSendSettingDisabled("dist")}
				  disabled_options={this.sendSettingDisabledOptions("contract")}
				  options={
					[
					  {
						  default : this.state.notification.values.want_guide_type,
						  label : "両方",
						  value : 0,
					  },
					  {
						label : "Eメール案内希望",
						value : 1
					  },
					  {
						label : "FAX案内希望",
						value : 2,
					  },
					]
				  }
				  validateCallback={this.validateSendContact} 
				  validateType='regist'
				  rootData={this.state.notification}
				  />
			  </Col>
			</Row>
			{this.state.data.values.register_type == 1 ? 
		        <Row style={{marginBottom: "2rem"}}>
				<p style={{color:"red"}}>{GetMessage(["2614"])}</p>
				</Row>
			:""
			}
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="3">
			CCメールアドレス（下請）
			</Col>      
			<Col md="8">
			  <InputText
				disabled={this.subconSendSettingDisabled("email","subcon")}
				label='CCメールアドレス（下請）'
				labelOn={false}
				name='NOTIFICATION__cc_email_subcon'
				default={this.state.notification.values.cc_email_subcon}
				validateCallback={this.validateSendContact}
				rootData={this.state.notification}
				validateType="regist"
			  />
			</Col>      
		  </Row>
		  <Row style={{marginBottom: "0.5rem"}}>
			<Col md="3">
			FAX番号（下請）
			</Col>      
			<Col md="8">
			  <InputText
				disabled={this.subconSendSettingDisabled("fax","subcon")}
				label='FAX番号（下請）'
				labelOn={false}
				name='NOTIFICATION__subcon_fax'
				default={this.state.notification.values.fax}
				validateCallback={this.validateSendContact}
				rootData={this.state.notification}
				validateType="regist"
			  />
			  {!this.validNotificateStatus(false,false,true)&&(<p style={{color:"red"}}>
				{GetMessage(["2024"])}
			  </p>)}
			</Col>
		  </Row>
		  <Row style={{marginBottom: "2rem"}}>
			<Col md="3">
			案内方法（下請）
			</Col>      
			<Col md="8">
			  <InputRadio
				name='NOTIFICATION__want_guide_type_subcontract'
				disabled={this.subconSendSettingDisabled("dist","subcon")}
				disabled_options={this.sendSettingDisabledOptions("subcon")}
				options={
				  [
					{
						default : this.state.notification.values.want_guide_type_subcontract,
						label : "両方",
						value : 0,
					},
					{
					  label : "Eメール案内希望",
					  value : 1
					},
					{
					  label : "FAX案内希望",
					  value : 2,
					},
				  ]
				}
				validateCallback={this.validateSendContact} 
				validateType='regist'
				rootData={this.state.notification}
				/>          
			</Col>
		  </Row>
		  <Row style={{marginBottom: "2rem"}}>
			<Col md="3">
			契約書送付
			</Col>      
			<Col md="5">
			  <InputRadio
				name='NOTIFICATION__send_contract'
				disabled={this.state.data.values.contract_create_flag != 1}
				options={
				  [
					{
						default : this.state.notification.values.send_contract,
						label : "送付しない",
						value : 0,
					},
					{
					  label : "送付する",
					  value : 1
					},
				  ]
				}
				validateCallback={this.validateSendContact} 
				validateType='regist'
				rootData={this.state.notification}
				/>
			</Col>
			{createFaxButtonEnabled && (<Col md="3">
				<Button 
					// color="info" 
					style={{minWidth:"200px",padding:"10px 30px"}}
					disabled={this.state.data.values.contract_create_flag != 1}
					onClick={() => {
						this.handleClickCreateFax();
					}}>
					FAX用確定見積送付状作成
				</Button>
			</Col>)}
		  </Row>
		  <Row style={{marginBottom: "2rem"}}>
			<Col>
				<InputCheckBox 
					label="請求処理を実施する"
					name="NODB__create_invoice_flag" 
					validateCallback={this.validateSendContact} 
					checkedValue={1}
					uncheckedValue={0}
					rootData={this.state.notification}
					disabled={this.state.data.values.invoice_process_status != null}
					/>
			</Col>
		  </Row>
		  <AlertModal ref={this.siteAlertModal}/>
		</>);
	  }
}  
export class DialogUploadFileApplicationForm extends DialogBase{
	constructor(props) {
	  super(props);
  
	//   console.log(this.props.data);
	  Object.assign(this.state, {
		title: '申込書アップロード',
		data: this.props.data,
		landmark_user: props.landmark_user,
	  });
	  this.validateCallback = this.validateCallback.bind(this)

	}
	componentDidUpdate(prevProps){
		if (prevProps.data !== this.props.data){
			const estimate_id = this.props.data.values.id;
			const {
				latest_pdf_application_form_url,
				application_form_upload_flag,
			} = this.props.data.values;
			// console.log(this.props.data.values)
			this.setState({
				data: {
				values:{
					...this.props.data.values,
					latest_pdf_application_form_url: latest_pdf_application_form_url && application_form_upload_flag == 1 ? latest_pdf_application_form_url : "",
					send_fixed_notification:this.props.data.values.send_fixed_notification ? this.props.data.values.send_fixed_notification : 0
				},
				errors:{
					...((this.props.data.values.latest_pdf_application_form_url)?{latest_pdf_application_form_url:null}:{latest_pdf_application_form_url:[GetMessage(2024)]}),
			
				},
				requiredData:{
					latest_pdf_application_form_url: [GetMessage(2024)],
				}
				},
			},()=>{}
			)
		}		
	}
	
	validateCallback(newData, callback=()=>{}){
		let errors = newData.errors
		// console.log(this.state.data)
		this.setState({
			data:{
			...this.state.data,
			...newData,
			errors:errors
			}
		}, ()=>callback())  
	
	}
	validate(){
		let message = getErrorCodes(this.state.data.errors)
	
		if(message.length > 0){
		  this.props.alertModal.current.showErrorModal({messageNo:message});
		  return false;
		}
		return true;
	}
	
    async handleClickPositive(){
		if(!this.validate()){
			return;
		}
		Request.setProgress(10)
		if(this.state.data.values.latest_pdf_application_form_url_base64){
			const uploadParams = {
				// ...this.state.data.values,
				order_box_status:2,
				latest_pdf_application_form_url_base64: this.state.data.values.latest_pdf_application_form_url_base64,
				update_timestamp : this.state.data.values.update_timestamp,
			}
				Request.put('/api/order_box/application/' + this.state.data.values.estimate_ulid, uploadParams, async res=>{
			},(err)=>{
				Request.setProgress(0)
			})
		}
		
		// console.log(this.state.data.values);
		// 確定通知
		const sendFixedNotification = Boolean(this.state.data.values.send_fixed_notification)

		if(sendFixedNotification){
			let messageNo = [2417];
			const {
				want_guide_type,
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				want_guide_type_subcontract,
				request_user_branch_natural_id:user_branch_natural_id,
				customer_system_use_flag
			} = this.state.data.values

			const estimateCommonParams = await Request.getEstimateCommon({
				customer_branch_natural_id,
				customer_user_natural_id,
				project_natural_id,
				request_natural_id,
				subcontract_customer_branch_natural_id,
				subcontract_customer_user_natural_id,
				estimateObject: this.state.data.values,
				user_branch_natural_id
			})
			const {
				CUSTOMER_USER__customer_reminder_sms_flag_code,
				CUSTOMER_USER__customer_user_tel
			} = estimateCommonParams.object_customer
			const {
				CUSTOMER_USER__customer_reminder_sms_flag_code:CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
				CUSTOMER_USER__customer_user_tel:CUSTOMER_USER__customer_user_tel_subcontract
			} = estimateCommonParams.object_customer_subcontract
			const {
				PROJECT__send_destination_type
			} = estimateCommonParams.object_project
			Request.setProgress(60)
			// D03_MAIL_確定通知
			let d03Mail = (
				((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0"))
				||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))
			) 
			? new Promise((resolve, reject)=>{
				const mailUrl = '/api/pout/D03_MAIL'
				const mailParams = {
				format_url:GoogleDrive.getFormatUrl(format_url.D03_MAIL),
				send_destination_type:PROJECT__send_destination_type,
				want_guide_type:want_guide_type,
				want_guide_type_subcontract:want_guide_type_subcontract,
				...estimateCommonParams
				}
				Request.post(mailUrl, mailParams, res=>{
		//          console.log(res)
				resolve(res)
				}, err=>{
				reject(err)
				})
			})
			:{Code:200}

			// D03_FAX_確定通知
			let d03Fax = (
				((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="2"||want_guide_type=="0"))
				||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="2"||want_guide_type_subcontract=="0"))
			) 
			? new Promise((resolve, reject)=>{
				const faxUrl = '/api/pout/D03_FAX'
				const faxParams = {
				format_url:GoogleDrive.getFormatUrl(format_url.D03_FAX),
				// 顧客システム利用の場合は元請けのFAXは作成しない
				send_destination_type : customer_system_use_flag === 1 ? 1 : PROJECT__send_destination_type,
				want_guide_type:want_guide_type,
				want_guide_type_subcontract:want_guide_type_subcontract,        
				...estimateCommonParams
				}
				Request.post(faxUrl, faxParams, res=>{
		//          console.log(res)
				resolve(res)
				}, err=>{
				reject(err)
				})
			})
			:{Code:200}

			// D03_SMS_確定通知
			let isPushAllowedCust = estimateCommonParams.object_customer.CUSTOMER_USER__notification_flag=="1" ? true : false;
			let isSmsAllowedCust = (estimateCommonParams.object_customer.CUSTOMER_USER__customer_reminder_sms_flag_code=="1" && estimateCommonParams.object_customer.CUSTOMER_USER__customer_user_tel) ? true : false;
			if(isPushAllowedCust){
				isSmsAllowedCust = false;
			}


			let d03Sms = (
				isSmsAllowedCust || isPushAllowedCust
			)
			? new Promise((resolve, reject)=>{
				const smsUrl = '/api/pout/D03_SMS'
				const smsParams = {
				format_url:GoogleDrive.getFormatUrl(format_url.D03_SMS),
				send_destination_type:PROJECT__send_destination_type,
				want_guide_type:want_guide_type,
				want_guide_type_subcontract:want_guide_type_subcontract,        
				...estimateCommonParams
				}
				Request.post(smsUrl, smsParams, res=>{
		//          console.log(res)
				resolve(res)
				}, err=>{
				reject(err)
				})
			})
			:{Code:200}

			const d03Results = await Promise.all([d03Mail, d03Fax, d03Sms]).then(r=>r).catch(()=>{
				Request.setProgress(0)  
				return 
			})

			d03Mail = d03Results && d03Results[0]
			d03Fax = d03Results && d03Results[1]
			d03Sms = d03Results && d03Results[2]

			Request.setProgress(60)

			if (d03Mail.Code==200 && d03Fax.Code==200 && d03Sms.Code==200){

				const sendMailUrl = '/api/send/MAIL'
				d03Mail.Data&&d03Mail.Data.forEach((mailData)=>{
				Request.post(sendMailUrl, mailData, res=>{
				}, err=>{
					
				},undefined, true, false)
				})
				
				// 顧客システム利用の場合は送付先が下請け、両方の場合のみ送付状を送信する
				if(customer_system_use_flag === 0){
				const sendFaxUrl = '/api/send/FAX'
				d03Fax.Data&&d03Fax.Data.forEach((faxData)=>{
					Request.post(sendFaxUrl, faxData, res=>{
					
					}, err=>{
					
					},undefined, true, false)
				})
				}
				
				const sendPush = isPushAllowedCust && d03Sms && 
					d03Sms.Data&&d03Sms.Data.forEach((smsData)=>{
						const sendPushParams = {...smsData,customer_user_id:estimateCommonParams.object_customer.CUSTOMER_USER__id}
						Request.post('/api/send/PUSH', sendPushParams, res=>{}, err=>{},undefined, true, false)
					})
					 

				const sendSms = isSmsAllowedCust && d03Sms && 
					d03Sms.Data&&d03Sms.Data.forEach((smsData)=>{
					  Request.post('/api/send/SMS', smsData, res=>{}, err=>{},undefined, true, false)
					})

				Request.setProgress(90)

				if(((PROJECT__send_destination_type=="2" || PROJECT__send_destination_type=="0" ) && (want_guide_type=="1"||want_guide_type=="0")) 
				||((PROJECT__send_destination_type=="2"|| PROJECT__send_destination_type=="1") && (want_guide_type_subcontract=="1"||want_guide_type_subcontract=="0"))){
				window.open(`https://mail.google.com/mail/u/0/#drafts`);
				messageNo.push(2471)
				}

			}else{
				Request.setProgress(0)
			}


			Request.setProgress(90)
		}


		  Request.setProgress(0)
		  document.body.style.overflow = "auto";
		  this.props.alertModal.current.confirmCheck({
			title: "処理完了",
			messageNo: [2417],
			closeBtn: false
		  }, ()=>{
			this.props.refreshCallback()
			this.toggleModal();
		  }, false)
  
	}
	
	bodyContent() {
		return (
		  <>
			<InputFile 
			  label="申込書"
			  name="ESTIMATE__latest_pdf_application_form_url"
			  copy={false}
			  showLink={true}
			  validateCallback={this.validateCallback} 
			  rootData={this.state.data} 
			  filename={`申込書_${moment().format("YYYYMMDDHHmmss")}&extension=true`}
			  />		  
			  {/* <InputCheckBox
				label='駐車場の確定通知を送る'
				name='NODB__send_fixed_notification'
				labelOn={false}
				checkedValue={1}
				uncheckedValue={0}
				validateCallback={this.validateCallback}
				rootData={this.state.data}
				/>		 */}

		  </>
		);
	}
}
export class DialogCustomerRequestFileDownload extends DialogBase {
	constructor(props) {
	  super(props);
	  Object.assign(this.state, {
		title: '見積依頼書ダウンロード',
		data: this.props.data? this.props.data: {
			values:{}
		},
		cuFiles : []
		// disablePositive:false
	  });
	  this.validateCallback = this.validateCallback.bind(this)
  
	  this.CU_FILE_TYPE = 2;
	  this.CU_FILE_DETAIL_TYPE = 201;
	}
  
	async componentDidUpdate(prevProps){
		if ( this.props.data == undefined ) {
			return
		}
		const {CU_FILE_TYPE,CU_FILE_DETAIL_TYPE} = this
		const {request_id} = this.props.data.values

		if (prevProps.data !== this.props.data){

		// ファイル情報取得
		Request.get('/api/cufile', { ref_id : request_id, file_type: CU_FILE_TYPE }, res => {
		  this.setState({
			cuFiles : res.Data
		  })
		})
  
		this.setState({
		  data: {
			values:{
			  ...this.props.data.values,
			  send_upload_notification:false
			},
			errors:{
			  invoice:[GetMessage(2024)]
			},
			requiredData:{
			  invoice:[GetMessage(2024)],
			}
		  },
		})
	  }
	}
  
	validateCallback(newData, callback=()=>{}){
	  this.setState({
		data:{
		  ...this.state.data,
		  ...newData
		},
	  }, ()=>callback())
	}
  
	handleClickNegative(){
	  this.props.handleClickNegative && this.props.handleClickNegative();
	  this.setState({
		data:{
		  ...this.state.data,
		}
	  })
  
	  this.toggleModal()
	}
	bodyContent() {
	  return (
		<>
		  {this.state.cuFiles.map((file, index) => (
			<Row key={index}>
				<Col>
				  <a className={file.status === 0 ? "disabled-link":""} href={`/api/gcs_download/${file.file_path}?d=${file.file_name}`} target="_blank">{file.file_name}</a>      
				</Col>
				{/*<Col>
				  <Button onClick={()=>{this.handleDeleteLink(file.file_id)}}color="danger" size="sm" disabled={file.status === 0}>削除</Button>
				  <Button onClick={()=>{this.handleReactivateLink(file.file_id)}} className="ml-3" color="secondary" size="sm" disabled={file.status === 1}>戻す</Button>
		  </Col>*/}
			</Row>
		  ))}
		  <br/>
		</>
	  );
	}
  }
  